export type Maybe<T> = T | null | undefined;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  CRMSubscriptionID: { input: string; output: string; }
  CallID: { input: string; output: string; }
  CallUserID: { input: string; output: string; }
  /**
   * Define a Relay Cursor type:
   * https://relay.dev/graphql/connections.htm#sec-Cursor
   */
  Cursor: { input: string; output: string; }
  DirectoryID: { input: string; output: string; }
  DocumentID: { input: string; output: string; }
  EnumerationValueID: { input: string; output: string; }
  JSON: { input: Record<string, unknown>; output: Record<string, unknown>; }
  /** The builtin Map type */
  Map: { input: Record<string, unknown>; output: Record<string, unknown>; }
  Metadata: { input: Record<string, unknown>; output: Record<string, unknown>; }
  OldID: { input: number; output: number; }
  OpportunityID: { input: string; output: string; }
  ProspectID: { input: string; output: string; }
  SpeakerID: { input: string; output: string; }
  TableID: { input: string; output: string; }
  UUID: { input: string; output: string; }
  Unix: { input: number; output: number; }
  UserGroupID: { input: string; output: string; }
  UserID: { input: string; output: string; }
}

export interface ApiKey extends Node {
  readonly clientID: Scalars['String']['output'];
  readonly createdAt: Scalars['Int']['output'];
  readonly createdByUUID: Scalars['ID']['output'];
  readonly disabled: Scalars['Boolean']['output'];
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
  readonly oldCreatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly oldID?: Maybe<Scalars['Int']['output']>;
  readonly oldUpdatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly updatedAt: Scalars['Int']['output'];
  readonly updatedByUUID: Scalars['ID']['output'];
}

/** A connection to a list of items. */
export interface ApiKeyConnection {
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<ApiKeyEdge>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface ApiKeyEdge {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<ApiKey>;
}

/** Ordering options for APIKey connections */
export interface ApiKeyOrder {
  /** The ordering direction. */
  readonly direction?: OrderDirection;
  /** The field by which to order APIKeys. */
  readonly field: ApiKeyOrderField;
}

/** Properties by which APIKey connections can be ordered. */
export const ApiKeyOrderField = {
  CreatedAt: 'CREATED_AT',
  Name: 'NAME',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type ApiKeyOrderField = typeof ApiKeyOrderField[keyof typeof ApiKeyOrderField];
/**
 * APIKeyWhereInput is used for filtering APIKey objects.
 * Input was generated by ent.
 */
export interface ApiKeyWhereInput {
  readonly and?: InputMaybe<ReadonlyArray<ApiKeyWhereInput>>;
  /** client_id field predicates */
  readonly clientID?: InputMaybe<Scalars['String']['input']>;
  readonly clientIDContains?: InputMaybe<Scalars['String']['input']>;
  readonly clientIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly clientIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly clientIDGT?: InputMaybe<Scalars['String']['input']>;
  readonly clientIDGTE?: InputMaybe<Scalars['String']['input']>;
  readonly clientIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly clientIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly clientIDIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly clientIDLT?: InputMaybe<Scalars['String']['input']>;
  readonly clientIDLTE?: InputMaybe<Scalars['String']['input']>;
  readonly clientIDNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly clientIDNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** created_at field predicates */
  readonly createdAt?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly createdAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** created_by_uuid field predicates */
  readonly createdByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly createdByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** disabled field predicates */
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** id field predicates */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly idGT?: InputMaybe<Scalars['ID']['input']>;
  readonly idGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly idLT?: InputMaybe<Scalars['ID']['input']>;
  readonly idLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly idNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** name field predicates */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly nameContains?: InputMaybe<Scalars['String']['input']>;
  readonly nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly nameGT?: InputMaybe<Scalars['String']['input']>;
  readonly nameGTE?: InputMaybe<Scalars['String']['input']>;
  readonly nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly nameIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly nameLT?: InputMaybe<Scalars['String']['input']>;
  readonly nameLTE?: InputMaybe<Scalars['String']['input']>;
  readonly nameNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly nameNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly not?: InputMaybe<ApiKeyWhereInput>;
  /** old_created_by_id field predicates */
  readonly oldCreatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldCreatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_id field predicates */
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDGT?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly oldIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldIDLT?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly oldIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_updated_by_id field predicates */
  readonly oldUpdatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldUpdatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly or?: InputMaybe<ReadonlyArray<ApiKeyWhereInput>>;
  /** updated_at field predicates */
  readonly updatedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly updatedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** updated_by_uuid field predicates */
  readonly updatedByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly updatedByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
}

export interface Account extends Node {
  readonly calls: CallConnection;
  readonly contacts?: Maybe<ReadonlyArray<Contact>>;
  readonly createdAt: Scalars['Int']['output'];
  readonly createdByUUID: Scalars['ID']['output'];
  readonly customFieldValues: CustomFieldValueConnection;
  readonly disabled: Scalars['Boolean']['output'];
  readonly documents: DocumentConnection;
  readonly externalIdentifier: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
  readonly oldCreatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly oldUpdatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly opportunities?: Maybe<ReadonlyArray<Opportunity>>;
  readonly sourcePlatform: CallIntegration;
  readonly tasks?: Maybe<ReadonlyArray<Task>>;
  readonly updatedAt: Scalars['Int']['output'];
  readonly updatedByUUID: Scalars['ID']['output'];
  /** Websites represents the websites of the account. It is not sanitized in anyway, as different platforms allow URLs vs domains, etc. */
  readonly websites?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
}


export interface AccountCallsArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CallOrder>;
  where?: InputMaybe<CallWhereInput>;
}


export interface AccountCustomFieldValuesArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CustomFieldValueOrder>;
  where?: InputMaybe<CustomFieldValueWhereInput>;
}


export interface AccountDocumentsArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<DocumentOrder>;
  where?: InputMaybe<DocumentWhereInput>;
}

/** A connection to a list of items. */
export interface AccountConnection {
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<AccountEdge>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface AccountEdge {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<Account>;
}

/** Ordering options for Account connections */
export interface AccountOrder {
  /** The ordering direction. */
  readonly direction?: OrderDirection;
  /** The field by which to order Accounts. */
  readonly field: AccountOrderField;
}

/** Properties by which Account connections can be ordered. */
export const AccountOrderField = {
  CreatedAt: 'CREATED_AT',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type AccountOrderField = typeof AccountOrderField[keyof typeof AccountOrderField];
/**
 * AccountWhereInput is used for filtering Account objects.
 * Input was generated by ent.
 */
export interface AccountWhereInput {
  readonly and?: InputMaybe<ReadonlyArray<AccountWhereInput>>;
  /** created_at field predicates */
  readonly createdAt?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly createdAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** created_by_uuid field predicates */
  readonly createdByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly createdByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** disabled field predicates */
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** external_identifier field predicates */
  readonly externalIdentifier?: InputMaybe<Scalars['String']['input']>;
  readonly externalIdentifierContains?: InputMaybe<Scalars['String']['input']>;
  readonly externalIdentifierContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly externalIdentifierEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly externalIdentifierGT?: InputMaybe<Scalars['String']['input']>;
  readonly externalIdentifierGTE?: InputMaybe<Scalars['String']['input']>;
  readonly externalIdentifierHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly externalIdentifierHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly externalIdentifierIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly externalIdentifierLT?: InputMaybe<Scalars['String']['input']>;
  readonly externalIdentifierLTE?: InputMaybe<Scalars['String']['input']>;
  readonly externalIdentifierNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly externalIdentifierNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** calls edge predicates */
  readonly hasCalls?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasCallsWith?: InputMaybe<ReadonlyArray<CallWhereInput>>;
  /** contacts edge predicates */
  readonly hasContacts?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasContactsWith?: InputMaybe<ReadonlyArray<ContactWhereInput>>;
  /** custom_field_values edge predicates */
  readonly hasCustomFieldValues?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasCustomFieldValuesWith?: InputMaybe<ReadonlyArray<CustomFieldValueWhereInput>>;
  /** documents edge predicates */
  readonly hasDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasDocumentsWith?: InputMaybe<ReadonlyArray<DocumentWhereInput>>;
  /** opportunities edge predicates */
  readonly hasOpportunities?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasOpportunitiesWith?: InputMaybe<ReadonlyArray<OpportunityWhereInput>>;
  /** tasks edge predicates */
  readonly hasTasks?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasTasksWith?: InputMaybe<ReadonlyArray<TaskWhereInput>>;
  /** id field predicates */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly idGT?: InputMaybe<Scalars['ID']['input']>;
  readonly idGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly idLT?: InputMaybe<Scalars['ID']['input']>;
  readonly idLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly idNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** name field predicates */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly nameContains?: InputMaybe<Scalars['String']['input']>;
  readonly nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly nameGT?: InputMaybe<Scalars['String']['input']>;
  readonly nameGTE?: InputMaybe<Scalars['String']['input']>;
  readonly nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly nameIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly nameLT?: InputMaybe<Scalars['String']['input']>;
  readonly nameLTE?: InputMaybe<Scalars['String']['input']>;
  readonly nameNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly nameNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly not?: InputMaybe<AccountWhereInput>;
  /** old_created_by_id field predicates */
  readonly oldCreatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldCreatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_updated_by_id field predicates */
  readonly oldUpdatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldUpdatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly or?: InputMaybe<ReadonlyArray<AccountWhereInput>>;
  /** source_platform field predicates */
  readonly sourcePlatform?: InputMaybe<CallIntegration>;
  readonly sourcePlatformIn?: InputMaybe<ReadonlyArray<CallIntegration>>;
  readonly sourcePlatformNEQ?: InputMaybe<CallIntegration>;
  readonly sourcePlatformNotIn?: InputMaybe<ReadonlyArray<CallIntegration>>;
  /** updated_at field predicates */
  readonly updatedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly updatedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** updated_by_uuid field predicates */
  readonly updatedByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly updatedByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
}

export interface AdhocEmailSend extends Node {
  readonly additionalNotes?: Maybe<Scalars['String']['output']>;
  readonly createdAt: Scalars['Int']['output'];
  readonly createdByUUID: Scalars['ID']['output'];
  readonly disabled: Scalars['Boolean']['output'];
  readonly emailSubscriptionConfig?: Maybe<EmailSubscriptionConfig>;
  readonly emailSubscriptionConfigUUID?: Maybe<Scalars['ID']['output']>;
  readonly enumerationValue: EnumerationValue;
  readonly enumerationValueUUID: Scalars['ID']['output'];
  readonly id: Scalars['ID']['output'];
  readonly oldCreatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly oldID?: Maybe<Scalars['Int']['output']>;
  readonly oldUpdatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly senderUser: User;
  readonly senderUserUUID: Scalars['ID']['output'];
  readonly toAddress: Scalars['String']['output'];
  readonly updatedAt: Scalars['Int']['output'];
  readonly updatedByUUID: Scalars['ID']['output'];
}

/** A connection to a list of items. */
export interface AdhocEmailSendConnection {
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<AdhocEmailSendEdge>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface AdhocEmailSendEdge {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<AdhocEmailSend>;
}

/** Ordering options for AdhocEmailSend connections */
export interface AdhocEmailSendOrder {
  /** The ordering direction. */
  readonly direction?: OrderDirection;
  /** The field by which to order AdhocEmailSends. */
  readonly field: AdhocEmailSendOrderField;
}

/** Properties by which AdhocEmailSend connections can be ordered. */
export const AdhocEmailSendOrderField = {
  CreatedAt: 'CREATED_AT',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type AdhocEmailSendOrderField = typeof AdhocEmailSendOrderField[keyof typeof AdhocEmailSendOrderField];
/**
 * AdhocEmailSendWhereInput is used for filtering AdhocEmailSend objects.
 * Input was generated by ent.
 */
export interface AdhocEmailSendWhereInput {
  /** additional_notes field predicates */
  readonly additionalNotes?: InputMaybe<Scalars['String']['input']>;
  readonly additionalNotesContains?: InputMaybe<Scalars['String']['input']>;
  readonly additionalNotesContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly additionalNotesEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly additionalNotesGT?: InputMaybe<Scalars['String']['input']>;
  readonly additionalNotesGTE?: InputMaybe<Scalars['String']['input']>;
  readonly additionalNotesHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly additionalNotesHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly additionalNotesIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly additionalNotesIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly additionalNotesLT?: InputMaybe<Scalars['String']['input']>;
  readonly additionalNotesLTE?: InputMaybe<Scalars['String']['input']>;
  readonly additionalNotesNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly additionalNotesNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly additionalNotesNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly and?: InputMaybe<ReadonlyArray<AdhocEmailSendWhereInput>>;
  /** created_at field predicates */
  readonly createdAt?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly createdAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** created_by_uuid field predicates */
  readonly createdByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly createdByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** disabled field predicates */
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** email_subscription_config_uuid field predicates */
  readonly emailSubscriptionConfigUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly emailSubscriptionConfigUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly emailSubscriptionConfigUUIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly emailSubscriptionConfigUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly emailSubscriptionConfigUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly emailSubscriptionConfigUUIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** enumeration_value_uuid field predicates */
  readonly enumerationValueUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly enumerationValueUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly enumerationValueUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly enumerationValueUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** email_subscription_config edge predicates */
  readonly hasEmailSubscriptionConfig?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasEmailSubscriptionConfigWith?: InputMaybe<ReadonlyArray<EmailSubscriptionConfigWhereInput>>;
  /** enumeration_value edge predicates */
  readonly hasEnumerationValue?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasEnumerationValueWith?: InputMaybe<ReadonlyArray<EnumerationValueWhereInput>>;
  /** sender_user edge predicates */
  readonly hasSenderUser?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasSenderUserWith?: InputMaybe<ReadonlyArray<UserWhereInput>>;
  /** id field predicates */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly idGT?: InputMaybe<Scalars['ID']['input']>;
  readonly idGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly idLT?: InputMaybe<Scalars['ID']['input']>;
  readonly idLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly idNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly not?: InputMaybe<AdhocEmailSendWhereInput>;
  /** old_created_by_id field predicates */
  readonly oldCreatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldCreatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_id field predicates */
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDGT?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly oldIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldIDLT?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly oldIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_updated_by_id field predicates */
  readonly oldUpdatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldUpdatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly or?: InputMaybe<ReadonlyArray<AdhocEmailSendWhereInput>>;
  /** sender_user_uuid field predicates */
  readonly senderUserUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly senderUserUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly senderUserUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly senderUserUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** to_address field predicates */
  readonly toAddress?: InputMaybe<Scalars['String']['input']>;
  readonly toAddressContains?: InputMaybe<Scalars['String']['input']>;
  readonly toAddressContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly toAddressEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly toAddressGT?: InputMaybe<Scalars['String']['input']>;
  readonly toAddressGTE?: InputMaybe<Scalars['String']['input']>;
  readonly toAddressHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly toAddressHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly toAddressIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly toAddressLT?: InputMaybe<Scalars['String']['input']>;
  readonly toAddressLTE?: InputMaybe<Scalars['String']['input']>;
  readonly toAddressNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly toAddressNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** updated_at field predicates */
  readonly updatedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly updatedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** updated_by_uuid field predicates */
  readonly updatedByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly updatedByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
}

export interface Attendee {
  readonly id: Scalars['SpeakerID']['output'];
  readonly internal: Scalars['Boolean']['output'];
  readonly name: Scalars['String']['output'];
  readonly title: Scalars['String']['output'];
  readonly userId?: Maybe<Scalars['CallUserID']['output']>;
}

export interface CrmDelivery extends Node {
  readonly createdAt: Scalars['Int']['output'];
  readonly crmSubscription: CrmSubscription;
  readonly crmSubscriptionUUID: Scalars['ID']['output'];
  readonly disabled: Scalars['Boolean']['output'];
  readonly enumerationValue?: Maybe<EnumerationValue>;
  readonly enumerationValueOutput?: Maybe<EnumerationValueOutput>;
  readonly enumerationValueOutputUUID?: Maybe<Scalars['ID']['output']>;
  readonly enumerationValueScore?: Maybe<EnumerationValueScore>;
  readonly enumerationValueScoreUUID?: Maybe<Scalars['ID']['output']>;
  readonly enumerationValueUUID?: Maybe<Scalars['ID']['output']>;
  readonly fieldName?: Maybe<Scalars['String']['output']>;
  readonly fieldValue?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly noteID?: Maybe<Scalars['String']['output']>;
  readonly objectID?: Maybe<Scalars['String']['output']>;
  readonly objectType?: Maybe<CrmDeliveryObjectType>;
  readonly oldID?: Maybe<Scalars['Int']['output']>;
  readonly updatedAt: Scalars['Int']['output'];
}

/** A connection to a list of items. */
export interface CrmDeliveryConnection {
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<CrmDeliveryEdge>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface CrmDeliveryEdge {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<CrmDelivery>;
}

/** CRMDeliveryObjectType is enum for the field object_type */
export const CrmDeliveryObjectType = {
  Call: 'CALL',
  Company: 'COMPANY',
  Contact: 'CONTACT',
  Deal: 'DEAL',
  Document: 'DOCUMENT',
  Email: 'EMAIL',
  Pipeline: 'PIPELINE',
  Unknown: 'UNKNOWN'
} as const;

export type CrmDeliveryObjectType = typeof CrmDeliveryObjectType[keyof typeof CrmDeliveryObjectType];
/** Ordering options for CRMDelivery connections */
export interface CrmDeliveryOrder {
  /** The ordering direction. */
  readonly direction?: OrderDirection;
  /** The field by which to order CRMDeliveries. */
  readonly field: CrmDeliveryOrderField;
}

/** Properties by which CRMDelivery connections can be ordered. */
export const CrmDeliveryOrderField = {
  CreatedAt: 'CREATED_AT',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type CrmDeliveryOrderField = typeof CrmDeliveryOrderField[keyof typeof CrmDeliveryOrderField];
/**
 * CRMDeliveryWhereInput is used for filtering CRMDelivery objects.
 * Input was generated by ent.
 */
export interface CrmDeliveryWhereInput {
  readonly and?: InputMaybe<ReadonlyArray<CrmDeliveryWhereInput>>;
  /** created_at field predicates */
  readonly createdAt?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly createdAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** crm_subscription_uuid field predicates */
  readonly crmSubscriptionUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly crmSubscriptionUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly crmSubscriptionUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly crmSubscriptionUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** disabled field predicates */
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** enumeration_value_output_uuid field predicates */
  readonly enumerationValueOutputUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly enumerationValueOutputUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly enumerationValueOutputUUIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly enumerationValueOutputUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly enumerationValueOutputUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly enumerationValueOutputUUIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** enumeration_value_score_uuid field predicates */
  readonly enumerationValueScoreUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly enumerationValueScoreUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly enumerationValueScoreUUIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly enumerationValueScoreUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly enumerationValueScoreUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly enumerationValueScoreUUIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** enumeration_value_uuid field predicates */
  readonly enumerationValueUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly enumerationValueUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly enumerationValueUUIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly enumerationValueUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly enumerationValueUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly enumerationValueUUIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** field_name field predicates */
  readonly fieldName?: InputMaybe<Scalars['String']['input']>;
  readonly fieldNameContains?: InputMaybe<Scalars['String']['input']>;
  readonly fieldNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly fieldNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly fieldNameGT?: InputMaybe<Scalars['String']['input']>;
  readonly fieldNameGTE?: InputMaybe<Scalars['String']['input']>;
  readonly fieldNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly fieldNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly fieldNameIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly fieldNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly fieldNameLT?: InputMaybe<Scalars['String']['input']>;
  readonly fieldNameLTE?: InputMaybe<Scalars['String']['input']>;
  readonly fieldNameNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly fieldNameNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly fieldNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** field_value field predicates */
  readonly fieldValue?: InputMaybe<Scalars['String']['input']>;
  readonly fieldValueContains?: InputMaybe<Scalars['String']['input']>;
  readonly fieldValueContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly fieldValueEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly fieldValueGT?: InputMaybe<Scalars['String']['input']>;
  readonly fieldValueGTE?: InputMaybe<Scalars['String']['input']>;
  readonly fieldValueHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly fieldValueHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly fieldValueIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly fieldValueIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly fieldValueLT?: InputMaybe<Scalars['String']['input']>;
  readonly fieldValueLTE?: InputMaybe<Scalars['String']['input']>;
  readonly fieldValueNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly fieldValueNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly fieldValueNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** crm_subscription edge predicates */
  readonly hasCrmSubscription?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasCrmSubscriptionWith?: InputMaybe<ReadonlyArray<CrmSubscriptionWhereInput>>;
  /** enumeration_value edge predicates */
  readonly hasEnumerationValue?: InputMaybe<Scalars['Boolean']['input']>;
  /** enumeration_value_output edge predicates */
  readonly hasEnumerationValueOutput?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasEnumerationValueOutputWith?: InputMaybe<ReadonlyArray<EnumerationValueOutputWhereInput>>;
  /** enumeration_value_score edge predicates */
  readonly hasEnumerationValueScore?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasEnumerationValueScoreWith?: InputMaybe<ReadonlyArray<EnumerationValueScoreWhereInput>>;
  readonly hasEnumerationValueWith?: InputMaybe<ReadonlyArray<EnumerationValueWhereInput>>;
  /** id field predicates */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly idGT?: InputMaybe<Scalars['ID']['input']>;
  readonly idGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly idLT?: InputMaybe<Scalars['ID']['input']>;
  readonly idLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly idNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly not?: InputMaybe<CrmDeliveryWhereInput>;
  /** note_id field predicates */
  readonly noteID?: InputMaybe<Scalars['String']['input']>;
  readonly noteIDContains?: InputMaybe<Scalars['String']['input']>;
  readonly noteIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly noteIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly noteIDGT?: InputMaybe<Scalars['String']['input']>;
  readonly noteIDGTE?: InputMaybe<Scalars['String']['input']>;
  readonly noteIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly noteIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly noteIDIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly noteIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly noteIDLT?: InputMaybe<Scalars['String']['input']>;
  readonly noteIDLTE?: InputMaybe<Scalars['String']['input']>;
  readonly noteIDNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly noteIDNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly noteIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** object_id field predicates */
  readonly objectID?: InputMaybe<Scalars['String']['input']>;
  readonly objectIDContains?: InputMaybe<Scalars['String']['input']>;
  readonly objectIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly objectIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly objectIDGT?: InputMaybe<Scalars['String']['input']>;
  readonly objectIDGTE?: InputMaybe<Scalars['String']['input']>;
  readonly objectIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly objectIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly objectIDIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly objectIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly objectIDLT?: InputMaybe<Scalars['String']['input']>;
  readonly objectIDLTE?: InputMaybe<Scalars['String']['input']>;
  readonly objectIDNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly objectIDNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly objectIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** object_type field predicates */
  readonly objectType?: InputMaybe<CrmDeliveryObjectType>;
  readonly objectTypeIn?: InputMaybe<ReadonlyArray<CrmDeliveryObjectType>>;
  readonly objectTypeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly objectTypeNEQ?: InputMaybe<CrmDeliveryObjectType>;
  readonly objectTypeNotIn?: InputMaybe<ReadonlyArray<CrmDeliveryObjectType>>;
  readonly objectTypeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_id field predicates */
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDGT?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly oldIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldIDLT?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly oldIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly or?: InputMaybe<ReadonlyArray<CrmDeliveryWhereInput>>;
  /** updated_at field predicates */
  readonly updatedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly updatedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
}

export interface CrmSubscription extends Node {
  /** ConvertMarkdown indicates that the content should be converted from markdown to HTML before being pushed to the CRM system. */
  readonly convertMarkdown: Scalars['Boolean']['output'];
  readonly createdAt: Scalars['Int']['output'];
  readonly createdByUUID: Scalars['ID']['output'];
  readonly disabled: Scalars['Boolean']['output'];
  readonly enumType: CrmSubscriptionValueType;
  readonly enumerationField?: Maybe<EnumerationField>;
  readonly enumerationFieldUUID?: Maybe<Scalars['ID']['output']>;
  /** FieldName is the name of the field in the CRM system. If not set, the data will be pushed as a note */
  readonly fieldName?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly integrationSecret: IntegrationSecret;
  readonly integrationSecretUUID: Scalars['ID']['output'];
  readonly objectType: CrmSubscriptionObjectType;
  readonly oldCreatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly oldID?: Maybe<Scalars['Int']['output']>;
  readonly oldUpdatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly updatedAt: Scalars['Int']['output'];
  readonly updatedByUUID: Scalars['ID']['output'];
}

/** A connection to a list of items. */
export interface CrmSubscriptionConnection {
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<CrmSubscriptionEdge>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface CrmSubscriptionEdge {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<CrmSubscription>;
}

/** CRMSubscriptionObjectType is enum for the field object_type */
export const CrmSubscriptionObjectType = {
  Call: 'CALL',
  Company: 'COMPANY',
  Contact: 'CONTACT',
  Deal: 'DEAL',
  Document: 'DOCUMENT',
  Email: 'EMAIL',
  Pipeline: 'PIPELINE',
  Unknown: 'UNKNOWN'
} as const;

export type CrmSubscriptionObjectType = typeof CrmSubscriptionObjectType[keyof typeof CrmSubscriptionObjectType];
/** Ordering options for CRMSubscription connections */
export interface CrmSubscriptionOrder {
  /** The ordering direction. */
  readonly direction?: OrderDirection;
  /** The field by which to order CRMSubscriptions. */
  readonly field: CrmSubscriptionOrderField;
}

/** Properties by which CRMSubscription connections can be ordered. */
export const CrmSubscriptionOrderField = {
  CreatedAt: 'CREATED_AT',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type CrmSubscriptionOrderField = typeof CrmSubscriptionOrderField[keyof typeof CrmSubscriptionOrderField];
/** CRMSubscriptionValueType is enum for the field enum_type */
export const CrmSubscriptionValueType = {
  AdQuickResponse: 'AD_QUICK_RESPONSE',
  AirbyteResponse: 'AIRBYTE_RESPONSE',
  AirbyteSdrSummaries: 'AIRBYTE_SDR_SUMMARIES',
  BantAuthority: 'BANT_AUTHORITY',
  BantBudget: 'BANT_BUDGET',
  BantNeed: 'BANT_NEED',
  BantTiming: 'BANT_TIMING',
  BruntworkInterviewSummary: 'BRUNTWORK_INTERVIEW_SUMMARY',
  BruntworkSummary: 'BRUNTWORK_SUMMARY',
  CompetitorMentions: 'COMPETITOR_MENTIONS',
  CustomerConcerns: 'CUSTOMER_CONCERNS',
  CustomerWins: 'CUSTOMER_WINS',
  DataSources: 'DATA_SOURCES',
  DealType: 'DEAL_TYPE',
  DiscoveryCue: 'DISCOVERY_CUE',
  DiscoveryResponse: 'DISCOVERY_RESPONSE',
  FabiusResponse: 'FABIUS_RESPONSE',
  FermatResponse: 'FERMAT_RESPONSE',
  Invalid: 'INVALID',
  MeddpiccChampion: 'MEDDPICC_CHAMPION',
  MeddpiccCompetition: 'MEDDPICC_COMPETITION',
  MeddpiccDecisionCriteria: 'MEDDPICC_DECISION_CRITERIA',
  MeddpiccDecisionProcess: 'MEDDPICC_DECISION_PROCESS',
  MeddpiccEconomicBuyer: 'MEDDPICC_ECONOMIC_BUYER',
  MeddpiccImplicatedPain: 'MEDDPICC_IMPLICATED_PAIN',
  MeddpiccMetrics: 'MEDDPICC_METRICS',
  MeddpiccPaperProcess: 'MEDDPICC_PAPER_PROCESS',
  MozartResponse: 'MOZART_RESPONSE',
  ObjectionHandling: 'OBJECTION_HANDLING',
  OneSchemaResponse: 'ONE_SCHEMA_RESPONSE',
  OrbSummary: 'ORB_SUMMARY',
  ParadeSummary: 'PARADE_SUMMARY',
  PaveAtRiskCall: 'PAVE_AT_RISK_CALL',
  PaveResponse: 'PAVE_RESPONSE',
  PostSales: 'POST_SALES',
  PreSales: 'PRE_SALES',
  ProductGaps: 'PRODUCT_GAPS',
  Qualification: 'QUALIFICATION',
  QuestionsAndAnswers: 'QUESTIONS_AND_ANSWERS',
  ReloSummary: 'RELO_SUMMARY',
  ReshapeSummary: 'RESHAPE_SUMMARY',
  Urgency: 'URGENCY',
  UxCamResponse: 'UX_CAM_RESPONSE',
  WinLosses: 'WIN_LOSSES'
} as const;

export type CrmSubscriptionValueType = typeof CrmSubscriptionValueType[keyof typeof CrmSubscriptionValueType];
/**
 * CRMSubscriptionWhereInput is used for filtering CRMSubscription objects.
 * Input was generated by ent.
 */
export interface CrmSubscriptionWhereInput {
  readonly and?: InputMaybe<ReadonlyArray<CrmSubscriptionWhereInput>>;
  /** convert_markdown field predicates */
  readonly convertMarkdown?: InputMaybe<Scalars['Boolean']['input']>;
  readonly convertMarkdownNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  readonly createdAt?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly createdAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** created_by_uuid field predicates */
  readonly createdByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly createdByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** disabled field predicates */
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** enum_type field predicates */
  readonly enumType?: InputMaybe<CrmSubscriptionValueType>;
  readonly enumTypeIn?: InputMaybe<ReadonlyArray<CrmSubscriptionValueType>>;
  readonly enumTypeNEQ?: InputMaybe<CrmSubscriptionValueType>;
  readonly enumTypeNotIn?: InputMaybe<ReadonlyArray<CrmSubscriptionValueType>>;
  /** enumeration_field_uuid field predicates */
  readonly enumerationFieldUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly enumerationFieldUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly enumerationFieldUUIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly enumerationFieldUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly enumerationFieldUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly enumerationFieldUUIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** field_name field predicates */
  readonly fieldName?: InputMaybe<Scalars['String']['input']>;
  readonly fieldNameContains?: InputMaybe<Scalars['String']['input']>;
  readonly fieldNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly fieldNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly fieldNameGT?: InputMaybe<Scalars['String']['input']>;
  readonly fieldNameGTE?: InputMaybe<Scalars['String']['input']>;
  readonly fieldNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly fieldNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly fieldNameIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly fieldNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly fieldNameLT?: InputMaybe<Scalars['String']['input']>;
  readonly fieldNameLTE?: InputMaybe<Scalars['String']['input']>;
  readonly fieldNameNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly fieldNameNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly fieldNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** enumeration_field edge predicates */
  readonly hasEnumerationField?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasEnumerationFieldWith?: InputMaybe<ReadonlyArray<EnumerationFieldWhereInput>>;
  /** integration_secret edge predicates */
  readonly hasIntegrationSecret?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasIntegrationSecretWith?: InputMaybe<ReadonlyArray<IntegrationSecretWhereInput>>;
  /** id field predicates */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly idGT?: InputMaybe<Scalars['ID']['input']>;
  readonly idGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly idLT?: InputMaybe<Scalars['ID']['input']>;
  readonly idLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly idNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** integration_secret_uuid field predicates */
  readonly integrationSecretUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly integrationSecretUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly integrationSecretUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly integrationSecretUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly not?: InputMaybe<CrmSubscriptionWhereInput>;
  /** object_type field predicates */
  readonly objectType?: InputMaybe<CrmSubscriptionObjectType>;
  readonly objectTypeIn?: InputMaybe<ReadonlyArray<CrmSubscriptionObjectType>>;
  readonly objectTypeNEQ?: InputMaybe<CrmSubscriptionObjectType>;
  readonly objectTypeNotIn?: InputMaybe<ReadonlyArray<CrmSubscriptionObjectType>>;
  /** old_created_by_id field predicates */
  readonly oldCreatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldCreatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_id field predicates */
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDGT?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly oldIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldIDLT?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly oldIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_updated_by_id field predicates */
  readonly oldUpdatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldUpdatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly or?: InputMaybe<ReadonlyArray<CrmSubscriptionWhereInput>>;
  /** updated_at field predicates */
  readonly updatedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly updatedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** updated_by_uuid field predicates */
  readonly updatedByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly updatedByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
}

export interface Call extends Node {
  readonly account?: Maybe<Account>;
  readonly accountUUID?: Maybe<Scalars['ID']['output']>;
  readonly attendees: ReadonlyArray<Maybe<Attendee>>;
  readonly callHost: Scalars['String']['output'];
  readonly contact?: Maybe<Contact>;
  readonly contactUUID?: Maybe<Scalars['ID']['output']>;
  readonly createdAt: Scalars['Int']['output'];
  readonly customFieldValues: CustomFieldValueConnection;
  /** Direction of the call (Inbound, Outbound, Conference, Unknown). */
  readonly direction: CallDirection;
  readonly disabled: Scalars['Boolean']['output'];
  readonly disposition?: Maybe<Scalars['String']['output']>;
  readonly duration: Scalars['Int']['output'];
  readonly enumerationValues: EnumerationValueConnection;
  readonly externalCallID: Scalars['CallID']['output'];
  /** ExternalMeetingRoomId is an ID used to link this call to an external system, like a Zoom Meeting Room. */
  readonly externalMeetingRoomID?: Maybe<Scalars['String']['output']>;
  /** ExternalMeetingRoomPlatform is where the actual call recording / transcript was ingested from. */
  readonly externalMeetingRoomPlatform?: Maybe<CallCallIntegration>;
  readonly gongUser?: Maybe<GongUser>;
  readonly id: Scalars['ID']['output'];
  readonly legacyPrimaryUserID?: Maybe<Scalars['OldID']['output']>;
  readonly link: Scalars['String']['output'];
  /** Metadata is arbitrary keys and values related to the call. */
  readonly metadata?: Maybe<Scalars['Metadata']['output']>;
  readonly opportunities: OpportunityConnection;
  readonly opportunityCallLinks: OpportunityCallLinkConnection;
  readonly opportunitySize?: Maybe<Scalars['Int']['output']>;
  readonly opportunityStage?: Maybe<Scalars['String']['output']>;
  readonly primaryUserUUID?: Maybe<Scalars['ID']['output']>;
  readonly purpose?: Maybe<Scalars['String']['output']>;
  readonly scheduled: Scalars['Unix']['output'];
  /**
   * SourcePlatform is the platform from which the call was ingested. It is generally a CRM or similar platform
   * and is where we will later look up associations for the call during enrichment.
   */
  readonly sourcePlatform?: Maybe<CallIntegration>;
  readonly started: Scalars['Unix']['output'];
  readonly title: Scalars['String']['output'];
  readonly updatedAt: Scalars['Int']['output'];
}


export interface CallCustomFieldValuesArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CustomFieldValueOrder>;
  where?: InputMaybe<CustomFieldValueWhereInput>;
}


export interface CallEnumerationValuesArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EnumerationValueOrder>;
  where?: InputMaybe<EnumerationValueWhereInput>;
}


export interface CallOpportunitiesArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OpportunityOrder>;
  where?: InputMaybe<OpportunityWhereInput>;
}


export interface CallOpportunityCallLinksArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OpportunityCallLinkOrder>;
  where?: InputMaybe<OpportunityCallLinkWhereInput>;
}

/** CallCallIntegration is enum for the field external_meeting_room_platform */
export const CallCallIntegration = {
  Apollo: 'APOLLO',
  Freshcaller: 'FRESHCALLER',
  Freshdesk: 'FRESHDESK',
  Gmail: 'GMAIL',
  Gohighlevel: 'GOHIGHLEVEL',
  Gong: 'GONG',
  GongOauth: 'GONG_OAUTH',
  GoogleCalendar: 'GOOGLE_CALENDAR',
  GoogleMeet: 'GOOGLE_MEET',
  Hubspot: 'HUBSPOT',
  Justcall: 'JUSTCALL',
  Outreach: 'OUTREACH',
  Pipedrive: 'PIPEDRIVE',
  ProductBoard: 'PRODUCT_BOARD',
  Salesloft: 'SALESLOFT',
  Sfdc: 'SFDC',
  Slack: 'SLACK',
  UnknownIntegration: 'UNKNOWN_INTEGRATION',
  Volie: 'VOLIE',
  Wingman: 'WINGMAN',
  Zoho: 'ZOHO',
  Zoom: 'ZOOM'
} as const;

export type CallCallIntegration = typeof CallCallIntegration[keyof typeof CallCallIntegration];
/** A connection to a list of items. */
export interface CallConnection {
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<CallEdge>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
}

export const CallDirection = {
  Conference: 'Conference',
  Inbound: 'Inbound',
  Outbound: 'Outbound',
  Unknown: 'Unknown'
} as const;

export type CallDirection = typeof CallDirection[keyof typeof CallDirection];
/** An edge in a connection. */
export interface CallEdge {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<Call>;
}

/** CallIntegration is enum for the field source_platform */
export const CallIntegration = {
  Apollo: 'APOLLO',
  Freshcaller: 'FRESHCALLER',
  Freshdesk: 'FRESHDESK',
  Gmail: 'GMAIL',
  Gohighlevel: 'GOHIGHLEVEL',
  Gong: 'GONG',
  GongOauth: 'GONG_OAUTH',
  GoogleCalendar: 'GOOGLE_CALENDAR',
  GoogleMeet: 'GOOGLE_MEET',
  Hubspot: 'HUBSPOT',
  Justcall: 'JUSTCALL',
  Outreach: 'OUTREACH',
  Pipedrive: 'PIPEDRIVE',
  ProductBoard: 'PRODUCT_BOARD',
  Salesloft: 'SALESLOFT',
  Sfdc: 'SFDC',
  Slack: 'SLACK',
  UnknownIntegration: 'UNKNOWN_INTEGRATION',
  Volie: 'VOLIE',
  Wingman: 'WINGMAN',
  Zoho: 'ZOHO',
  Zoom: 'ZOOM'
} as const;

export type CallIntegration = typeof CallIntegration[keyof typeof CallIntegration];
/** Ordering options for Call connections */
export interface CallOrder {
  /** The ordering direction. */
  readonly direction?: OrderDirection;
  /** The field by which to order Calls. */
  readonly field: CallOrderField;
}

/** Properties by which Call connections can be ordered. */
export const CallOrderField = {
  CreatedAt: 'CREATED_AT',
  Duration: 'DURATION',
  Link: 'LINK',
  Scheduled: 'SCHEDULED',
  Started: 'STARTED',
  Title: 'TITLE',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type CallOrderField = typeof CallOrderField[keyof typeof CallOrderField];
/**
 * CallWhereInput is used for filtering Call objects.
 * Input was generated by ent.
 */
export interface CallWhereInput {
  /** account_uuid field predicates */
  readonly accountUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly accountUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly accountUUIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly accountUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly accountUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly accountUUIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly and?: InputMaybe<ReadonlyArray<CallWhereInput>>;
  /** call_host field predicates */
  readonly callHost?: InputMaybe<Scalars['String']['input']>;
  readonly callHostContains?: InputMaybe<Scalars['String']['input']>;
  readonly callHostContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly callHostEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly callHostGT?: InputMaybe<Scalars['String']['input']>;
  readonly callHostGTE?: InputMaybe<Scalars['String']['input']>;
  readonly callHostHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly callHostHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly callHostIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly callHostLT?: InputMaybe<Scalars['String']['input']>;
  readonly callHostLTE?: InputMaybe<Scalars['String']['input']>;
  readonly callHostNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly callHostNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** contact_uuid field predicates */
  readonly contactUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly contactUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly contactUUIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly contactUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly contactUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly contactUUIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  readonly createdAt?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly createdAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** direction field predicates */
  readonly direction?: InputMaybe<CallDirection>;
  readonly directionContains?: InputMaybe<CallDirection>;
  readonly directionContainsFold?: InputMaybe<CallDirection>;
  readonly directionEqualFold?: InputMaybe<CallDirection>;
  readonly directionGT?: InputMaybe<CallDirection>;
  readonly directionGTE?: InputMaybe<CallDirection>;
  readonly directionHasPrefix?: InputMaybe<CallDirection>;
  readonly directionHasSuffix?: InputMaybe<CallDirection>;
  readonly directionIn?: InputMaybe<ReadonlyArray<CallDirection>>;
  readonly directionLT?: InputMaybe<CallDirection>;
  readonly directionLTE?: InputMaybe<CallDirection>;
  readonly directionNEQ?: InputMaybe<CallDirection>;
  readonly directionNotIn?: InputMaybe<ReadonlyArray<CallDirection>>;
  /** disabled field predicates */
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** disposition field predicates */
  readonly disposition?: InputMaybe<Scalars['String']['input']>;
  readonly dispositionContains?: InputMaybe<Scalars['String']['input']>;
  readonly dispositionContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly dispositionEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly dispositionGT?: InputMaybe<Scalars['String']['input']>;
  readonly dispositionGTE?: InputMaybe<Scalars['String']['input']>;
  readonly dispositionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly dispositionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly dispositionIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly dispositionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly dispositionLT?: InputMaybe<Scalars['String']['input']>;
  readonly dispositionLTE?: InputMaybe<Scalars['String']['input']>;
  readonly dispositionNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly dispositionNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly dispositionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** duration field predicates */
  readonly duration?: InputMaybe<Scalars['Int']['input']>;
  readonly durationGT?: InputMaybe<Scalars['Int']['input']>;
  readonly durationGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly durationIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly durationLT?: InputMaybe<Scalars['Int']['input']>;
  readonly durationLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly durationNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly durationNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** external_call_id field predicates */
  readonly externalCallID?: InputMaybe<Scalars['CallID']['input']>;
  readonly externalCallIDContains?: InputMaybe<Scalars['CallID']['input']>;
  readonly externalCallIDContainsFold?: InputMaybe<Scalars['CallID']['input']>;
  readonly externalCallIDEqualFold?: InputMaybe<Scalars['CallID']['input']>;
  readonly externalCallIDGT?: InputMaybe<Scalars['CallID']['input']>;
  readonly externalCallIDGTE?: InputMaybe<Scalars['CallID']['input']>;
  readonly externalCallIDHasPrefix?: InputMaybe<Scalars['CallID']['input']>;
  readonly externalCallIDHasSuffix?: InputMaybe<Scalars['CallID']['input']>;
  readonly externalCallIDIn?: InputMaybe<ReadonlyArray<Scalars['CallID']['input']>>;
  readonly externalCallIDLT?: InputMaybe<Scalars['CallID']['input']>;
  readonly externalCallIDLTE?: InputMaybe<Scalars['CallID']['input']>;
  readonly externalCallIDNEQ?: InputMaybe<Scalars['CallID']['input']>;
  readonly externalCallIDNotIn?: InputMaybe<ReadonlyArray<Scalars['CallID']['input']>>;
  /** external_meeting_room_id field predicates */
  readonly externalMeetingRoomID?: InputMaybe<Scalars['String']['input']>;
  readonly externalMeetingRoomIDContains?: InputMaybe<Scalars['String']['input']>;
  readonly externalMeetingRoomIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly externalMeetingRoomIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly externalMeetingRoomIDGT?: InputMaybe<Scalars['String']['input']>;
  readonly externalMeetingRoomIDGTE?: InputMaybe<Scalars['String']['input']>;
  readonly externalMeetingRoomIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly externalMeetingRoomIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly externalMeetingRoomIDIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly externalMeetingRoomIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly externalMeetingRoomIDLT?: InputMaybe<Scalars['String']['input']>;
  readonly externalMeetingRoomIDLTE?: InputMaybe<Scalars['String']['input']>;
  readonly externalMeetingRoomIDNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly externalMeetingRoomIDNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly externalMeetingRoomIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** external_meeting_room_platform field predicates */
  readonly externalMeetingRoomPlatform?: InputMaybe<CallCallIntegration>;
  readonly externalMeetingRoomPlatformIn?: InputMaybe<ReadonlyArray<CallCallIntegration>>;
  readonly externalMeetingRoomPlatformIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly externalMeetingRoomPlatformNEQ?: InputMaybe<CallCallIntegration>;
  readonly externalMeetingRoomPlatformNotIn?: InputMaybe<ReadonlyArray<CallCallIntegration>>;
  readonly externalMeetingRoomPlatformNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** account edge predicates */
  readonly hasAccount?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasAccountWith?: InputMaybe<ReadonlyArray<AccountWhereInput>>;
  /** contact edge predicates */
  readonly hasContact?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasContactWith?: InputMaybe<ReadonlyArray<ContactWhereInput>>;
  /** custom_field_values edge predicates */
  readonly hasCustomFieldValues?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasCustomFieldValuesWith?: InputMaybe<ReadonlyArray<CustomFieldValueWhereInput>>;
  /** enumeration_values edge predicates */
  readonly hasEnumerationValues?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasEnumerationValuesWith?: InputMaybe<ReadonlyArray<EnumerationValueWhereInput>>;
  /** gong_user edge predicates */
  readonly hasGongUser?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasGongUserWith?: InputMaybe<ReadonlyArray<GongUserWhereInput>>;
  /** opportunities edge predicates */
  readonly hasOpportunities?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasOpportunitiesWith?: InputMaybe<ReadonlyArray<OpportunityWhereInput>>;
  /** opportunity_call_links edge predicates */
  readonly hasOpportunityCallLinks?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasOpportunityCallLinksWith?: InputMaybe<ReadonlyArray<OpportunityCallLinkWhereInput>>;
  /** id field predicates */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly idGT?: InputMaybe<Scalars['ID']['input']>;
  readonly idGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly idLT?: InputMaybe<Scalars['ID']['input']>;
  readonly idLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly idNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** legacy_primary_user_id field predicates */
  readonly legacyPrimaryUserID?: InputMaybe<Scalars['OldID']['input']>;
  readonly legacyPrimaryUserIDContains?: InputMaybe<Scalars['OldID']['input']>;
  readonly legacyPrimaryUserIDContainsFold?: InputMaybe<Scalars['OldID']['input']>;
  readonly legacyPrimaryUserIDEqualFold?: InputMaybe<Scalars['OldID']['input']>;
  readonly legacyPrimaryUserIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly legacyPrimaryUserIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly legacyPrimaryUserIDHasPrefix?: InputMaybe<Scalars['OldID']['input']>;
  readonly legacyPrimaryUserIDHasSuffix?: InputMaybe<Scalars['OldID']['input']>;
  readonly legacyPrimaryUserIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly legacyPrimaryUserIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly legacyPrimaryUserIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly legacyPrimaryUserIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly legacyPrimaryUserIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly legacyPrimaryUserIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly legacyPrimaryUserIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** link field predicates */
  readonly link?: InputMaybe<Scalars['String']['input']>;
  readonly linkContains?: InputMaybe<Scalars['String']['input']>;
  readonly linkContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly linkEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly linkGT?: InputMaybe<Scalars['String']['input']>;
  readonly linkGTE?: InputMaybe<Scalars['String']['input']>;
  readonly linkHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly linkHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly linkIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly linkLT?: InputMaybe<Scalars['String']['input']>;
  readonly linkLTE?: InputMaybe<Scalars['String']['input']>;
  readonly linkNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly linkNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly not?: InputMaybe<CallWhereInput>;
  /** opportunity_size field predicates */
  readonly opportunitySize?: InputMaybe<Scalars['Int']['input']>;
  readonly opportunitySizeGT?: InputMaybe<Scalars['Int']['input']>;
  readonly opportunitySizeGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly opportunitySizeIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly opportunitySizeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly opportunitySizeLT?: InputMaybe<Scalars['Int']['input']>;
  readonly opportunitySizeLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly opportunitySizeNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly opportunitySizeNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly opportunitySizeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** opportunity_stage field predicates */
  readonly opportunityStage?: InputMaybe<Scalars['String']['input']>;
  readonly opportunityStageContains?: InputMaybe<Scalars['String']['input']>;
  readonly opportunityStageContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly opportunityStageEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly opportunityStageGT?: InputMaybe<Scalars['String']['input']>;
  readonly opportunityStageGTE?: InputMaybe<Scalars['String']['input']>;
  readonly opportunityStageHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly opportunityStageHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly opportunityStageIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly opportunityStageIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly opportunityStageLT?: InputMaybe<Scalars['String']['input']>;
  readonly opportunityStageLTE?: InputMaybe<Scalars['String']['input']>;
  readonly opportunityStageNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly opportunityStageNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly opportunityStageNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly or?: InputMaybe<ReadonlyArray<CallWhereInput>>;
  /** primary_user_uuid field predicates */
  readonly primaryUserUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly primaryUserUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly primaryUserUUIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly primaryUserUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly primaryUserUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly primaryUserUUIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** purpose field predicates */
  readonly purpose?: InputMaybe<Scalars['String']['input']>;
  readonly purposeContains?: InputMaybe<Scalars['String']['input']>;
  readonly purposeContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly purposeEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly purposeGT?: InputMaybe<Scalars['String']['input']>;
  readonly purposeGTE?: InputMaybe<Scalars['String']['input']>;
  readonly purposeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly purposeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly purposeIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly purposeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly purposeLT?: InputMaybe<Scalars['String']['input']>;
  readonly purposeLTE?: InputMaybe<Scalars['String']['input']>;
  readonly purposeNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly purposeNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly purposeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** scheduled field predicates */
  readonly scheduled?: InputMaybe<Scalars['Unix']['input']>;
  readonly scheduledGT?: InputMaybe<Scalars['Unix']['input']>;
  readonly scheduledGTE?: InputMaybe<Scalars['Unix']['input']>;
  readonly scheduledIn?: InputMaybe<ReadonlyArray<Scalars['Unix']['input']>>;
  readonly scheduledLT?: InputMaybe<Scalars['Unix']['input']>;
  readonly scheduledLTE?: InputMaybe<Scalars['Unix']['input']>;
  readonly scheduledNEQ?: InputMaybe<Scalars['Unix']['input']>;
  readonly scheduledNotIn?: InputMaybe<ReadonlyArray<Scalars['Unix']['input']>>;
  /** source_platform field predicates */
  readonly sourcePlatform?: InputMaybe<CallIntegration>;
  readonly sourcePlatformIn?: InputMaybe<ReadonlyArray<CallIntegration>>;
  readonly sourcePlatformIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly sourcePlatformNEQ?: InputMaybe<CallIntegration>;
  readonly sourcePlatformNotIn?: InputMaybe<ReadonlyArray<CallIntegration>>;
  readonly sourcePlatformNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** started field predicates */
  readonly started?: InputMaybe<Scalars['Unix']['input']>;
  readonly startedGT?: InputMaybe<Scalars['Unix']['input']>;
  readonly startedGTE?: InputMaybe<Scalars['Unix']['input']>;
  readonly startedIn?: InputMaybe<ReadonlyArray<Scalars['Unix']['input']>>;
  readonly startedLT?: InputMaybe<Scalars['Unix']['input']>;
  readonly startedLTE?: InputMaybe<Scalars['Unix']['input']>;
  readonly startedNEQ?: InputMaybe<Scalars['Unix']['input']>;
  readonly startedNotIn?: InputMaybe<ReadonlyArray<Scalars['Unix']['input']>>;
  /** title field predicates */
  readonly title?: InputMaybe<Scalars['String']['input']>;
  readonly titleContains?: InputMaybe<Scalars['String']['input']>;
  readonly titleContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly titleEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly titleGT?: InputMaybe<Scalars['String']['input']>;
  readonly titleGTE?: InputMaybe<Scalars['String']['input']>;
  readonly titleHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly titleHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly titleIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly titleLT?: InputMaybe<Scalars['String']['input']>;
  readonly titleLTE?: InputMaybe<Scalars['String']['input']>;
  readonly titleNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly titleNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** updated_at field predicates */
  readonly updatedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly updatedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
}

export interface Classifier extends Node {
  readonly active: Scalars['Boolean']['output'];
  /** Indicates whether the classifier assigns a single enum value or multiple enum values to an event */
  readonly classificationType: ClassifierType;
  readonly classifierEnumValues: ClassifierEnumValueConnection;
  readonly classifierExamples: ClassifierExampleConnection;
  readonly classifierResults: ClassifierResultConnection;
  readonly createdAt: Scalars['Int']['output'];
  readonly createdByUUID: Scalars['ID']['output'];
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly disabled: Scalars['Boolean']['output'];
  readonly id: Scalars['ID']['output'];
  /** Specifies the LLM model to use; defaults to standard model if not provided */
  readonly model?: Maybe<Scalars['String']['output']>;
  readonly name: Scalars['String']['output'];
  readonly oldCreatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly oldID?: Maybe<Scalars['Int']['output']>;
  readonly oldUpdatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly updatedAt: Scalars['Int']['output'];
  readonly updatedByUUID: Scalars['ID']['output'];
}


export interface ClassifierClassifierEnumValuesArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ClassifierEnumValueOrder>;
  where?: InputMaybe<ClassifierEnumValueWhereInput>;
}


export interface ClassifierClassifierExamplesArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ClassifierExampleOrder>;
  where?: InputMaybe<ClassifierExampleWhereInput>;
}


export interface ClassifierClassifierResultsArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ClassifierResultOrder>;
  where?: InputMaybe<ClassifierResultWhereInput>;
}

export interface ClassifierCondition extends Node {
  readonly classifierEnumValue: ClassifierEnumValue;
  /** Reference to the associated ClassifierEnumValue. */
  readonly classifierEnumValueUUID: Scalars['ID']['output'];
  readonly createdAt: Scalars['Int']['output'];
  readonly createdByUUID: Scalars['ID']['output'];
  /** Definitions represent the contextual definition that the model needs in order to be able to best do it's job, so that there isn't ambiguity about the terms using in the instructions/directions or whether the calls/documents themselves. This is often left blank if there isn't much chance of confusion. If the type of the value or score is non-custom, then adding to this will append the text after the standard definitions for that field. */
  readonly definitions?: Maybe<Scalars['String']['output']>;
  /** Directions are the specific steps or detailed context that the model needs to take in order to complete the analysis. This is generally more detailed than the instructions and is often used to break down the instructions into more digestible steps or talk through edge cases. If the type of the value or score is non-custom, then adding to this will append the text after the standard directions for that field. */
  readonly directions?: Maybe<Scalars['String']['output']>;
  readonly disabled: Scalars['Boolean']['output'];
  readonly enumerationConfigFieldLink: EnumerationConfigFieldLink;
  /** Reference to the associated EnumerationConfigFieldLink. */
  readonly enumerationConfigFieldLinkUUID: Scalars['ID']['output'];
  readonly id: Scalars['ID']['output'];
  /** Instructions represents the main description of the task that the model needs to do to complete the analysis. For normal fields, this generally describes how to analyze the call/document. For scores, this is the rubric that outlines exactly how to score the rep on the call. If the type of the value or score is non-custom, then adding to this will append the text after the standard instructions for that field. */
  readonly instructions?: Maybe<Scalars['String']['output']>;
  /** Knowledge documents associated with this classifier condition. */
  readonly knowledgeDocumentPromptInstructions?: Maybe<ReadonlyArray<KnowledgeDocumentPromptInstruction>>;
  readonly oldCreatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly oldUpdatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly updatedAt: Scalars['Int']['output'];
  readonly updatedByUUID: Scalars['ID']['output'];
}

/** A connection to a list of items. */
export interface ClassifierConditionConnection {
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<ClassifierConditionEdge>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface ClassifierConditionEdge {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<ClassifierCondition>;
}

/** Ordering options for ClassifierCondition connections */
export interface ClassifierConditionOrder {
  /** The ordering direction. */
  readonly direction?: OrderDirection;
  /** The field by which to order ClassifierConditions. */
  readonly field: ClassifierConditionOrderField;
}

/** Properties by which ClassifierCondition connections can be ordered. */
export const ClassifierConditionOrderField = {
  CreatedAt: 'CREATED_AT',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type ClassifierConditionOrderField = typeof ClassifierConditionOrderField[keyof typeof ClassifierConditionOrderField];
/**
 * ClassifierConditionWhereInput is used for filtering ClassifierCondition objects.
 * Input was generated by ent.
 */
export interface ClassifierConditionWhereInput {
  readonly and?: InputMaybe<ReadonlyArray<ClassifierConditionWhereInput>>;
  /** classifier_enum_value_uuid field predicates */
  readonly classifierEnumValueUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly classifierEnumValueUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly classifierEnumValueUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly classifierEnumValueUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** created_at field predicates */
  readonly createdAt?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly createdAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** created_by_uuid field predicates */
  readonly createdByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly createdByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** definitions field predicates */
  readonly definitions?: InputMaybe<Scalars['String']['input']>;
  readonly definitionsContains?: InputMaybe<Scalars['String']['input']>;
  readonly definitionsContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly definitionsEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly definitionsGT?: InputMaybe<Scalars['String']['input']>;
  readonly definitionsGTE?: InputMaybe<Scalars['String']['input']>;
  readonly definitionsHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly definitionsHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly definitionsIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly definitionsIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly definitionsLT?: InputMaybe<Scalars['String']['input']>;
  readonly definitionsLTE?: InputMaybe<Scalars['String']['input']>;
  readonly definitionsNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly definitionsNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly definitionsNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** directions field predicates */
  readonly directions?: InputMaybe<Scalars['String']['input']>;
  readonly directionsContains?: InputMaybe<Scalars['String']['input']>;
  readonly directionsContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly directionsEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly directionsGT?: InputMaybe<Scalars['String']['input']>;
  readonly directionsGTE?: InputMaybe<Scalars['String']['input']>;
  readonly directionsHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly directionsHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly directionsIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly directionsIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly directionsLT?: InputMaybe<Scalars['String']['input']>;
  readonly directionsLTE?: InputMaybe<Scalars['String']['input']>;
  readonly directionsNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly directionsNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly directionsNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** disabled field predicates */
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** enumeration_config_field_link_uuid field predicates */
  readonly enumerationConfigFieldLinkUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly enumerationConfigFieldLinkUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly enumerationConfigFieldLinkUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly enumerationConfigFieldLinkUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** classifier_enum_value edge predicates */
  readonly hasClassifierEnumValue?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasClassifierEnumValueWith?: InputMaybe<ReadonlyArray<ClassifierEnumValueWhereInput>>;
  /** enumeration_config_field_link edge predicates */
  readonly hasEnumerationConfigFieldLink?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasEnumerationConfigFieldLinkWith?: InputMaybe<ReadonlyArray<EnumerationConfigFieldLinkWhereInput>>;
  /** knowledge_document_prompt_instructions edge predicates */
  readonly hasKnowledgeDocumentPromptInstructions?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasKnowledgeDocumentPromptInstructionsWith?: InputMaybe<ReadonlyArray<KnowledgeDocumentPromptInstructionWhereInput>>;
  /** id field predicates */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly idGT?: InputMaybe<Scalars['ID']['input']>;
  readonly idGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly idLT?: InputMaybe<Scalars['ID']['input']>;
  readonly idLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly idNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** instructions field predicates */
  readonly instructions?: InputMaybe<Scalars['String']['input']>;
  readonly instructionsContains?: InputMaybe<Scalars['String']['input']>;
  readonly instructionsContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly instructionsEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly instructionsGT?: InputMaybe<Scalars['String']['input']>;
  readonly instructionsGTE?: InputMaybe<Scalars['String']['input']>;
  readonly instructionsHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly instructionsHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly instructionsIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly instructionsIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly instructionsLT?: InputMaybe<Scalars['String']['input']>;
  readonly instructionsLTE?: InputMaybe<Scalars['String']['input']>;
  readonly instructionsNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly instructionsNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly instructionsNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly not?: InputMaybe<ClassifierConditionWhereInput>;
  /** old_created_by_id field predicates */
  readonly oldCreatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldCreatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_updated_by_id field predicates */
  readonly oldUpdatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldUpdatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly or?: InputMaybe<ReadonlyArray<ClassifierConditionWhereInput>>;
  /** updated_at field predicates */
  readonly updatedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly updatedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** updated_by_uuid field predicates */
  readonly updatedByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly updatedByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
}

/** A connection to a list of items. */
export interface ClassifierConnection {
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<ClassifierEdge>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface ClassifierEdge {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<Classifier>;
}

export interface ClassifierEnumValue extends Node {
  readonly classifier: Classifier;
  /** Classifier conditions associated with this enum value. */
  readonly classifierConditions?: Maybe<ReadonlyArray<ClassifierCondition>>;
  readonly classifierExamples?: Maybe<ReadonlyArray<ClassifierExample>>;
  readonly classifierResults?: Maybe<ReadonlyArray<ClassifierResult>>;
  readonly classifierUUID: Scalars['ID']['output'];
  readonly createdAt: Scalars['Int']['output'];
  readonly createdByUUID: Scalars['ID']['output'];
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly disabled: Scalars['Boolean']['output'];
  readonly enumValue: Scalars['String']['output'];
  readonly enumerationConfigurationClassifierEnumValues?: Maybe<ReadonlyArray<EnumerationConfigurationClassifierEnum>>;
  readonly id: Scalars['ID']['output'];
  readonly oldCreatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly oldID?: Maybe<Scalars['Int']['output']>;
  readonly oldUpdatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly updatedAt: Scalars['Int']['output'];
  readonly updatedByUUID: Scalars['ID']['output'];
}

/** A connection to a list of items. */
export interface ClassifierEnumValueConnection {
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<ClassifierEnumValueEdge>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface ClassifierEnumValueEdge {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<ClassifierEnumValue>;
}

/** Ordering options for ClassifierEnumValue connections */
export interface ClassifierEnumValueOrder {
  /** The ordering direction. */
  readonly direction?: OrderDirection;
  /** The field by which to order ClassifierEnumValues. */
  readonly field: ClassifierEnumValueOrderField;
}

/** Properties by which ClassifierEnumValue connections can be ordered. */
export const ClassifierEnumValueOrderField = {
  CreatedAt: 'CREATED_AT',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type ClassifierEnumValueOrderField = typeof ClassifierEnumValueOrderField[keyof typeof ClassifierEnumValueOrderField];
/**
 * ClassifierEnumValueWhereInput is used for filtering ClassifierEnumValue objects.
 * Input was generated by ent.
 */
export interface ClassifierEnumValueWhereInput {
  readonly and?: InputMaybe<ReadonlyArray<ClassifierEnumValueWhereInput>>;
  /** classifier_uuid field predicates */
  readonly classifierUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly classifierUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly classifierUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly classifierUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** created_at field predicates */
  readonly createdAt?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly createdAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** created_by_uuid field predicates */
  readonly createdByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly createdByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** description field predicates */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionContains?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionGT?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly descriptionLT?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** disabled field predicates */
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** enum_value field predicates */
  readonly enumValue?: InputMaybe<Scalars['String']['input']>;
  readonly enumValueContains?: InputMaybe<Scalars['String']['input']>;
  readonly enumValueContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly enumValueEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly enumValueGT?: InputMaybe<Scalars['String']['input']>;
  readonly enumValueGTE?: InputMaybe<Scalars['String']['input']>;
  readonly enumValueHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly enumValueHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly enumValueIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly enumValueLT?: InputMaybe<Scalars['String']['input']>;
  readonly enumValueLTE?: InputMaybe<Scalars['String']['input']>;
  readonly enumValueNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly enumValueNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** classifier edge predicates */
  readonly hasClassifier?: InputMaybe<Scalars['Boolean']['input']>;
  /** classifier_conditions edge predicates */
  readonly hasClassifierConditions?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasClassifierConditionsWith?: InputMaybe<ReadonlyArray<ClassifierConditionWhereInput>>;
  /** classifier_examples edge predicates */
  readonly hasClassifierExamples?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasClassifierExamplesWith?: InputMaybe<ReadonlyArray<ClassifierExampleWhereInput>>;
  /** classifier_results edge predicates */
  readonly hasClassifierResults?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasClassifierResultsWith?: InputMaybe<ReadonlyArray<ClassifierResultWhereInput>>;
  readonly hasClassifierWith?: InputMaybe<ReadonlyArray<ClassifierWhereInput>>;
  /** enumeration_configuration_classifier_enum_values edge predicates */
  readonly hasEnumerationConfigurationClassifierEnumValues?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasEnumerationConfigurationClassifierEnumValuesWith?: InputMaybe<ReadonlyArray<EnumerationConfigurationClassifierEnumWhereInput>>;
  /** id field predicates */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly idGT?: InputMaybe<Scalars['ID']['input']>;
  readonly idGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly idLT?: InputMaybe<Scalars['ID']['input']>;
  readonly idLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly idNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly not?: InputMaybe<ClassifierEnumValueWhereInput>;
  /** old_created_by_id field predicates */
  readonly oldCreatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldCreatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_id field predicates */
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDGT?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly oldIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldIDLT?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly oldIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_updated_by_id field predicates */
  readonly oldUpdatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldUpdatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly or?: InputMaybe<ReadonlyArray<ClassifierEnumValueWhereInput>>;
  /** updated_at field predicates */
  readonly updatedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly updatedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** updated_by_uuid field predicates */
  readonly updatedByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly updatedByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
}

export interface ClassifierExample extends Node {
  readonly call?: Maybe<Call>;
  readonly callUUID?: Maybe<Scalars['ID']['output']>;
  readonly classifier: Classifier;
  readonly classifierEnumValue: ClassifierEnumValue;
  readonly classifierEnumValueUUID: Scalars['ID']['output'];
  readonly classifierUUID: Scalars['ID']['output'];
  readonly createdAt: Scalars['Int']['output'];
  readonly createdByUUID: Scalars['ID']['output'];
  readonly disabled: Scalars['Boolean']['output'];
  readonly document?: Maybe<Document>;
  readonly documentUUID?: Maybe<Scalars['ID']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly oldCreatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly oldID?: Maybe<Scalars['Int']['output']>;
  readonly oldUpdatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly opportunity?: Maybe<Opportunity>;
  readonly opportunityUUID?: Maybe<Scalars['ID']['output']>;
  readonly updatedAt: Scalars['Int']['output'];
  readonly updatedByUUID: Scalars['ID']['output'];
}

/** A connection to a list of items. */
export interface ClassifierExampleConnection {
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<ClassifierExampleEdge>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface ClassifierExampleEdge {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<ClassifierExample>;
}

/** Ordering options for ClassifierExample connections */
export interface ClassifierExampleOrder {
  /** The ordering direction. */
  readonly direction?: OrderDirection;
  /** The field by which to order ClassifierExamples. */
  readonly field: ClassifierExampleOrderField;
}

/** Properties by which ClassifierExample connections can be ordered. */
export const ClassifierExampleOrderField = {
  CreatedAt: 'CREATED_AT',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type ClassifierExampleOrderField = typeof ClassifierExampleOrderField[keyof typeof ClassifierExampleOrderField];
/**
 * ClassifierExampleWhereInput is used for filtering ClassifierExample objects.
 * Input was generated by ent.
 */
export interface ClassifierExampleWhereInput {
  readonly and?: InputMaybe<ReadonlyArray<ClassifierExampleWhereInput>>;
  /** call_uuid field predicates */
  readonly callUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly callUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly callUUIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly callUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly callUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly callUUIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** classifier_enum_value_uuid field predicates */
  readonly classifierEnumValueUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly classifierEnumValueUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly classifierEnumValueUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly classifierEnumValueUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** classifier_uuid field predicates */
  readonly classifierUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly classifierUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly classifierUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly classifierUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** created_at field predicates */
  readonly createdAt?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly createdAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** created_by_uuid field predicates */
  readonly createdByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly createdByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** disabled field predicates */
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** document_uuid field predicates */
  readonly documentUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly documentUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly documentUUIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly documentUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly documentUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly documentUUIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** call edge predicates */
  readonly hasCall?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasCallWith?: InputMaybe<ReadonlyArray<CallWhereInput>>;
  /** classifier edge predicates */
  readonly hasClassifier?: InputMaybe<Scalars['Boolean']['input']>;
  /** classifier_enum_value edge predicates */
  readonly hasClassifierEnumValue?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasClassifierEnumValueWith?: InputMaybe<ReadonlyArray<ClassifierEnumValueWhereInput>>;
  readonly hasClassifierWith?: InputMaybe<ReadonlyArray<ClassifierWhereInput>>;
  /** document edge predicates */
  readonly hasDocument?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasDocumentWith?: InputMaybe<ReadonlyArray<DocumentWhereInput>>;
  /** opportunity edge predicates */
  readonly hasOpportunity?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasOpportunityWith?: InputMaybe<ReadonlyArray<OpportunityWhereInput>>;
  /** id field predicates */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly idGT?: InputMaybe<Scalars['ID']['input']>;
  readonly idGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly idLT?: InputMaybe<Scalars['ID']['input']>;
  readonly idLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly idNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly not?: InputMaybe<ClassifierExampleWhereInput>;
  /** old_created_by_id field predicates */
  readonly oldCreatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldCreatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_id field predicates */
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDGT?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly oldIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldIDLT?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly oldIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_updated_by_id field predicates */
  readonly oldUpdatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldUpdatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** opportunity_uuid field predicates */
  readonly opportunityUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly opportunityUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly opportunityUUIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly opportunityUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly opportunityUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly opportunityUUIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly or?: InputMaybe<ReadonlyArray<ClassifierExampleWhereInput>>;
  /** updated_at field predicates */
  readonly updatedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly updatedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** updated_by_uuid field predicates */
  readonly updatedByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly updatedByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
}

/** Ordering options for Classifier connections */
export interface ClassifierOrder {
  /** The ordering direction. */
  readonly direction?: OrderDirection;
  /** The field by which to order Classifiers. */
  readonly field: ClassifierOrderField;
}

/** Properties by which Classifier connections can be ordered. */
export const ClassifierOrderField = {
  Active: 'ACTIVE',
  ClassificationType: 'CLASSIFICATION_TYPE',
  CreatedAt: 'CREATED_AT',
  Description: 'DESCRIPTION',
  Model: 'MODEL',
  Name: 'NAME',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type ClassifierOrderField = typeof ClassifierOrderField[keyof typeof ClassifierOrderField];
export interface ClassifierResult extends Node {
  readonly call?: Maybe<Call>;
  readonly callUUID?: Maybe<Scalars['ID']['output']>;
  readonly classifier: Classifier;
  readonly classifierEnumValue: ClassifierEnumValue;
  readonly classifierEnumValueUUID: Scalars['ID']['output'];
  readonly classifierUUID: Scalars['ID']['output'];
  readonly createdAt: Scalars['Int']['output'];
  readonly createdByUUID: Scalars['ID']['output'];
  readonly disabled: Scalars['Boolean']['output'];
  readonly document?: Maybe<Document>;
  readonly documentUUID?: Maybe<Scalars['ID']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly oldCreatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly oldID?: Maybe<Scalars['Int']['output']>;
  readonly oldUpdatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly opportunityStageChange?: Maybe<OpportunityStageChange>;
  readonly opportunityStageChangeUUID?: Maybe<Scalars['ID']['output']>;
  readonly updatedAt: Scalars['Int']['output'];
  readonly updatedByUUID: Scalars['ID']['output'];
}

/** A connection to a list of items. */
export interface ClassifierResultConnection {
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<ClassifierResultEdge>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface ClassifierResultEdge {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<ClassifierResult>;
}

/** Ordering options for ClassifierResult connections */
export interface ClassifierResultOrder {
  /** The ordering direction. */
  readonly direction?: OrderDirection;
  /** The field by which to order ClassifierResults. */
  readonly field: ClassifierResultOrderField;
}

/** Properties by which ClassifierResult connections can be ordered. */
export const ClassifierResultOrderField = {
  CreatedAt: 'CREATED_AT',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type ClassifierResultOrderField = typeof ClassifierResultOrderField[keyof typeof ClassifierResultOrderField];
/**
 * ClassifierResultWhereInput is used for filtering ClassifierResult objects.
 * Input was generated by ent.
 */
export interface ClassifierResultWhereInput {
  readonly and?: InputMaybe<ReadonlyArray<ClassifierResultWhereInput>>;
  /** call_uuid field predicates */
  readonly callUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly callUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly callUUIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly callUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly callUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly callUUIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** classifier_enum_value_uuid field predicates */
  readonly classifierEnumValueUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly classifierEnumValueUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly classifierEnumValueUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly classifierEnumValueUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** classifier_uuid field predicates */
  readonly classifierUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly classifierUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly classifierUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly classifierUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** created_at field predicates */
  readonly createdAt?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly createdAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** created_by_uuid field predicates */
  readonly createdByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly createdByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** disabled field predicates */
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** document_uuid field predicates */
  readonly documentUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly documentUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly documentUUIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly documentUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly documentUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly documentUUIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** call edge predicates */
  readonly hasCall?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasCallWith?: InputMaybe<ReadonlyArray<CallWhereInput>>;
  /** classifier edge predicates */
  readonly hasClassifier?: InputMaybe<Scalars['Boolean']['input']>;
  /** classifier_enum_value edge predicates */
  readonly hasClassifierEnumValue?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasClassifierEnumValueWith?: InputMaybe<ReadonlyArray<ClassifierEnumValueWhereInput>>;
  readonly hasClassifierWith?: InputMaybe<ReadonlyArray<ClassifierWhereInput>>;
  /** document edge predicates */
  readonly hasDocument?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasDocumentWith?: InputMaybe<ReadonlyArray<DocumentWhereInput>>;
  /** opportunity_stage_change edge predicates */
  readonly hasOpportunityStageChange?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasOpportunityStageChangeWith?: InputMaybe<ReadonlyArray<OpportunityStageChangeWhereInput>>;
  /** id field predicates */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly idGT?: InputMaybe<Scalars['ID']['input']>;
  readonly idGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly idLT?: InputMaybe<Scalars['ID']['input']>;
  readonly idLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly idNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly not?: InputMaybe<ClassifierResultWhereInput>;
  /** old_created_by_id field predicates */
  readonly oldCreatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldCreatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_id field predicates */
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDGT?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly oldIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldIDLT?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly oldIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_updated_by_id field predicates */
  readonly oldUpdatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldUpdatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** opportunity_stage_change_uuid field predicates */
  readonly opportunityStageChangeUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly opportunityStageChangeUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly opportunityStageChangeUUIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly opportunityStageChangeUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly opportunityStageChangeUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly opportunityStageChangeUUIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly or?: InputMaybe<ReadonlyArray<ClassifierResultWhereInput>>;
  /** updated_at field predicates */
  readonly updatedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly updatedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** updated_by_uuid field predicates */
  readonly updatedByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly updatedByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
}

/** ClassifierType is enum for the field classification_type */
export const ClassifierType = {
  MultiLabel: 'MULTI_LABEL',
  SingleLabel: 'SINGLE_LABEL',
  UnknownClassifier: 'UNKNOWN_CLASSIFIER'
} as const;

export type ClassifierType = typeof ClassifierType[keyof typeof ClassifierType];
/**
 * ClassifierWhereInput is used for filtering Classifier objects.
 * Input was generated by ent.
 */
export interface ClassifierWhereInput {
  /** active field predicates */
  readonly active?: InputMaybe<Scalars['Boolean']['input']>;
  readonly activeNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  readonly and?: InputMaybe<ReadonlyArray<ClassifierWhereInput>>;
  /** classification_type field predicates */
  readonly classificationType?: InputMaybe<ClassifierType>;
  readonly classificationTypeIn?: InputMaybe<ReadonlyArray<ClassifierType>>;
  readonly classificationTypeNEQ?: InputMaybe<ClassifierType>;
  readonly classificationTypeNotIn?: InputMaybe<ReadonlyArray<ClassifierType>>;
  /** created_at field predicates */
  readonly createdAt?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly createdAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** created_by_uuid field predicates */
  readonly createdByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly createdByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** description field predicates */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionContains?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionGT?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly descriptionLT?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** disabled field predicates */
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** classifier_enum_values edge predicates */
  readonly hasClassifierEnumValues?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasClassifierEnumValuesWith?: InputMaybe<ReadonlyArray<ClassifierEnumValueWhereInput>>;
  /** classifier_examples edge predicates */
  readonly hasClassifierExamples?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasClassifierExamplesWith?: InputMaybe<ReadonlyArray<ClassifierExampleWhereInput>>;
  /** classifier_results edge predicates */
  readonly hasClassifierResults?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasClassifierResultsWith?: InputMaybe<ReadonlyArray<ClassifierResultWhereInput>>;
  /** id field predicates */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly idGT?: InputMaybe<Scalars['ID']['input']>;
  readonly idGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly idLT?: InputMaybe<Scalars['ID']['input']>;
  readonly idLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly idNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** model field predicates */
  readonly model?: InputMaybe<Scalars['String']['input']>;
  readonly modelContains?: InputMaybe<Scalars['String']['input']>;
  readonly modelContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly modelEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly modelGT?: InputMaybe<Scalars['String']['input']>;
  readonly modelGTE?: InputMaybe<Scalars['String']['input']>;
  readonly modelHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly modelHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly modelIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly modelIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly modelLT?: InputMaybe<Scalars['String']['input']>;
  readonly modelLTE?: InputMaybe<Scalars['String']['input']>;
  readonly modelNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly modelNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly modelNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** name field predicates */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly nameContains?: InputMaybe<Scalars['String']['input']>;
  readonly nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly nameGT?: InputMaybe<Scalars['String']['input']>;
  readonly nameGTE?: InputMaybe<Scalars['String']['input']>;
  readonly nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly nameIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly nameLT?: InputMaybe<Scalars['String']['input']>;
  readonly nameLTE?: InputMaybe<Scalars['String']['input']>;
  readonly nameNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly nameNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly not?: InputMaybe<ClassifierWhereInput>;
  /** old_created_by_id field predicates */
  readonly oldCreatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldCreatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_id field predicates */
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDGT?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly oldIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldIDLT?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly oldIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_updated_by_id field predicates */
  readonly oldUpdatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldUpdatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly or?: InputMaybe<ReadonlyArray<ClassifierWhereInput>>;
  /** updated_at field predicates */
  readonly updatedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly updatedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** updated_by_uuid field predicates */
  readonly updatedByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly updatedByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
}

export interface Contact extends Node {
  readonly account?: Maybe<Account>;
  readonly accountUUID?: Maybe<Scalars['ID']['output']>;
  readonly calls?: Maybe<ReadonlyArray<Call>>;
  readonly createdAt: Scalars['Int']['output'];
  readonly createdByUUID: Scalars['ID']['output'];
  readonly customFieldValues: CustomFieldValueConnection;
  readonly disabled: Scalars['Boolean']['output'];
  readonly documents?: Maybe<ReadonlyArray<Document>>;
  readonly externalIdentifier: Scalars['String']['output'];
  readonly firstName?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly lastName?: Maybe<Scalars['String']['output']>;
  readonly name: Scalars['String']['output'];
  readonly oldCreatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly oldUpdatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly opportunities?: Maybe<ReadonlyArray<Opportunity>>;
  readonly receivedEmails: EmailRecipientConnection;
  readonly sentEmails: EmailConnection;
  readonly sourcePlatform: CallIntegration;
  readonly tasks?: Maybe<ReadonlyArray<Task>>;
  readonly title?: Maybe<Scalars['String']['output']>;
  readonly updatedAt: Scalars['Int']['output'];
  readonly updatedByUUID: Scalars['ID']['output'];
}


export interface ContactCustomFieldValuesArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CustomFieldValueOrder>;
  where?: InputMaybe<CustomFieldValueWhereInput>;
}


export interface ContactReceivedEmailsArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EmailRecipientOrder>;
  where?: InputMaybe<EmailRecipientWhereInput>;
}


export interface ContactSentEmailsArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EmailOrder>;
  where?: InputMaybe<EmailWhereInput>;
}

/** A connection to a list of items. */
export interface ContactConnection {
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<ContactEdge>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface ContactEdge {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<Contact>;
}

/** Ordering options for Contact connections */
export interface ContactOrder {
  /** The ordering direction. */
  readonly direction?: OrderDirection;
  /** The field by which to order Contacts. */
  readonly field: ContactOrderField;
}

/** Properties by which Contact connections can be ordered. */
export const ContactOrderField = {
  CreatedAt: 'CREATED_AT',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type ContactOrderField = typeof ContactOrderField[keyof typeof ContactOrderField];
/**
 * ContactWhereInput is used for filtering Contact objects.
 * Input was generated by ent.
 */
export interface ContactWhereInput {
  /** account_uuid field predicates */
  readonly accountUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly accountUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly accountUUIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly accountUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly accountUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly accountUUIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly and?: InputMaybe<ReadonlyArray<ContactWhereInput>>;
  /** created_at field predicates */
  readonly createdAt?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly createdAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** created_by_uuid field predicates */
  readonly createdByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly createdByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** disabled field predicates */
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** external_identifier field predicates */
  readonly externalIdentifier?: InputMaybe<Scalars['String']['input']>;
  readonly externalIdentifierContains?: InputMaybe<Scalars['String']['input']>;
  readonly externalIdentifierContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly externalIdentifierEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly externalIdentifierGT?: InputMaybe<Scalars['String']['input']>;
  readonly externalIdentifierGTE?: InputMaybe<Scalars['String']['input']>;
  readonly externalIdentifierHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly externalIdentifierHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly externalIdentifierIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly externalIdentifierLT?: InputMaybe<Scalars['String']['input']>;
  readonly externalIdentifierLTE?: InputMaybe<Scalars['String']['input']>;
  readonly externalIdentifierNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly externalIdentifierNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** first_name field predicates */
  readonly firstName?: InputMaybe<Scalars['String']['input']>;
  readonly firstNameContains?: InputMaybe<Scalars['String']['input']>;
  readonly firstNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly firstNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly firstNameGT?: InputMaybe<Scalars['String']['input']>;
  readonly firstNameGTE?: InputMaybe<Scalars['String']['input']>;
  readonly firstNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly firstNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly firstNameIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly firstNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly firstNameLT?: InputMaybe<Scalars['String']['input']>;
  readonly firstNameLTE?: InputMaybe<Scalars['String']['input']>;
  readonly firstNameNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly firstNameNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly firstNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** account edge predicates */
  readonly hasAccount?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasAccountWith?: InputMaybe<ReadonlyArray<AccountWhereInput>>;
  /** calls edge predicates */
  readonly hasCalls?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasCallsWith?: InputMaybe<ReadonlyArray<CallWhereInput>>;
  /** custom_field_values edge predicates */
  readonly hasCustomFieldValues?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasCustomFieldValuesWith?: InputMaybe<ReadonlyArray<CustomFieldValueWhereInput>>;
  /** documents edge predicates */
  readonly hasDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasDocumentsWith?: InputMaybe<ReadonlyArray<DocumentWhereInput>>;
  /** opportunities edge predicates */
  readonly hasOpportunities?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasOpportunitiesWith?: InputMaybe<ReadonlyArray<OpportunityWhereInput>>;
  /** received_emails edge predicates */
  readonly hasReceivedEmails?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasReceivedEmailsWith?: InputMaybe<ReadonlyArray<EmailRecipientWhereInput>>;
  /** sent_emails edge predicates */
  readonly hasSentEmails?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasSentEmailsWith?: InputMaybe<ReadonlyArray<EmailWhereInput>>;
  /** tasks edge predicates */
  readonly hasTasks?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasTasksWith?: InputMaybe<ReadonlyArray<TaskWhereInput>>;
  /** id field predicates */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly idGT?: InputMaybe<Scalars['ID']['input']>;
  readonly idGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly idLT?: InputMaybe<Scalars['ID']['input']>;
  readonly idLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly idNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** last_name field predicates */
  readonly lastName?: InputMaybe<Scalars['String']['input']>;
  readonly lastNameContains?: InputMaybe<Scalars['String']['input']>;
  readonly lastNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly lastNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly lastNameGT?: InputMaybe<Scalars['String']['input']>;
  readonly lastNameGTE?: InputMaybe<Scalars['String']['input']>;
  readonly lastNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly lastNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly lastNameIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly lastNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly lastNameLT?: InputMaybe<Scalars['String']['input']>;
  readonly lastNameLTE?: InputMaybe<Scalars['String']['input']>;
  readonly lastNameNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly lastNameNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly lastNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly not?: InputMaybe<ContactWhereInput>;
  /** old_created_by_id field predicates */
  readonly oldCreatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldCreatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_updated_by_id field predicates */
  readonly oldUpdatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldUpdatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly or?: InputMaybe<ReadonlyArray<ContactWhereInput>>;
  /** source_platform field predicates */
  readonly sourcePlatform?: InputMaybe<CallIntegration>;
  readonly sourcePlatformIn?: InputMaybe<ReadonlyArray<CallIntegration>>;
  readonly sourcePlatformNEQ?: InputMaybe<CallIntegration>;
  readonly sourcePlatformNotIn?: InputMaybe<ReadonlyArray<CallIntegration>>;
  /** title field predicates */
  readonly title?: InputMaybe<Scalars['String']['input']>;
  readonly titleContains?: InputMaybe<Scalars['String']['input']>;
  readonly titleContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly titleEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly titleGT?: InputMaybe<Scalars['String']['input']>;
  readonly titleGTE?: InputMaybe<Scalars['String']['input']>;
  readonly titleHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly titleHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly titleIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly titleIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly titleLT?: InputMaybe<Scalars['String']['input']>;
  readonly titleLTE?: InputMaybe<Scalars['String']['input']>;
  readonly titleNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly titleNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly titleNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  readonly updatedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly updatedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** updated_by_uuid field predicates */
  readonly updatedByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly updatedByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
}

/**
 * CreateAPIKeyInput is used for create APIKey object.
 * Input was generated by ent.
 */
export interface CreateApiKeyInput {
  readonly clientID: Scalars['String']['input'];
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly name: Scalars['String']['input'];
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
}

/**
 * CreateAccountInput is used for create Account object.
 * Input was generated by ent.
 */
export interface CreateAccountInput {
  readonly callIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly contactIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly customFieldValueIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly documentIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly externalIdentifier: Scalars['String']['input'];
  readonly name: Scalars['String']['input'];
  readonly opportunityIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly sourcePlatform: CallIntegration;
  readonly taskIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** Websites represents the websites of the account. It is not sanitized in anyway, as different platforms allow URLs vs domains, etc. */
  readonly websites?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
}

/**
 * CreateAdhocEmailSendInput is used for create AdhocEmailSend object.
 * Input was generated by ent.
 */
export interface CreateAdhocEmailSendInput {
  readonly additionalNotes?: InputMaybe<Scalars['String']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly emailSubscriptionConfigID?: InputMaybe<Scalars['ID']['input']>;
  readonly enumerationValueID: Scalars['ID']['input'];
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  readonly senderUserID: Scalars['ID']['input'];
  readonly toAddress: Scalars['String']['input'];
}

/**
 * CreateCRMDeliveryInput is used for create CRMDelivery object.
 * Input was generated by ent.
 */
export interface CreateCrmDeliveryInput {
  readonly crmSubscriptionID: Scalars['ID']['input'];
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly enumerationValueID?: InputMaybe<Scalars['ID']['input']>;
  readonly enumerationValueOutputID?: InputMaybe<Scalars['ID']['input']>;
  readonly enumerationValueScoreID?: InputMaybe<Scalars['ID']['input']>;
  readonly fieldName?: InputMaybe<Scalars['String']['input']>;
  readonly fieldValue?: InputMaybe<Scalars['String']['input']>;
  readonly noteID?: InputMaybe<Scalars['String']['input']>;
  readonly objectID?: InputMaybe<Scalars['String']['input']>;
  readonly objectType?: InputMaybe<CrmDeliveryObjectType>;
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
}

/**
 * CreateCRMSubscriptionInput is used for create CRMSubscription object.
 * Input was generated by ent.
 */
export interface CreateCrmSubscriptionInput {
  /** ConvertMarkdown indicates that the content should be converted from markdown to HTML before being pushed to the CRM system. */
  readonly convertMarkdown?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly enumType: CrmSubscriptionValueType;
  readonly enumerationFieldID?: InputMaybe<Scalars['ID']['input']>;
  /** FieldName is the name of the field in the CRM system. If not set, the data will be pushed as a note */
  readonly fieldName?: InputMaybe<Scalars['String']['input']>;
  readonly integrationSecretID: Scalars['ID']['input'];
  readonly objectType: CrmSubscriptionObjectType;
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
}

/**
 * CreateClassifierConditionInput is used for create ClassifierCondition object.
 * Input was generated by ent.
 */
export interface CreateClassifierConditionInput {
  readonly classifierEnumValueID: Scalars['ID']['input'];
  /** Definitions represent the contextual definition that the model needs in order to be able to best do it's job, so that there isn't ambiguity about the terms using in the instructions/directions or whether the calls/documents themselves. This is often left blank if there isn't much chance of confusion. If the type of the value or score is non-custom, then adding to this will append the text after the standard definitions for that field. */
  readonly definitions?: InputMaybe<Scalars['String']['input']>;
  /** Directions are the specific steps or detailed context that the model needs to take in order to complete the analysis. This is generally more detailed than the instructions and is often used to break down the instructions into more digestible steps or talk through edge cases. If the type of the value or score is non-custom, then adding to this will append the text after the standard directions for that field. */
  readonly directions?: InputMaybe<Scalars['String']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Instructions represents the main description of the task that the model needs to do to complete the analysis. For normal fields, this generally describes how to analyze the call/document. For scores, this is the rubric that outlines exactly how to score the rep on the call. If the type of the value or score is non-custom, then adding to this will append the text after the standard instructions for that field. */
  readonly instructions?: InputMaybe<Scalars['String']['input']>;
  readonly knowledgeDocumentPromptInstructionIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
}

/**
 * CreateClassifierEnumValueInput is used for create ClassifierEnumValue object.
 * Input was generated by ent.
 */
export interface CreateClassifierEnumValueInput {
  readonly classifierConditionIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly classifierExampleIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly classifierID: Scalars['ID']['input'];
  readonly classifierResultIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly enumValue: Scalars['String']['input'];
  readonly enumerationConfigurationClassifierEnumValueIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
}

/**
 * CreateClassifierExampleInput is used for create ClassifierExample object.
 * Input was generated by ent.
 */
export interface CreateClassifierExampleInput {
  readonly callID?: InputMaybe<Scalars['ID']['input']>;
  readonly classifierEnumValueID: Scalars['ID']['input'];
  readonly classifierID: Scalars['ID']['input'];
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly documentID?: InputMaybe<Scalars['ID']['input']>;
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  readonly opportunityID?: InputMaybe<Scalars['ID']['input']>;
}

/**
 * CreateClassifierInput is used for create Classifier object.
 * Input was generated by ent.
 */
export interface CreateClassifierInput {
  readonly active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates whether the classifier assigns a single enum value or multiple enum values to an event */
  readonly classificationType: ClassifierType;
  readonly classifierEnumValueIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly classifierExampleIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly classifierResultIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Specifies the LLM model to use; defaults to standard model if not provided */
  readonly model?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
}

/**
 * CreateClassifierResultInput is used for create ClassifierResult object.
 * Input was generated by ent.
 */
export interface CreateClassifierResultInput {
  readonly callID?: InputMaybe<Scalars['ID']['input']>;
  readonly classifierEnumValueID: Scalars['ID']['input'];
  readonly classifierID: Scalars['ID']['input'];
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly documentID?: InputMaybe<Scalars['ID']['input']>;
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  readonly opportunityStageChangeID?: InputMaybe<Scalars['ID']['input']>;
}

/**
 * CreateContactInput is used for create Contact object.
 * Input was generated by ent.
 */
export interface CreateContactInput {
  readonly accountID?: InputMaybe<Scalars['ID']['input']>;
  readonly callIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly customFieldValueIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly documentIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly emailAddress?: InputMaybe<Scalars['String']['input']>;
  readonly externalIdentifier: Scalars['String']['input'];
  readonly firstName?: InputMaybe<Scalars['String']['input']>;
  readonly lastName?: InputMaybe<Scalars['String']['input']>;
  readonly opportunityIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly phoneNumber?: InputMaybe<Scalars['String']['input']>;
  readonly receivedEmailIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly sentEmailIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly sourcePlatform: CallIntegration;
  readonly taskIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly title?: InputMaybe<Scalars['String']['input']>;
}

/**
 * CreateCustomFieldEnumInput is used for create CustomFieldEnum object.
 * Input was generated by ent.
 */
export interface CreateCustomFieldEnumInput {
  readonly customFieldID: Scalars['ID']['input'];
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * ExternalIdentifier refers to a platform's internal name / ID for a given field value.
   * Not every platform has these (e.g. HubSpot), but some (like Volie) do.
   */
  readonly externalIdentifier?: InputMaybe<Scalars['String']['input']>;
  readonly value: Scalars['String']['input'];
  readonly valueIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
}

/**
 * CreateCustomFieldEnumerationFieldLinkInput is used for create CustomFieldEnumerationFieldLink object.
 * Input was generated by ent.
 */
export interface CreateCustomFieldEnumerationFieldLinkInput {
  readonly customFieldID: Scalars['ID']['input'];
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly enumerationFieldID: Scalars['ID']['input'];
}

/**
 * CreateCustomFieldInput is used for create CustomField object.
 * Input was generated by ent.
 */
export interface CreateCustomFieldInput {
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly displayName: Scalars['String']['input'];
  readonly enumIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly enumerationFieldIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /**
   * ExternalIdentifier refers to a platform's internal name / ID for a given field.
   * E.g. in HubSpot, a property has both "label" (which is equivalent to our DisplayName field)
   * and a "name" field (which is unique, e.g. "favorite_food"). Other platforms have a typical
   * identifier, e.g. a UUID.
   */
  readonly externalIdentifier?: InputMaybe<Scalars['String']['input']>;
  readonly fieldType?: InputMaybe<CustomFieldCustomFieldType>;
  /** GroupName corresponds to the grouping of fields present in CRMs like Hubspot */
  readonly groupName?: InputMaybe<Scalars['String']['input']>;
  readonly objectType?: InputMaybe<CustomFieldObjectType>;
  readonly sourcePlatform?: InputMaybe<CallIntegration>;
  readonly valueIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
}

/**
 * CreateCustomFieldValueInput is used for create CustomFieldValue object.
 * Input was generated by ent.
 */
export interface CreateCustomFieldValueInput {
  readonly accountID?: InputMaybe<Scalars['ID']['input']>;
  readonly callID?: InputMaybe<Scalars['ID']['input']>;
  readonly contactID?: InputMaybe<Scalars['ID']['input']>;
  readonly customFieldEnumID?: InputMaybe<Scalars['ID']['input']>;
  readonly customFieldID: Scalars['ID']['input'];
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly documentID?: InputMaybe<Scalars['ID']['input']>;
  readonly opportunityID?: InputMaybe<Scalars['ID']['input']>;
  readonly value?: InputMaybe<Scalars['String']['input']>;
}

/**
 * CreateCustomerCRMConfigInput is used for create CustomerCRMConfig object.
 * Input was generated by ent.
 */
export interface CreateCustomerCrmConfigInput {
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly integrationSecretID: Scalars['ID']['input'];
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  readonly ownerID?: InputMaybe<Scalars['ID']['input']>;
  /** StagesToUpdate is a list of stage IDs which should be updated. */
  readonly stageIdsToUpdate?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** TerminalStages is a list of stage IDs which should no longer be updated. */
  readonly terminalStageIds?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
}

/**
 * CreateCustomerInput is used for create Customer object.
 * Input was generated by ent.
 */
export interface CreateCustomerInput {
  readonly childCustomerIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly customerCrmConfigID?: InputMaybe<Scalars['ID']['input']>;
  readonly customerProspectingConfigIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly domains?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly enumerationConfigurationIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly fiscalYearStartDay?: InputMaybe<Scalars['Int']['input']>;
  readonly fiscalYearStartMonth?: InputMaybe<Scalars['Int']['input']>;
  readonly integrationSecretIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** A summary of the customer that is only visible to Fabius, used for prompts */
  readonly internalSummary?: InputMaybe<Scalars['String']['input']>;
  readonly isActive?: InputMaybe<Scalars['Boolean']['input']>;
  readonly isReseller?: InputMaybe<Scalars['Boolean']['input']>;
  readonly name: Scalars['String']['input'];
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  readonly parentCustomerID?: InputMaybe<Scalars['ID']['input']>;
  readonly userIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
}

/**
 * CreateCustomerProspectingConfigInput is used for create CustomerProspectingConfig object.
 * Input was generated by ent.
 */
export interface CreateCustomerProspectingConfigInput {
  readonly automatedAccountsPerDay?: InputMaybe<Scalars['Int']['input']>;
  readonly automaticallyPushContacts?: InputMaybe<Scalars['Boolean']['input']>;
  readonly buyerOrg: Scalars['String']['input'];
  readonly buyerSkills: Scalars['String']['input'];
  readonly closedLostStageNames?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** DomainSpecificDirections adds additional steering to the Contact Analysis prompt if set. */
  readonly domainSpecificDirections?: InputMaybe<Scalars['String']['input']>;
  /** The number of primary emails to create for each prospect. Each primary email will then have follow ups. */
  readonly numPrimaryEmails?: InputMaybe<Scalars['Int']['input']>;
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  /** OnlyWebsite determines whether to only use the prospect's website for prospecting. If true, we will scrape the website in depth vs making Google searches and other outside searches. */
  readonly onlyWebsite?: InputMaybe<Scalars['Boolean']['input']>;
  readonly primaryEmailTemplates?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** Re-engagement email templates represent the templates to use when sending emails to prospects that the customer has met with before, and hence referencing the previous call */
  readonly reengagementEmailTemplates?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** ReengagementWithPublicInfo determines whether to include public information about the prospect in the re-engagement email. */
  readonly reengagementWithPublicInfo?: InputMaybe<Scalars['Boolean']['input']>;
  readonly valueMessaging: Scalars['String']['input'];
}

/**
 * CreateDirectoryInput is used for create Directory object.
 * Input was generated by ent.
 */
export interface CreateDirectoryInput {
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly documentIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly name: Scalars['String']['input'];
  readonly oldID?: InputMaybe<Scalars['OldID']['input']>;
  readonly parentID?: InputMaybe<Scalars['ID']['input']>;
  readonly subdirectoryIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
}

/**
 * CreateDocumentIngestionConfigInput is used for create DocumentIngestionConfig object.
 * Input was generated by ent.
 */
export interface CreateDocumentIngestionConfigInput {
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly documentType: DocumentIngestionConfigDocumentType;
  readonly integrationSecretID: Scalars['ID']['input'];
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
}

/**
 * CreateDocumentInput is used for create Document object.
 * Input was generated by ent.
 */
export interface CreateDocumentInput {
  readonly accountID?: InputMaybe<Scalars['ID']['input']>;
  readonly contactID?: InputMaybe<Scalars['ID']['input']>;
  readonly customFieldValueIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly documentSource?: InputMaybe<DocumentCallIntegration>;
  /** DocumentTimestamp is the timestamp of when the document was generated, published, etc. */
  readonly documentTimestamp?: InputMaybe<Scalars['Unix']['input']>;
  readonly documentType: DocumentDocumentType;
  readonly enumerationValueIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /**
   * ExternalDocumentID is the ID of the document in an external system. Typically corresponds to the
   * ID of the resource in the platform it was pulled from. E.g. the ID of a Note in GoHighLevel.
   */
  readonly externalDocumentID: Scalars['OldID']['input'];
  readonly gongUserID?: InputMaybe<Scalars['ID']['input']>;
  readonly name: Scalars['String']['input'];
  readonly opportunityID?: InputMaybe<Scalars['ID']['input']>;
  /** Path is the relative path to the file on s3 */
  readonly path: Scalars['String']['input'];
}

/**
 * CreateEmailDeliveryInput is used for create EmailDelivery object.
 * Input was generated by ent.
 */
export interface CreateEmailDeliveryInput {
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** EmailAddress is the email address of the recipient of the email delivery. */
  readonly emailAddress?: InputMaybe<Scalars['String']['input']>;
  readonly emailSubscriptionID: Scalars['ID']['input'];
  readonly enumerationValueID: Scalars['ID']['input'];
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  /** Subject is the subject of the email delivery. */
  readonly subject?: InputMaybe<Scalars['String']['input']>;
}

/**
 * CreateEmailDraftPublishInput is used for create EmailDraftPublish object.
 * Input was generated by ent.
 */
export interface CreateEmailDraftPublishInput {
  readonly body?: InputMaybe<Scalars['String']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly emailID: Scalars['ID']['input'];
  readonly emailReplyDraftID: Scalars['ID']['input'];
}

/**
 * CreateEmailInput is used for create Email object.
 * Input was generated by ent.
 */
export interface CreateEmailInput {
  /** Bcc is the raw Bcc header value from the email. */
  readonly bcc: ReadonlyArray<Scalars['String']['input']>;
  readonly body?: InputMaybe<Scalars['String']['input']>;
  /** Cc is the raw Cc header value from the email. */
  readonly cc: ReadonlyArray<Scalars['String']['input']>;
  readonly currentSummaryID?: InputMaybe<Scalars['ID']['input']>;
  /** Date is the timestamp of when the email was delivered. */
  readonly date: Scalars['Unix']['input'];
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly emailReplyContextIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly emailReplyDraftIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly enumerationValueIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** ExternalIdentifier is the unique identifier of the email in the source platform (e.g. `gmail_message_id`). */
  readonly externalIdentifier: Scalars['String']['input'];
  /** From is the raw FROM header value from the email. */
  readonly from: Scalars['String']['input'];
  readonly fromContactID?: InputMaybe<Scalars['ID']['input']>;
  readonly fromUserID?: InputMaybe<Scalars['ID']['input']>;
  /** InReplyTo is the raw In-Reply-To header value from the email. */
  readonly inReplyTo?: InputMaybe<Scalars['String']['input']>;
  readonly nextID?: InputMaybe<Scalars['ID']['input']>;
  readonly previousID?: InputMaybe<Scalars['ID']['input']>;
  readonly recipientIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** References is the raw References header value from the email. */
  readonly references?: InputMaybe<Scalars['String']['input']>;
  readonly responseIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** RFCMessageID is the unique identifier of the email in the RFC822 format (e.g. `Message-ID`). */
  readonly rfcMessageID: Scalars['String']['input'];
  readonly sourcePlatform: EmailCallIntegration;
  /** Subject is the raw Subject header value from the email. */
  readonly subject?: InputMaybe<Scalars['String']['input']>;
  readonly taskIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly threadID: Scalars['ID']['input'];
  /** To is the raw To header value from the email. */
  readonly to: ReadonlyArray<Scalars['String']['input']>;
}

/**
 * CreateEmailRecipientInput is used for create EmailRecipient object.
 * Input was generated by ent.
 */
export interface CreateEmailRecipientInput {
  readonly contactID?: InputMaybe<Scalars['ID']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly emailID: Scalars['ID']['input'];
  readonly recipientType: EmailRecipientRecipientType;
  readonly userID?: InputMaybe<Scalars['ID']['input']>;
}

/**
 * CreateEmailReplyContextInput is used for create EmailReplyContext object.
 * Input was generated by ent.
 */
export interface CreateEmailReplyContextInput {
  /** A human-readable context for the email reply, also used by the LLM to generate the reply. */
  readonly context: Scalars['String']['input'];
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly emailID: Scalars['ID']['input'];
  readonly knowledgeDocumentID?: InputMaybe<Scalars['ID']['input']>;
}

/**
 * CreateEmailReplyDraftInput is used for create EmailReplyDraft object.
 * Input was generated by ent.
 */
export interface CreateEmailReplyDraftInput {
  readonly body?: InputMaybe<Scalars['String']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly emailDraftPublishIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly emailID: Scalars['ID']['input'];
}

/**
 * CreateEmailSubscriptionConfigFieldInput is used for create EmailSubscriptionConfigField object.
 * Input was generated by ent.
 */
export interface CreateEmailSubscriptionConfigFieldInput {
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly displayName?: InputMaybe<Scalars['String']['input']>;
  readonly emailSubscriptionConfigID: Scalars['ID']['input'];
  readonly enumerationFieldID?: InputMaybe<Scalars['ID']['input']>;
  readonly filterTemplate?: InputMaybe<Scalars['String']['input']>;
  /**
   * Index specifies which order this field should be rendered in an email.
   * Index is zero based, and lower values are rendered first.
   */
  readonly index: Scalars['Int']['input'];
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
}

/**
 * CreateEmailSubscriptionConfigInput is used for create EmailSubscriptionConfig object.
 * Input was generated by ent.
 */
export interface CreateEmailSubscriptionConfigInput {
  readonly adhocEmailSendIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** Default is a boolean field that when set to true will be the default email subscription config for the enumeration configuration. */
  readonly default?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly emailSubscriptionConfigFieldIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly emailSubscriptionLinkIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly enumerationConfigurationID: Scalars['ID']['input'];
  readonly name: Scalars['String']['input'];
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  /** ShowFeedbackLink is a boolean field that when set to true will include a feedback link in the email. */
  readonly showFeedbackLink?: InputMaybe<Scalars['Boolean']['input']>;
  /** SubjectTemplate is an optional field that when set will be executed to generate the email subject. */
  readonly subjectTemplate?: InputMaybe<Scalars['String']['input']>;
}

/**
 * CreateEmailSubscriptionInput is used for create EmailSubscription object.
 * Input was generated by ent.
 */
export interface CreateEmailSubscriptionInput {
  readonly attendeeGroups?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly attendees?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly callFilterTemplate?: InputMaybe<Scalars['String']['input']>;
  readonly customerCustomers?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly emailDeliveryIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly emailSubscriptionLinkIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly hostGroups?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly hosts?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly toAddress?: InputMaybe<Scalars['String']['input']>;
  readonly userGroupIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly userID?: InputMaybe<Scalars['ID']['input']>;
}

/**
 * CreateEmailSubscriptionLinkInput is used for create EmailSubscriptionLink object.
 * Input was generated by ent.
 */
export interface CreateEmailSubscriptionLinkInput {
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly emailSubscriptionConfigID: Scalars['ID']['input'];
  readonly emailSubscriptionID: Scalars['ID']['input'];
  readonly enumerationConfigurationID: Scalars['ID']['input'];
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
}

/**
 * CreateEmailThreadInput is used for create EmailThread object.
 * Input was generated by ent.
 */
export interface CreateEmailThreadInput {
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly emailIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly externalIdentifier: Scalars['String']['input'];
  readonly lastActivityAt: Scalars['Unix']['input'];
  readonly sourcePlatform: CallIntegration;
  readonly summaryIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly userID: Scalars['ID']['input'];
}

/**
 * CreateEmailThreadSummaryInput is used for create EmailThreadSummary object.
 * Input was generated by ent.
 */
export interface CreateEmailThreadSummaryInput {
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly emailID: Scalars['ID']['input'];
  readonly emailThreadID: Scalars['ID']['input'];
  readonly summary: Scalars['String']['input'];
}

/**
 * CreateEnumerationConfigFieldLinkInput is used for create EnumerationConfigFieldLink object.
 * Input was generated by ent.
 */
export interface CreateEnumerationConfigFieldLinkInput {
  readonly classifierConditionIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** Definitions represent the contextual definition that the model needs in order to be able to best do it's job, so that there isn't ambiguity about the terms using in the instructions/directions or whether the calls/documents themselves. This is often left blank if there isn't much chance of confusion. If the type of the value or score is non-custom, then adding to this will append the text after the standard definitions for that field. */
  readonly definitions?: InputMaybe<Scalars['String']['input']>;
  /** Directions are the specific steps or detailed context that the model needs to take in order to complete the analysis. This is generally more detailed than the instructions and is often used to break down the instructions into more digestible steps or talk through edge cases. If the type of the value or score is non-custom, then adding to this will append the text after the standard directions for that field. */
  readonly directions?: InputMaybe<Scalars['String']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly draftIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly enumerationConfigurationID: Scalars['ID']['input'];
  readonly enumerationFieldID: Scalars['ID']['input'];
  /** Instructions represents the main description of the task that the model needs to do to complete the analysis. For normal fields, this generally describes how to analyze the call/document. For scores, this is the rubric that outlines exactly how to score the rep on the call. If the type of the value or score is non-custom, then adding to this will append the text after the standard instructions for that field. */
  readonly instructions?: InputMaybe<Scalars['String']['input']>;
  /**
   * IsAggregation represents whether the field is an aggregation of the enumeration field, or the
   * field itself is what is to be enumerated.
   */
  readonly isAggregation?: InputMaybe<Scalars['Boolean']['input']>;
  readonly knowledgeDocumentPromptInstructionIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  /** Version tracks the revision number of this EnumerationConfigFieldLink. It increments with each deployment. */
  readonly version?: InputMaybe<Scalars['Int']['input']>;
}

/**
 * CreateEnumerationConfigStageLinkInput is used for create EnumerationConfigStageLink object.
 * Input was generated by ent.
 */
export interface CreateEnumerationConfigStageLinkInput {
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly enumerationConfigurationID: Scalars['ID']['input'];
  readonly pipelineStageID: Scalars['ID']['input'];
}

/**
 * CreateEnumerationConfigurationClassifierEnumInput is used for create EnumerationConfigurationClassifierEnum object.
 * Input was generated by ent.
 */
export interface CreateEnumerationConfigurationClassifierEnumInput {
  readonly classifierEnumValueID: Scalars['ID']['input'];
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly enumerationConfigurationID: Scalars['ID']['input'];
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
}

/**
 * CreateEnumerationConfigurationDraftInput is used for create EnumerationConfigurationDraft object.
 * Input was generated by ent.
 */
export interface CreateEnumerationConfigurationDraftInput {
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly enumerationConfigurationID: Scalars['ID']['input'];
  readonly enumerationFieldIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly name: Scalars['String']['input'];
}

/**
 * CreateEnumerationConfigurationInput is used for create EnumerationConfiguration object.
 * Input was generated by ent.
 */
export interface CreateEnumerationConfigurationInput {
  /** Active specifies whether the enumeration_configuration is currently active. This is separate from disabled, which means that it is soft-deleted. */
  readonly active?: InputMaybe<Scalars['Boolean']['input']>;
  /** CustomPreface, if set, will overwrite or the standard prompt preface (which differs depending on the Mode). */
  readonly customPreface?: InputMaybe<Scalars['String']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly draftIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly emailSubscriptionConfigIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly emailSubscriptionLinkIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly enumerationConfigurationClassifierEnumValueIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly enumerationFieldIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly enumerationPromptConfigFilterID?: InputMaybe<Scalars['ID']['input']>;
  readonly enumerationPromptConfigIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly enumerationValueIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** FilterTemplate determines which calls/documents/etc should be analyzed by this specific enumeration_configuration. For example, we could filter it to only analyze calls from certain reps, or calls with certain names, or documents that are added to the account during a certain part of the sales pipeline */
  readonly filterTemplate?: InputMaybe<Scalars['String']['input']>;
  readonly knowledgeDocumentPromptInstructionIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly lookBackDays?: InputMaybe<Scalars['Int']['input']>;
  /** Mode specifies which type(s) of messages the config applies to. */
  readonly mode: EnumerationConfigurationMode;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  readonly pipelineStageIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /**
   * Publish specifies whether the resulting enumeration values are published to downstream consumers.
   * Should be set to true once "live".
   */
  readonly publish?: InputMaybe<Scalars['Boolean']['input']>;
  /** ScoreEligibilityQuestions represents a way to "turn off" doing a full analysis if it doesn't fit into the type of analysis we want to perform. For example, the default is that if the client doesn't show up to a call, then we don't do a full analysis. */
  readonly scoreEligibilityQuestions?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly type: EnumerationConfigurationType;
  /** UseTool specifies whether to use the tool to generate analysis. */
  readonly useTool?: InputMaybe<Scalars['Boolean']['input']>;
}

/**
 * CreateEnumerationDraftInput is used for create EnumerationDraft object.
 * Input was generated by ent.
 */
export interface CreateEnumerationDraftInput {
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly enumerationFieldDraftIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly name: Scalars['String']['input'];
  /** Status indicates the current state of the draft in the drafting workflow. */
  readonly status: EnumerationDraftDraftStatus;
}

/**
 * CreateEnumerationFieldDraftInput is used for create EnumerationFieldDraft object.
 * Input was generated by ent.
 */
export interface CreateEnumerationFieldDraftInput {
  readonly alwaysIncludeTranscript?: InputMaybe<Scalars['Boolean']['input']>;
  readonly complexity: EnumerationFieldDraftComplexity;
  /** CustomOutputMessage provides a template for the output formatting of the analysis, if needed. */
  readonly customOutputMessage?: InputMaybe<Scalars['String']['input']>;
  /** Definitions represent the contextual definition that the model needs in order to be able to best do it's job, so that there isn't ambiguity about the terms using in the instructions/directions or whether the calls/documents themselves. This is often left blank if there isn't much chance of confusion. If the type of the value or score is non-custom, then adding to this will append the text after the standard definitions for that field. */
  readonly definitions?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** Directions are the specific steps or detailed context that the model needs to take in order to complete the analysis. This is generally more detailed than the instructions and is often used to break down the instructions into more digestible steps or talk through edge cases. If the type of the value or score is non-custom, then adding to this will append the text after the standard directions for that field. */
  readonly directions?: InputMaybe<Scalars['String']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly enumerationDraftID?: InputMaybe<Scalars['ID']['input']>;
  /** Instructions represents the main description of the task that the model needs to do to complete the analysis. For normal fields, this generally describes how to analyze the call/document. For scores, this is the rubric that outlines exactly how to score the rep on the call. If the type of the value or score is non-custom, then adding to this will append the text after the standard instructions for that field. */
  readonly instructions?: InputMaybe<Scalars['String']['input']>;
  /** IsRuleBased indicates if the analysis follows specific rules (true) or is more judgment-based (false). */
  readonly isRuleBased?: InputMaybe<Scalars['Boolean']['input']>;
  readonly liveFieldID?: InputMaybe<Scalars['ID']['input']>;
  readonly name: Scalars['String']['input'];
  /** ScoreType specifies the scoring method for score analyses. It may be a custom score or a predefined score type. */
  readonly scoreType?: InputMaybe<EnumerationFieldDraftType>;
  /** Scratchpad contains prompts or instructions to assist the model in processing complex analyses. */
  readonly scratchpad?: InputMaybe<Scalars['String']['input']>;
  /** Status indicates the current state of the draft in the drafting workflow. */
  readonly status: EnumerationFieldDraftDraftStatus;
  /** ValueType specifies the output type for value analyses. It may be a standard field, an array of strings, a key-value map, etc. */
  readonly valueType?: InputMaybe<EnumerationFieldDraftValue>;
  /** Version tracks the revision number of this draft. It increments with each new draft for a specific field, and it is DIFFERENT than the version of the EnumerationField that this draft is modifying (because drafts can be rejected, etc). */
  readonly version?: InputMaybe<Scalars['Int']['input']>;
}

/**
 * CreateEnumerationFieldInput is used for create EnumerationField object.
 * Input was generated by ent.
 */
export interface CreateEnumerationFieldInput {
  /**
   * AlwaysIncludeTranscript determines whether we should include the transcript in the analysis IF
   * the analysis also has fields it depends on.
   */
  readonly alwaysIncludeTranscript?: InputMaybe<Scalars['Boolean']['input']>;
  readonly complexity: EnumerationFieldComplexity;
  readonly crmSubscriptionIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly customFieldIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** CustomOutputMessage, if set, will replace the generic value in the OutputFormat. This will provide the template for the output of the analysis. For example, if generating a job description, the CustomOutputMessage may show the model to format the JD with sections for Requirements, Responsibilities, and Scope. */
  readonly customOutputMessage?: InputMaybe<Scalars['String']['input']>;
  /** Definitions represent the contextual definition that the model needs in order to be able to best do it's job, so that there isn't ambiguity about the terms using in the instructions/directions or whether the calls/documents themselves. This is often left blank if there isn't much chance of confusion. If the type of the value or score is non-custom, then adding to this will append the text after the standard definitions for that field. */
  readonly definitions?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** Directions are the specific steps or detailed context that the model needs to take in order to complete the analysis. This is generally more detailed than the instructions and is often used to break down the instructions into more digestible steps or talk through edge cases. If the type of the value or score is non-custom, then adding to this will append the text after the standard directions for that field. */
  readonly directions?: InputMaybe<Scalars['String']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly draftIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly emailSubscriptionConfigFieldIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly enumerationConfigurationIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly fromFieldDependencyLinkIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** Instructions represents the main description of the task that the model needs to do to complete the analysis. For normal fields, this generally describes how to analyze the call/document. For scores, this is the rubric that outlines exactly how to score the rep on the call. If the type of the value or score is non-custom, then adding to this will append the text after the standard instructions for that field. */
  readonly instructions?: InputMaybe<Scalars['String']['input']>;
  /**
   * IsRuleBased is a flag that determines whether the instructions are primarily based on specific rules to follow (such as "did the sales rep mention XYZ while selling")
   * or is it more judgement based (how good of a fit is this customer for our product).
   */
  readonly isRuleBased?: InputMaybe<Scalars['Boolean']['input']>;
  readonly knowledgeDocumentPromptInstructionIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly name: Scalars['String']['input'];
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  readonly outputIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly scoreIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** ScoreType is non-nill when the enumeration_field represents a score analysis. It is either a pre-defined score like 'Type_DISCOVERY' that already has the score laid out, or (more likely) it defines the type of the score which would be 'Type_CUSTOM_SCORE'. */
  readonly scoreType?: InputMaybe<EnumerationFieldType>;
  /** Scratchpad, if set, will add a scratchpad field prior to the output of this field whose directions are the value of this field. This will let the model think through the answer beforehand, which is useful when the analysis is complex and the model may need to think out loud before outputting the final analysis. */
  readonly scratchpad?: InputMaybe<Scalars['String']['input']>;
  readonly toFieldDependencyLinkIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly userScoreStatIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** ValueType is non-nil when the enumeration_field represents a value analysis. It is either a pre-defined analysis like 'Stakeholders' that already has the analysis laid out, or (more likely) it defines the type of the value. This is either a standard field (which is type Value_CUSTOM_STRING), an array of fields such as when trying to capture all the competitors (which is type Value_CUSTOM_STRINGS), or a key/value map such as when trying to capture the customer's objections and explaining how the rep handled it (which is type Value_CUSTOM_MAP). */
  readonly valueType?: InputMaybe<EnumerationFieldValue>;
  /** Version tracks the revision number of this EnumerationField. It increments with each deployment. */
  readonly version?: InputMaybe<Scalars['Int']['input']>;
}

/**
 * CreateEnumerationPromptConfigInput is used for create EnumerationPromptConfig object.
 * Input was generated by ent.
 */
export interface CreateEnumerationPromptConfigInput {
  readonly analysisMode: EnumerationPromptConfigMode;
  /** CustomDocumentPreface, if set, will either overwrite or append/prepend to the standard prompt document section. */
  readonly customDocumentPreface?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly customDocumentPrefaceAction?: InputMaybe<EnumerationPromptConfigCustomAction>;
  /**
   * CustomSystemMessage, if set, will either overwrite or append/prepend to the standard prompt "system message"
   * aka the very beginning of the prompt (depending on CustomSystemMessageAction). Each value will be on a new line.
   */
  readonly customSystemMessage?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly customSystemMessageAction?: InputMaybe<EnumerationPromptConfigCustomAction>;
  /**
   * CustomTranscriptPreface, if set, will either overwrite or append/prepend to the standard prompt transcript
   * preface (depending on CustomSystemMessageAction). Each value will be on a new line.
   */
  readonly customTranscriptPreface?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly customTranscriptPrefaceAction?: InputMaybe<EnumerationPromptConfigCustomAction>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly enumerationConfigurationsID: Scalars['ID']['input'];
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
}

/**
 * CreateEnumerationValueFeedbackInput is used for create EnumerationValueFeedback object.
 * Input was generated by ent.
 */
export interface CreateEnumerationValueFeedbackInput {
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly enumerationFieldID: Scalars['ID']['input'];
  readonly enumerationValueID: Scalars['ID']['input'];
  readonly feedback: Scalars['String']['input'];
  readonly fieldName: Scalars['String']['input'];
  readonly fieldType: EnumerationValueFeedbackFieldType;
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  /** specificFieldText represents a specific portion text that the user wants to give feedback on. */
  readonly specificFieldText?: InputMaybe<Scalars['String']['input']>;
}

/**
 * CreateEnumerationValueInput is used for create EnumerationValue object.
 * Input was generated by ent.
 */
export interface CreateEnumerationValueInput {
  readonly additionalCallUuids: ReadonlyArray<Scalars['ID']['input']>;
  readonly additionalDocumentUuids: ReadonlyArray<Scalars['ID']['input']>;
  readonly callID?: InputMaybe<Scalars['ID']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly documentID?: InputMaybe<Scalars['ID']['input']>;
  readonly emailDeliveryIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly emailID?: InputMaybe<Scalars['ID']['input']>;
  readonly endDate?: InputMaybe<Scalars['Unix']['input']>;
  readonly enumerationConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  readonly enumerationValueFeedbackIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /**
   * "Feedback refers to feedback from a user (or internal) on
   * whether or not the EnumerationValue was (in)correct. If null,
   * no feedback has been given."
   */
  readonly feedback?: InputMaybe<Scalars['Boolean']['input']>;
  readonly feedbackComment?: InputMaybe<Scalars['String']['input']>;
  readonly gongUserID?: InputMaybe<Scalars['ID']['input']>;
  readonly opportunityStageChangeID?: InputMaybe<Scalars['ID']['input']>;
  readonly outputIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly scoreIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly startDate?: InputMaybe<Scalars['Unix']['input']>;
}

/**
 * CreateEnumerationValueScoreInput is used for create EnumerationValueScore object.
 * Input was generated by ent.
 */
export interface CreateEnumerationValueScoreInput {
  readonly cons: Scalars['String']['input'];
  readonly deliveryIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly enumerationFieldID: Scalars['ID']['input'];
  readonly enumerationValueID: Scalars['ID']['input'];
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  readonly pros: Scalars['String']['input'];
  /**
   * Score is the score given to the enumeration value. It is a value between 1 and 10. If nil,
   * this score was not applicable for the given source input.
   */
  readonly score?: InputMaybe<Scalars['Int']['input']>;
  readonly suggestions?: InputMaybe<Scalars['String']['input']>;
}

/**
 * CreateFieldDependencyLinkInput is used for create FieldDependencyLink object.
 * Input was generated by ent.
 */
export interface CreateFieldDependencyLinkInput {
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly fromEnumerationFieldID?: InputMaybe<Scalars['ID']['input']>;
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  readonly toEnumerationFieldID?: InputMaybe<Scalars['ID']['input']>;
}

/**
 * CreateGongUserInput is used for create GongUser object.
 * Input was generated by ent.
 */
export interface CreateGongUserInput {
  readonly active: Scalars['Boolean']['input'];
  readonly callIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly documentIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly emailAddress?: InputMaybe<Scalars['String']['input']>;
  readonly enumerationValueIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly externalUserID: Scalars['OldID']['input'];
  readonly fabiusManagerIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly fabiusReportIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly firstName: Scalars['String']['input'];
  readonly lastName: Scalars['String']['input'];
  readonly managerID?: InputMaybe<Scalars['ID']['input']>;
  readonly opportunityIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly reportIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly sourcePlatform?: InputMaybe<GongUserCallIntegration>;
  readonly title?: InputMaybe<Scalars['String']['input']>;
  readonly userID?: InputMaybe<Scalars['ID']['input']>;
}

/**
 * CreateIntegrationSecretInput is used for create IntegrationSecret object.
 * Input was generated by ent.
 */
export interface CreateIntegrationSecretInput {
  /** AccountID represents the associated account ID of the integration (if applicable). */
  readonly accountID?: InputMaybe<Scalars['String']['input']>;
  readonly childSecretIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly customerCrmConfigID?: InputMaybe<Scalars['ID']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly documentIngestionConfigID?: InputMaybe<Scalars['ID']['input']>;
  readonly integration: IntegrationSecretCallIntegration;
  /** IsBackfilling means we are actively backfilling data from this integration if true. */
  readonly isBackfilling?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  readonly parentSecretID?: InputMaybe<Scalars['ID']['input']>;
  readonly secretArn: Scalars['String']['input'];
  readonly useCases: ReadonlyArray<UseCase>;
  readonly userID?: InputMaybe<Scalars['ID']['input']>;
}

/**
 * CreateKnowledgeDocumentInput is used for create KnowledgeDocument object.
 * Input was generated by ent.
 */
export interface CreateKnowledgeDocumentInput {
  readonly currentVersionID?: InputMaybe<Scalars['ID']['input']>;
  /** Description is the customer-facing description of the document */
  readonly description: Scalars['String']['input'];
  readonly directoryID?: InputMaybe<Scalars['ID']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly emailReplyContextIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** IsUseful is a flag to indicate if the document is useful or not for further processing/synthesis. When we ingest large numbers of documents at once, we want to give the models an option to process a document (so we don't process it again) while flagging that it shouldn't be used for downstream purposes. An example could be a webpage with only 2-3 sentences on it, terms of service that are very long and don't have much information, or internal documents that aren't useful for sales */
  readonly isUseful?: InputMaybe<Scalars['Boolean']['input']>;
  readonly knowledgeDocumentPromptInstructionIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** MimeType is the mime type of the raw document contents stored in the RawFilePath */
  readonly mimeType: Scalars['String']['input'];
  readonly name: Scalars['String']['input'];
  readonly oldID?: InputMaybe<Scalars['OldID']['input']>;
  /** Source is where the document came from, for example a manual upload, a URL, or a Google Docs. */
  readonly source: KnowledgeDocumentDocumentSourceType;
  /** Type is the type of the document - meant in a domain-specific way. For example, two documents from a customer's webpage could be different types, like one could be marketing material and the other product documentation */
  readonly type: KnowledgeDocumentDocumentType;
  /** URL is the URL to the document (if it was pulled from a URL). */
  readonly url?: InputMaybe<Scalars['String']['input']>;
  readonly versionIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
}

/**
 * CreateKnowledgeDocumentPromptInstructionInput is used for create KnowledgeDocumentPromptInstruction object.
 * Input was generated by ent.
 */
export interface CreateKnowledgeDocumentPromptInstructionInput {
  readonly classifierConditionID?: InputMaybe<Scalars['ID']['input']>;
  /** Definitions represent the contextual definition that the model needs in order to be able to best do it's job, so that there isn't ambiguity about the terms using in the instructions/directions or whether the calls/documents themselves. This is often left blank if there isn't much chance of confusion. If the type of the value or score is non-custom, then adding to this will append the text after the standard definitions for that field. */
  readonly definitions?: InputMaybe<Scalars['String']['input']>;
  /** Directions are the specific steps or detailed context that the model needs to take in order to complete the analysis. This is generally more detailed than the instructions and is often used to break down the instructions into more digestible steps or talk through edge cases. If the type of the value or score is non-custom, then adding to this will append the text after the standard directions for that field. */
  readonly directions?: InputMaybe<Scalars['String']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly enumerationConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  readonly enumerationFieldID?: InputMaybe<Scalars['ID']['input']>;
  /** Instructions represents the main description of the task that the model needs to do to complete the analysis. For normal fields, this generally describes how to analyze the call/document. For scores, this is the rubric that outlines exactly how to score the rep on the call. If the type of the value or score is non-custom, then adding to this will append the text after the standard instructions for that field. */
  readonly instructions?: InputMaybe<Scalars['String']['input']>;
  readonly knowledgeDocumentID: Scalars['ID']['input'];
  /** Mode indicating how the knowledge document's content affects the prompt. */
  readonly mode: KnowledgeDocumentPromptInstructionKnowledgeDocumentPromptInstructionMode;
}

/**
 * CreateKnowledgeDocumentVersionInput is used for create KnowledgeDocumentVersion object.
 * Input was generated by ent.
 */
export interface CreateKnowledgeDocumentVersionInput {
  /** LLM-written summary of changes from the previous version, primarily used to pass downstream to have another LLM make updates to things like enumerationfield instructions, etc. */
  readonly diffSummary?: InputMaybe<Scalars['String']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** InternalSummary is a summary of the document for internal (non-customer) use. */
  readonly internalSummary?: InputMaybe<Scalars['String']['input']>;
  readonly knowledgeDocumentID: Scalars['ID']['input'];
  /** Metadata specific to this version */
  readonly metadata?: InputMaybe<Scalars['JSON']['input']>;
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  /** Checksum of the processed file */
  readonly processedChecksum?: InputMaybe<Scalars['String']['input']>;
  /** Path to the processed version of the file on S3 for this version */
  readonly processedFilePath?: InputMaybe<Scalars['String']['input']>;
  /** Timestamp when background processing finished (successfully or failed). */
  readonly processingCompletedAt?: InputMaybe<Scalars['Int']['input']>;
  /** Stores the error message if background processing failed. */
  readonly processingError?: InputMaybe<Scalars['String']['input']>;
  /** Timestamp when background processing started. */
  readonly processingStartedAt?: InputMaybe<Scalars['Int']['input']>;
  /** The status of background processing for this version. */
  readonly processingStatus: KnowledgeDocumentVersionProcessingStatus;
  /** Checksum of the raw file */
  readonly rawChecksum?: InputMaybe<Scalars['String']['input']>;
  /** Path to the raw version of the file on S3 for this version */
  readonly rawFilePath: Scalars['String']['input'];
  readonly versionNumber?: InputMaybe<Scalars['Int']['input']>;
}

/**
 * CreateOpportunityCallLinkInput is used for create OpportunityCallLink object.
 * Input was generated by ent.
 */
export interface CreateOpportunityCallLinkInput {
  readonly callID: Scalars['ID']['input'];
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly opportunityID: Scalars['ID']['input'];
  readonly opportunityStageChangeID?: InputMaybe<Scalars['ID']['input']>;
  /** Probability is the listed probability of the opportunity at the time of the call. */
  readonly probability: Scalars['Float']['input'];
  /**
   * StageName represents the state of the opportunity at the time of the call.
   * For the current state see the Opportunity table.
   */
  readonly stageName: Scalars['String']['input'];
}

/**
 * CreateOpportunityInput is used for create Opportunity object.
 * Input was generated by ent.
 */
export interface CreateOpportunityInput {
  readonly accountID?: InputMaybe<Scalars['ID']['input']>;
  readonly amount: Scalars['Int']['input'];
  readonly callIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly closeDate: Scalars['Unix']['input'];
  readonly contactID?: InputMaybe<Scalars['ID']['input']>;
  readonly customFieldValueIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly documentIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly documentUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly externalMappingUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly externalOpportunityID: Scalars['OldID']['input'];
  readonly link?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  /** NewlyIngested is true if the opportunity was just ingested by the call-enricher. */
  readonly newlyIngested?: InputMaybe<Scalars['Boolean']['input']>;
  readonly opportunityStageChangeIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly ownerID?: InputMaybe<Scalars['ID']['input']>;
  readonly pipelineStageID?: InputMaybe<Scalars['ID']['input']>;
  /** PlatformCreatedAt is the date when the opportunity was created in the CRM/end-user platform. */
  readonly platformCreatedAt?: InputMaybe<Scalars['Unix']['input']>;
  readonly sourcePlatform?: InputMaybe<CallIntegration>;
  /**
   * StageName represents the current state of the opportunity.
   * For the state at the time of the call see the OpportunityCallLink table.
   */
  readonly stageName: Scalars['String']['input'];
  readonly type: Scalars['String']['input'];
}

/**
 * CreateOpportunityStageChangeInput is used for create OpportunityStageChange object.
 * Input was generated by ent.
 */
export interface CreateOpportunityStageChangeInput {
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly enteredDate: Scalars['Unix']['input'];
  readonly enumerationValueIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly oldID?: InputMaybe<Scalars['OldID']['input']>;
  readonly opportunityID: Scalars['ID']['input'];
  readonly pipelineStageID?: InputMaybe<Scalars['ID']['input']>;
  readonly stageName: Scalars['String']['input'];
}

/**
 * CreatePipelineInput is used for create Pipeline object.
 * Input was generated by ent.
 */
export interface CreatePipelineInput {
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** ExternalPlatformID is the ID of the Pipeline in the CRM. */
  readonly externalPlatformID: Scalars['String']['input'];
  readonly name: Scalars['String']['input'];
  readonly sourcePlatform: PipelineCallIntegration;
  readonly stageIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
}

/**
 * CreatePipelineStageInput is used for create PipelineStage object.
 * Input was generated by ent.
 */
export interface CreatePipelineStageInput {
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly enumerationConfigurationIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** ExternalPlatformID is the ID of the PipelineStage in the CRM. */
  readonly externalPlatformID: Scalars['String']['input'];
  readonly name: Scalars['String']['input'];
  readonly opportunityIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly order: Scalars['Int']['input'];
  readonly outcome?: InputMaybe<PipelineStageOutcome>;
  readonly pipelineID: Scalars['ID']['input'];
  readonly stageChangeIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
}

/**
 * CreateProspectContactInput is used for create ProspectContact object.
 * Input was generated by ent.
 */
export interface CreateProspectContactInput {
  readonly contacted?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly engagementPlatform?: InputMaybe<ProspectContactCallIntegration>;
  readonly externalContactID?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalSequenceID?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalSequenceMembershipID?: InputMaybe<Scalars['OldID']['input']>;
  readonly firstName: Scalars['String']['input'];
  readonly lastName: Scalars['String']['input'];
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  /** Processed is true when the ProspectContact has been analyzed by us. */
  readonly processed?: InputMaybe<Scalars['Boolean']['input']>;
  readonly prospectID: Scalars['ID']['input'];
  readonly title: Scalars['String']['input'];
}

/**
 * CreateProspectExecutiveInput is used for create ProspectExecutive object.
 * Input was generated by ent.
 */
export interface CreateProspectExecutiveInput {
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly firstName: Scalars['String']['input'];
  /** IsRelevant is true if this executive would be relevant to it's CustomerCustomer. */
  readonly isRelevant?: InputMaybe<Scalars['Boolean']['input']>;
  readonly lastName: Scalars['String']['input'];
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  readonly prospectID: Scalars['ID']['input'];
  readonly title: Scalars['String']['input'];
}

/**
 * CreateProspectInput is used for create Prospect object.
 * Input was generated by ent.
 */
export interface CreateProspectInput {
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly domain: Scalars['String']['input'];
  readonly engagementPlatform?: InputMaybe<ProspectCallIntegration>;
  readonly externalProspectID?: InputMaybe<Scalars['OldID']['input']>;
  readonly name: Scalars['String']['input'];
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  readonly prospectContactIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly prospectExecutiveIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly status: ProspectProcessingStatus;
  readonly stockTicker?: InputMaybe<Scalars['String']['input']>;
}

/**
 * CreateReportingLinkInput is used for create ReportingLink object.
 * Input was generated by ent.
 */
export interface CreateReportingLinkInput {
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly managerID: Scalars['ID']['input'];
  readonly reportID: Scalars['ID']['input'];
}

/**
 * CreateSlackDeliveryInput is used for create SlackDelivery object.
 * Input was generated by ent.
 */
export interface CreateSlackDeliveryInput {
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly enumerationValueID: Scalars['ID']['input'];
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  readonly slackSubscriptionID: Scalars['ID']['input'];
  readonly threadTs: Scalars['String']['input'];
}

/**
 * CreateSlackSubscriptionInput is used for create SlackSubscription object.
 * Input was generated by ent.
 */
export interface CreateSlackSubscriptionInput {
  readonly attendeeGroups?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly attendees?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly callFilterTemplate?: InputMaybe<Scalars['String']['input']>;
  readonly channelID: Scalars['String']['input'];
  readonly customerCustomers?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly enumType: SlackSubscriptionValueType;
  readonly hostGroups?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly hosts?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  readonly slackDeliveryIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly type: SlackSubscriptionSubscriptionType;
}

/**
 * CreateTaskInput is used for create Task object.
 * Input was generated by ent.
 */
export interface CreateTaskInput {
  readonly accountID?: InputMaybe<Scalars['ID']['input']>;
  readonly assignedUserID?: InputMaybe<Scalars['ID']['input']>;
  readonly contactID?: InputMaybe<Scalars['ID']['input']>;
  readonly description: Scalars['String']['input'];
  /** Details for the task, if applicable. This might be quite long and contain instructions to the user on how to complete the task. */
  readonly details?: InputMaybe<Scalars['String']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly emailIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly status: TaskStatus;
  readonly title: Scalars['String']['input'];
}

/**
 * CreateTaskReferenceInput is used for create TaskReference object.
 * Input was generated by ent.
 */
export interface CreateTaskReferenceInput {
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly emailID: Scalars['ID']['input'];
  readonly taskID: Scalars['ID']['input'];
}

/**
 * CreateUserCallStatInput is used for create UserCallStat object.
 * Input was generated by ent.
 */
export interface CreateUserCallStatInput {
  readonly count: Scalars['Int']['input'];
  readonly date: Scalars['Unix']['input'];
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly userID: Scalars['ID']['input'];
}

/**
 * CreateUserGroupInput is used for create UserGroup object.
 * Input was generated by ent.
 */
export interface CreateUserGroupInput {
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly managerID?: InputMaybe<Scalars['ID']['input']>;
  readonly name: Scalars['String']['input'];
  readonly oldID?: InputMaybe<Scalars['OldID']['input']>;
  readonly userIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly viewerIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
}

/**
 * CreateUserGroupMembershipInput is used for create UserGroupMembership object.
 * Input was generated by ent.
 */
export interface CreateUserGroupMembershipInput {
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  readonly userGroupID: Scalars['ID']['input'];
  readonly userID: Scalars['ID']['input'];
}

/**
 * CreateUserGroupViewerInput is used for create UserGroupViewer object.
 * Input was generated by ent.
 */
export interface CreateUserGroupViewerInput {
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly userGroupID: Scalars['ID']['input'];
  readonly viewerID: Scalars['ID']['input'];
}

/**
 * CreateUserInput is used for create User object.
 * Input was generated by ent.
 */
export interface CreateUserInput {
  readonly assignedTaskIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly auth0ID?: InputMaybe<Scalars['String']['input']>;
  readonly callStatIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly email: Scalars['String']['input'];
  readonly emailSubscriptionIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly emailThreadIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly firstName?: InputMaybe<Scalars['String']['input']>;
  readonly gongUserIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly integrationSecretIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly internal?: InputMaybe<Scalars['Boolean']['input']>;
  readonly lastName?: InputMaybe<Scalars['String']['input']>;
  readonly managedUserGroupIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  readonly receivedEmailIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly role?: InputMaybe<UserRole>;
  readonly scoreStatIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly sentEmailIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly userGroupIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly userProspectingConfigID?: InputMaybe<Scalars['ID']['input']>;
  readonly viewedUserGroupIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly welcomeEmailSent?: InputMaybe<Scalars['Boolean']['input']>;
}

/**
 * CreateUserProspectingConfigInput is used for create UserProspectingConfig object.
 * Input was generated by ent.
 */
export interface CreateUserProspectingConfigInput {
  /** Automatically ingest prospects from the user's engagement platform (e.g. HubSpot). */
  readonly autoIngestProspects?: InputMaybe<Scalars['Boolean']['input']>;
  /** Automatically push prospect analysis to the user's CRM (e.g. HubSpot). */
  readonly autoPushToCrm?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** User-specific link to schedule a meeting, e.g. Calendly */
  readonly meetingLink?: InputMaybe<Scalars['String']['input']>;
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  readonly userID: Scalars['ID']['input'];
}

/**
 * CreateUserScoreStatInput is used for create UserScoreStat object.
 * Input was generated by ent.
 */
export interface CreateUserScoreStatInput {
  readonly count: Scalars['Int']['input'];
  readonly date: Scalars['Unix']['input'];
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly eightCount?: InputMaybe<Scalars['Int']['input']>;
  readonly enumerationFieldID: Scalars['ID']['input'];
  readonly fiveCount?: InputMaybe<Scalars['Int']['input']>;
  readonly fourCount?: InputMaybe<Scalars['Int']['input']>;
  readonly nineCount?: InputMaybe<Scalars['Int']['input']>;
  readonly oneCount?: InputMaybe<Scalars['Int']['input']>;
  readonly sevenCount?: InputMaybe<Scalars['Int']['input']>;
  readonly sixCount?: InputMaybe<Scalars['Int']['input']>;
  readonly tenCount?: InputMaybe<Scalars['Int']['input']>;
  readonly threeCount?: InputMaybe<Scalars['Int']['input']>;
  readonly total: Scalars['Int']['input'];
  readonly twoCount?: InputMaybe<Scalars['Int']['input']>;
  readonly userID: Scalars['ID']['input'];
}

export interface CustomField extends Node {
  readonly createdAt: Scalars['Int']['output'];
  readonly customFieldEnumerationFieldLinks: CustomFieldEnumerationFieldLinkConnection;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly disabled: Scalars['Boolean']['output'];
  readonly displayName: Scalars['String']['output'];
  readonly enumerationFields: EnumerationFieldConnection;
  readonly enums?: Maybe<ReadonlyArray<CustomFieldEnum>>;
  /**
   * ExternalIdentifier refers to a platform's internal name / ID for a given field.
   * E.g. in HubSpot, a property has both "label" (which is equivalent to our DisplayName field)
   * and a "name" field (which is unique, e.g. "favorite_food"). Other platforms have a typical
   * identifier, e.g. a UUID.
   */
  readonly externalIdentifier?: Maybe<Scalars['String']['output']>;
  readonly fieldType?: Maybe<CustomFieldCustomFieldType>;
  /** GroupName corresponds to the grouping of fields present in CRMs like Hubspot */
  readonly groupName?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly objectType?: Maybe<CustomFieldObjectType>;
  readonly sourcePlatform?: Maybe<CallIntegration>;
  readonly updatedAt: Scalars['Int']['output'];
  readonly values?: Maybe<ReadonlyArray<CustomFieldValue>>;
}


export interface CustomFieldCustomFieldEnumerationFieldLinksArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CustomFieldEnumerationFieldLinkOrder>;
  where?: InputMaybe<CustomFieldEnumerationFieldLinkWhereInput>;
}


export interface CustomFieldEnumerationFieldsArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EnumerationFieldOrder>;
  where?: InputMaybe<EnumerationFieldWhereInput>;
}

/** A connection to a list of items. */
export interface CustomFieldConnection {
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<CustomFieldEdge>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
}

/** CustomFieldCustomFieldType is enum for the field field_type */
export const CustomFieldCustomFieldType = {
  Boolean: 'BOOLEAN',
  Date: 'DATE',
  Datetime: 'DATETIME',
  Enum: 'ENUM',
  Number: 'NUMBER',
  Text: 'TEXT',
  UnknownCustomFieldType: 'UNKNOWN_CUSTOM_FIELD_TYPE'
} as const;

export type CustomFieldCustomFieldType = typeof CustomFieldCustomFieldType[keyof typeof CustomFieldCustomFieldType];
/** An edge in a connection. */
export interface CustomFieldEdge {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<CustomField>;
}

export interface CustomFieldEnum extends Node {
  readonly createdAt: Scalars['Int']['output'];
  readonly customField: CustomField;
  readonly customFieldUUID: Scalars['ID']['output'];
  readonly disabled: Scalars['Boolean']['output'];
  /**
   * ExternalIdentifier refers to a platform's internal name / ID for a given field value.
   * Not every platform has these (e.g. HubSpot), but some (like Volie) do.
   */
  readonly externalIdentifier?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly updatedAt: Scalars['Int']['output'];
  readonly value: Scalars['String']['output'];
  readonly values?: Maybe<ReadonlyArray<CustomFieldValue>>;
}

/** A connection to a list of items. */
export interface CustomFieldEnumConnection {
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<CustomFieldEnumEdge>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface CustomFieldEnumEdge {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<CustomFieldEnum>;
}

/** Ordering options for CustomFieldEnum connections */
export interface CustomFieldEnumOrder {
  /** The ordering direction. */
  readonly direction?: OrderDirection;
  /** The field by which to order CustomFieldEnums. */
  readonly field: CustomFieldEnumOrderField;
}

/** Properties by which CustomFieldEnum connections can be ordered. */
export const CustomFieldEnumOrderField = {
  CreatedAt: 'CREATED_AT',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type CustomFieldEnumOrderField = typeof CustomFieldEnumOrderField[keyof typeof CustomFieldEnumOrderField];
/**
 * CustomFieldEnumWhereInput is used for filtering CustomFieldEnum objects.
 * Input was generated by ent.
 */
export interface CustomFieldEnumWhereInput {
  readonly and?: InputMaybe<ReadonlyArray<CustomFieldEnumWhereInput>>;
  /** created_at field predicates */
  readonly createdAt?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly createdAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** custom_field_uuid field predicates */
  readonly customFieldUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly customFieldUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly customFieldUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly customFieldUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** disabled field predicates */
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** external_identifier field predicates */
  readonly externalIdentifier?: InputMaybe<Scalars['String']['input']>;
  readonly externalIdentifierContains?: InputMaybe<Scalars['String']['input']>;
  readonly externalIdentifierContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly externalIdentifierEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly externalIdentifierGT?: InputMaybe<Scalars['String']['input']>;
  readonly externalIdentifierGTE?: InputMaybe<Scalars['String']['input']>;
  readonly externalIdentifierHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly externalIdentifierHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly externalIdentifierIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly externalIdentifierIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly externalIdentifierLT?: InputMaybe<Scalars['String']['input']>;
  readonly externalIdentifierLTE?: InputMaybe<Scalars['String']['input']>;
  readonly externalIdentifierNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly externalIdentifierNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly externalIdentifierNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** custom_field edge predicates */
  readonly hasCustomField?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasCustomFieldWith?: InputMaybe<ReadonlyArray<CustomFieldWhereInput>>;
  /** values edge predicates */
  readonly hasValues?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasValuesWith?: InputMaybe<ReadonlyArray<CustomFieldValueWhereInput>>;
  /** id field predicates */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly idGT?: InputMaybe<Scalars['ID']['input']>;
  readonly idGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly idLT?: InputMaybe<Scalars['ID']['input']>;
  readonly idLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly idNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly not?: InputMaybe<CustomFieldEnumWhereInput>;
  readonly or?: InputMaybe<ReadonlyArray<CustomFieldEnumWhereInput>>;
  /** updated_at field predicates */
  readonly updatedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly updatedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** value field predicates */
  readonly value?: InputMaybe<Scalars['String']['input']>;
  readonly valueContains?: InputMaybe<Scalars['String']['input']>;
  readonly valueContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly valueEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly valueGT?: InputMaybe<Scalars['String']['input']>;
  readonly valueGTE?: InputMaybe<Scalars['String']['input']>;
  readonly valueHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly valueHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly valueIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly valueLT?: InputMaybe<Scalars['String']['input']>;
  readonly valueLTE?: InputMaybe<Scalars['String']['input']>;
  readonly valueNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly valueNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
}

export interface CustomFieldEnumerationFieldLink extends Node {
  readonly createdAt: Scalars['Int']['output'];
  readonly createdByUUID: Scalars['ID']['output'];
  readonly customField: CustomField;
  readonly customFieldID: Scalars['ID']['output'];
  readonly disabled: Scalars['Boolean']['output'];
  readonly enumerationField: EnumerationField;
  readonly enumerationFieldID: Scalars['ID']['output'];
  readonly id: Scalars['ID']['output'];
  readonly oldCreatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly oldUpdatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly updatedAt: Scalars['Int']['output'];
  readonly updatedByUUID: Scalars['ID']['output'];
}

/** A connection to a list of items. */
export interface CustomFieldEnumerationFieldLinkConnection {
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<CustomFieldEnumerationFieldLinkEdge>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface CustomFieldEnumerationFieldLinkEdge {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<CustomFieldEnumerationFieldLink>;
}

/** Ordering options for CustomFieldEnumerationFieldLink connections */
export interface CustomFieldEnumerationFieldLinkOrder {
  /** The ordering direction. */
  readonly direction?: OrderDirection;
  /** The field by which to order CustomFieldEnumerationFieldLinks. */
  readonly field: CustomFieldEnumerationFieldLinkOrderField;
}

/** Properties by which CustomFieldEnumerationFieldLink connections can be ordered. */
export const CustomFieldEnumerationFieldLinkOrderField = {
  CreatedAt: 'CREATED_AT',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type CustomFieldEnumerationFieldLinkOrderField = typeof CustomFieldEnumerationFieldLinkOrderField[keyof typeof CustomFieldEnumerationFieldLinkOrderField];
/**
 * CustomFieldEnumerationFieldLinkWhereInput is used for filtering CustomFieldEnumerationFieldLink objects.
 * Input was generated by ent.
 */
export interface CustomFieldEnumerationFieldLinkWhereInput {
  readonly and?: InputMaybe<ReadonlyArray<CustomFieldEnumerationFieldLinkWhereInput>>;
  /** created_at field predicates */
  readonly createdAt?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly createdAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** disabled field predicates */
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** id field predicates */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly idGT?: InputMaybe<Scalars['ID']['input']>;
  readonly idGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly idLT?: InputMaybe<Scalars['ID']['input']>;
  readonly idLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly idNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly not?: InputMaybe<CustomFieldEnumerationFieldLinkWhereInput>;
  /** old_created_by_id field predicates */
  readonly oldCreatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldCreatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_updated_by_id field predicates */
  readonly oldUpdatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldUpdatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly or?: InputMaybe<ReadonlyArray<CustomFieldEnumerationFieldLinkWhereInput>>;
  /** updated_at field predicates */
  readonly updatedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly updatedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
}

/** CustomFieldObjectType is enum for the field object_type */
export const CustomFieldObjectType = {
  Call: 'CALL',
  Company: 'COMPANY',
  Contact: 'CONTACT',
  Deal: 'DEAL',
  Document: 'DOCUMENT',
  Email: 'EMAIL',
  Pipeline: 'PIPELINE',
  Unknown: 'UNKNOWN'
} as const;

export type CustomFieldObjectType = typeof CustomFieldObjectType[keyof typeof CustomFieldObjectType];
/** Ordering options for CustomField connections */
export interface CustomFieldOrder {
  /** The ordering direction. */
  readonly direction?: OrderDirection;
  /** The field by which to order CustomFields. */
  readonly field: CustomFieldOrderField;
}

/** Properties by which CustomField connections can be ordered. */
export const CustomFieldOrderField = {
  CreatedAt: 'CREATED_AT',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type CustomFieldOrderField = typeof CustomFieldOrderField[keyof typeof CustomFieldOrderField];
export interface CustomFieldValue extends Node {
  readonly account?: Maybe<Account>;
  readonly accountUUID?: Maybe<Scalars['ID']['output']>;
  readonly call?: Maybe<Call>;
  readonly callUUID?: Maybe<Scalars['ID']['output']>;
  readonly contact?: Maybe<Contact>;
  readonly contactUUID?: Maybe<Scalars['ID']['output']>;
  readonly createdAt: Scalars['Int']['output'];
  readonly customField: CustomField;
  readonly customFieldEnum?: Maybe<CustomFieldEnum>;
  readonly customFieldEnumUUID?: Maybe<Scalars['ID']['output']>;
  readonly customFieldUUID: Scalars['ID']['output'];
  readonly disabled: Scalars['Boolean']['output'];
  readonly document?: Maybe<Document>;
  readonly documentUUID?: Maybe<Scalars['ID']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly opportunity?: Maybe<Opportunity>;
  readonly opportunityUUID?: Maybe<Scalars['ID']['output']>;
  readonly updatedAt: Scalars['Int']['output'];
  readonly value?: Maybe<Scalars['String']['output']>;
}

/** A connection to a list of items. */
export interface CustomFieldValueConnection {
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<CustomFieldValueEdge>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface CustomFieldValueEdge {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<CustomFieldValue>;
}

/** Ordering options for CustomFieldValue connections */
export interface CustomFieldValueOrder {
  /** The ordering direction. */
  readonly direction?: OrderDirection;
  /** The field by which to order CustomFieldValues. */
  readonly field: CustomFieldValueOrderField;
}

/** Properties by which CustomFieldValue connections can be ordered. */
export const CustomFieldValueOrderField = {
  CreatedAt: 'CREATED_AT',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type CustomFieldValueOrderField = typeof CustomFieldValueOrderField[keyof typeof CustomFieldValueOrderField];
/**
 * CustomFieldValueWhereInput is used for filtering CustomFieldValue objects.
 * Input was generated by ent.
 */
export interface CustomFieldValueWhereInput {
  /** account_uuid field predicates */
  readonly accountUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly accountUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly accountUUIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly accountUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly accountUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly accountUUIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly and?: InputMaybe<ReadonlyArray<CustomFieldValueWhereInput>>;
  /** call_uuid field predicates */
  readonly callUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly callUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly callUUIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly callUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly callUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly callUUIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** contact_uuid field predicates */
  readonly contactUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly contactUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly contactUUIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly contactUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly contactUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly contactUUIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  readonly createdAt?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly createdAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** custom_field_enum_uuid field predicates */
  readonly customFieldEnumUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly customFieldEnumUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly customFieldEnumUUIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly customFieldEnumUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly customFieldEnumUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly customFieldEnumUUIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** custom_field_uuid field predicates */
  readonly customFieldUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly customFieldUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly customFieldUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly customFieldUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** disabled field predicates */
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** document_uuid field predicates */
  readonly documentUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly documentUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly documentUUIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly documentUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly documentUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly documentUUIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** account edge predicates */
  readonly hasAccount?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasAccountWith?: InputMaybe<ReadonlyArray<AccountWhereInput>>;
  /** call edge predicates */
  readonly hasCall?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasCallWith?: InputMaybe<ReadonlyArray<CallWhereInput>>;
  /** contact edge predicates */
  readonly hasContact?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasContactWith?: InputMaybe<ReadonlyArray<ContactWhereInput>>;
  /** custom_field edge predicates */
  readonly hasCustomField?: InputMaybe<Scalars['Boolean']['input']>;
  /** custom_field_enum edge predicates */
  readonly hasCustomFieldEnum?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasCustomFieldEnumWith?: InputMaybe<ReadonlyArray<CustomFieldEnumWhereInput>>;
  readonly hasCustomFieldWith?: InputMaybe<ReadonlyArray<CustomFieldWhereInput>>;
  /** document edge predicates */
  readonly hasDocument?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasDocumentWith?: InputMaybe<ReadonlyArray<DocumentWhereInput>>;
  /** opportunity edge predicates */
  readonly hasOpportunity?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasOpportunityWith?: InputMaybe<ReadonlyArray<OpportunityWhereInput>>;
  /** id field predicates */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly idGT?: InputMaybe<Scalars['ID']['input']>;
  readonly idGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly idLT?: InputMaybe<Scalars['ID']['input']>;
  readonly idLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly idNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly not?: InputMaybe<CustomFieldValueWhereInput>;
  /** opportunity_uuid field predicates */
  readonly opportunityUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly opportunityUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly opportunityUUIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly opportunityUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly opportunityUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly opportunityUUIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly or?: InputMaybe<ReadonlyArray<CustomFieldValueWhereInput>>;
  /** updated_at field predicates */
  readonly updatedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly updatedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** value field predicates */
  readonly value?: InputMaybe<Scalars['String']['input']>;
  readonly valueContains?: InputMaybe<Scalars['String']['input']>;
  readonly valueContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly valueEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly valueGT?: InputMaybe<Scalars['String']['input']>;
  readonly valueGTE?: InputMaybe<Scalars['String']['input']>;
  readonly valueHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly valueHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly valueIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly valueIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly valueLT?: InputMaybe<Scalars['String']['input']>;
  readonly valueLTE?: InputMaybe<Scalars['String']['input']>;
  readonly valueNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly valueNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly valueNotNil?: InputMaybe<Scalars['Boolean']['input']>;
}

/**
 * CustomFieldWhereInput is used for filtering CustomField objects.
 * Input was generated by ent.
 */
export interface CustomFieldWhereInput {
  readonly and?: InputMaybe<ReadonlyArray<CustomFieldWhereInput>>;
  /** created_at field predicates */
  readonly createdAt?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly createdAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** description field predicates */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionContains?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionGT?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly descriptionLT?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** disabled field predicates */
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** display_name field predicates */
  readonly displayName?: InputMaybe<Scalars['String']['input']>;
  readonly displayNameContains?: InputMaybe<Scalars['String']['input']>;
  readonly displayNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly displayNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly displayNameGT?: InputMaybe<Scalars['String']['input']>;
  readonly displayNameGTE?: InputMaybe<Scalars['String']['input']>;
  readonly displayNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly displayNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly displayNameIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly displayNameLT?: InputMaybe<Scalars['String']['input']>;
  readonly displayNameLTE?: InputMaybe<Scalars['String']['input']>;
  readonly displayNameNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly displayNameNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** external_identifier field predicates */
  readonly externalIdentifier?: InputMaybe<Scalars['String']['input']>;
  readonly externalIdentifierContains?: InputMaybe<Scalars['String']['input']>;
  readonly externalIdentifierContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly externalIdentifierEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly externalIdentifierGT?: InputMaybe<Scalars['String']['input']>;
  readonly externalIdentifierGTE?: InputMaybe<Scalars['String']['input']>;
  readonly externalIdentifierHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly externalIdentifierHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly externalIdentifierIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly externalIdentifierIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly externalIdentifierLT?: InputMaybe<Scalars['String']['input']>;
  readonly externalIdentifierLTE?: InputMaybe<Scalars['String']['input']>;
  readonly externalIdentifierNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly externalIdentifierNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly externalIdentifierNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** field_type field predicates */
  readonly fieldType?: InputMaybe<CustomFieldCustomFieldType>;
  readonly fieldTypeIn?: InputMaybe<ReadonlyArray<CustomFieldCustomFieldType>>;
  readonly fieldTypeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly fieldTypeNEQ?: InputMaybe<CustomFieldCustomFieldType>;
  readonly fieldTypeNotIn?: InputMaybe<ReadonlyArray<CustomFieldCustomFieldType>>;
  readonly fieldTypeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** group_name field predicates */
  readonly groupName?: InputMaybe<Scalars['String']['input']>;
  readonly groupNameContains?: InputMaybe<Scalars['String']['input']>;
  readonly groupNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly groupNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly groupNameGT?: InputMaybe<Scalars['String']['input']>;
  readonly groupNameGTE?: InputMaybe<Scalars['String']['input']>;
  readonly groupNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly groupNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly groupNameIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly groupNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly groupNameLT?: InputMaybe<Scalars['String']['input']>;
  readonly groupNameLTE?: InputMaybe<Scalars['String']['input']>;
  readonly groupNameNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly groupNameNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly groupNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** custom_field_enumeration_field_links edge predicates */
  readonly hasCustomFieldEnumerationFieldLinks?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasCustomFieldEnumerationFieldLinksWith?: InputMaybe<ReadonlyArray<CustomFieldEnumerationFieldLinkWhereInput>>;
  /** enumeration_fields edge predicates */
  readonly hasEnumerationFields?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasEnumerationFieldsWith?: InputMaybe<ReadonlyArray<EnumerationFieldWhereInput>>;
  /** enums edge predicates */
  readonly hasEnums?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasEnumsWith?: InputMaybe<ReadonlyArray<CustomFieldEnumWhereInput>>;
  /** values edge predicates */
  readonly hasValues?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasValuesWith?: InputMaybe<ReadonlyArray<CustomFieldValueWhereInput>>;
  /** id field predicates */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly idGT?: InputMaybe<Scalars['ID']['input']>;
  readonly idGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly idLT?: InputMaybe<Scalars['ID']['input']>;
  readonly idLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly idNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly not?: InputMaybe<CustomFieldWhereInput>;
  /** object_type field predicates */
  readonly objectType?: InputMaybe<CustomFieldObjectType>;
  readonly objectTypeIn?: InputMaybe<ReadonlyArray<CustomFieldObjectType>>;
  readonly objectTypeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly objectTypeNEQ?: InputMaybe<CustomFieldObjectType>;
  readonly objectTypeNotIn?: InputMaybe<ReadonlyArray<CustomFieldObjectType>>;
  readonly objectTypeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly or?: InputMaybe<ReadonlyArray<CustomFieldWhereInput>>;
  /** source_platform field predicates */
  readonly sourcePlatform?: InputMaybe<CallIntegration>;
  readonly sourcePlatformIn?: InputMaybe<ReadonlyArray<CallIntegration>>;
  readonly sourcePlatformIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly sourcePlatformNEQ?: InputMaybe<CallIntegration>;
  readonly sourcePlatformNotIn?: InputMaybe<ReadonlyArray<CallIntegration>>;
  readonly sourcePlatformNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  readonly updatedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly updatedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
}

export interface Customer extends Node {
  readonly childCustomers?: Maybe<ReadonlyArray<Customer>>;
  readonly config?: Maybe<CustomerConfig>;
  readonly createdAt: Scalars['Int']['output'];
  readonly createdBy?: Maybe<Scalars['OldID']['output']>;
  readonly createdByUUID?: Maybe<Scalars['ID']['output']>;
  readonly customerCrmConfig?: Maybe<CustomerCrmConfig>;
  readonly customerProspectingConfig?: Maybe<ReadonlyArray<CustomerProspectingConfig>>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly disabled: Scalars['Boolean']['output'];
  readonly domains?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly enumerationConfigurations?: Maybe<ReadonlyArray<EnumerationConfiguration>>;
  readonly fiscalYearStartDay: Scalars['Int']['output'];
  readonly fiscalYearStartMonth: Scalars['Int']['output'];
  readonly id: Scalars['ID']['output'];
  readonly integrationSecrets?: Maybe<ReadonlyArray<IntegrationSecret>>;
  /** A summary of the customer that is only visible to Fabius, used for prompts */
  readonly internalSummary?: Maybe<Scalars['String']['output']>;
  readonly isActive: Scalars['Boolean']['output'];
  readonly isReseller: Scalars['Boolean']['output'];
  readonly name: Scalars['String']['output'];
  readonly oldID?: Maybe<Scalars['Int']['output']>;
  readonly parentCustomer?: Maybe<Customer>;
  readonly parentCustomerUUID?: Maybe<Scalars['ID']['output']>;
  readonly updatedAt: Scalars['Int']['output'];
  readonly updatedBy?: Maybe<Scalars['OldID']['output']>;
  readonly updatedByUUID?: Maybe<Scalars['ID']['output']>;
  readonly users?: Maybe<ReadonlyArray<User>>;
}

export interface CustomerCrmConfig extends Node {
  readonly createdAt: Scalars['Int']['output'];
  readonly createdByUUID: Scalars['ID']['output'];
  readonly disabled: Scalars['Boolean']['output'];
  readonly id: Scalars['ID']['output'];
  readonly integrationSecret: IntegrationSecret;
  readonly integrationSecretUUID: Scalars['ID']['output'];
  readonly oldCreatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly oldID?: Maybe<Scalars['Int']['output']>;
  readonly oldUpdatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly owner?: Maybe<Customer>;
  readonly ownerUUID?: Maybe<Scalars['ID']['output']>;
  /** StagesToUpdate is a list of stage IDs which should be updated. */
  readonly stageIdsToUpdate?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** TerminalStages is a list of stage IDs which should no longer be updated. */
  readonly terminalStageIds?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly updatedAt: Scalars['Int']['output'];
  readonly updatedByUUID: Scalars['ID']['output'];
}

/** A connection to a list of items. */
export interface CustomerCrmConfigConnection {
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<CustomerCrmConfigEdge>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface CustomerCrmConfigEdge {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<CustomerCrmConfig>;
}

/** Ordering options for CustomerCRMConfig connections */
export interface CustomerCrmConfigOrder {
  /** The ordering direction. */
  readonly direction?: OrderDirection;
  /** The field by which to order CustomerCRMConfigs. */
  readonly field: CustomerCrmConfigOrderField;
}

/** Properties by which CustomerCRMConfig connections can be ordered. */
export const CustomerCrmConfigOrderField = {
  CreatedAt: 'CREATED_AT',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type CustomerCrmConfigOrderField = typeof CustomerCrmConfigOrderField[keyof typeof CustomerCrmConfigOrderField];
/**
 * CustomerCRMConfigWhereInput is used for filtering CustomerCRMConfig objects.
 * Input was generated by ent.
 */
export interface CustomerCrmConfigWhereInput {
  readonly and?: InputMaybe<ReadonlyArray<CustomerCrmConfigWhereInput>>;
  /** created_at field predicates */
  readonly createdAt?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly createdAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** created_by_uuid field predicates */
  readonly createdByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly createdByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** disabled field predicates */
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** integration_secret edge predicates */
  readonly hasIntegrationSecret?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasIntegrationSecretWith?: InputMaybe<ReadonlyArray<IntegrationSecretWhereInput>>;
  /** owner edge predicates */
  readonly hasOwner?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasOwnerWith?: InputMaybe<ReadonlyArray<CustomerWhereInput>>;
  /** id field predicates */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly idGT?: InputMaybe<Scalars['ID']['input']>;
  readonly idGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly idLT?: InputMaybe<Scalars['ID']['input']>;
  readonly idLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly idNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** integration_secret_uuid field predicates */
  readonly integrationSecretUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly integrationSecretUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly integrationSecretUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly integrationSecretUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly not?: InputMaybe<CustomerCrmConfigWhereInput>;
  /** old_created_by_id field predicates */
  readonly oldCreatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldCreatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_id field predicates */
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDGT?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly oldIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldIDLT?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly oldIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_updated_by_id field predicates */
  readonly oldUpdatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldUpdatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly or?: InputMaybe<ReadonlyArray<CustomerCrmConfigWhereInput>>;
  /** owner_uuid field predicates */
  readonly ownerUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly ownerUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly ownerUUIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly ownerUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly ownerUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly ownerUUIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  readonly updatedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly updatedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** updated_by_uuid field predicates */
  readonly updatedByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly updatedByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
}

export interface CustomerConfig {
  readonly accounts?: Maybe<Scalars['Boolean']['output']>;
  readonly defaultRoute?: Maybe<Scalars['String']['output']>;
  readonly performance?: Maybe<Scalars['Boolean']['output']>;
  readonly teams?: Maybe<Scalars['Boolean']['output']>;
}

/** A connection to a list of items. */
export interface CustomerConnection {
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<CustomerEdge>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface CustomerEdge {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<Customer>;
}

/** Ordering options for Customer connections */
export interface CustomerOrder {
  /** The ordering direction. */
  readonly direction?: OrderDirection;
  /** The field by which to order Customers. */
  readonly field: CustomerOrderField;
}

/** Properties by which Customer connections can be ordered. */
export const CustomerOrderField = {
  CreatedAt: 'CREATED_AT',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type CustomerOrderField = typeof CustomerOrderField[keyof typeof CustomerOrderField];
export interface CustomerProspectingConfig extends Node {
  readonly automatedAccountsPerDay?: Maybe<Scalars['Int']['output']>;
  readonly automaticallyPushContacts: Scalars['Boolean']['output'];
  readonly buyerOrg: Scalars['String']['output'];
  readonly buyerSkills: Scalars['String']['output'];
  readonly closedLostStageNames?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly createdAt: Scalars['Int']['output'];
  readonly createdByUUID: Scalars['ID']['output'];
  readonly disabled: Scalars['Boolean']['output'];
  /** DomainSpecificDirections adds additional steering to the Contact Analysis prompt if set. */
  readonly domainSpecificDirections?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  /** The number of primary emails to create for each prospect. Each primary email will then have follow ups. */
  readonly numPrimaryEmails: Scalars['Int']['output'];
  readonly oldCreatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly oldID?: Maybe<Scalars['Int']['output']>;
  readonly oldUpdatedByID?: Maybe<Scalars['OldID']['output']>;
  /** OnlyWebsite determines whether to only use the prospect's website for prospecting. If true, we will scrape the website in depth vs making Google searches and other outside searches. */
  readonly onlyWebsite?: Maybe<Scalars['Boolean']['output']>;
  readonly primaryEmailTemplates?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** Re-engagement email templates represent the templates to use when sending emails to prospects that the customer has met with before, and hence referencing the previous call */
  readonly reengagementEmailTemplates?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** ReengagementWithPublicInfo determines whether to include public information about the prospect in the re-engagement email. */
  readonly reengagementWithPublicInfo?: Maybe<Scalars['Boolean']['output']>;
  readonly updatedAt: Scalars['Int']['output'];
  readonly updatedByUUID: Scalars['ID']['output'];
  readonly valueMessaging: Scalars['String']['output'];
}

/** A connection to a list of items. */
export interface CustomerProspectingConfigConnection {
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<CustomerProspectingConfigEdge>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface CustomerProspectingConfigEdge {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<CustomerProspectingConfig>;
}

/** Ordering options for CustomerProspectingConfig connections */
export interface CustomerProspectingConfigOrder {
  /** The ordering direction. */
  readonly direction?: OrderDirection;
  /** The field by which to order CustomerProspectingConfigs. */
  readonly field: CustomerProspectingConfigOrderField;
}

/** Properties by which CustomerProspectingConfig connections can be ordered. */
export const CustomerProspectingConfigOrderField = {
  CreatedAt: 'CREATED_AT',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type CustomerProspectingConfigOrderField = typeof CustomerProspectingConfigOrderField[keyof typeof CustomerProspectingConfigOrderField];
/**
 * CustomerProspectingConfigWhereInput is used for filtering CustomerProspectingConfig objects.
 * Input was generated by ent.
 */
export interface CustomerProspectingConfigWhereInput {
  readonly and?: InputMaybe<ReadonlyArray<CustomerProspectingConfigWhereInput>>;
  /** automated_accounts_per_day field predicates */
  readonly automatedAccountsPerDay?: InputMaybe<Scalars['Int']['input']>;
  readonly automatedAccountsPerDayGT?: InputMaybe<Scalars['Int']['input']>;
  readonly automatedAccountsPerDayGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly automatedAccountsPerDayIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly automatedAccountsPerDayIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly automatedAccountsPerDayLT?: InputMaybe<Scalars['Int']['input']>;
  readonly automatedAccountsPerDayLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly automatedAccountsPerDayNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly automatedAccountsPerDayNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly automatedAccountsPerDayNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** automatically_push_contacts field predicates */
  readonly automaticallyPushContacts?: InputMaybe<Scalars['Boolean']['input']>;
  readonly automaticallyPushContactsNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** buyer_org field predicates */
  readonly buyerOrg?: InputMaybe<Scalars['String']['input']>;
  readonly buyerOrgContains?: InputMaybe<Scalars['String']['input']>;
  readonly buyerOrgContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly buyerOrgEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly buyerOrgGT?: InputMaybe<Scalars['String']['input']>;
  readonly buyerOrgGTE?: InputMaybe<Scalars['String']['input']>;
  readonly buyerOrgHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly buyerOrgHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly buyerOrgIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly buyerOrgLT?: InputMaybe<Scalars['String']['input']>;
  readonly buyerOrgLTE?: InputMaybe<Scalars['String']['input']>;
  readonly buyerOrgNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly buyerOrgNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** buyer_skills field predicates */
  readonly buyerSkills?: InputMaybe<Scalars['String']['input']>;
  readonly buyerSkillsContains?: InputMaybe<Scalars['String']['input']>;
  readonly buyerSkillsContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly buyerSkillsEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly buyerSkillsGT?: InputMaybe<Scalars['String']['input']>;
  readonly buyerSkillsGTE?: InputMaybe<Scalars['String']['input']>;
  readonly buyerSkillsHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly buyerSkillsHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly buyerSkillsIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly buyerSkillsLT?: InputMaybe<Scalars['String']['input']>;
  readonly buyerSkillsLTE?: InputMaybe<Scalars['String']['input']>;
  readonly buyerSkillsNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly buyerSkillsNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** created_at field predicates */
  readonly createdAt?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly createdAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** created_by_uuid field predicates */
  readonly createdByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly createdByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** disabled field predicates */
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** domain_specific_directions field predicates */
  readonly domainSpecificDirections?: InputMaybe<Scalars['String']['input']>;
  readonly domainSpecificDirectionsContains?: InputMaybe<Scalars['String']['input']>;
  readonly domainSpecificDirectionsContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly domainSpecificDirectionsEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly domainSpecificDirectionsGT?: InputMaybe<Scalars['String']['input']>;
  readonly domainSpecificDirectionsGTE?: InputMaybe<Scalars['String']['input']>;
  readonly domainSpecificDirectionsHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly domainSpecificDirectionsHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly domainSpecificDirectionsIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly domainSpecificDirectionsIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly domainSpecificDirectionsLT?: InputMaybe<Scalars['String']['input']>;
  readonly domainSpecificDirectionsLTE?: InputMaybe<Scalars['String']['input']>;
  readonly domainSpecificDirectionsNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly domainSpecificDirectionsNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly domainSpecificDirectionsNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** id field predicates */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly idGT?: InputMaybe<Scalars['ID']['input']>;
  readonly idGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly idLT?: InputMaybe<Scalars['ID']['input']>;
  readonly idLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly idNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly not?: InputMaybe<CustomerProspectingConfigWhereInput>;
  /** num_primary_emails field predicates */
  readonly numPrimaryEmails?: InputMaybe<Scalars['Int']['input']>;
  readonly numPrimaryEmailsGT?: InputMaybe<Scalars['Int']['input']>;
  readonly numPrimaryEmailsGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly numPrimaryEmailsIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly numPrimaryEmailsLT?: InputMaybe<Scalars['Int']['input']>;
  readonly numPrimaryEmailsLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly numPrimaryEmailsNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly numPrimaryEmailsNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** old_created_by_id field predicates */
  readonly oldCreatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldCreatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_id field predicates */
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDGT?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly oldIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldIDLT?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly oldIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_updated_by_id field predicates */
  readonly oldUpdatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldUpdatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** only_website field predicates */
  readonly onlyWebsite?: InputMaybe<Scalars['Boolean']['input']>;
  readonly onlyWebsiteIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly onlyWebsiteNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  readonly onlyWebsiteNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly or?: InputMaybe<ReadonlyArray<CustomerProspectingConfigWhereInput>>;
  /** reengagement_with_public_info field predicates */
  readonly reengagementWithPublicInfo?: InputMaybe<Scalars['Boolean']['input']>;
  readonly reengagementWithPublicInfoIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly reengagementWithPublicInfoNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  readonly reengagementWithPublicInfoNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  readonly updatedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly updatedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** updated_by_uuid field predicates */
  readonly updatedByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly updatedByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** value_messaging field predicates */
  readonly valueMessaging?: InputMaybe<Scalars['String']['input']>;
  readonly valueMessagingContains?: InputMaybe<Scalars['String']['input']>;
  readonly valueMessagingContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly valueMessagingEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly valueMessagingGT?: InputMaybe<Scalars['String']['input']>;
  readonly valueMessagingGTE?: InputMaybe<Scalars['String']['input']>;
  readonly valueMessagingHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly valueMessagingHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly valueMessagingIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly valueMessagingLT?: InputMaybe<Scalars['String']['input']>;
  readonly valueMessagingLTE?: InputMaybe<Scalars['String']['input']>;
  readonly valueMessagingNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly valueMessagingNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
}

/**
 * CustomerWhereInput is used for filtering Customer objects.
 * Input was generated by ent.
 */
export interface CustomerWhereInput {
  readonly and?: InputMaybe<ReadonlyArray<CustomerWhereInput>>;
  /** created_at field predicates */
  readonly createdAt?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly createdAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** created_by field predicates */
  readonly createdBy?: InputMaybe<Scalars['OldID']['input']>;
  readonly createdByGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly createdByGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly createdByIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly createdByIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly createdByLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly createdByLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly createdByNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly createdByNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly createdByNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_by_uuid field predicates */
  readonly createdByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDGT?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly createdByUUIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly createdByUUIDLT?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly createdByUUIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** description field predicates */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionContains?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionGT?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly descriptionLT?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** disabled field predicates */
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** fiscal_year_start_day field predicates */
  readonly fiscalYearStartDay?: InputMaybe<Scalars['Int']['input']>;
  readonly fiscalYearStartDayGT?: InputMaybe<Scalars['Int']['input']>;
  readonly fiscalYearStartDayGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly fiscalYearStartDayIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly fiscalYearStartDayLT?: InputMaybe<Scalars['Int']['input']>;
  readonly fiscalYearStartDayLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly fiscalYearStartDayNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly fiscalYearStartDayNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** fiscal_year_start_month field predicates */
  readonly fiscalYearStartMonth?: InputMaybe<Scalars['Int']['input']>;
  readonly fiscalYearStartMonthGT?: InputMaybe<Scalars['Int']['input']>;
  readonly fiscalYearStartMonthGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly fiscalYearStartMonthIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly fiscalYearStartMonthLT?: InputMaybe<Scalars['Int']['input']>;
  readonly fiscalYearStartMonthLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly fiscalYearStartMonthNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly fiscalYearStartMonthNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** child_customers edge predicates */
  readonly hasChildCustomers?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasChildCustomersWith?: InputMaybe<ReadonlyArray<CustomerWhereInput>>;
  /** customer_crm_config edge predicates */
  readonly hasCustomerCrmConfig?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasCustomerCrmConfigWith?: InputMaybe<ReadonlyArray<CustomerCrmConfigWhereInput>>;
  /** customer_prospecting_config edge predicates */
  readonly hasCustomerProspectingConfig?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasCustomerProspectingConfigWith?: InputMaybe<ReadonlyArray<CustomerProspectingConfigWhereInput>>;
  /** enumeration_configurations edge predicates */
  readonly hasEnumerationConfigurations?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasEnumerationConfigurationsWith?: InputMaybe<ReadonlyArray<EnumerationConfigurationWhereInput>>;
  /** integration_secrets edge predicates */
  readonly hasIntegrationSecrets?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasIntegrationSecretsWith?: InputMaybe<ReadonlyArray<IntegrationSecretWhereInput>>;
  /** parent_customer edge predicates */
  readonly hasParentCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasParentCustomerWith?: InputMaybe<ReadonlyArray<CustomerWhereInput>>;
  /** users edge predicates */
  readonly hasUsers?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasUsersWith?: InputMaybe<ReadonlyArray<UserWhereInput>>;
  /** id field predicates */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly idGT?: InputMaybe<Scalars['ID']['input']>;
  readonly idGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly idLT?: InputMaybe<Scalars['ID']['input']>;
  readonly idLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly idNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** internal_summary field predicates */
  readonly internalSummary?: InputMaybe<Scalars['String']['input']>;
  readonly internalSummaryContains?: InputMaybe<Scalars['String']['input']>;
  readonly internalSummaryContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly internalSummaryEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly internalSummaryGT?: InputMaybe<Scalars['String']['input']>;
  readonly internalSummaryGTE?: InputMaybe<Scalars['String']['input']>;
  readonly internalSummaryHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly internalSummaryHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly internalSummaryIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly internalSummaryIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly internalSummaryLT?: InputMaybe<Scalars['String']['input']>;
  readonly internalSummaryLTE?: InputMaybe<Scalars['String']['input']>;
  readonly internalSummaryNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly internalSummaryNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly internalSummaryNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** is_active field predicates */
  readonly isActive?: InputMaybe<Scalars['Boolean']['input']>;
  readonly isActiveNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** is_reseller field predicates */
  readonly isReseller?: InputMaybe<Scalars['Boolean']['input']>;
  readonly isResellerNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** name field predicates */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly nameContains?: InputMaybe<Scalars['String']['input']>;
  readonly nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly nameGT?: InputMaybe<Scalars['String']['input']>;
  readonly nameGTE?: InputMaybe<Scalars['String']['input']>;
  readonly nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly nameIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly nameLT?: InputMaybe<Scalars['String']['input']>;
  readonly nameLTE?: InputMaybe<Scalars['String']['input']>;
  readonly nameNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly nameNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly not?: InputMaybe<CustomerWhereInput>;
  /** old_id field predicates */
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDGT?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly oldIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldIDLT?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly oldIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly or?: InputMaybe<ReadonlyArray<CustomerWhereInput>>;
  /** parent_customer_uuid field predicates */
  readonly parentCustomerUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly parentCustomerUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly parentCustomerUUIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly parentCustomerUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly parentCustomerUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly parentCustomerUUIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  readonly updatedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly updatedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** updated_by field predicates */
  readonly updatedBy?: InputMaybe<Scalars['OldID']['input']>;
  readonly updatedByGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly updatedByGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly updatedByIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly updatedByIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly updatedByLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly updatedByLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly updatedByNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly updatedByNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly updatedByNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_by_uuid field predicates */
  readonly updatedByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDGT?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly updatedByUUIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly updatedByUUIDLT?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly updatedByUUIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface Directory extends Node {
  readonly createdAt: Scalars['Int']['output'];
  readonly createdByUUID: Scalars['ID']['output'];
  readonly disabled: Scalars['Boolean']['output'];
  readonly documents?: Maybe<ReadonlyArray<KnowledgeDocument>>;
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
  readonly oldCreatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly oldID?: Maybe<Scalars['OldID']['output']>;
  readonly oldUpdatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly parent?: Maybe<Directory>;
  readonly parentUUID?: Maybe<Scalars['ID']['output']>;
  readonly subdirectories?: Maybe<ReadonlyArray<Directory>>;
  readonly updatedAt: Scalars['Int']['output'];
  readonly updatedByUUID: Scalars['ID']['output'];
}

/** A connection to a list of items. */
export interface DirectoryConnection {
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<DirectoryEdge>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface DirectoryEdge {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<Directory>;
}

/** Ordering options for Directory connections */
export interface DirectoryOrder {
  /** The ordering direction. */
  readonly direction?: OrderDirection;
  /** The field by which to order Directories. */
  readonly field: DirectoryOrderField;
}

/** Properties by which Directory connections can be ordered. */
export const DirectoryOrderField = {
  CreatedAt: 'CREATED_AT',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type DirectoryOrderField = typeof DirectoryOrderField[keyof typeof DirectoryOrderField];
/**
 * DirectoryWhereInput is used for filtering Directory objects.
 * Input was generated by ent.
 */
export interface DirectoryWhereInput {
  readonly and?: InputMaybe<ReadonlyArray<DirectoryWhereInput>>;
  /** created_at field predicates */
  readonly createdAt?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly createdAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** created_by_uuid field predicates */
  readonly createdByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly createdByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** disabled field predicates */
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** documents edge predicates */
  readonly hasDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasDocumentsWith?: InputMaybe<ReadonlyArray<KnowledgeDocumentWhereInput>>;
  /** parent edge predicates */
  readonly hasParent?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasParentWith?: InputMaybe<ReadonlyArray<DirectoryWhereInput>>;
  /** subdirectories edge predicates */
  readonly hasSubdirectories?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasSubdirectoriesWith?: InputMaybe<ReadonlyArray<DirectoryWhereInput>>;
  /** id field predicates */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly idGT?: InputMaybe<Scalars['ID']['input']>;
  readonly idGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly idLT?: InputMaybe<Scalars['ID']['input']>;
  readonly idLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly idNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** name field predicates */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly nameContains?: InputMaybe<Scalars['String']['input']>;
  readonly nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly nameGT?: InputMaybe<Scalars['String']['input']>;
  readonly nameGTE?: InputMaybe<Scalars['String']['input']>;
  readonly nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly nameIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly nameLT?: InputMaybe<Scalars['String']['input']>;
  readonly nameLTE?: InputMaybe<Scalars['String']['input']>;
  readonly nameNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly nameNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly not?: InputMaybe<DirectoryWhereInput>;
  /** old_created_by_id field predicates */
  readonly oldCreatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldCreatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_id field predicates */
  readonly oldID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_updated_by_id field predicates */
  readonly oldUpdatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldUpdatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly or?: InputMaybe<ReadonlyArray<DirectoryWhereInput>>;
  /** parent_uuid field predicates */
  readonly parentUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly parentUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly parentUUIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly parentUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly parentUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly parentUUIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  readonly updatedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly updatedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** updated_by_uuid field predicates */
  readonly updatedByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly updatedByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
}

export interface Document extends Node {
  readonly account?: Maybe<Account>;
  readonly accountUUID?: Maybe<Scalars['ID']['output']>;
  readonly contact?: Maybe<Contact>;
  readonly contactUUID?: Maybe<Scalars['ID']['output']>;
  readonly createdAt: Scalars['Int']['output'];
  readonly customFieldValues: CustomFieldValueConnection;
  readonly disabled: Scalars['Boolean']['output'];
  readonly documentSource?: Maybe<DocumentCallIntegration>;
  /** DocumentTimestamp is the timestamp of when the document was generated, published, etc. */
  readonly documentTimestamp: Scalars['Unix']['output'];
  readonly documentType: DocumentDocumentType;
  readonly enumerationValues: EnumerationValueConnection;
  /**
   * ExternalDocumentID is the ID of the document in an external system. Typically corresponds to the
   * ID of the resource in the platform it was pulled from. E.g. the ID of a Note in GoHighLevel.
   */
  readonly externalDocumentID: Scalars['OldID']['output'];
  readonly gongUser?: Maybe<GongUser>;
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
  readonly opportunity?: Maybe<Opportunity>;
  readonly opportunityUUID?: Maybe<Scalars['ID']['output']>;
  /** Path is the relative path to the file on s3 */
  readonly path: Scalars['String']['output'];
  readonly primaryUserUUID?: Maybe<Scalars['ID']['output']>;
  readonly updatedAt: Scalars['Int']['output'];
}


export interface DocumentCustomFieldValuesArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CustomFieldValueOrder>;
  where?: InputMaybe<CustomFieldValueWhereInput>;
}


export interface DocumentEnumerationValuesArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EnumerationValueOrder>;
  where?: InputMaybe<EnumerationValueWhereInput>;
}

/** DocumentCallIntegration is enum for the field document_source */
export const DocumentCallIntegration = {
  Apollo: 'APOLLO',
  Freshcaller: 'FRESHCALLER',
  Freshdesk: 'FRESHDESK',
  Gmail: 'GMAIL',
  Gohighlevel: 'GOHIGHLEVEL',
  Gong: 'GONG',
  GongOauth: 'GONG_OAUTH',
  GoogleCalendar: 'GOOGLE_CALENDAR',
  GoogleMeet: 'GOOGLE_MEET',
  Hubspot: 'HUBSPOT',
  Justcall: 'JUSTCALL',
  Outreach: 'OUTREACH',
  Pipedrive: 'PIPEDRIVE',
  ProductBoard: 'PRODUCT_BOARD',
  Salesloft: 'SALESLOFT',
  Sfdc: 'SFDC',
  Slack: 'SLACK',
  UnknownIntegration: 'UNKNOWN_INTEGRATION',
  Volie: 'VOLIE',
  Wingman: 'WINGMAN',
  Zoho: 'ZOHO',
  Zoom: 'ZOOM'
} as const;

export type DocumentCallIntegration = typeof DocumentCallIntegration[keyof typeof DocumentCallIntegration];
/** A connection to a list of items. */
export interface DocumentConnection {
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<DocumentEdge>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
}

/** DocumentDocumentType is enum for the field document_type */
export const DocumentDocumentType = {
  ChatbotLog: 'CHATBOT_LOG',
  DealNotes: 'DEAL_NOTES',
  EmailThread: 'EMAIL_THREAD',
  FormSubmission: 'FORM_SUBMISSION',
  UnknownDocument: 'UNKNOWN_DOCUMENT',
  WebsiteScrape: 'WEBSITE_SCRAPE'
} as const;

export type DocumentDocumentType = typeof DocumentDocumentType[keyof typeof DocumentDocumentType];
/** An edge in a connection. */
export interface DocumentEdge {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<Document>;
}

export interface DocumentIngestionConfig extends Node {
  readonly createdAt: Scalars['Int']['output'];
  readonly createdByUUID: Scalars['ID']['output'];
  readonly disabled: Scalars['Boolean']['output'];
  readonly documentType: DocumentIngestionConfigDocumentType;
  readonly id: Scalars['ID']['output'];
  readonly integrationSecret: IntegrationSecret;
  readonly integrationSecretUUID: Scalars['ID']['output'];
  readonly oldCreatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly oldID?: Maybe<Scalars['Int']['output']>;
  readonly oldUpdatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly updatedAt: Scalars['Int']['output'];
  readonly updatedByUUID: Scalars['ID']['output'];
}

/** A connection to a list of items. */
export interface DocumentIngestionConfigConnection {
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<DocumentIngestionConfigEdge>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
}

/** DocumentIngestionConfigDocumentType is enum for the field document_type */
export const DocumentIngestionConfigDocumentType = {
  ChatbotLog: 'CHATBOT_LOG',
  DealNotes: 'DEAL_NOTES',
  EmailThread: 'EMAIL_THREAD',
  FormSubmission: 'FORM_SUBMISSION',
  UnknownDocument: 'UNKNOWN_DOCUMENT',
  WebsiteScrape: 'WEBSITE_SCRAPE'
} as const;

export type DocumentIngestionConfigDocumentType = typeof DocumentIngestionConfigDocumentType[keyof typeof DocumentIngestionConfigDocumentType];
/** An edge in a connection. */
export interface DocumentIngestionConfigEdge {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<DocumentIngestionConfig>;
}

/** Ordering options for DocumentIngestionConfig connections */
export interface DocumentIngestionConfigOrder {
  /** The ordering direction. */
  readonly direction?: OrderDirection;
  /** The field by which to order DocumentIngestionConfigs. */
  readonly field: DocumentIngestionConfigOrderField;
}

/** Properties by which DocumentIngestionConfig connections can be ordered. */
export const DocumentIngestionConfigOrderField = {
  CreatedAt: 'CREATED_AT',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type DocumentIngestionConfigOrderField = typeof DocumentIngestionConfigOrderField[keyof typeof DocumentIngestionConfigOrderField];
/**
 * DocumentIngestionConfigWhereInput is used for filtering DocumentIngestionConfig objects.
 * Input was generated by ent.
 */
export interface DocumentIngestionConfigWhereInput {
  readonly and?: InputMaybe<ReadonlyArray<DocumentIngestionConfigWhereInput>>;
  /** created_at field predicates */
  readonly createdAt?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly createdAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** created_by_uuid field predicates */
  readonly createdByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly createdByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** disabled field predicates */
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** document_type field predicates */
  readonly documentType?: InputMaybe<DocumentIngestionConfigDocumentType>;
  readonly documentTypeIn?: InputMaybe<ReadonlyArray<DocumentIngestionConfigDocumentType>>;
  readonly documentTypeNEQ?: InputMaybe<DocumentIngestionConfigDocumentType>;
  readonly documentTypeNotIn?: InputMaybe<ReadonlyArray<DocumentIngestionConfigDocumentType>>;
  /** integration_secret edge predicates */
  readonly hasIntegrationSecret?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasIntegrationSecretWith?: InputMaybe<ReadonlyArray<IntegrationSecretWhereInput>>;
  /** id field predicates */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly idGT?: InputMaybe<Scalars['ID']['input']>;
  readonly idGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly idLT?: InputMaybe<Scalars['ID']['input']>;
  readonly idLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly idNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** integration_secret_uuid field predicates */
  readonly integrationSecretUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly integrationSecretUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly integrationSecretUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly integrationSecretUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly not?: InputMaybe<DocumentIngestionConfigWhereInput>;
  /** old_created_by_id field predicates */
  readonly oldCreatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldCreatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_id field predicates */
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDGT?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly oldIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldIDLT?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly oldIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_updated_by_id field predicates */
  readonly oldUpdatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldUpdatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly or?: InputMaybe<ReadonlyArray<DocumentIngestionConfigWhereInput>>;
  /** updated_at field predicates */
  readonly updatedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly updatedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** updated_by_uuid field predicates */
  readonly updatedByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly updatedByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
}

/** Ordering options for Document connections */
export interface DocumentOrder {
  /** The ordering direction. */
  readonly direction?: OrderDirection;
  /** The field by which to order Documents. */
  readonly field: DocumentOrderField;
}

/** Properties by which Document connections can be ordered. */
export const DocumentOrderField = {
  CreatedAt: 'CREATED_AT',
  DocumentTimestamp: 'DOCUMENT_TIMESTAMP',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type DocumentOrderField = typeof DocumentOrderField[keyof typeof DocumentOrderField];
/**
 * DocumentWhereInput is used for filtering Document objects.
 * Input was generated by ent.
 */
export interface DocumentWhereInput {
  /** account_uuid field predicates */
  readonly accountUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly accountUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly accountUUIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly accountUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly accountUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly accountUUIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly and?: InputMaybe<ReadonlyArray<DocumentWhereInput>>;
  /** contact_uuid field predicates */
  readonly contactUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly contactUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly contactUUIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly contactUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly contactUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly contactUUIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  readonly createdAt?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly createdAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** disabled field predicates */
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** document_source field predicates */
  readonly documentSource?: InputMaybe<DocumentCallIntegration>;
  readonly documentSourceIn?: InputMaybe<ReadonlyArray<DocumentCallIntegration>>;
  readonly documentSourceIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly documentSourceNEQ?: InputMaybe<DocumentCallIntegration>;
  readonly documentSourceNotIn?: InputMaybe<ReadonlyArray<DocumentCallIntegration>>;
  readonly documentSourceNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** document_timestamp field predicates */
  readonly documentTimestamp?: InputMaybe<Scalars['Unix']['input']>;
  readonly documentTimestampGT?: InputMaybe<Scalars['Unix']['input']>;
  readonly documentTimestampGTE?: InputMaybe<Scalars['Unix']['input']>;
  readonly documentTimestampIn?: InputMaybe<ReadonlyArray<Scalars['Unix']['input']>>;
  readonly documentTimestampLT?: InputMaybe<Scalars['Unix']['input']>;
  readonly documentTimestampLTE?: InputMaybe<Scalars['Unix']['input']>;
  readonly documentTimestampNEQ?: InputMaybe<Scalars['Unix']['input']>;
  readonly documentTimestampNotIn?: InputMaybe<ReadonlyArray<Scalars['Unix']['input']>>;
  /** document_type field predicates */
  readonly documentType?: InputMaybe<DocumentDocumentType>;
  readonly documentTypeIn?: InputMaybe<ReadonlyArray<DocumentDocumentType>>;
  readonly documentTypeNEQ?: InputMaybe<DocumentDocumentType>;
  readonly documentTypeNotIn?: InputMaybe<ReadonlyArray<DocumentDocumentType>>;
  /** external_document_id field predicates */
  readonly externalDocumentID?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalDocumentIDContains?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalDocumentIDContainsFold?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalDocumentIDEqualFold?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalDocumentIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalDocumentIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalDocumentIDHasPrefix?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalDocumentIDHasSuffix?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalDocumentIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly externalDocumentIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalDocumentIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalDocumentIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalDocumentIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  /** account edge predicates */
  readonly hasAccount?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasAccountWith?: InputMaybe<ReadonlyArray<AccountWhereInput>>;
  /** contact edge predicates */
  readonly hasContact?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasContactWith?: InputMaybe<ReadonlyArray<ContactWhereInput>>;
  /** custom_field_values edge predicates */
  readonly hasCustomFieldValues?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasCustomFieldValuesWith?: InputMaybe<ReadonlyArray<CustomFieldValueWhereInput>>;
  /** enumeration_values edge predicates */
  readonly hasEnumerationValues?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasEnumerationValuesWith?: InputMaybe<ReadonlyArray<EnumerationValueWhereInput>>;
  /** gong_user edge predicates */
  readonly hasGongUser?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasGongUserWith?: InputMaybe<ReadonlyArray<GongUserWhereInput>>;
  /** opportunity edge predicates */
  readonly hasOpportunity?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasOpportunityWith?: InputMaybe<ReadonlyArray<OpportunityWhereInput>>;
  /** id field predicates */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly idGT?: InputMaybe<Scalars['ID']['input']>;
  readonly idGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly idLT?: InputMaybe<Scalars['ID']['input']>;
  readonly idLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly idNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** name field predicates */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly nameContains?: InputMaybe<Scalars['String']['input']>;
  readonly nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly nameGT?: InputMaybe<Scalars['String']['input']>;
  readonly nameGTE?: InputMaybe<Scalars['String']['input']>;
  readonly nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly nameIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly nameLT?: InputMaybe<Scalars['String']['input']>;
  readonly nameLTE?: InputMaybe<Scalars['String']['input']>;
  readonly nameNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly nameNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly not?: InputMaybe<DocumentWhereInput>;
  /** opportunity_uuid field predicates */
  readonly opportunityUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly opportunityUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly opportunityUUIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly opportunityUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly opportunityUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly opportunityUUIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly or?: InputMaybe<ReadonlyArray<DocumentWhereInput>>;
  /** path field predicates */
  readonly path?: InputMaybe<Scalars['String']['input']>;
  readonly pathContains?: InputMaybe<Scalars['String']['input']>;
  readonly pathContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly pathEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly pathGT?: InputMaybe<Scalars['String']['input']>;
  readonly pathGTE?: InputMaybe<Scalars['String']['input']>;
  readonly pathHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly pathHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly pathIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly pathLT?: InputMaybe<Scalars['String']['input']>;
  readonly pathLTE?: InputMaybe<Scalars['String']['input']>;
  readonly pathNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly pathNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** primary_user_uuid field predicates */
  readonly primaryUserUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly primaryUserUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly primaryUserUUIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly primaryUserUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly primaryUserUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly primaryUserUUIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  readonly updatedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly updatedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
}

export interface Email extends Node {
  /** Bcc is the raw Bcc header value from the email. */
  readonly bcc: ReadonlyArray<Scalars['String']['output']>;
  readonly body?: Maybe<Scalars['String']['output']>;
  /** Cc is the raw Cc header value from the email. */
  readonly cc: ReadonlyArray<Scalars['String']['output']>;
  readonly createdAt: Scalars['Int']['output'];
  readonly createdByUUID: Scalars['ID']['output'];
  readonly currentSummary?: Maybe<EmailThreadSummary>;
  /** Date is the timestamp of when the email was delivered. */
  readonly date: Scalars['Unix']['output'];
  readonly disabled: Scalars['Boolean']['output'];
  readonly emailReplyContexts?: Maybe<ReadonlyArray<EmailReplyContext>>;
  readonly emailReplyDrafts?: Maybe<ReadonlyArray<EmailReplyDraft>>;
  readonly enumerationValues: EnumerationValueConnection;
  /** ExternalIdentifier is the unique identifier of the email in the source platform (e.g. `gmail_message_id`). */
  readonly externalIdentifier: Scalars['String']['output'];
  /** From is the raw FROM header value from the email. */
  readonly from: Scalars['String']['output'];
  readonly fromContact?: Maybe<Contact>;
  readonly fromContactUUID?: Maybe<Scalars['ID']['output']>;
  readonly fromUser?: Maybe<User>;
  readonly fromUserUUID?: Maybe<Scalars['ID']['output']>;
  readonly id: Scalars['ID']['output'];
  /** InReplyTo is the raw In-Reply-To header value from the email. */
  readonly inReplyTo?: Maybe<Scalars['String']['output']>;
  /** InReplyToUUID is the UUID of the email that this email is in reply to. */
  readonly inReplyToUUID?: Maybe<Scalars['ID']['output']>;
  readonly next?: Maybe<Email>;
  readonly oldCreatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly oldUpdatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly previous?: Maybe<Email>;
  readonly recipients?: Maybe<ReadonlyArray<EmailRecipient>>;
  /** References is the raw References header value from the email. */
  readonly references?: Maybe<Scalars['String']['output']>;
  readonly responses?: Maybe<ReadonlyArray<EmailDraftPublish>>;
  /** RFCMessageID is the unique identifier of the email in the RFC822 format (e.g. `Message-ID`). */
  readonly rfcMessageID: Scalars['String']['output'];
  readonly sourcePlatform: EmailCallIntegration;
  /** Subject is the raw Subject header value from the email. */
  readonly subject?: Maybe<Scalars['String']['output']>;
  readonly taskReferences?: Maybe<ReadonlyArray<TaskReference>>;
  readonly tasks?: Maybe<ReadonlyArray<Task>>;
  readonly thread: EmailThread;
  readonly threadUUID: Scalars['ID']['output'];
  /** To is the raw To header value from the email. */
  readonly to: ReadonlyArray<Scalars['String']['output']>;
  readonly updatedAt: Scalars['Int']['output'];
  readonly updatedByUUID: Scalars['ID']['output'];
}


export interface EmailEnumerationValuesArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EnumerationValueOrder>;
  where?: InputMaybe<EnumerationValueWhereInput>;
}

/** EmailCallIntegration is enum for the field source_platform */
export const EmailCallIntegration = {
  Apollo: 'APOLLO',
  Freshcaller: 'FRESHCALLER',
  Freshdesk: 'FRESHDESK',
  Gmail: 'GMAIL',
  Gohighlevel: 'GOHIGHLEVEL',
  Gong: 'GONG',
  GongOauth: 'GONG_OAUTH',
  GoogleCalendar: 'GOOGLE_CALENDAR',
  GoogleMeet: 'GOOGLE_MEET',
  Hubspot: 'HUBSPOT',
  Justcall: 'JUSTCALL',
  Outreach: 'OUTREACH',
  Pipedrive: 'PIPEDRIVE',
  ProductBoard: 'PRODUCT_BOARD',
  Salesloft: 'SALESLOFT',
  Sfdc: 'SFDC',
  Slack: 'SLACK',
  UnknownIntegration: 'UNKNOWN_INTEGRATION',
  Volie: 'VOLIE',
  Wingman: 'WINGMAN',
  Zoho: 'ZOHO',
  Zoom: 'ZOOM'
} as const;

export type EmailCallIntegration = typeof EmailCallIntegration[keyof typeof EmailCallIntegration];
/** A connection to a list of items. */
export interface EmailConnection {
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<EmailEdge>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
}

export interface EmailDelivery extends Node {
  readonly createdAt: Scalars['Int']['output'];
  readonly createdByUUID: Scalars['ID']['output'];
  readonly disabled: Scalars['Boolean']['output'];
  /** EmailAddress is the email address of the recipient of the email delivery. */
  readonly emailAddress?: Maybe<Scalars['String']['output']>;
  readonly emailSubscription: EmailSubscription;
  readonly emailSubscriptionUUID: Scalars['ID']['output'];
  readonly enumerationValue: EnumerationValue;
  readonly enumerationValueUUID: Scalars['ID']['output'];
  readonly id: Scalars['ID']['output'];
  readonly oldCreatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly oldID?: Maybe<Scalars['Int']['output']>;
  readonly oldUpdatedByID?: Maybe<Scalars['OldID']['output']>;
  /** Subject is the subject of the email delivery. */
  readonly subject?: Maybe<Scalars['String']['output']>;
  readonly updatedAt: Scalars['Int']['output'];
  readonly updatedByUUID: Scalars['ID']['output'];
}

/** A connection to a list of items. */
export interface EmailDeliveryConnection {
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<EmailDeliveryEdge>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface EmailDeliveryEdge {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<EmailDelivery>;
}

/** Ordering options for EmailDelivery connections */
export interface EmailDeliveryOrder {
  /** The ordering direction. */
  readonly direction?: OrderDirection;
  /** The field by which to order EmailDeliveries. */
  readonly field: EmailDeliveryOrderField;
}

/** Properties by which EmailDelivery connections can be ordered. */
export const EmailDeliveryOrderField = {
  CreatedAt: 'CREATED_AT',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type EmailDeliveryOrderField = typeof EmailDeliveryOrderField[keyof typeof EmailDeliveryOrderField];
/**
 * EmailDeliveryWhereInput is used for filtering EmailDelivery objects.
 * Input was generated by ent.
 */
export interface EmailDeliveryWhereInput {
  readonly and?: InputMaybe<ReadonlyArray<EmailDeliveryWhereInput>>;
  /** created_at field predicates */
  readonly createdAt?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly createdAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** created_by_uuid field predicates */
  readonly createdByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly createdByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** disabled field predicates */
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** email_address field predicates */
  readonly emailAddress?: InputMaybe<Scalars['String']['input']>;
  readonly emailAddressContains?: InputMaybe<Scalars['String']['input']>;
  readonly emailAddressContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly emailAddressEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly emailAddressGT?: InputMaybe<Scalars['String']['input']>;
  readonly emailAddressGTE?: InputMaybe<Scalars['String']['input']>;
  readonly emailAddressHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly emailAddressHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly emailAddressIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly emailAddressIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly emailAddressLT?: InputMaybe<Scalars['String']['input']>;
  readonly emailAddressLTE?: InputMaybe<Scalars['String']['input']>;
  readonly emailAddressNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly emailAddressNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly emailAddressNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** email_subscription_uuid field predicates */
  readonly emailSubscriptionUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly emailSubscriptionUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly emailSubscriptionUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly emailSubscriptionUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** enumeration_value_uuid field predicates */
  readonly enumerationValueUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly enumerationValueUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly enumerationValueUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly enumerationValueUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** email_subscription edge predicates */
  readonly hasEmailSubscription?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasEmailSubscriptionWith?: InputMaybe<ReadonlyArray<EmailSubscriptionWhereInput>>;
  /** enumeration_value edge predicates */
  readonly hasEnumerationValue?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasEnumerationValueWith?: InputMaybe<ReadonlyArray<EnumerationValueWhereInput>>;
  /** id field predicates */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly idGT?: InputMaybe<Scalars['ID']['input']>;
  readonly idGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly idLT?: InputMaybe<Scalars['ID']['input']>;
  readonly idLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly idNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly not?: InputMaybe<EmailDeliveryWhereInput>;
  /** old_created_by_id field predicates */
  readonly oldCreatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldCreatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_id field predicates */
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDGT?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly oldIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldIDLT?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly oldIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_updated_by_id field predicates */
  readonly oldUpdatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldUpdatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly or?: InputMaybe<ReadonlyArray<EmailDeliveryWhereInput>>;
  /** subject field predicates */
  readonly subject?: InputMaybe<Scalars['String']['input']>;
  readonly subjectContains?: InputMaybe<Scalars['String']['input']>;
  readonly subjectContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly subjectEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly subjectGT?: InputMaybe<Scalars['String']['input']>;
  readonly subjectGTE?: InputMaybe<Scalars['String']['input']>;
  readonly subjectHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly subjectHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly subjectIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly subjectIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly subjectLT?: InputMaybe<Scalars['String']['input']>;
  readonly subjectLTE?: InputMaybe<Scalars['String']['input']>;
  readonly subjectNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly subjectNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly subjectNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  readonly updatedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly updatedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** updated_by_uuid field predicates */
  readonly updatedByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly updatedByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
}

export interface EmailDraftPublish extends Node {
  readonly body?: Maybe<Scalars['String']['output']>;
  readonly createdAt: Scalars['Int']['output'];
  readonly createdByUUID: Scalars['ID']['output'];
  readonly disabled: Scalars['Boolean']['output'];
  readonly email: Email;
  readonly emailReplyDraft: EmailReplyDraft;
  readonly emailReplyDraftUUID: Scalars['ID']['output'];
  readonly emailUUID: Scalars['ID']['output'];
  readonly id: Scalars['ID']['output'];
  readonly oldCreatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly oldUpdatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly updatedAt: Scalars['Int']['output'];
  readonly updatedByUUID: Scalars['ID']['output'];
}

/** A connection to a list of items. */
export interface EmailDraftPublishConnection {
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<EmailDraftPublishEdge>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface EmailDraftPublishEdge {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<EmailDraftPublish>;
}

/** Ordering options for EmailDraftPublish connections */
export interface EmailDraftPublishOrder {
  /** The ordering direction. */
  readonly direction?: OrderDirection;
  /** The field by which to order EmailDraftPublishes. */
  readonly field: EmailDraftPublishOrderField;
}

/** Properties by which EmailDraftPublish connections can be ordered. */
export const EmailDraftPublishOrderField = {
  CreatedAt: 'CREATED_AT',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type EmailDraftPublishOrderField = typeof EmailDraftPublishOrderField[keyof typeof EmailDraftPublishOrderField];
/**
 * EmailDraftPublishWhereInput is used for filtering EmailDraftPublish objects.
 * Input was generated by ent.
 */
export interface EmailDraftPublishWhereInput {
  readonly and?: InputMaybe<ReadonlyArray<EmailDraftPublishWhereInput>>;
  /** body field predicates */
  readonly body?: InputMaybe<Scalars['String']['input']>;
  readonly bodyContains?: InputMaybe<Scalars['String']['input']>;
  readonly bodyContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly bodyEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly bodyGT?: InputMaybe<Scalars['String']['input']>;
  readonly bodyGTE?: InputMaybe<Scalars['String']['input']>;
  readonly bodyHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly bodyHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly bodyIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly bodyIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly bodyLT?: InputMaybe<Scalars['String']['input']>;
  readonly bodyLTE?: InputMaybe<Scalars['String']['input']>;
  readonly bodyNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly bodyNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly bodyNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  readonly createdAt?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly createdAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** created_by_uuid field predicates */
  readonly createdByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly createdByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** disabled field predicates */
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** email_reply_draft_uuid field predicates */
  readonly emailReplyDraftUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly emailReplyDraftUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly emailReplyDraftUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly emailReplyDraftUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** email_uuid field predicates */
  readonly emailUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly emailUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly emailUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly emailUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** email edge predicates */
  readonly hasEmail?: InputMaybe<Scalars['Boolean']['input']>;
  /** email_reply_draft edge predicates */
  readonly hasEmailReplyDraft?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasEmailReplyDraftWith?: InputMaybe<ReadonlyArray<EmailReplyDraftWhereInput>>;
  readonly hasEmailWith?: InputMaybe<ReadonlyArray<EmailWhereInput>>;
  /** id field predicates */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly idGT?: InputMaybe<Scalars['ID']['input']>;
  readonly idGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly idLT?: InputMaybe<Scalars['ID']['input']>;
  readonly idLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly idNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly not?: InputMaybe<EmailDraftPublishWhereInput>;
  /** old_created_by_id field predicates */
  readonly oldCreatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldCreatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_updated_by_id field predicates */
  readonly oldUpdatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldUpdatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly or?: InputMaybe<ReadonlyArray<EmailDraftPublishWhereInput>>;
  /** updated_at field predicates */
  readonly updatedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly updatedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** updated_by_uuid field predicates */
  readonly updatedByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly updatedByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
}

/** An edge in a connection. */
export interface EmailEdge {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<Email>;
}

/** Ordering options for Email connections */
export interface EmailOrder {
  /** The ordering direction. */
  readonly direction?: OrderDirection;
  /** The field by which to order Emails. */
  readonly field: EmailOrderField;
}

/** Properties by which Email connections can be ordered. */
export const EmailOrderField = {
  CreatedAt: 'CREATED_AT',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type EmailOrderField = typeof EmailOrderField[keyof typeof EmailOrderField];
export interface EmailRecipient extends Node {
  readonly contact?: Maybe<Contact>;
  readonly contactUUID?: Maybe<Scalars['ID']['output']>;
  readonly createdAt: Scalars['Int']['output'];
  readonly createdByUUID: Scalars['ID']['output'];
  readonly disabled: Scalars['Boolean']['output'];
  readonly email: Email;
  readonly emailUUID: Scalars['ID']['output'];
  readonly id: Scalars['ID']['output'];
  readonly oldCreatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly oldUpdatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly recipientType: EmailRecipientRecipientType;
  readonly updatedAt: Scalars['Int']['output'];
  readonly updatedByUUID: Scalars['ID']['output'];
  readonly user?: Maybe<User>;
  readonly userUUID?: Maybe<Scalars['ID']['output']>;
}

/** A connection to a list of items. */
export interface EmailRecipientConnection {
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<EmailRecipientEdge>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface EmailRecipientEdge {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<EmailRecipient>;
}

/** Ordering options for EmailRecipient connections */
export interface EmailRecipientOrder {
  /** The ordering direction. */
  readonly direction?: OrderDirection;
  /** The field by which to order EmailRecipients. */
  readonly field: EmailRecipientOrderField;
}

/** Properties by which EmailRecipient connections can be ordered. */
export const EmailRecipientOrderField = {
  CreatedAt: 'CREATED_AT',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type EmailRecipientOrderField = typeof EmailRecipientOrderField[keyof typeof EmailRecipientOrderField];
/** EmailRecipientRecipientType is enum for the field recipient_type */
export const EmailRecipientRecipientType = {
  Bcc: 'BCC',
  Cc: 'CC',
  To: 'TO',
  Unknown: 'UNKNOWN'
} as const;

export type EmailRecipientRecipientType = typeof EmailRecipientRecipientType[keyof typeof EmailRecipientRecipientType];
/**
 * EmailRecipientWhereInput is used for filtering EmailRecipient objects.
 * Input was generated by ent.
 */
export interface EmailRecipientWhereInput {
  readonly and?: InputMaybe<ReadonlyArray<EmailRecipientWhereInput>>;
  /** contact_uuid field predicates */
  readonly contactUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly contactUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly contactUUIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly contactUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly contactUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly contactUUIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  readonly createdAt?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly createdAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** created_by_uuid field predicates */
  readonly createdByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly createdByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** disabled field predicates */
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** email_uuid field predicates */
  readonly emailUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly emailUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly emailUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly emailUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** contact edge predicates */
  readonly hasContact?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasContactWith?: InputMaybe<ReadonlyArray<ContactWhereInput>>;
  /** email edge predicates */
  readonly hasEmail?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasEmailWith?: InputMaybe<ReadonlyArray<EmailWhereInput>>;
  /** user edge predicates */
  readonly hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasUserWith?: InputMaybe<ReadonlyArray<UserWhereInput>>;
  /** id field predicates */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly idGT?: InputMaybe<Scalars['ID']['input']>;
  readonly idGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly idLT?: InputMaybe<Scalars['ID']['input']>;
  readonly idLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly idNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly not?: InputMaybe<EmailRecipientWhereInput>;
  /** old_created_by_id field predicates */
  readonly oldCreatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldCreatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_updated_by_id field predicates */
  readonly oldUpdatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldUpdatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly or?: InputMaybe<ReadonlyArray<EmailRecipientWhereInput>>;
  /** recipient_type field predicates */
  readonly recipientType?: InputMaybe<EmailRecipientRecipientType>;
  readonly recipientTypeIn?: InputMaybe<ReadonlyArray<EmailRecipientRecipientType>>;
  readonly recipientTypeNEQ?: InputMaybe<EmailRecipientRecipientType>;
  readonly recipientTypeNotIn?: InputMaybe<ReadonlyArray<EmailRecipientRecipientType>>;
  /** updated_at field predicates */
  readonly updatedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly updatedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** updated_by_uuid field predicates */
  readonly updatedByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly updatedByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** user_uuid field predicates */
  readonly userUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly userUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly userUUIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly userUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly userUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly userUUIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface EmailReplyContext extends Node {
  /** A human-readable context for the email reply, also used by the LLM to generate the reply. */
  readonly context: Scalars['String']['output'];
  readonly createdAt: Scalars['Int']['output'];
  readonly disabled: Scalars['Boolean']['output'];
  readonly email: Email;
  readonly emailUUID: Scalars['ID']['output'];
  readonly id: Scalars['ID']['output'];
  readonly knowledgeDocument?: Maybe<KnowledgeDocument>;
  readonly knowledgeDocumentUUID?: Maybe<Scalars['ID']['output']>;
  readonly updatedAt: Scalars['Int']['output'];
}

/** A connection to a list of items. */
export interface EmailReplyContextConnection {
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<EmailReplyContextEdge>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface EmailReplyContextEdge {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<EmailReplyContext>;
}

/** Ordering options for EmailReplyContext connections */
export interface EmailReplyContextOrder {
  /** The ordering direction. */
  readonly direction?: OrderDirection;
  /** The field by which to order EmailReplyContexts. */
  readonly field: EmailReplyContextOrderField;
}

/** Properties by which EmailReplyContext connections can be ordered. */
export const EmailReplyContextOrderField = {
  CreatedAt: 'CREATED_AT',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type EmailReplyContextOrderField = typeof EmailReplyContextOrderField[keyof typeof EmailReplyContextOrderField];
/**
 * EmailReplyContextWhereInput is used for filtering EmailReplyContext objects.
 * Input was generated by ent.
 */
export interface EmailReplyContextWhereInput {
  readonly and?: InputMaybe<ReadonlyArray<EmailReplyContextWhereInput>>;
  /** context field predicates */
  readonly context?: InputMaybe<Scalars['String']['input']>;
  readonly contextContains?: InputMaybe<Scalars['String']['input']>;
  readonly contextContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly contextEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly contextGT?: InputMaybe<Scalars['String']['input']>;
  readonly contextGTE?: InputMaybe<Scalars['String']['input']>;
  readonly contextHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly contextHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly contextIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly contextLT?: InputMaybe<Scalars['String']['input']>;
  readonly contextLTE?: InputMaybe<Scalars['String']['input']>;
  readonly contextNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly contextNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** created_at field predicates */
  readonly createdAt?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly createdAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** disabled field predicates */
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** email_uuid field predicates */
  readonly emailUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly emailUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly emailUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly emailUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** email edge predicates */
  readonly hasEmail?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasEmailWith?: InputMaybe<ReadonlyArray<EmailWhereInput>>;
  /** knowledge_document edge predicates */
  readonly hasKnowledgeDocument?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasKnowledgeDocumentWith?: InputMaybe<ReadonlyArray<KnowledgeDocumentWhereInput>>;
  /** id field predicates */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly idGT?: InputMaybe<Scalars['ID']['input']>;
  readonly idGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly idLT?: InputMaybe<Scalars['ID']['input']>;
  readonly idLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly idNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** knowledge_document_uuid field predicates */
  readonly knowledgeDocumentUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly knowledgeDocumentUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly knowledgeDocumentUUIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly knowledgeDocumentUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly knowledgeDocumentUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly knowledgeDocumentUUIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly not?: InputMaybe<EmailReplyContextWhereInput>;
  readonly or?: InputMaybe<ReadonlyArray<EmailReplyContextWhereInput>>;
  /** updated_at field predicates */
  readonly updatedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly updatedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
}

export interface EmailReplyDraft extends Node {
  readonly body?: Maybe<Scalars['String']['output']>;
  readonly createdAt: Scalars['Int']['output'];
  readonly createdByUUID: Scalars['ID']['output'];
  readonly disabled: Scalars['Boolean']['output'];
  readonly email: Email;
  readonly emailDraftPublishes?: Maybe<ReadonlyArray<EmailDraftPublish>>;
  readonly emailUUID: Scalars['ID']['output'];
  readonly id: Scalars['ID']['output'];
  readonly oldCreatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly oldUpdatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly updatedAt: Scalars['Int']['output'];
  readonly updatedByUUID: Scalars['ID']['output'];
}

/** A connection to a list of items. */
export interface EmailReplyDraftConnection {
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<EmailReplyDraftEdge>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface EmailReplyDraftEdge {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<EmailReplyDraft>;
}

/** Ordering options for EmailReplyDraft connections */
export interface EmailReplyDraftOrder {
  /** The ordering direction. */
  readonly direction?: OrderDirection;
  /** The field by which to order EmailReplyDrafts. */
  readonly field: EmailReplyDraftOrderField;
}

/** Properties by which EmailReplyDraft connections can be ordered. */
export const EmailReplyDraftOrderField = {
  CreatedAt: 'CREATED_AT',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type EmailReplyDraftOrderField = typeof EmailReplyDraftOrderField[keyof typeof EmailReplyDraftOrderField];
/**
 * EmailReplyDraftWhereInput is used for filtering EmailReplyDraft objects.
 * Input was generated by ent.
 */
export interface EmailReplyDraftWhereInput {
  readonly and?: InputMaybe<ReadonlyArray<EmailReplyDraftWhereInput>>;
  /** body field predicates */
  readonly body?: InputMaybe<Scalars['String']['input']>;
  readonly bodyContains?: InputMaybe<Scalars['String']['input']>;
  readonly bodyContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly bodyEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly bodyGT?: InputMaybe<Scalars['String']['input']>;
  readonly bodyGTE?: InputMaybe<Scalars['String']['input']>;
  readonly bodyHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly bodyHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly bodyIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly bodyIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly bodyLT?: InputMaybe<Scalars['String']['input']>;
  readonly bodyLTE?: InputMaybe<Scalars['String']['input']>;
  readonly bodyNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly bodyNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly bodyNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  readonly createdAt?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly createdAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** created_by_uuid field predicates */
  readonly createdByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly createdByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** disabled field predicates */
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** email_uuid field predicates */
  readonly emailUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly emailUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly emailUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly emailUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** email edge predicates */
  readonly hasEmail?: InputMaybe<Scalars['Boolean']['input']>;
  /** email_draft_publishes edge predicates */
  readonly hasEmailDraftPublishes?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasEmailDraftPublishesWith?: InputMaybe<ReadonlyArray<EmailDraftPublishWhereInput>>;
  readonly hasEmailWith?: InputMaybe<ReadonlyArray<EmailWhereInput>>;
  /** id field predicates */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly idGT?: InputMaybe<Scalars['ID']['input']>;
  readonly idGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly idLT?: InputMaybe<Scalars['ID']['input']>;
  readonly idLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly idNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly not?: InputMaybe<EmailReplyDraftWhereInput>;
  /** old_created_by_id field predicates */
  readonly oldCreatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldCreatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_updated_by_id field predicates */
  readonly oldUpdatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldUpdatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly or?: InputMaybe<ReadonlyArray<EmailReplyDraftWhereInput>>;
  /** updated_at field predicates */
  readonly updatedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly updatedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** updated_by_uuid field predicates */
  readonly updatedByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly updatedByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
}

export interface EmailSubscription extends Node {
  readonly attendeeGroups?: Maybe<ReadonlyArray<Scalars['ID']['output']>>;
  readonly attendees?: Maybe<ReadonlyArray<Scalars['ID']['output']>>;
  readonly callFilterTemplate?: Maybe<Scalars['String']['output']>;
  readonly createdAt: Scalars['Int']['output'];
  readonly createdByUUID: Scalars['ID']['output'];
  readonly customerCustomers?: Maybe<ReadonlyArray<Scalars['ID']['output']>>;
  readonly disabled: Scalars['Boolean']['output'];
  readonly emailDeliveries?: Maybe<ReadonlyArray<EmailDelivery>>;
  readonly emailSubscriptionLinks?: Maybe<ReadonlyArray<EmailSubscriptionLink>>;
  readonly hostGroups?: Maybe<ReadonlyArray<Scalars['ID']['output']>>;
  readonly hosts?: Maybe<ReadonlyArray<Scalars['ID']['output']>>;
  readonly id: Scalars['ID']['output'];
  readonly oldCreatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly oldUpdatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly toAddress?: Maybe<Scalars['String']['output']>;
  readonly updatedAt: Scalars['Int']['output'];
  readonly updatedByUUID: Scalars['ID']['output'];
  readonly user?: Maybe<User>;
  readonly userGroupIds?: Maybe<ReadonlyArray<Scalars['ID']['output']>>;
  readonly userUUID?: Maybe<Scalars['ID']['output']>;
}

export interface EmailSubscriptionConfig extends Node {
  readonly adhocEmailSends?: Maybe<ReadonlyArray<AdhocEmailSend>>;
  readonly createdAt: Scalars['Int']['output'];
  readonly createdByUUID: Scalars['ID']['output'];
  /** Default is a boolean field that when set to true will be the default email subscription config for the enumeration configuration. */
  readonly default: Scalars['Boolean']['output'];
  readonly disabled: Scalars['Boolean']['output'];
  readonly emailSubscriptionConfigFields?: Maybe<ReadonlyArray<EmailSubscriptionConfigField>>;
  readonly emailSubscriptionLinks?: Maybe<ReadonlyArray<EmailSubscriptionLink>>;
  readonly enumerationConfiguration: EnumerationConfiguration;
  readonly enumerationConfigurationUUID: Scalars['ID']['output'];
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
  readonly oldCreatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly oldID?: Maybe<Scalars['Int']['output']>;
  readonly oldUpdatedByID?: Maybe<Scalars['OldID']['output']>;
  /** ShowFeedbackLink is a boolean field that when set to true will include a feedback link in the email. */
  readonly showFeedbackLink: Scalars['Boolean']['output'];
  /** SubjectTemplate is an optional field that when set will be executed to generate the email subject. */
  readonly subjectTemplate?: Maybe<Scalars['String']['output']>;
  readonly updatedAt: Scalars['Int']['output'];
  readonly updatedByUUID: Scalars['ID']['output'];
}

/** A connection to a list of items. */
export interface EmailSubscriptionConfigConnection {
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<EmailSubscriptionConfigEdge>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface EmailSubscriptionConfigEdge {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<EmailSubscriptionConfig>;
}

export interface EmailSubscriptionConfigField extends Node {
  readonly createdAt: Scalars['Int']['output'];
  readonly createdByUUID: Scalars['ID']['output'];
  readonly disabled: Scalars['Boolean']['output'];
  readonly displayName?: Maybe<Scalars['String']['output']>;
  readonly emailSubscriptionConfig: EmailSubscriptionConfig;
  readonly emailSubscriptionConfigUUID: Scalars['ID']['output'];
  readonly enumerationField?: Maybe<EnumerationField>;
  readonly enumerationFieldUUID?: Maybe<Scalars['ID']['output']>;
  readonly filterTemplate: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  /**
   * Index specifies which order this field should be rendered in an email.
   * Index is zero based, and lower values are rendered first.
   */
  readonly index: Scalars['Int']['output'];
  readonly oldCreatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly oldID?: Maybe<Scalars['Int']['output']>;
  readonly oldUpdatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly updatedAt: Scalars['Int']['output'];
  readonly updatedByUUID: Scalars['ID']['output'];
}

/** A connection to a list of items. */
export interface EmailSubscriptionConfigFieldConnection {
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<EmailSubscriptionConfigFieldEdge>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface EmailSubscriptionConfigFieldEdge {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<EmailSubscriptionConfigField>;
}

/** Ordering options for EmailSubscriptionConfigField connections */
export interface EmailSubscriptionConfigFieldOrder {
  /** The ordering direction. */
  readonly direction?: OrderDirection;
  /** The field by which to order EmailSubscriptionConfigFields. */
  readonly field: EmailSubscriptionConfigFieldOrderField;
}

/** Properties by which EmailSubscriptionConfigField connections can be ordered. */
export const EmailSubscriptionConfigFieldOrderField = {
  CreatedAt: 'CREATED_AT',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type EmailSubscriptionConfigFieldOrderField = typeof EmailSubscriptionConfigFieldOrderField[keyof typeof EmailSubscriptionConfigFieldOrderField];
/**
 * EmailSubscriptionConfigFieldWhereInput is used for filtering EmailSubscriptionConfigField objects.
 * Input was generated by ent.
 */
export interface EmailSubscriptionConfigFieldWhereInput {
  readonly and?: InputMaybe<ReadonlyArray<EmailSubscriptionConfigFieldWhereInput>>;
  /** created_at field predicates */
  readonly createdAt?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly createdAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** created_by_uuid field predicates */
  readonly createdByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly createdByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** disabled field predicates */
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** display_name field predicates */
  readonly displayName?: InputMaybe<Scalars['String']['input']>;
  readonly displayNameContains?: InputMaybe<Scalars['String']['input']>;
  readonly displayNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly displayNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly displayNameGT?: InputMaybe<Scalars['String']['input']>;
  readonly displayNameGTE?: InputMaybe<Scalars['String']['input']>;
  readonly displayNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly displayNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly displayNameIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly displayNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly displayNameLT?: InputMaybe<Scalars['String']['input']>;
  readonly displayNameLTE?: InputMaybe<Scalars['String']['input']>;
  readonly displayNameNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly displayNameNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly displayNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** email_subscription_config_uuid field predicates */
  readonly emailSubscriptionConfigUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly emailSubscriptionConfigUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly emailSubscriptionConfigUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly emailSubscriptionConfigUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** enumeration_field_uuid field predicates */
  readonly enumerationFieldUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly enumerationFieldUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly enumerationFieldUUIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly enumerationFieldUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly enumerationFieldUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly enumerationFieldUUIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** filter_template field predicates */
  readonly filterTemplate?: InputMaybe<Scalars['String']['input']>;
  readonly filterTemplateContains?: InputMaybe<Scalars['String']['input']>;
  readonly filterTemplateContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly filterTemplateEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly filterTemplateGT?: InputMaybe<Scalars['String']['input']>;
  readonly filterTemplateGTE?: InputMaybe<Scalars['String']['input']>;
  readonly filterTemplateHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly filterTemplateHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly filterTemplateIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly filterTemplateLT?: InputMaybe<Scalars['String']['input']>;
  readonly filterTemplateLTE?: InputMaybe<Scalars['String']['input']>;
  readonly filterTemplateNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly filterTemplateNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** email_subscription_config edge predicates */
  readonly hasEmailSubscriptionConfig?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasEmailSubscriptionConfigWith?: InputMaybe<ReadonlyArray<EmailSubscriptionConfigWhereInput>>;
  /** enumeration_field edge predicates */
  readonly hasEnumerationField?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasEnumerationFieldWith?: InputMaybe<ReadonlyArray<EnumerationFieldWhereInput>>;
  /** id field predicates */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly idGT?: InputMaybe<Scalars['ID']['input']>;
  readonly idGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly idLT?: InputMaybe<Scalars['ID']['input']>;
  readonly idLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly idNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** index field predicates */
  readonly index?: InputMaybe<Scalars['Int']['input']>;
  readonly indexGT?: InputMaybe<Scalars['Int']['input']>;
  readonly indexGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly indexIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly indexLT?: InputMaybe<Scalars['Int']['input']>;
  readonly indexLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly indexNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly indexNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly not?: InputMaybe<EmailSubscriptionConfigFieldWhereInput>;
  /** old_created_by_id field predicates */
  readonly oldCreatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldCreatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_id field predicates */
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDGT?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly oldIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldIDLT?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly oldIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_updated_by_id field predicates */
  readonly oldUpdatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldUpdatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly or?: InputMaybe<ReadonlyArray<EmailSubscriptionConfigFieldWhereInput>>;
  /** updated_at field predicates */
  readonly updatedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly updatedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** updated_by_uuid field predicates */
  readonly updatedByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly updatedByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
}

/** Ordering options for EmailSubscriptionConfig connections */
export interface EmailSubscriptionConfigOrder {
  /** The ordering direction. */
  readonly direction?: OrderDirection;
  /** The field by which to order EmailSubscriptionConfigs. */
  readonly field: EmailSubscriptionConfigOrderField;
}

/** Properties by which EmailSubscriptionConfig connections can be ordered. */
export const EmailSubscriptionConfigOrderField = {
  CreatedAt: 'CREATED_AT',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type EmailSubscriptionConfigOrderField = typeof EmailSubscriptionConfigOrderField[keyof typeof EmailSubscriptionConfigOrderField];
/**
 * EmailSubscriptionConfigWhereInput is used for filtering EmailSubscriptionConfig objects.
 * Input was generated by ent.
 */
export interface EmailSubscriptionConfigWhereInput {
  readonly and?: InputMaybe<ReadonlyArray<EmailSubscriptionConfigWhereInput>>;
  /** created_at field predicates */
  readonly createdAt?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly createdAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** created_by_uuid field predicates */
  readonly createdByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly createdByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** default field predicates */
  readonly default?: InputMaybe<Scalars['Boolean']['input']>;
  readonly defaultNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** disabled field predicates */
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** enumeration_configuration_uuid field predicates */
  readonly enumerationConfigurationUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly enumerationConfigurationUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly enumerationConfigurationUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly enumerationConfigurationUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** adhoc_email_sends edge predicates */
  readonly hasAdhocEmailSends?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasAdhocEmailSendsWith?: InputMaybe<ReadonlyArray<AdhocEmailSendWhereInput>>;
  /** email_subscription_config_fields edge predicates */
  readonly hasEmailSubscriptionConfigFields?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasEmailSubscriptionConfigFieldsWith?: InputMaybe<ReadonlyArray<EmailSubscriptionConfigFieldWhereInput>>;
  /** email_subscription_links edge predicates */
  readonly hasEmailSubscriptionLinks?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasEmailSubscriptionLinksWith?: InputMaybe<ReadonlyArray<EmailSubscriptionLinkWhereInput>>;
  /** enumeration_configuration edge predicates */
  readonly hasEnumerationConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasEnumerationConfigurationWith?: InputMaybe<ReadonlyArray<EnumerationConfigurationWhereInput>>;
  /** id field predicates */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly idGT?: InputMaybe<Scalars['ID']['input']>;
  readonly idGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly idLT?: InputMaybe<Scalars['ID']['input']>;
  readonly idLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly idNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** name field predicates */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly nameContains?: InputMaybe<Scalars['String']['input']>;
  readonly nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly nameGT?: InputMaybe<Scalars['String']['input']>;
  readonly nameGTE?: InputMaybe<Scalars['String']['input']>;
  readonly nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly nameIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly nameLT?: InputMaybe<Scalars['String']['input']>;
  readonly nameLTE?: InputMaybe<Scalars['String']['input']>;
  readonly nameNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly nameNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly not?: InputMaybe<EmailSubscriptionConfigWhereInput>;
  /** old_created_by_id field predicates */
  readonly oldCreatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldCreatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_id field predicates */
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDGT?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly oldIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldIDLT?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly oldIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_updated_by_id field predicates */
  readonly oldUpdatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldUpdatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly or?: InputMaybe<ReadonlyArray<EmailSubscriptionConfigWhereInput>>;
  /** show_feedback_link field predicates */
  readonly showFeedbackLink?: InputMaybe<Scalars['Boolean']['input']>;
  readonly showFeedbackLinkNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** subject_template field predicates */
  readonly subjectTemplate?: InputMaybe<Scalars['String']['input']>;
  readonly subjectTemplateContains?: InputMaybe<Scalars['String']['input']>;
  readonly subjectTemplateContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly subjectTemplateEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly subjectTemplateGT?: InputMaybe<Scalars['String']['input']>;
  readonly subjectTemplateGTE?: InputMaybe<Scalars['String']['input']>;
  readonly subjectTemplateHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly subjectTemplateHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly subjectTemplateIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly subjectTemplateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly subjectTemplateLT?: InputMaybe<Scalars['String']['input']>;
  readonly subjectTemplateLTE?: InputMaybe<Scalars['String']['input']>;
  readonly subjectTemplateNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly subjectTemplateNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly subjectTemplateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  readonly updatedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly updatedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** updated_by_uuid field predicates */
  readonly updatedByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly updatedByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
}

/** A connection to a list of items. */
export interface EmailSubscriptionConnection {
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<EmailSubscriptionEdge>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface EmailSubscriptionEdge {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<EmailSubscription>;
}

export interface EmailSubscriptionLink extends Node {
  readonly createdAt: Scalars['Int']['output'];
  readonly createdByUUID: Scalars['ID']['output'];
  readonly disabled: Scalars['Boolean']['output'];
  readonly emailSubscription: EmailSubscription;
  readonly emailSubscriptionConfig: EmailSubscriptionConfig;
  readonly emailSubscriptionConfigUUID: Scalars['ID']['output'];
  readonly emailSubscriptionUUID: Scalars['ID']['output'];
  readonly enumerationConfiguration: EnumerationConfiguration;
  readonly enumerationConfigurationUUID: Scalars['ID']['output'];
  readonly id: Scalars['ID']['output'];
  readonly oldCreatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly oldID?: Maybe<Scalars['Int']['output']>;
  readonly oldUpdatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly updatedAt: Scalars['Int']['output'];
  readonly updatedByUUID: Scalars['ID']['output'];
}

/** A connection to a list of items. */
export interface EmailSubscriptionLinkConnection {
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<EmailSubscriptionLinkEdge>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface EmailSubscriptionLinkEdge {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<EmailSubscriptionLink>;
}

/** Ordering options for EmailSubscriptionLink connections */
export interface EmailSubscriptionLinkOrder {
  /** The ordering direction. */
  readonly direction?: OrderDirection;
  /** The field by which to order EmailSubscriptionLinks. */
  readonly field: EmailSubscriptionLinkOrderField;
}

/** Properties by which EmailSubscriptionLink connections can be ordered. */
export const EmailSubscriptionLinkOrderField = {
  CreatedAt: 'CREATED_AT',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type EmailSubscriptionLinkOrderField = typeof EmailSubscriptionLinkOrderField[keyof typeof EmailSubscriptionLinkOrderField];
/**
 * EmailSubscriptionLinkWhereInput is used for filtering EmailSubscriptionLink objects.
 * Input was generated by ent.
 */
export interface EmailSubscriptionLinkWhereInput {
  readonly and?: InputMaybe<ReadonlyArray<EmailSubscriptionLinkWhereInput>>;
  /** created_at field predicates */
  readonly createdAt?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly createdAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** created_by_uuid field predicates */
  readonly createdByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly createdByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** disabled field predicates */
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** email_subscription_config_uuid field predicates */
  readonly emailSubscriptionConfigUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly emailSubscriptionConfigUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly emailSubscriptionConfigUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly emailSubscriptionConfigUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** email_subscription_uuid field predicates */
  readonly emailSubscriptionUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly emailSubscriptionUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly emailSubscriptionUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly emailSubscriptionUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** enumeration_configuration_uuid field predicates */
  readonly enumerationConfigurationUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly enumerationConfigurationUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly enumerationConfigurationUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly enumerationConfigurationUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** email_subscription edge predicates */
  readonly hasEmailSubscription?: InputMaybe<Scalars['Boolean']['input']>;
  /** email_subscription_config edge predicates */
  readonly hasEmailSubscriptionConfig?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasEmailSubscriptionConfigWith?: InputMaybe<ReadonlyArray<EmailSubscriptionConfigWhereInput>>;
  readonly hasEmailSubscriptionWith?: InputMaybe<ReadonlyArray<EmailSubscriptionWhereInput>>;
  /** enumeration_configuration edge predicates */
  readonly hasEnumerationConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasEnumerationConfigurationWith?: InputMaybe<ReadonlyArray<EnumerationConfigurationWhereInput>>;
  /** id field predicates */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly idGT?: InputMaybe<Scalars['ID']['input']>;
  readonly idGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly idLT?: InputMaybe<Scalars['ID']['input']>;
  readonly idLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly idNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly not?: InputMaybe<EmailSubscriptionLinkWhereInput>;
  /** old_created_by_id field predicates */
  readonly oldCreatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldCreatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_id field predicates */
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDGT?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly oldIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldIDLT?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly oldIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_updated_by_id field predicates */
  readonly oldUpdatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldUpdatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly or?: InputMaybe<ReadonlyArray<EmailSubscriptionLinkWhereInput>>;
  /** updated_at field predicates */
  readonly updatedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly updatedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** updated_by_uuid field predicates */
  readonly updatedByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly updatedByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
}

/** Ordering options for EmailSubscription connections */
export interface EmailSubscriptionOrder {
  /** The ordering direction. */
  readonly direction?: OrderDirection;
  /** The field by which to order EmailSubscriptions. */
  readonly field: EmailSubscriptionOrderField;
}

/** Properties by which EmailSubscription connections can be ordered. */
export const EmailSubscriptionOrderField = {
  CreatedAt: 'CREATED_AT',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type EmailSubscriptionOrderField = typeof EmailSubscriptionOrderField[keyof typeof EmailSubscriptionOrderField];
/**
 * EmailSubscriptionWhereInput is used for filtering EmailSubscription objects.
 * Input was generated by ent.
 */
export interface EmailSubscriptionWhereInput {
  readonly and?: InputMaybe<ReadonlyArray<EmailSubscriptionWhereInput>>;
  /** call_filter_template field predicates */
  readonly callFilterTemplate?: InputMaybe<Scalars['String']['input']>;
  readonly callFilterTemplateContains?: InputMaybe<Scalars['String']['input']>;
  readonly callFilterTemplateContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly callFilterTemplateEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly callFilterTemplateGT?: InputMaybe<Scalars['String']['input']>;
  readonly callFilterTemplateGTE?: InputMaybe<Scalars['String']['input']>;
  readonly callFilterTemplateHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly callFilterTemplateHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly callFilterTemplateIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly callFilterTemplateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly callFilterTemplateLT?: InputMaybe<Scalars['String']['input']>;
  readonly callFilterTemplateLTE?: InputMaybe<Scalars['String']['input']>;
  readonly callFilterTemplateNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly callFilterTemplateNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly callFilterTemplateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  readonly createdAt?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly createdAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** created_by_uuid field predicates */
  readonly createdByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly createdByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** disabled field predicates */
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** email_deliveries edge predicates */
  readonly hasEmailDeliveries?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasEmailDeliveriesWith?: InputMaybe<ReadonlyArray<EmailDeliveryWhereInput>>;
  /** email_subscription_links edge predicates */
  readonly hasEmailSubscriptionLinks?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasEmailSubscriptionLinksWith?: InputMaybe<ReadonlyArray<EmailSubscriptionLinkWhereInput>>;
  /** user edge predicates */
  readonly hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasUserWith?: InputMaybe<ReadonlyArray<UserWhereInput>>;
  /** id field predicates */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly idGT?: InputMaybe<Scalars['ID']['input']>;
  readonly idGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly idLT?: InputMaybe<Scalars['ID']['input']>;
  readonly idLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly idNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly not?: InputMaybe<EmailSubscriptionWhereInput>;
  /** old_created_by_id field predicates */
  readonly oldCreatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldCreatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_updated_by_id field predicates */
  readonly oldUpdatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldUpdatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly or?: InputMaybe<ReadonlyArray<EmailSubscriptionWhereInput>>;
  /** to_address field predicates */
  readonly toAddress?: InputMaybe<Scalars['String']['input']>;
  readonly toAddressContains?: InputMaybe<Scalars['String']['input']>;
  readonly toAddressContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly toAddressEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly toAddressGT?: InputMaybe<Scalars['String']['input']>;
  readonly toAddressGTE?: InputMaybe<Scalars['String']['input']>;
  readonly toAddressHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly toAddressHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly toAddressIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly toAddressIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly toAddressLT?: InputMaybe<Scalars['String']['input']>;
  readonly toAddressLTE?: InputMaybe<Scalars['String']['input']>;
  readonly toAddressNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly toAddressNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly toAddressNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  readonly updatedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly updatedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** updated_by_uuid field predicates */
  readonly updatedByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly updatedByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** user_uuid field predicates */
  readonly userUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly userUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly userUUIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly userUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly userUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly userUUIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface EmailThread extends Node {
  readonly createdAt: Scalars['Int']['output'];
  readonly createdByUUID: Scalars['ID']['output'];
  readonly disabled: Scalars['Boolean']['output'];
  readonly emails?: Maybe<ReadonlyArray<Email>>;
  readonly externalIdentifier: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly lastActivityAt: Scalars['Unix']['output'];
  readonly oldCreatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly oldUpdatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly sourcePlatform: CallIntegration;
  readonly summaries?: Maybe<ReadonlyArray<EmailThreadSummary>>;
  readonly updatedAt: Scalars['Int']['output'];
  readonly updatedByUUID: Scalars['ID']['output'];
  readonly user: User;
  readonly userUUID: Scalars['ID']['output'];
}

/** A connection to a list of items. */
export interface EmailThreadConnection {
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<EmailThreadEdge>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface EmailThreadEdge {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<EmailThread>;
}

/** Ordering options for EmailThread connections */
export interface EmailThreadOrder {
  /** The ordering direction. */
  readonly direction?: OrderDirection;
  /** The field by which to order EmailThreads. */
  readonly field: EmailThreadOrderField;
}

/** Properties by which EmailThread connections can be ordered. */
export const EmailThreadOrderField = {
  CreatedAt: 'CREATED_AT',
  LastActivityAt: 'LAST_ACTIVITY_AT',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type EmailThreadOrderField = typeof EmailThreadOrderField[keyof typeof EmailThreadOrderField];
export interface EmailThreadSummary extends Node {
  readonly createdAt: Scalars['Int']['output'];
  readonly createdByUUID: Scalars['ID']['output'];
  readonly disabled: Scalars['Boolean']['output'];
  readonly email: Email;
  readonly emailThread: EmailThread;
  /** EmailUUID is the most recent email in the thread which this summary is current through. */
  readonly emailUUID: Scalars['ID']['output'];
  readonly id: Scalars['ID']['output'];
  readonly oldCreatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly oldUpdatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly summary: Scalars['String']['output'];
  readonly threadUUID: Scalars['ID']['output'];
  readonly updatedAt: Scalars['Int']['output'];
  readonly updatedByUUID: Scalars['ID']['output'];
}

/** A connection to a list of items. */
export interface EmailThreadSummaryConnection {
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<EmailThreadSummaryEdge>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface EmailThreadSummaryEdge {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<EmailThreadSummary>;
}

/** Ordering options for EmailThreadSummary connections */
export interface EmailThreadSummaryOrder {
  /** The ordering direction. */
  readonly direction?: OrderDirection;
  /** The field by which to order EmailThreadSummaries. */
  readonly field: EmailThreadSummaryOrderField;
}

/** Properties by which EmailThreadSummary connections can be ordered. */
export const EmailThreadSummaryOrderField = {
  CreatedAt: 'CREATED_AT',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type EmailThreadSummaryOrderField = typeof EmailThreadSummaryOrderField[keyof typeof EmailThreadSummaryOrderField];
/**
 * EmailThreadSummaryWhereInput is used for filtering EmailThreadSummary objects.
 * Input was generated by ent.
 */
export interface EmailThreadSummaryWhereInput {
  readonly and?: InputMaybe<ReadonlyArray<EmailThreadSummaryWhereInput>>;
  /** created_at field predicates */
  readonly createdAt?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly createdAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** created_by_uuid field predicates */
  readonly createdByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly createdByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** disabled field predicates */
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** email_uuid field predicates */
  readonly emailUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly emailUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly emailUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly emailUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** email edge predicates */
  readonly hasEmail?: InputMaybe<Scalars['Boolean']['input']>;
  /** email_thread edge predicates */
  readonly hasEmailThread?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasEmailThreadWith?: InputMaybe<ReadonlyArray<EmailThreadWhereInput>>;
  readonly hasEmailWith?: InputMaybe<ReadonlyArray<EmailWhereInput>>;
  /** id field predicates */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly idGT?: InputMaybe<Scalars['ID']['input']>;
  readonly idGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly idLT?: InputMaybe<Scalars['ID']['input']>;
  readonly idLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly idNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly not?: InputMaybe<EmailThreadSummaryWhereInput>;
  /** old_created_by_id field predicates */
  readonly oldCreatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldCreatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_updated_by_id field predicates */
  readonly oldUpdatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldUpdatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly or?: InputMaybe<ReadonlyArray<EmailThreadSummaryWhereInput>>;
  /** summary field predicates */
  readonly summary?: InputMaybe<Scalars['String']['input']>;
  readonly summaryContains?: InputMaybe<Scalars['String']['input']>;
  readonly summaryContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly summaryEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly summaryGT?: InputMaybe<Scalars['String']['input']>;
  readonly summaryGTE?: InputMaybe<Scalars['String']['input']>;
  readonly summaryHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly summaryHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly summaryIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly summaryLT?: InputMaybe<Scalars['String']['input']>;
  readonly summaryLTE?: InputMaybe<Scalars['String']['input']>;
  readonly summaryNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly summaryNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** thread_uuid field predicates */
  readonly threadUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly threadUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly threadUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly threadUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  readonly updatedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly updatedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** updated_by_uuid field predicates */
  readonly updatedByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly updatedByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
}

/**
 * EmailThreadWhereInput is used for filtering EmailThread objects.
 * Input was generated by ent.
 */
export interface EmailThreadWhereInput {
  readonly and?: InputMaybe<ReadonlyArray<EmailThreadWhereInput>>;
  /** created_at field predicates */
  readonly createdAt?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly createdAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** created_by_uuid field predicates */
  readonly createdByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly createdByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** disabled field predicates */
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** external_identifier field predicates */
  readonly externalIdentifier?: InputMaybe<Scalars['String']['input']>;
  readonly externalIdentifierContains?: InputMaybe<Scalars['String']['input']>;
  readonly externalIdentifierContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly externalIdentifierEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly externalIdentifierGT?: InputMaybe<Scalars['String']['input']>;
  readonly externalIdentifierGTE?: InputMaybe<Scalars['String']['input']>;
  readonly externalIdentifierHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly externalIdentifierHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly externalIdentifierIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly externalIdentifierLT?: InputMaybe<Scalars['String']['input']>;
  readonly externalIdentifierLTE?: InputMaybe<Scalars['String']['input']>;
  readonly externalIdentifierNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly externalIdentifierNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** emails edge predicates */
  readonly hasEmails?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasEmailsWith?: InputMaybe<ReadonlyArray<EmailWhereInput>>;
  /** summaries edge predicates */
  readonly hasSummaries?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasSummariesWith?: InputMaybe<ReadonlyArray<EmailThreadSummaryWhereInput>>;
  /** user edge predicates */
  readonly hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasUserWith?: InputMaybe<ReadonlyArray<UserWhereInput>>;
  /** id field predicates */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly idGT?: InputMaybe<Scalars['ID']['input']>;
  readonly idGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly idLT?: InputMaybe<Scalars['ID']['input']>;
  readonly idLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly idNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** last_activity_at field predicates */
  readonly lastActivityAt?: InputMaybe<Scalars['Unix']['input']>;
  readonly lastActivityAtGT?: InputMaybe<Scalars['Unix']['input']>;
  readonly lastActivityAtGTE?: InputMaybe<Scalars['Unix']['input']>;
  readonly lastActivityAtIn?: InputMaybe<ReadonlyArray<Scalars['Unix']['input']>>;
  readonly lastActivityAtLT?: InputMaybe<Scalars['Unix']['input']>;
  readonly lastActivityAtLTE?: InputMaybe<Scalars['Unix']['input']>;
  readonly lastActivityAtNEQ?: InputMaybe<Scalars['Unix']['input']>;
  readonly lastActivityAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Unix']['input']>>;
  readonly not?: InputMaybe<EmailThreadWhereInput>;
  /** old_created_by_id field predicates */
  readonly oldCreatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldCreatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_updated_by_id field predicates */
  readonly oldUpdatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldUpdatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly or?: InputMaybe<ReadonlyArray<EmailThreadWhereInput>>;
  /** source_platform field predicates */
  readonly sourcePlatform?: InputMaybe<CallIntegration>;
  readonly sourcePlatformIn?: InputMaybe<ReadonlyArray<CallIntegration>>;
  readonly sourcePlatformNEQ?: InputMaybe<CallIntegration>;
  readonly sourcePlatformNotIn?: InputMaybe<ReadonlyArray<CallIntegration>>;
  /** updated_at field predicates */
  readonly updatedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly updatedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** updated_by_uuid field predicates */
  readonly updatedByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly updatedByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** user_uuid field predicates */
  readonly userUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly userUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly userUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly userUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
}

/**
 * EmailWhereInput is used for filtering Email objects.
 * Input was generated by ent.
 */
export interface EmailWhereInput {
  readonly and?: InputMaybe<ReadonlyArray<EmailWhereInput>>;
  /** body field predicates */
  readonly body?: InputMaybe<Scalars['String']['input']>;
  readonly bodyContains?: InputMaybe<Scalars['String']['input']>;
  readonly bodyContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly bodyEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly bodyGT?: InputMaybe<Scalars['String']['input']>;
  readonly bodyGTE?: InputMaybe<Scalars['String']['input']>;
  readonly bodyHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly bodyHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly bodyIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly bodyIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly bodyLT?: InputMaybe<Scalars['String']['input']>;
  readonly bodyLTE?: InputMaybe<Scalars['String']['input']>;
  readonly bodyNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly bodyNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly bodyNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  readonly createdAt?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly createdAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** created_by_uuid field predicates */
  readonly createdByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly createdByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** date field predicates */
  readonly date?: InputMaybe<Scalars['Unix']['input']>;
  readonly dateGT?: InputMaybe<Scalars['Unix']['input']>;
  readonly dateGTE?: InputMaybe<Scalars['Unix']['input']>;
  readonly dateIn?: InputMaybe<ReadonlyArray<Scalars['Unix']['input']>>;
  readonly dateLT?: InputMaybe<Scalars['Unix']['input']>;
  readonly dateLTE?: InputMaybe<Scalars['Unix']['input']>;
  readonly dateNEQ?: InputMaybe<Scalars['Unix']['input']>;
  readonly dateNotIn?: InputMaybe<ReadonlyArray<Scalars['Unix']['input']>>;
  /** disabled field predicates */
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** external_identifier field predicates */
  readonly externalIdentifier?: InputMaybe<Scalars['String']['input']>;
  readonly externalIdentifierContains?: InputMaybe<Scalars['String']['input']>;
  readonly externalIdentifierContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly externalIdentifierEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly externalIdentifierGT?: InputMaybe<Scalars['String']['input']>;
  readonly externalIdentifierGTE?: InputMaybe<Scalars['String']['input']>;
  readonly externalIdentifierHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly externalIdentifierHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly externalIdentifierIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly externalIdentifierLT?: InputMaybe<Scalars['String']['input']>;
  readonly externalIdentifierLTE?: InputMaybe<Scalars['String']['input']>;
  readonly externalIdentifierNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly externalIdentifierNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** from field predicates */
  readonly from?: InputMaybe<Scalars['String']['input']>;
  /** from_contact_uuid field predicates */
  readonly fromContactUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly fromContactUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly fromContactUUIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly fromContactUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly fromContactUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly fromContactUUIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly fromContains?: InputMaybe<Scalars['String']['input']>;
  readonly fromContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly fromEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly fromGT?: InputMaybe<Scalars['String']['input']>;
  readonly fromGTE?: InputMaybe<Scalars['String']['input']>;
  readonly fromHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly fromHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly fromIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly fromLT?: InputMaybe<Scalars['String']['input']>;
  readonly fromLTE?: InputMaybe<Scalars['String']['input']>;
  readonly fromNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly fromNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** from_user_uuid field predicates */
  readonly fromUserUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly fromUserUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly fromUserUUIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly fromUserUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly fromUserUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly fromUserUUIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** current_summary edge predicates */
  readonly hasCurrentSummary?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasCurrentSummaryWith?: InputMaybe<ReadonlyArray<EmailThreadSummaryWhereInput>>;
  /** email_reply_contexts edge predicates */
  readonly hasEmailReplyContexts?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasEmailReplyContextsWith?: InputMaybe<ReadonlyArray<EmailReplyContextWhereInput>>;
  /** email_reply_drafts edge predicates */
  readonly hasEmailReplyDrafts?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasEmailReplyDraftsWith?: InputMaybe<ReadonlyArray<EmailReplyDraftWhereInput>>;
  /** enumeration_values edge predicates */
  readonly hasEnumerationValues?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasEnumerationValuesWith?: InputMaybe<ReadonlyArray<EnumerationValueWhereInput>>;
  /** from_contact edge predicates */
  readonly hasFromContact?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasFromContactWith?: InputMaybe<ReadonlyArray<ContactWhereInput>>;
  /** from_user edge predicates */
  readonly hasFromUser?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasFromUserWith?: InputMaybe<ReadonlyArray<UserWhereInput>>;
  /** next edge predicates */
  readonly hasNext?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasNextWith?: InputMaybe<ReadonlyArray<EmailWhereInput>>;
  /** previous edge predicates */
  readonly hasPrevious?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasPreviousWith?: InputMaybe<ReadonlyArray<EmailWhereInput>>;
  /** recipients edge predicates */
  readonly hasRecipients?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasRecipientsWith?: InputMaybe<ReadonlyArray<EmailRecipientWhereInput>>;
  /** responses edge predicates */
  readonly hasResponses?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasResponsesWith?: InputMaybe<ReadonlyArray<EmailDraftPublishWhereInput>>;
  /** task_references edge predicates */
  readonly hasTaskReferences?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasTaskReferencesWith?: InputMaybe<ReadonlyArray<TaskReferenceWhereInput>>;
  /** tasks edge predicates */
  readonly hasTasks?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasTasksWith?: InputMaybe<ReadonlyArray<TaskWhereInput>>;
  /** thread edge predicates */
  readonly hasThread?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasThreadWith?: InputMaybe<ReadonlyArray<EmailThreadWhereInput>>;
  /** id field predicates */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly idGT?: InputMaybe<Scalars['ID']['input']>;
  readonly idGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly idLT?: InputMaybe<Scalars['ID']['input']>;
  readonly idLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly idNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** in_reply_to field predicates */
  readonly inReplyTo?: InputMaybe<Scalars['String']['input']>;
  readonly inReplyToContains?: InputMaybe<Scalars['String']['input']>;
  readonly inReplyToContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly inReplyToEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly inReplyToGT?: InputMaybe<Scalars['String']['input']>;
  readonly inReplyToGTE?: InputMaybe<Scalars['String']['input']>;
  readonly inReplyToHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly inReplyToHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly inReplyToIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly inReplyToIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly inReplyToLT?: InputMaybe<Scalars['String']['input']>;
  readonly inReplyToLTE?: InputMaybe<Scalars['String']['input']>;
  readonly inReplyToNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly inReplyToNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly inReplyToNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** in_reply_to_uuid field predicates */
  readonly inReplyToUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly inReplyToUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly inReplyToUUIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly inReplyToUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly inReplyToUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly inReplyToUUIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly not?: InputMaybe<EmailWhereInput>;
  /** old_created_by_id field predicates */
  readonly oldCreatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldCreatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_updated_by_id field predicates */
  readonly oldUpdatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldUpdatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly or?: InputMaybe<ReadonlyArray<EmailWhereInput>>;
  /** references field predicates */
  readonly references?: InputMaybe<Scalars['String']['input']>;
  readonly referencesContains?: InputMaybe<Scalars['String']['input']>;
  readonly referencesContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly referencesEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly referencesGT?: InputMaybe<Scalars['String']['input']>;
  readonly referencesGTE?: InputMaybe<Scalars['String']['input']>;
  readonly referencesHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly referencesHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly referencesIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly referencesIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly referencesLT?: InputMaybe<Scalars['String']['input']>;
  readonly referencesLTE?: InputMaybe<Scalars['String']['input']>;
  readonly referencesNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly referencesNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly referencesNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** rfc_message_id field predicates */
  readonly rfcMessageID?: InputMaybe<Scalars['String']['input']>;
  readonly rfcMessageIDContains?: InputMaybe<Scalars['String']['input']>;
  readonly rfcMessageIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly rfcMessageIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly rfcMessageIDGT?: InputMaybe<Scalars['String']['input']>;
  readonly rfcMessageIDGTE?: InputMaybe<Scalars['String']['input']>;
  readonly rfcMessageIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly rfcMessageIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly rfcMessageIDIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly rfcMessageIDLT?: InputMaybe<Scalars['String']['input']>;
  readonly rfcMessageIDLTE?: InputMaybe<Scalars['String']['input']>;
  readonly rfcMessageIDNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly rfcMessageIDNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** source_platform field predicates */
  readonly sourcePlatform?: InputMaybe<EmailCallIntegration>;
  readonly sourcePlatformIn?: InputMaybe<ReadonlyArray<EmailCallIntegration>>;
  readonly sourcePlatformNEQ?: InputMaybe<EmailCallIntegration>;
  readonly sourcePlatformNotIn?: InputMaybe<ReadonlyArray<EmailCallIntegration>>;
  /** subject field predicates */
  readonly subject?: InputMaybe<Scalars['String']['input']>;
  readonly subjectContains?: InputMaybe<Scalars['String']['input']>;
  readonly subjectContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly subjectEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly subjectGT?: InputMaybe<Scalars['String']['input']>;
  readonly subjectGTE?: InputMaybe<Scalars['String']['input']>;
  readonly subjectHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly subjectHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly subjectIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly subjectIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly subjectLT?: InputMaybe<Scalars['String']['input']>;
  readonly subjectLTE?: InputMaybe<Scalars['String']['input']>;
  readonly subjectNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly subjectNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly subjectNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** thread_uuid field predicates */
  readonly threadUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly threadUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly threadUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly threadUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  readonly updatedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly updatedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** updated_by_uuid field predicates */
  readonly updatedByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly updatedByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
}

export interface EnumerationConfigFieldLink extends Node {
  /** Classifier conditions associated with this config-field link. */
  readonly classifierConditions?: Maybe<ReadonlyArray<ClassifierCondition>>;
  readonly createdAt: Scalars['Int']['output'];
  readonly createdByUUID: Scalars['ID']['output'];
  /** Definitions represent the contextual definition that the model needs in order to be able to best do it's job, so that there isn't ambiguity about the terms using in the instructions/directions or whether the calls/documents themselves. This is often left blank if there isn't much chance of confusion. If the type of the value or score is non-custom, then adding to this will append the text after the standard definitions for that field. */
  readonly definitions?: Maybe<Scalars['String']['output']>;
  /** Directions are the specific steps or detailed context that the model needs to take in order to complete the analysis. This is generally more detailed than the instructions and is often used to break down the instructions into more digestible steps or talk through edge cases. If the type of the value or score is non-custom, then adding to this will append the text after the standard directions for that field. */
  readonly directions?: Maybe<Scalars['String']['output']>;
  readonly disabled: Scalars['Boolean']['output'];
  readonly drafts: EnumerationFieldDraftConnection;
  readonly enumerationConfiguration: EnumerationConfiguration;
  readonly enumerationConfigurationUUID: Scalars['ID']['output'];
  readonly enumerationField: EnumerationField;
  readonly enumerationFieldUUID: Scalars['ID']['output'];
  readonly id: Scalars['ID']['output'];
  /** Instructions represents the main description of the task that the model needs to do to complete the analysis. For normal fields, this generally describes how to analyze the call/document. For scores, this is the rubric that outlines exactly how to score the rep on the call. If the type of the value or score is non-custom, then adding to this will append the text after the standard instructions for that field. */
  readonly instructions?: Maybe<Scalars['String']['output']>;
  /**
   * IsAggregation represents whether the field is an aggregation of the enumeration field, or the
   * field itself is what is to be enumerated.
   */
  readonly isAggregation: Scalars['Boolean']['output'];
  /** Knowledge documents associated with this config-field link. */
  readonly knowledgeDocumentPromptInstructions?: Maybe<ReadonlyArray<KnowledgeDocumentPromptInstruction>>;
  readonly oldCreatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly oldID?: Maybe<Scalars['Int']['output']>;
  readonly oldUpdatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly updatedAt: Scalars['Int']['output'];
  readonly updatedByUUID: Scalars['ID']['output'];
  /** Version tracks the revision number of this EnumerationConfigFieldLink. It increments with each deployment. */
  readonly version: Scalars['Int']['output'];
}


export interface EnumerationConfigFieldLinkDraftsArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EnumerationFieldDraftOrder>;
  where?: InputMaybe<EnumerationFieldDraftWhereInput>;
}

/** A connection to a list of items. */
export interface EnumerationConfigFieldLinkConnection {
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<EnumerationConfigFieldLinkEdge>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface EnumerationConfigFieldLinkEdge {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<EnumerationConfigFieldLink>;
}

/** Ordering options for EnumerationConfigFieldLink connections */
export interface EnumerationConfigFieldLinkOrder {
  /** The ordering direction. */
  readonly direction?: OrderDirection;
  /** The field by which to order EnumerationConfigFieldLinks. */
  readonly field: EnumerationConfigFieldLinkOrderField;
}

/** Properties by which EnumerationConfigFieldLink connections can be ordered. */
export const EnumerationConfigFieldLinkOrderField = {
  CreatedAt: 'CREATED_AT',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type EnumerationConfigFieldLinkOrderField = typeof EnumerationConfigFieldLinkOrderField[keyof typeof EnumerationConfigFieldLinkOrderField];
/**
 * EnumerationConfigFieldLinkWhereInput is used for filtering EnumerationConfigFieldLink objects.
 * Input was generated by ent.
 */
export interface EnumerationConfigFieldLinkWhereInput {
  readonly and?: InputMaybe<ReadonlyArray<EnumerationConfigFieldLinkWhereInput>>;
  /** created_at field predicates */
  readonly createdAt?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly createdAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** definitions field predicates */
  readonly definitions?: InputMaybe<Scalars['String']['input']>;
  readonly definitionsContains?: InputMaybe<Scalars['String']['input']>;
  readonly definitionsContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly definitionsEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly definitionsGT?: InputMaybe<Scalars['String']['input']>;
  readonly definitionsGTE?: InputMaybe<Scalars['String']['input']>;
  readonly definitionsHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly definitionsHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly definitionsIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly definitionsIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly definitionsLT?: InputMaybe<Scalars['String']['input']>;
  readonly definitionsLTE?: InputMaybe<Scalars['String']['input']>;
  readonly definitionsNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly definitionsNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly definitionsNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** directions field predicates */
  readonly directions?: InputMaybe<Scalars['String']['input']>;
  readonly directionsContains?: InputMaybe<Scalars['String']['input']>;
  readonly directionsContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly directionsEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly directionsGT?: InputMaybe<Scalars['String']['input']>;
  readonly directionsGTE?: InputMaybe<Scalars['String']['input']>;
  readonly directionsHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly directionsHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly directionsIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly directionsIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly directionsLT?: InputMaybe<Scalars['String']['input']>;
  readonly directionsLTE?: InputMaybe<Scalars['String']['input']>;
  readonly directionsNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly directionsNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly directionsNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** disabled field predicates */
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** id field predicates */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly idGT?: InputMaybe<Scalars['ID']['input']>;
  readonly idGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly idLT?: InputMaybe<Scalars['ID']['input']>;
  readonly idLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly idNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** instructions field predicates */
  readonly instructions?: InputMaybe<Scalars['String']['input']>;
  readonly instructionsContains?: InputMaybe<Scalars['String']['input']>;
  readonly instructionsContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly instructionsEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly instructionsGT?: InputMaybe<Scalars['String']['input']>;
  readonly instructionsGTE?: InputMaybe<Scalars['String']['input']>;
  readonly instructionsHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly instructionsHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly instructionsIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly instructionsIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly instructionsLT?: InputMaybe<Scalars['String']['input']>;
  readonly instructionsLTE?: InputMaybe<Scalars['String']['input']>;
  readonly instructionsNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly instructionsNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly instructionsNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** is_aggregation field predicates */
  readonly isAggregation?: InputMaybe<Scalars['Boolean']['input']>;
  readonly isAggregationNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  readonly not?: InputMaybe<EnumerationConfigFieldLinkWhereInput>;
  /** old_created_by_id field predicates */
  readonly oldCreatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldCreatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_id field predicates */
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDGT?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly oldIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldIDLT?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly oldIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_updated_by_id field predicates */
  readonly oldUpdatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldUpdatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly or?: InputMaybe<ReadonlyArray<EnumerationConfigFieldLinkWhereInput>>;
  /** updated_at field predicates */
  readonly updatedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly updatedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** version field predicates */
  readonly version?: InputMaybe<Scalars['Int']['input']>;
  readonly versionGT?: InputMaybe<Scalars['Int']['input']>;
  readonly versionGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly versionIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly versionLT?: InputMaybe<Scalars['Int']['input']>;
  readonly versionLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly versionNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly versionNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
}

export interface EnumerationConfigStageLink extends Node {
  readonly createdAt: Scalars['Int']['output'];
  readonly createdByUUID: Scalars['ID']['output'];
  readonly disabled: Scalars['Boolean']['output'];
  readonly enumerationConfiguration: EnumerationConfiguration;
  readonly enumerationConfigurationUUID: Scalars['ID']['output'];
  readonly id: Scalars['ID']['output'];
  readonly oldCreatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly oldUpdatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly pipelineStage: PipelineStage;
  readonly pipelineStageUUID: Scalars['ID']['output'];
  readonly updatedAt: Scalars['Int']['output'];
  readonly updatedByUUID: Scalars['ID']['output'];
}

/** A connection to a list of items. */
export interface EnumerationConfigStageLinkConnection {
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<EnumerationConfigStageLinkEdge>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface EnumerationConfigStageLinkEdge {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<EnumerationConfigStageLink>;
}

/** Ordering options for EnumerationConfigStageLink connections */
export interface EnumerationConfigStageLinkOrder {
  /** The ordering direction. */
  readonly direction?: OrderDirection;
  /** The field by which to order EnumerationConfigStageLinks. */
  readonly field: EnumerationConfigStageLinkOrderField;
}

/** Properties by which EnumerationConfigStageLink connections can be ordered. */
export const EnumerationConfigStageLinkOrderField = {
  CreatedAt: 'CREATED_AT',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type EnumerationConfigStageLinkOrderField = typeof EnumerationConfigStageLinkOrderField[keyof typeof EnumerationConfigStageLinkOrderField];
/**
 * EnumerationConfigStageLinkWhereInput is used for filtering EnumerationConfigStageLink objects.
 * Input was generated by ent.
 */
export interface EnumerationConfigStageLinkWhereInput {
  readonly and?: InputMaybe<ReadonlyArray<EnumerationConfigStageLinkWhereInput>>;
  /** created_at field predicates */
  readonly createdAt?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly createdAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** disabled field predicates */
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** id field predicates */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly idGT?: InputMaybe<Scalars['ID']['input']>;
  readonly idGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly idLT?: InputMaybe<Scalars['ID']['input']>;
  readonly idLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly idNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly not?: InputMaybe<EnumerationConfigStageLinkWhereInput>;
  /** old_created_by_id field predicates */
  readonly oldCreatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldCreatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_updated_by_id field predicates */
  readonly oldUpdatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldUpdatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly or?: InputMaybe<ReadonlyArray<EnumerationConfigStageLinkWhereInput>>;
  /** updated_at field predicates */
  readonly updatedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly updatedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
}

export interface EnumerationConfiguration extends Node {
  /** Active specifies whether the enumeration_configuration is currently active. This is separate from disabled, which means that it is soft-deleted. */
  readonly active: Scalars['Boolean']['output'];
  readonly createdAt: Scalars['Int']['output'];
  readonly createdByUUID: Scalars['ID']['output'];
  /** CustomPreface, if set, will overwrite or the standard prompt preface (which differs depending on the Mode). */
  readonly customPreface?: Maybe<Scalars['String']['output']>;
  readonly disabled: Scalars['Boolean']['output'];
  readonly drafts?: Maybe<ReadonlyArray<EnumerationConfigurationDraft>>;
  readonly emailSubscriptionConfigs?: Maybe<ReadonlyArray<EmailSubscriptionConfig>>;
  readonly emailSubscriptionLinks?: Maybe<ReadonlyArray<EmailSubscriptionLink>>;
  readonly enumerationConfigFieldLinks: EnumerationConfigFieldLinkConnection;
  readonly enumerationConfigStageLinks: EnumerationConfigStageLinkConnection;
  readonly enumerationConfigurationClassifierEnumValues?: Maybe<ReadonlyArray<EnumerationConfigurationClassifierEnum>>;
  readonly enumerationFields: EnumerationFieldConnection;
  readonly enumerationPromptConfig?: Maybe<ReadonlyArray<EnumerationPromptConfig>>;
  readonly enumerationPromptConfigFilter?: Maybe<EnumerationPromptConfig>;
  readonly enumerationValues: EnumerationValueConnection;
  /** FilterTemplate determines which calls/documents/etc should be analyzed by this specific enumeration_configuration. For example, we could filter it to only analyze calls from certain reps, or calls with certain names, or documents that are added to the account during a certain part of the sales pipeline */
  readonly filterTemplate?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly knowledgeDocumentPromptInstructions: KnowledgeDocumentPromptInstructionConnection;
  readonly lookBackDays?: Maybe<Scalars['Int']['output']>;
  /** Mode specifies which type(s) of messages the config applies to. */
  readonly mode: EnumerationConfigurationMode;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly oldCreatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly oldID?: Maybe<Scalars['Int']['output']>;
  readonly oldUpdatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly pipelineStages: PipelineStageConnection;
  /**
   * Publish specifies whether the resulting enumeration values are published to downstream consumers.
   * Should be set to true once "live".
   */
  readonly publish: Scalars['Boolean']['output'];
  /** ScoreEligibilityQuestions represents a way to "turn off" doing a full analysis if it doesn't fit into the type of analysis we want to perform. For example, the default is that if the client doesn't show up to a call, then we don't do a full analysis. */
  readonly scoreEligibilityQuestions?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly type: EnumerationConfigurationType;
  readonly updatedAt: Scalars['Int']['output'];
  readonly updatedByUUID: Scalars['ID']['output'];
  /** UseTool specifies whether to use the tool to generate analysis. */
  readonly useTool?: Maybe<Scalars['Boolean']['output']>;
}


export interface EnumerationConfigurationEnumerationConfigFieldLinksArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EnumerationConfigFieldLinkOrder>;
  where?: InputMaybe<EnumerationConfigFieldLinkWhereInput>;
}


export interface EnumerationConfigurationEnumerationConfigStageLinksArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EnumerationConfigStageLinkOrder>;
  where?: InputMaybe<EnumerationConfigStageLinkWhereInput>;
}


export interface EnumerationConfigurationEnumerationFieldsArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EnumerationFieldOrder>;
  where?: InputMaybe<EnumerationFieldWhereInput>;
}


export interface EnumerationConfigurationEnumerationValuesArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EnumerationValueOrder>;
  where?: InputMaybe<EnumerationValueWhereInput>;
}


export interface EnumerationConfigurationKnowledgeDocumentPromptInstructionsArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<KnowledgeDocumentPromptInstructionOrder>;
  where?: InputMaybe<KnowledgeDocumentPromptInstructionWhereInput>;
}


export interface EnumerationConfigurationPipelineStagesArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PipelineStageOrder>;
  where?: InputMaybe<PipelineStageWhereInput>;
}

export interface EnumerationConfigurationClassifierEnum extends Node {
  readonly classifierEnumValue: ClassifierEnumValue;
  readonly classifierEnumValueUUID: Scalars['ID']['output'];
  readonly createdAt: Scalars['Int']['output'];
  readonly createdByUUID: Scalars['ID']['output'];
  readonly disabled: Scalars['Boolean']['output'];
  readonly enumerationConfiguration: EnumerationConfiguration;
  readonly enumerationConfigurationUUID: Scalars['ID']['output'];
  readonly id: Scalars['ID']['output'];
  readonly oldCreatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly oldID?: Maybe<Scalars['Int']['output']>;
  readonly oldUpdatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly updatedAt: Scalars['Int']['output'];
  readonly updatedByUUID: Scalars['ID']['output'];
}

/** A connection to a list of items. */
export interface EnumerationConfigurationClassifierEnumConnection {
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<EnumerationConfigurationClassifierEnumEdge>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface EnumerationConfigurationClassifierEnumEdge {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<EnumerationConfigurationClassifierEnum>;
}

/** Ordering options for EnumerationConfigurationClassifierEnum connections */
export interface EnumerationConfigurationClassifierEnumOrder {
  /** The ordering direction. */
  readonly direction?: OrderDirection;
  /** The field by which to order EnumerationConfigurationClassifierEnums. */
  readonly field: EnumerationConfigurationClassifierEnumOrderField;
}

/** Properties by which EnumerationConfigurationClassifierEnum connections can be ordered. */
export const EnumerationConfigurationClassifierEnumOrderField = {
  CreatedAt: 'CREATED_AT',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type EnumerationConfigurationClassifierEnumOrderField = typeof EnumerationConfigurationClassifierEnumOrderField[keyof typeof EnumerationConfigurationClassifierEnumOrderField];
/**
 * EnumerationConfigurationClassifierEnumWhereInput is used for filtering EnumerationConfigurationClassifierEnum objects.
 * Input was generated by ent.
 */
export interface EnumerationConfigurationClassifierEnumWhereInput {
  readonly and?: InputMaybe<ReadonlyArray<EnumerationConfigurationClassifierEnumWhereInput>>;
  /** classifier_enum_value_uuid field predicates */
  readonly classifierEnumValueUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly classifierEnumValueUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly classifierEnumValueUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly classifierEnumValueUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** created_at field predicates */
  readonly createdAt?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly createdAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** created_by_uuid field predicates */
  readonly createdByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly createdByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** disabled field predicates */
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** enumeration_configuration_uuid field predicates */
  readonly enumerationConfigurationUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly enumerationConfigurationUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly enumerationConfigurationUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly enumerationConfigurationUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** classifier_enum_value edge predicates */
  readonly hasClassifierEnumValue?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasClassifierEnumValueWith?: InputMaybe<ReadonlyArray<ClassifierEnumValueWhereInput>>;
  /** enumeration_configuration edge predicates */
  readonly hasEnumerationConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasEnumerationConfigurationWith?: InputMaybe<ReadonlyArray<EnumerationConfigurationWhereInput>>;
  /** id field predicates */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly idGT?: InputMaybe<Scalars['ID']['input']>;
  readonly idGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly idLT?: InputMaybe<Scalars['ID']['input']>;
  readonly idLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly idNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly not?: InputMaybe<EnumerationConfigurationClassifierEnumWhereInput>;
  /** old_created_by_id field predicates */
  readonly oldCreatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldCreatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_id field predicates */
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDGT?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly oldIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldIDLT?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly oldIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_updated_by_id field predicates */
  readonly oldUpdatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldUpdatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly or?: InputMaybe<ReadonlyArray<EnumerationConfigurationClassifierEnumWhereInput>>;
  /** updated_at field predicates */
  readonly updatedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly updatedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** updated_by_uuid field predicates */
  readonly updatedByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly updatedByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
}

/** A connection to a list of items. */
export interface EnumerationConfigurationConnection {
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<EnumerationConfigurationEdge>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
}

export interface EnumerationConfigurationDraft extends Node {
  readonly createdAt: Scalars['Int']['output'];
  readonly createdByUUID: Scalars['ID']['output'];
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly disabled: Scalars['Boolean']['output'];
  readonly enumerationConfiguration: EnumerationConfiguration;
  readonly enumerationConfigurationUUID: Scalars['ID']['output'];
  readonly enumerationField?: Maybe<ReadonlyArray<EnumerationField>>;
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
  readonly oldCreatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly oldUpdatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly updatedAt: Scalars['Int']['output'];
  readonly updatedByUUID: Scalars['ID']['output'];
}

/** A connection to a list of items. */
export interface EnumerationConfigurationDraftConnection {
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<EnumerationConfigurationDraftEdge>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface EnumerationConfigurationDraftEdge {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<EnumerationConfigurationDraft>;
}

/** Ordering options for EnumerationConfigurationDraft connections */
export interface EnumerationConfigurationDraftOrder {
  /** The ordering direction. */
  readonly direction?: OrderDirection;
  /** The field by which to order EnumerationConfigurationDrafts. */
  readonly field: EnumerationConfigurationDraftOrderField;
}

/** Properties by which EnumerationConfigurationDraft connections can be ordered. */
export const EnumerationConfigurationDraftOrderField = {
  CreatedAt: 'CREATED_AT',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type EnumerationConfigurationDraftOrderField = typeof EnumerationConfigurationDraftOrderField[keyof typeof EnumerationConfigurationDraftOrderField];
/**
 * EnumerationConfigurationDraftWhereInput is used for filtering EnumerationConfigurationDraft objects.
 * Input was generated by ent.
 */
export interface EnumerationConfigurationDraftWhereInput {
  readonly and?: InputMaybe<ReadonlyArray<EnumerationConfigurationDraftWhereInput>>;
  /** created_at field predicates */
  readonly createdAt?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly createdAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** created_by_uuid field predicates */
  readonly createdByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly createdByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** description field predicates */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionContains?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionGT?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly descriptionLT?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** disabled field predicates */
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** enumeration_configuration_uuid field predicates */
  readonly enumerationConfigurationUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly enumerationConfigurationUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly enumerationConfigurationUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly enumerationConfigurationUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** enumeration_configuration edge predicates */
  readonly hasEnumerationConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasEnumerationConfigurationWith?: InputMaybe<ReadonlyArray<EnumerationConfigurationWhereInput>>;
  /** enumeration_field edge predicates */
  readonly hasEnumerationField?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasEnumerationFieldWith?: InputMaybe<ReadonlyArray<EnumerationFieldWhereInput>>;
  /** id field predicates */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly idGT?: InputMaybe<Scalars['ID']['input']>;
  readonly idGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly idLT?: InputMaybe<Scalars['ID']['input']>;
  readonly idLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly idNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** name field predicates */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly nameContains?: InputMaybe<Scalars['String']['input']>;
  readonly nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly nameGT?: InputMaybe<Scalars['String']['input']>;
  readonly nameGTE?: InputMaybe<Scalars['String']['input']>;
  readonly nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly nameIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly nameLT?: InputMaybe<Scalars['String']['input']>;
  readonly nameLTE?: InputMaybe<Scalars['String']['input']>;
  readonly nameNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly nameNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly not?: InputMaybe<EnumerationConfigurationDraftWhereInput>;
  /** old_created_by_id field predicates */
  readonly oldCreatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldCreatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_updated_by_id field predicates */
  readonly oldUpdatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldUpdatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly or?: InputMaybe<ReadonlyArray<EnumerationConfigurationDraftWhereInput>>;
  /** updated_at field predicates */
  readonly updatedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly updatedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** updated_by_uuid field predicates */
  readonly updatedByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly updatedByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
}

/** An edge in a connection. */
export interface EnumerationConfigurationEdge {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<EnumerationConfiguration>;
}

/** EnumerationConfigurationMode is enum for the field mode */
export const EnumerationConfigurationMode = {
  Aggregate: 'AGGREGATE',
  All: 'ALL',
  Call: 'CALL',
  Document: 'DOCUMENT',
  Email: 'EMAIL',
  Opportunity: 'OPPORTUNITY',
  UnknownMode: 'UNKNOWN_MODE'
} as const;

export type EnumerationConfigurationMode = typeof EnumerationConfigurationMode[keyof typeof EnumerationConfigurationMode];
/** Ordering options for EnumerationConfiguration connections */
export interface EnumerationConfigurationOrder {
  /** The ordering direction. */
  readonly direction?: OrderDirection;
  /** The field by which to order EnumerationConfigurations. */
  readonly field: EnumerationConfigurationOrderField;
}

/** Properties by which EnumerationConfiguration connections can be ordered. */
export const EnumerationConfigurationOrderField = {
  CreatedAt: 'CREATED_AT',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type EnumerationConfigurationOrderField = typeof EnumerationConfigurationOrderField[keyof typeof EnumerationConfigurationOrderField];
/** EnumerationConfigurationType is enum for the field type */
export const EnumerationConfigurationType = {
  AdQuick: 'AD_QUICK',
  Aggregation: 'AGGREGATION',
  Airbyte: 'AIRBYTE',
  AirbyteSdrSummary: 'AIRBYTE_SDR_SUMMARY',
  Bant: 'BANT',
  Bruntwork: 'BRUNTWORK',
  BruntworkInterview: 'BRUNTWORK_INTERVIEW',
  CustomerWin: 'CUSTOMER_WIN',
  DealTypes: 'DEAL_TYPES',
  Discovery: 'DISCOVERY',
  DiscoveryCues: 'DISCOVERY_CUES',
  EmailDrafter: 'EMAIL_DRAFTER',
  Fabius: 'FABIUS',
  Fermat: 'FERMAT',
  LostOpportunity: 'LOST_OPPORTUNITY',
  Meddpicc: 'MEDDPICC',
  Mozart: 'MOZART',
  Objections: 'OBJECTIONS',
  OneSchema: 'ONE_SCHEMA',
  Orb: 'ORB',
  Parade: 'PARADE',
  Pave: 'PAVE',
  PreSale: 'PRE_SALE',
  Product: 'PRODUCT',
  ProductGap: 'PRODUCT_GAP',
  QAndA: 'Q_AND_A',
  Relo: 'RELO',
  Reshape: 'RESHAPE',
  Standard: 'STANDARD',
  Unknown: 'UNKNOWN',
  UxCam: 'UX_CAM',
  WonOpportunity: 'WON_OPPORTUNITY'
} as const;

export type EnumerationConfigurationType = typeof EnumerationConfigurationType[keyof typeof EnumerationConfigurationType];
/**
 * EnumerationConfigurationWhereInput is used for filtering EnumerationConfiguration objects.
 * Input was generated by ent.
 */
export interface EnumerationConfigurationWhereInput {
  /** active field predicates */
  readonly active?: InputMaybe<Scalars['Boolean']['input']>;
  readonly activeNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  readonly and?: InputMaybe<ReadonlyArray<EnumerationConfigurationWhereInput>>;
  /** created_at field predicates */
  readonly createdAt?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly createdAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** created_by_uuid field predicates */
  readonly createdByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly createdByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** custom_preface field predicates */
  readonly customPreface?: InputMaybe<Scalars['String']['input']>;
  readonly customPrefaceContains?: InputMaybe<Scalars['String']['input']>;
  readonly customPrefaceContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly customPrefaceEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly customPrefaceGT?: InputMaybe<Scalars['String']['input']>;
  readonly customPrefaceGTE?: InputMaybe<Scalars['String']['input']>;
  readonly customPrefaceHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly customPrefaceHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly customPrefaceIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly customPrefaceIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly customPrefaceLT?: InputMaybe<Scalars['String']['input']>;
  readonly customPrefaceLTE?: InputMaybe<Scalars['String']['input']>;
  readonly customPrefaceNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly customPrefaceNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly customPrefaceNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** disabled field predicates */
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** filter_template field predicates */
  readonly filterTemplate?: InputMaybe<Scalars['String']['input']>;
  readonly filterTemplateContains?: InputMaybe<Scalars['String']['input']>;
  readonly filterTemplateContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly filterTemplateEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly filterTemplateGT?: InputMaybe<Scalars['String']['input']>;
  readonly filterTemplateGTE?: InputMaybe<Scalars['String']['input']>;
  readonly filterTemplateHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly filterTemplateHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly filterTemplateIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly filterTemplateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly filterTemplateLT?: InputMaybe<Scalars['String']['input']>;
  readonly filterTemplateLTE?: InputMaybe<Scalars['String']['input']>;
  readonly filterTemplateNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly filterTemplateNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly filterTemplateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** drafts edge predicates */
  readonly hasDrafts?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasDraftsWith?: InputMaybe<ReadonlyArray<EnumerationConfigurationDraftWhereInput>>;
  /** email_subscription_configs edge predicates */
  readonly hasEmailSubscriptionConfigs?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasEmailSubscriptionConfigsWith?: InputMaybe<ReadonlyArray<EmailSubscriptionConfigWhereInput>>;
  /** email_subscription_links edge predicates */
  readonly hasEmailSubscriptionLinks?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasEmailSubscriptionLinksWith?: InputMaybe<ReadonlyArray<EmailSubscriptionLinkWhereInput>>;
  /** enumeration_config_field_links edge predicates */
  readonly hasEnumerationConfigFieldLinks?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasEnumerationConfigFieldLinksWith?: InputMaybe<ReadonlyArray<EnumerationConfigFieldLinkWhereInput>>;
  /** enumeration_config_stage_links edge predicates */
  readonly hasEnumerationConfigStageLinks?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasEnumerationConfigStageLinksWith?: InputMaybe<ReadonlyArray<EnumerationConfigStageLinkWhereInput>>;
  /** enumeration_configuration_classifier_enum_values edge predicates */
  readonly hasEnumerationConfigurationClassifierEnumValues?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasEnumerationConfigurationClassifierEnumValuesWith?: InputMaybe<ReadonlyArray<EnumerationConfigurationClassifierEnumWhereInput>>;
  /** enumeration_fields edge predicates */
  readonly hasEnumerationFields?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasEnumerationFieldsWith?: InputMaybe<ReadonlyArray<EnumerationFieldWhereInput>>;
  /** enumeration_prompt_config edge predicates */
  readonly hasEnumerationPromptConfig?: InputMaybe<Scalars['Boolean']['input']>;
  /** enumeration_prompt_config_filter edge predicates */
  readonly hasEnumerationPromptConfigFilter?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasEnumerationPromptConfigFilterWith?: InputMaybe<ReadonlyArray<EnumerationPromptConfigWhereInput>>;
  readonly hasEnumerationPromptConfigWith?: InputMaybe<ReadonlyArray<EnumerationPromptConfigWhereInput>>;
  /** enumeration_values edge predicates */
  readonly hasEnumerationValues?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasEnumerationValuesWith?: InputMaybe<ReadonlyArray<EnumerationValueWhereInput>>;
  /** knowledge_document_prompt_instructions edge predicates */
  readonly hasKnowledgeDocumentPromptInstructions?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasKnowledgeDocumentPromptInstructionsWith?: InputMaybe<ReadonlyArray<KnowledgeDocumentPromptInstructionWhereInput>>;
  /** pipeline_stages edge predicates */
  readonly hasPipelineStages?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasPipelineStagesWith?: InputMaybe<ReadonlyArray<PipelineStageWhereInput>>;
  /** id field predicates */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly idGT?: InputMaybe<Scalars['ID']['input']>;
  readonly idGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly idLT?: InputMaybe<Scalars['ID']['input']>;
  readonly idLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly idNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** look_back_days field predicates */
  readonly lookBackDays?: InputMaybe<Scalars['Int']['input']>;
  readonly lookBackDaysGT?: InputMaybe<Scalars['Int']['input']>;
  readonly lookBackDaysGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly lookBackDaysIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly lookBackDaysIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly lookBackDaysLT?: InputMaybe<Scalars['Int']['input']>;
  readonly lookBackDaysLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly lookBackDaysNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly lookBackDaysNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly lookBackDaysNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** mode field predicates */
  readonly mode?: InputMaybe<EnumerationConfigurationMode>;
  readonly modeIn?: InputMaybe<ReadonlyArray<EnumerationConfigurationMode>>;
  readonly modeNEQ?: InputMaybe<EnumerationConfigurationMode>;
  readonly modeNotIn?: InputMaybe<ReadonlyArray<EnumerationConfigurationMode>>;
  /** name field predicates */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly nameContains?: InputMaybe<Scalars['String']['input']>;
  readonly nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly nameGT?: InputMaybe<Scalars['String']['input']>;
  readonly nameGTE?: InputMaybe<Scalars['String']['input']>;
  readonly nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly nameIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly nameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly nameLT?: InputMaybe<Scalars['String']['input']>;
  readonly nameLTE?: InputMaybe<Scalars['String']['input']>;
  readonly nameNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly nameNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly nameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly not?: InputMaybe<EnumerationConfigurationWhereInput>;
  /** old_created_by_id field predicates */
  readonly oldCreatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldCreatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_id field predicates */
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDGT?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly oldIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldIDLT?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly oldIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_updated_by_id field predicates */
  readonly oldUpdatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldUpdatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly or?: InputMaybe<ReadonlyArray<EnumerationConfigurationWhereInput>>;
  /** publish field predicates */
  readonly publish?: InputMaybe<Scalars['Boolean']['input']>;
  readonly publishNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** type field predicates */
  readonly type?: InputMaybe<EnumerationConfigurationType>;
  readonly typeIn?: InputMaybe<ReadonlyArray<EnumerationConfigurationType>>;
  readonly typeNEQ?: InputMaybe<EnumerationConfigurationType>;
  readonly typeNotIn?: InputMaybe<ReadonlyArray<EnumerationConfigurationType>>;
  /** updated_at field predicates */
  readonly updatedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly updatedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** updated_by_uuid field predicates */
  readonly updatedByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly updatedByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** use_tool field predicates */
  readonly useTool?: InputMaybe<Scalars['Boolean']['input']>;
  readonly useToolIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly useToolNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  readonly useToolNotNil?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface EnumerationDraft extends Node {
  readonly createdAt: Scalars['Int']['output'];
  readonly createdByUUID: Scalars['ID']['output'];
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly disabled: Scalars['Boolean']['output'];
  readonly enumerationFieldDrafts?: Maybe<ReadonlyArray<EnumerationFieldDraft>>;
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
  readonly oldCreatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly oldUpdatedByID?: Maybe<Scalars['OldID']['output']>;
  /** Status indicates the current state of the draft in the drafting workflow. */
  readonly status: EnumerationDraftDraftStatus;
  readonly updatedAt: Scalars['Int']['output'];
  readonly updatedByUUID: Scalars['ID']['output'];
}

/** A connection to a list of items. */
export interface EnumerationDraftConnection {
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<EnumerationDraftEdge>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
}

/** EnumerationDraftDraftStatus is enum for the field status */
export const EnumerationDraftDraftStatus = {
  Approved: 'APPROVED',
  Deployed: 'DEPLOYED',
  InProgress: 'IN_PROGRESS',
  Rejected: 'REJECTED',
  UnderReview: 'UNDER_REVIEW',
  UnknownDraftStatus: 'UNKNOWN_DRAFT_STATUS'
} as const;

export type EnumerationDraftDraftStatus = typeof EnumerationDraftDraftStatus[keyof typeof EnumerationDraftDraftStatus];
/** An edge in a connection. */
export interface EnumerationDraftEdge {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<EnumerationDraft>;
}

/** Ordering options for EnumerationDraft connections */
export interface EnumerationDraftOrder {
  /** The ordering direction. */
  readonly direction?: OrderDirection;
  /** The field by which to order EnumerationDrafts. */
  readonly field: EnumerationDraftOrderField;
}

/** Properties by which EnumerationDraft connections can be ordered. */
export const EnumerationDraftOrderField = {
  CreatedAt: 'CREATED_AT',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type EnumerationDraftOrderField = typeof EnumerationDraftOrderField[keyof typeof EnumerationDraftOrderField];
/**
 * EnumerationDraftWhereInput is used for filtering EnumerationDraft objects.
 * Input was generated by ent.
 */
export interface EnumerationDraftWhereInput {
  readonly and?: InputMaybe<ReadonlyArray<EnumerationDraftWhereInput>>;
  /** created_at field predicates */
  readonly createdAt?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly createdAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** created_by_uuid field predicates */
  readonly createdByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly createdByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** description field predicates */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionContains?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionGT?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly descriptionLT?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** disabled field predicates */
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** enumeration_field_drafts edge predicates */
  readonly hasEnumerationFieldDrafts?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasEnumerationFieldDraftsWith?: InputMaybe<ReadonlyArray<EnumerationFieldDraftWhereInput>>;
  /** id field predicates */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly idGT?: InputMaybe<Scalars['ID']['input']>;
  readonly idGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly idLT?: InputMaybe<Scalars['ID']['input']>;
  readonly idLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly idNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** name field predicates */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly nameContains?: InputMaybe<Scalars['String']['input']>;
  readonly nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly nameGT?: InputMaybe<Scalars['String']['input']>;
  readonly nameGTE?: InputMaybe<Scalars['String']['input']>;
  readonly nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly nameIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly nameLT?: InputMaybe<Scalars['String']['input']>;
  readonly nameLTE?: InputMaybe<Scalars['String']['input']>;
  readonly nameNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly nameNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly not?: InputMaybe<EnumerationDraftWhereInput>;
  /** old_created_by_id field predicates */
  readonly oldCreatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldCreatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_updated_by_id field predicates */
  readonly oldUpdatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldUpdatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly or?: InputMaybe<ReadonlyArray<EnumerationDraftWhereInput>>;
  /** status field predicates */
  readonly status?: InputMaybe<EnumerationDraftDraftStatus>;
  readonly statusIn?: InputMaybe<ReadonlyArray<EnumerationDraftDraftStatus>>;
  readonly statusNEQ?: InputMaybe<EnumerationDraftDraftStatus>;
  readonly statusNotIn?: InputMaybe<ReadonlyArray<EnumerationDraftDraftStatus>>;
  /** updated_at field predicates */
  readonly updatedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly updatedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** updated_by_uuid field predicates */
  readonly updatedByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly updatedByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
}

export interface EnumerationField extends Node {
  /**
   * AlwaysIncludeTranscript determines whether we should include the transcript in the analysis IF
   * the analysis also has fields it depends on.
   */
  readonly alwaysIncludeTranscript?: Maybe<Scalars['Boolean']['output']>;
  readonly complexity: EnumerationFieldComplexity;
  readonly createdAt: Scalars['Int']['output'];
  readonly createdByUUID: Scalars['ID']['output'];
  readonly crmSubscriptions?: Maybe<ReadonlyArray<CrmSubscription>>;
  readonly customFieldEnumerationFieldLinks: CustomFieldEnumerationFieldLinkConnection;
  readonly customFields: CustomFieldConnection;
  /** CustomOutputMessage, if set, will replace the generic value in the OutputFormat. This will provide the template for the output of the analysis. For example, if generating a job description, the CustomOutputMessage may show the model to format the JD with sections for Requirements, Responsibilities, and Scope. */
  readonly customOutputMessage?: Maybe<Scalars['String']['output']>;
  /** Definitions represent the contextual definition that the model needs in order to be able to best do it's job, so that there isn't ambiguity about the terms using in the instructions/directions or whether the calls/documents themselves. This is often left blank if there isn't much chance of confusion. If the type of the value or score is non-custom, then adding to this will append the text after the standard definitions for that field. */
  readonly definitions?: Maybe<Scalars['String']['output']>;
  readonly description?: Maybe<Scalars['String']['output']>;
  /** Directions are the specific steps or detailed context that the model needs to take in order to complete the analysis. This is generally more detailed than the instructions and is often used to break down the instructions into more digestible steps or talk through edge cases. If the type of the value or score is non-custom, then adding to this will append the text after the standard directions for that field. */
  readonly directions?: Maybe<Scalars['String']['output']>;
  readonly disabled: Scalars['Boolean']['output'];
  readonly drafts: EnumerationFieldDraftConnection;
  readonly emailSubscriptionConfigFields?: Maybe<ReadonlyArray<EmailSubscriptionConfigField>>;
  readonly enumerationConfigFieldLinks?: Maybe<ReadonlyArray<EnumerationConfigFieldLink>>;
  readonly enumerationConfigurations?: Maybe<ReadonlyArray<EnumerationConfiguration>>;
  readonly fromFieldDependencyLinks: FieldDependencyLinkConnection;
  readonly id: Scalars['ID']['output'];
  /** Instructions represents the main description of the task that the model needs to do to complete the analysis. For normal fields, this generally describes how to analyze the call/document. For scores, this is the rubric that outlines exactly how to score the rep on the call. If the type of the value or score is non-custom, then adding to this will append the text after the standard instructions for that field. */
  readonly instructions?: Maybe<Scalars['String']['output']>;
  /**
   * IsRuleBased is a flag that determines whether the instructions are primarily based on specific rules to follow (such as "did the sales rep mention XYZ while selling")
   * or is it more judgement based (how good of a fit is this customer for our product).
   */
  readonly isRuleBased?: Maybe<Scalars['Boolean']['output']>;
  readonly knowledgeDocumentPromptInstructions: KnowledgeDocumentPromptInstructionConnection;
  readonly name: Scalars['String']['output'];
  readonly oldCreatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly oldID?: Maybe<Scalars['Int']['output']>;
  readonly oldUpdatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly outputs: EnumerationValueOutputConnection;
  /** ScoreType is non-nill when the enumeration_field represents a score analysis. It is either a pre-defined score like 'Type_DISCOVERY' that already has the score laid out, or (more likely) it defines the type of the score which would be 'Type_CUSTOM_SCORE'. */
  readonly scoreType?: Maybe<EnumerationFieldType>;
  readonly scores: EnumerationValueScoreConnection;
  /** Scratchpad, if set, will add a scratchpad field prior to the output of this field whose directions are the value of this field. This will let the model think through the answer beforehand, which is useful when the analysis is complex and the model may need to think out loud before outputting the final analysis. */
  readonly scratchpad?: Maybe<Scalars['String']['output']>;
  readonly toFieldDependencyLinks: FieldDependencyLinkConnection;
  readonly updatedAt: Scalars['Int']['output'];
  readonly updatedByUUID: Scalars['ID']['output'];
  readonly userScoreStats?: Maybe<ReadonlyArray<UserScoreStat>>;
  /** ValueType is non-nil when the enumeration_field represents a value analysis. It is either a pre-defined analysis like 'Stakeholders' that already has the analysis laid out, or (more likely) it defines the type of the value. This is either a standard field (which is type Value_CUSTOM_STRING), an array of fields such as when trying to capture all the competitors (which is type Value_CUSTOM_STRINGS), or a key/value map such as when trying to capture the customer's objections and explaining how the rep handled it (which is type Value_CUSTOM_MAP). */
  readonly valueType?: Maybe<EnumerationFieldValue>;
  /** Version tracks the revision number of this EnumerationField. It increments with each deployment. */
  readonly version: Scalars['Int']['output'];
}


export interface EnumerationFieldCustomFieldEnumerationFieldLinksArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CustomFieldEnumerationFieldLinkOrder>;
  where?: InputMaybe<CustomFieldEnumerationFieldLinkWhereInput>;
}


export interface EnumerationFieldCustomFieldsArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CustomFieldOrder>;
  where?: InputMaybe<CustomFieldWhereInput>;
}


export interface EnumerationFieldDraftsArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EnumerationFieldDraftOrder>;
  where?: InputMaybe<EnumerationFieldDraftWhereInput>;
}


export interface EnumerationFieldFromFieldDependencyLinksArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<FieldDependencyLinkOrder>;
  where?: InputMaybe<FieldDependencyLinkWhereInput>;
}


export interface EnumerationFieldKnowledgeDocumentPromptInstructionsArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<KnowledgeDocumentPromptInstructionOrder>;
  where?: InputMaybe<KnowledgeDocumentPromptInstructionWhereInput>;
}


export interface EnumerationFieldOutputsArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EnumerationValueOutputOrder>;
  where?: InputMaybe<EnumerationValueOutputWhereInput>;
}


export interface EnumerationFieldScoresArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EnumerationValueScoreOrder>;
  where?: InputMaybe<EnumerationValueScoreWhereInput>;
}


export interface EnumerationFieldToFieldDependencyLinksArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<FieldDependencyLinkOrder>;
  where?: InputMaybe<FieldDependencyLinkWhereInput>;
}

/** EnumerationFieldComplexity is enum for the field complexity */
export const EnumerationFieldComplexity = {
  AccurateComplex: 'ACCURATE_COMPLEX',
  Complex: 'COMPLEX',
  Fast: 'FAST',
  Legacy: 'LEGACY',
  Standard: 'STANDARD',
  UnknownComplexity: 'UNKNOWN_COMPLEXITY'
} as const;

export type EnumerationFieldComplexity = typeof EnumerationFieldComplexity[keyof typeof EnumerationFieldComplexity];
/** A connection to a list of items. */
export interface EnumerationFieldConnection {
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<EnumerationFieldEdge>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
}

export interface EnumerationFieldDraft extends Node {
  readonly alwaysIncludeTranscript: Scalars['Boolean']['output'];
  readonly complexity: EnumerationFieldDraftComplexity;
  readonly createdAt: Scalars['Int']['output'];
  readonly createdByUUID: Scalars['ID']['output'];
  /** CustomOutputMessage provides a template for the output formatting of the analysis, if needed. */
  readonly customOutputMessage?: Maybe<Scalars['String']['output']>;
  /** Definitions represent the contextual definition that the model needs in order to be able to best do it's job, so that there isn't ambiguity about the terms using in the instructions/directions or whether the calls/documents themselves. This is often left blank if there isn't much chance of confusion. If the type of the value or score is non-custom, then adding to this will append the text after the standard definitions for that field. */
  readonly definitions?: Maybe<Scalars['String']['output']>;
  readonly description?: Maybe<Scalars['String']['output']>;
  /** Directions are the specific steps or detailed context that the model needs to take in order to complete the analysis. This is generally more detailed than the instructions and is often used to break down the instructions into more digestible steps or talk through edge cases. If the type of the value or score is non-custom, then adding to this will append the text after the standard directions for that field. */
  readonly directions?: Maybe<Scalars['String']['output']>;
  readonly disabled: Scalars['Boolean']['output'];
  /** EnumerationDraft associates this field draft with an overall draft collection. */
  readonly enumerationDraft?: Maybe<EnumerationDraft>;
  /** EnumerationDraftID associates this field draft with a specific EnumerationDraft, representing a collection of changes. */
  readonly enumerationDraftID?: Maybe<Scalars['ID']['output']>;
  readonly id: Scalars['ID']['output'];
  /** Instructions represents the main description of the task that the model needs to do to complete the analysis. For normal fields, this generally describes how to analyze the call/document. For scores, this is the rubric that outlines exactly how to score the rep on the call. If the type of the value or score is non-custom, then adding to this will append the text after the standard instructions for that field. */
  readonly instructions?: Maybe<Scalars['String']['output']>;
  /** IsRuleBased indicates if the analysis follows specific rules (true) or is more judgment-based (false). */
  readonly isRuleBased: Scalars['Boolean']['output'];
  /** LiveConfigLink references the EnumerationConfigFieldLink that this draft is modifying. Nil if this is a new field. */
  readonly liveConfigLink?: Maybe<EnumerationConfigFieldLink>;
  /** LiveConfigLinkID references the existing EnumerationConfigFieldLink that this draft proposes to update. Nil if this is a new field. */
  readonly liveConfigLinkID?: Maybe<Scalars['ID']['output']>;
  /** LiveField references the EnumerationField that this draft is modifying. Nil if this is a new field. */
  readonly liveField?: Maybe<EnumerationField>;
  /** LiveFieldID references the existing EnumerationField that this draft proposes to update. Nil if this is a new field. */
  readonly liveFieldID?: Maybe<Scalars['ID']['output']>;
  readonly name: Scalars['String']['output'];
  readonly oldCreatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly oldUpdatedByID?: Maybe<Scalars['OldID']['output']>;
  /** ScoreType specifies the scoring method for score analyses. It may be a custom score or a predefined score type. */
  readonly scoreType?: Maybe<EnumerationFieldDraftType>;
  /** Scratchpad contains prompts or instructions to assist the model in processing complex analyses. */
  readonly scratchpad?: Maybe<Scalars['String']['output']>;
  /** Status indicates the current state of the draft in the drafting workflow. */
  readonly status: EnumerationFieldDraftDraftStatus;
  readonly updatedAt: Scalars['Int']['output'];
  readonly updatedByUUID: Scalars['ID']['output'];
  /** ValueType specifies the output type for value analyses. It may be a standard field, an array of strings, a key-value map, etc. */
  readonly valueType?: Maybe<EnumerationFieldDraftValue>;
  /** Version tracks the revision number of this draft. It increments with each new draft for a specific field, and it is DIFFERENT than the version of the EnumerationField that this draft is modifying (because drafts can be rejected, etc). */
  readonly version: Scalars['Int']['output'];
}

/** EnumerationFieldDraftComplexity is enum for the field complexity */
export const EnumerationFieldDraftComplexity = {
  AccurateComplex: 'ACCURATE_COMPLEX',
  Complex: 'COMPLEX',
  Fast: 'FAST',
  Legacy: 'LEGACY',
  Standard: 'STANDARD',
  UnknownComplexity: 'UNKNOWN_COMPLEXITY'
} as const;

export type EnumerationFieldDraftComplexity = typeof EnumerationFieldDraftComplexity[keyof typeof EnumerationFieldDraftComplexity];
/** A connection to a list of items. */
export interface EnumerationFieldDraftConnection {
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<EnumerationFieldDraftEdge>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
}

/** EnumerationFieldDraftDraftStatus is enum for the field status */
export const EnumerationFieldDraftDraftStatus = {
  Approved: 'APPROVED',
  Deployed: 'DEPLOYED',
  InProgress: 'IN_PROGRESS',
  Rejected: 'REJECTED',
  UnderReview: 'UNDER_REVIEW',
  UnknownDraftStatus: 'UNKNOWN_DRAFT_STATUS'
} as const;

export type EnumerationFieldDraftDraftStatus = typeof EnumerationFieldDraftDraftStatus[keyof typeof EnumerationFieldDraftDraftStatus];
/** An edge in a connection. */
export interface EnumerationFieldDraftEdge {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<EnumerationFieldDraft>;
}

/** Ordering options for EnumerationFieldDraft connections */
export interface EnumerationFieldDraftOrder {
  /** The ordering direction. */
  readonly direction?: OrderDirection;
  /** The field by which to order EnumerationFieldDrafts. */
  readonly field: EnumerationFieldDraftOrderField;
}

/** Properties by which EnumerationFieldDraft connections can be ordered. */
export const EnumerationFieldDraftOrderField = {
  CreatedAt: 'CREATED_AT',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type EnumerationFieldDraftOrderField = typeof EnumerationFieldDraftOrderField[keyof typeof EnumerationFieldDraftOrderField];
/** EnumerationFieldDraftType is enum for the field score_type */
export const EnumerationFieldDraftType = {
  CustomScore: 'CUSTOM_SCORE',
  Demo: 'DEMO',
  Discovery: 'DISCOVERY',
  Fit: 'FIT',
  Invalid: 'INVALID',
  Meddic: 'MEDDIC'
} as const;

export type EnumerationFieldDraftType = typeof EnumerationFieldDraftType[keyof typeof EnumerationFieldDraftType];
/** EnumerationFieldDraftValue is enum for the field value_type */
export const EnumerationFieldDraftValue = {
  Authority: 'AUTHORITY',
  Budget: 'BUDGET',
  CallExtensiveReport: 'CALL_EXTENSIVE_REPORT',
  Champion: 'CHAMPION',
  Competitors: 'COMPETITORS',
  Concerns: 'CONCERNS',
  CustomerSituation: 'CUSTOMER_SITUATION',
  CustomerWinAnalysis: 'CUSTOMER_WIN_ANALYSIS',
  CustomMap: 'CUSTOM_MAP',
  CustomString: 'CUSTOM_STRING',
  CustomStrings: 'CUSTOM_STRINGS',
  DealRisks: 'DEAL_RISKS',
  DecisionCriteria: 'DECISION_CRITERIA',
  DecisionProcess: 'DECISION_PROCESS',
  DetailedCallSummary: 'DETAILED_CALL_SUMMARY',
  EconomicBuyer: 'ECONOMIC_BUYER',
  EmailDraft: 'EMAIL_DRAFT',
  FollowUpEmail: 'FOLLOW_UP_EMAIL',
  IdentifiedPain: 'IDENTIFIED_PAIN',
  JobDescriptions: 'JOB_DESCRIPTIONS',
  Metrics: 'METRICS',
  NextCallAgenda: 'NEXT_CALL_AGENDA',
  NextSteps: 'NEXT_STEPS',
  OnboardingInformation: 'ONBOARDING_INFORMATION',
  OperationalGoals: 'OPERATIONAL_GOALS',
  Positioning: 'POSITIONING',
  Pricing: 'PRICING',
  Stakeholders: 'STAKEHOLDERS',
  StrategicGoals: 'STRATEGIC_GOALS',
  Timeline: 'TIMELINE',
  UnknownValue: 'UNKNOWN_VALUE',
  UseCases: 'USE_CASES',
  WinLossAnalysis: 'WIN_LOSS_ANALYSIS',
  WowMoments: 'WOW_MOMENTS'
} as const;

export type EnumerationFieldDraftValue = typeof EnumerationFieldDraftValue[keyof typeof EnumerationFieldDraftValue];
/**
 * EnumerationFieldDraftWhereInput is used for filtering EnumerationFieldDraft objects.
 * Input was generated by ent.
 */
export interface EnumerationFieldDraftWhereInput {
  /** always_include_transcript field predicates */
  readonly alwaysIncludeTranscript?: InputMaybe<Scalars['Boolean']['input']>;
  readonly alwaysIncludeTranscriptNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  readonly and?: InputMaybe<ReadonlyArray<EnumerationFieldDraftWhereInput>>;
  /** complexity field predicates */
  readonly complexity?: InputMaybe<EnumerationFieldDraftComplexity>;
  readonly complexityIn?: InputMaybe<ReadonlyArray<EnumerationFieldDraftComplexity>>;
  readonly complexityNEQ?: InputMaybe<EnumerationFieldDraftComplexity>;
  readonly complexityNotIn?: InputMaybe<ReadonlyArray<EnumerationFieldDraftComplexity>>;
  /** created_at field predicates */
  readonly createdAt?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly createdAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** created_by_uuid field predicates */
  readonly createdByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly createdByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** custom_output_message field predicates */
  readonly customOutputMessage?: InputMaybe<Scalars['String']['input']>;
  readonly customOutputMessageContains?: InputMaybe<Scalars['String']['input']>;
  readonly customOutputMessageContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly customOutputMessageEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly customOutputMessageGT?: InputMaybe<Scalars['String']['input']>;
  readonly customOutputMessageGTE?: InputMaybe<Scalars['String']['input']>;
  readonly customOutputMessageHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly customOutputMessageHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly customOutputMessageIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly customOutputMessageIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly customOutputMessageLT?: InputMaybe<Scalars['String']['input']>;
  readonly customOutputMessageLTE?: InputMaybe<Scalars['String']['input']>;
  readonly customOutputMessageNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly customOutputMessageNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly customOutputMessageNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** definitions field predicates */
  readonly definitions?: InputMaybe<Scalars['String']['input']>;
  readonly definitionsContains?: InputMaybe<Scalars['String']['input']>;
  readonly definitionsContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly definitionsEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly definitionsGT?: InputMaybe<Scalars['String']['input']>;
  readonly definitionsGTE?: InputMaybe<Scalars['String']['input']>;
  readonly definitionsHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly definitionsHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly definitionsIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly definitionsIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly definitionsLT?: InputMaybe<Scalars['String']['input']>;
  readonly definitionsLTE?: InputMaybe<Scalars['String']['input']>;
  readonly definitionsNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly definitionsNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly definitionsNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** description field predicates */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionContains?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionGT?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly descriptionLT?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** directions field predicates */
  readonly directions?: InputMaybe<Scalars['String']['input']>;
  readonly directionsContains?: InputMaybe<Scalars['String']['input']>;
  readonly directionsContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly directionsEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly directionsGT?: InputMaybe<Scalars['String']['input']>;
  readonly directionsGTE?: InputMaybe<Scalars['String']['input']>;
  readonly directionsHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly directionsHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly directionsIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly directionsIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly directionsLT?: InputMaybe<Scalars['String']['input']>;
  readonly directionsLTE?: InputMaybe<Scalars['String']['input']>;
  readonly directionsNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly directionsNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly directionsNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** disabled field predicates */
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** enumeration_draft_id field predicates */
  readonly enumerationDraftID?: InputMaybe<Scalars['ID']['input']>;
  readonly enumerationDraftIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly enumerationDraftIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly enumerationDraftIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly enumerationDraftIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly enumerationDraftIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** enumeration_draft edge predicates */
  readonly hasEnumerationDraft?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasEnumerationDraftWith?: InputMaybe<ReadonlyArray<EnumerationDraftWhereInput>>;
  /** live_config_link edge predicates */
  readonly hasLiveConfigLink?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasLiveConfigLinkWith?: InputMaybe<ReadonlyArray<EnumerationConfigFieldLinkWhereInput>>;
  /** live_field edge predicates */
  readonly hasLiveField?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasLiveFieldWith?: InputMaybe<ReadonlyArray<EnumerationFieldWhereInput>>;
  /** id field predicates */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly idGT?: InputMaybe<Scalars['ID']['input']>;
  readonly idGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly idLT?: InputMaybe<Scalars['ID']['input']>;
  readonly idLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly idNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** instructions field predicates */
  readonly instructions?: InputMaybe<Scalars['String']['input']>;
  readonly instructionsContains?: InputMaybe<Scalars['String']['input']>;
  readonly instructionsContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly instructionsEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly instructionsGT?: InputMaybe<Scalars['String']['input']>;
  readonly instructionsGTE?: InputMaybe<Scalars['String']['input']>;
  readonly instructionsHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly instructionsHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly instructionsIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly instructionsIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly instructionsLT?: InputMaybe<Scalars['String']['input']>;
  readonly instructionsLTE?: InputMaybe<Scalars['String']['input']>;
  readonly instructionsNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly instructionsNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly instructionsNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** is_rule_based field predicates */
  readonly isRuleBased?: InputMaybe<Scalars['Boolean']['input']>;
  readonly isRuleBasedNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** live_config_link_id field predicates */
  readonly liveConfigLinkID?: InputMaybe<Scalars['ID']['input']>;
  readonly liveConfigLinkIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly liveConfigLinkIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly liveConfigLinkIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly liveConfigLinkIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly liveConfigLinkIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** live_field_id field predicates */
  readonly liveFieldID?: InputMaybe<Scalars['ID']['input']>;
  readonly liveFieldIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly liveFieldIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly liveFieldIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly liveFieldIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly liveFieldIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** name field predicates */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly nameContains?: InputMaybe<Scalars['String']['input']>;
  readonly nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly nameGT?: InputMaybe<Scalars['String']['input']>;
  readonly nameGTE?: InputMaybe<Scalars['String']['input']>;
  readonly nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly nameIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly nameLT?: InputMaybe<Scalars['String']['input']>;
  readonly nameLTE?: InputMaybe<Scalars['String']['input']>;
  readonly nameNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly nameNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly not?: InputMaybe<EnumerationFieldDraftWhereInput>;
  /** old_created_by_id field predicates */
  readonly oldCreatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldCreatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_updated_by_id field predicates */
  readonly oldUpdatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldUpdatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly or?: InputMaybe<ReadonlyArray<EnumerationFieldDraftWhereInput>>;
  /** score_type field predicates */
  readonly scoreType?: InputMaybe<EnumerationFieldDraftType>;
  readonly scoreTypeIn?: InputMaybe<ReadonlyArray<EnumerationFieldDraftType>>;
  readonly scoreTypeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly scoreTypeNEQ?: InputMaybe<EnumerationFieldDraftType>;
  readonly scoreTypeNotIn?: InputMaybe<ReadonlyArray<EnumerationFieldDraftType>>;
  readonly scoreTypeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** scratchpad field predicates */
  readonly scratchpad?: InputMaybe<Scalars['String']['input']>;
  readonly scratchpadContains?: InputMaybe<Scalars['String']['input']>;
  readonly scratchpadContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly scratchpadEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly scratchpadGT?: InputMaybe<Scalars['String']['input']>;
  readonly scratchpadGTE?: InputMaybe<Scalars['String']['input']>;
  readonly scratchpadHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly scratchpadHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly scratchpadIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly scratchpadIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly scratchpadLT?: InputMaybe<Scalars['String']['input']>;
  readonly scratchpadLTE?: InputMaybe<Scalars['String']['input']>;
  readonly scratchpadNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly scratchpadNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly scratchpadNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** status field predicates */
  readonly status?: InputMaybe<EnumerationFieldDraftDraftStatus>;
  readonly statusIn?: InputMaybe<ReadonlyArray<EnumerationFieldDraftDraftStatus>>;
  readonly statusNEQ?: InputMaybe<EnumerationFieldDraftDraftStatus>;
  readonly statusNotIn?: InputMaybe<ReadonlyArray<EnumerationFieldDraftDraftStatus>>;
  /** updated_at field predicates */
  readonly updatedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly updatedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** updated_by_uuid field predicates */
  readonly updatedByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly updatedByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** value_type field predicates */
  readonly valueType?: InputMaybe<EnumerationFieldDraftValue>;
  readonly valueTypeIn?: InputMaybe<ReadonlyArray<EnumerationFieldDraftValue>>;
  readonly valueTypeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly valueTypeNEQ?: InputMaybe<EnumerationFieldDraftValue>;
  readonly valueTypeNotIn?: InputMaybe<ReadonlyArray<EnumerationFieldDraftValue>>;
  readonly valueTypeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** version field predicates */
  readonly version?: InputMaybe<Scalars['Int']['input']>;
  readonly versionGT?: InputMaybe<Scalars['Int']['input']>;
  readonly versionGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly versionIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly versionLT?: InputMaybe<Scalars['Int']['input']>;
  readonly versionLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly versionNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly versionNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
}

/** An edge in a connection. */
export interface EnumerationFieldEdge {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<EnumerationField>;
}

/** Ordering options for EnumerationField connections */
export interface EnumerationFieldOrder {
  /** The ordering direction. */
  readonly direction?: OrderDirection;
  /** The field by which to order EnumerationFields. */
  readonly field: EnumerationFieldOrderField;
}

/** Properties by which EnumerationField connections can be ordered. */
export const EnumerationFieldOrderField = {
  CreatedAt: 'CREATED_AT',
  Name: 'NAME',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type EnumerationFieldOrderField = typeof EnumerationFieldOrderField[keyof typeof EnumerationFieldOrderField];
/** EnumerationFieldType is enum for the field score_type */
export const EnumerationFieldType = {
  CustomScore: 'CUSTOM_SCORE',
  Demo: 'DEMO',
  Discovery: 'DISCOVERY',
  Fit: 'FIT',
  Invalid: 'INVALID',
  Meddic: 'MEDDIC'
} as const;

export type EnumerationFieldType = typeof EnumerationFieldType[keyof typeof EnumerationFieldType];
/** EnumerationFieldValue is enum for the field value_type */
export const EnumerationFieldValue = {
  Authority: 'AUTHORITY',
  Budget: 'BUDGET',
  CallExtensiveReport: 'CALL_EXTENSIVE_REPORT',
  Champion: 'CHAMPION',
  Competitors: 'COMPETITORS',
  Concerns: 'CONCERNS',
  CustomerSituation: 'CUSTOMER_SITUATION',
  CustomerWinAnalysis: 'CUSTOMER_WIN_ANALYSIS',
  CustomMap: 'CUSTOM_MAP',
  CustomString: 'CUSTOM_STRING',
  CustomStrings: 'CUSTOM_STRINGS',
  DealRisks: 'DEAL_RISKS',
  DecisionCriteria: 'DECISION_CRITERIA',
  DecisionProcess: 'DECISION_PROCESS',
  DetailedCallSummary: 'DETAILED_CALL_SUMMARY',
  EconomicBuyer: 'ECONOMIC_BUYER',
  EmailDraft: 'EMAIL_DRAFT',
  FollowUpEmail: 'FOLLOW_UP_EMAIL',
  IdentifiedPain: 'IDENTIFIED_PAIN',
  JobDescriptions: 'JOB_DESCRIPTIONS',
  Metrics: 'METRICS',
  NextCallAgenda: 'NEXT_CALL_AGENDA',
  NextSteps: 'NEXT_STEPS',
  OnboardingInformation: 'ONBOARDING_INFORMATION',
  OperationalGoals: 'OPERATIONAL_GOALS',
  Positioning: 'POSITIONING',
  Pricing: 'PRICING',
  Stakeholders: 'STAKEHOLDERS',
  StrategicGoals: 'STRATEGIC_GOALS',
  Timeline: 'TIMELINE',
  UnknownValue: 'UNKNOWN_VALUE',
  UseCases: 'USE_CASES',
  WinLossAnalysis: 'WIN_LOSS_ANALYSIS',
  WowMoments: 'WOW_MOMENTS'
} as const;

export type EnumerationFieldValue = typeof EnumerationFieldValue[keyof typeof EnumerationFieldValue];
/**
 * EnumerationFieldWhereInput is used for filtering EnumerationField objects.
 * Input was generated by ent.
 */
export interface EnumerationFieldWhereInput {
  /** always_include_transcript field predicates */
  readonly alwaysIncludeTranscript?: InputMaybe<Scalars['Boolean']['input']>;
  readonly alwaysIncludeTranscriptIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly alwaysIncludeTranscriptNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  readonly alwaysIncludeTranscriptNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly and?: InputMaybe<ReadonlyArray<EnumerationFieldWhereInput>>;
  /** complexity field predicates */
  readonly complexity?: InputMaybe<EnumerationFieldComplexity>;
  readonly complexityIn?: InputMaybe<ReadonlyArray<EnumerationFieldComplexity>>;
  readonly complexityNEQ?: InputMaybe<EnumerationFieldComplexity>;
  readonly complexityNotIn?: InputMaybe<ReadonlyArray<EnumerationFieldComplexity>>;
  /** created_at field predicates */
  readonly createdAt?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly createdAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** created_by_uuid field predicates */
  readonly createdByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly createdByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** custom_output_message field predicates */
  readonly customOutputMessage?: InputMaybe<Scalars['String']['input']>;
  readonly customOutputMessageContains?: InputMaybe<Scalars['String']['input']>;
  readonly customOutputMessageContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly customOutputMessageEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly customOutputMessageGT?: InputMaybe<Scalars['String']['input']>;
  readonly customOutputMessageGTE?: InputMaybe<Scalars['String']['input']>;
  readonly customOutputMessageHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly customOutputMessageHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly customOutputMessageIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly customOutputMessageIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly customOutputMessageLT?: InputMaybe<Scalars['String']['input']>;
  readonly customOutputMessageLTE?: InputMaybe<Scalars['String']['input']>;
  readonly customOutputMessageNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly customOutputMessageNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly customOutputMessageNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** definitions field predicates */
  readonly definitions?: InputMaybe<Scalars['String']['input']>;
  readonly definitionsContains?: InputMaybe<Scalars['String']['input']>;
  readonly definitionsContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly definitionsEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly definitionsGT?: InputMaybe<Scalars['String']['input']>;
  readonly definitionsGTE?: InputMaybe<Scalars['String']['input']>;
  readonly definitionsHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly definitionsHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly definitionsIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly definitionsIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly definitionsLT?: InputMaybe<Scalars['String']['input']>;
  readonly definitionsLTE?: InputMaybe<Scalars['String']['input']>;
  readonly definitionsNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly definitionsNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly definitionsNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** description field predicates */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionContains?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionGT?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly descriptionLT?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** directions field predicates */
  readonly directions?: InputMaybe<Scalars['String']['input']>;
  readonly directionsContains?: InputMaybe<Scalars['String']['input']>;
  readonly directionsContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly directionsEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly directionsGT?: InputMaybe<Scalars['String']['input']>;
  readonly directionsGTE?: InputMaybe<Scalars['String']['input']>;
  readonly directionsHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly directionsHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly directionsIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly directionsIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly directionsLT?: InputMaybe<Scalars['String']['input']>;
  readonly directionsLTE?: InputMaybe<Scalars['String']['input']>;
  readonly directionsNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly directionsNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly directionsNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** disabled field predicates */
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** crm_subscriptions edge predicates */
  readonly hasCrmSubscriptions?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasCrmSubscriptionsWith?: InputMaybe<ReadonlyArray<CrmSubscriptionWhereInput>>;
  /** custom_field_enumeration_field_links edge predicates */
  readonly hasCustomFieldEnumerationFieldLinks?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasCustomFieldEnumerationFieldLinksWith?: InputMaybe<ReadonlyArray<CustomFieldEnumerationFieldLinkWhereInput>>;
  /** custom_fields edge predicates */
  readonly hasCustomFields?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasCustomFieldsWith?: InputMaybe<ReadonlyArray<CustomFieldWhereInput>>;
  /** drafts edge predicates */
  readonly hasDrafts?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasDraftsWith?: InputMaybe<ReadonlyArray<EnumerationFieldDraftWhereInput>>;
  /** email_subscription_config_fields edge predicates */
  readonly hasEmailSubscriptionConfigFields?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasEmailSubscriptionConfigFieldsWith?: InputMaybe<ReadonlyArray<EmailSubscriptionConfigFieldWhereInput>>;
  /** enumeration_config_field_links edge predicates */
  readonly hasEnumerationConfigFieldLinks?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasEnumerationConfigFieldLinksWith?: InputMaybe<ReadonlyArray<EnumerationConfigFieldLinkWhereInput>>;
  /** enumeration_configurations edge predicates */
  readonly hasEnumerationConfigurations?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasEnumerationConfigurationsWith?: InputMaybe<ReadonlyArray<EnumerationConfigurationWhereInput>>;
  /** from_field_dependency_links edge predicates */
  readonly hasFromFieldDependencyLinks?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasFromFieldDependencyLinksWith?: InputMaybe<ReadonlyArray<FieldDependencyLinkWhereInput>>;
  /** knowledge_document_prompt_instructions edge predicates */
  readonly hasKnowledgeDocumentPromptInstructions?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasKnowledgeDocumentPromptInstructionsWith?: InputMaybe<ReadonlyArray<KnowledgeDocumentPromptInstructionWhereInput>>;
  /** outputs edge predicates */
  readonly hasOutputs?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasOutputsWith?: InputMaybe<ReadonlyArray<EnumerationValueOutputWhereInput>>;
  /** scores edge predicates */
  readonly hasScores?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasScoresWith?: InputMaybe<ReadonlyArray<EnumerationValueScoreWhereInput>>;
  /** to_field_dependency_links edge predicates */
  readonly hasToFieldDependencyLinks?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasToFieldDependencyLinksWith?: InputMaybe<ReadonlyArray<FieldDependencyLinkWhereInput>>;
  /** user_score_stats edge predicates */
  readonly hasUserScoreStats?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasUserScoreStatsWith?: InputMaybe<ReadonlyArray<UserScoreStatWhereInput>>;
  /** id field predicates */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly idGT?: InputMaybe<Scalars['ID']['input']>;
  readonly idGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly idLT?: InputMaybe<Scalars['ID']['input']>;
  readonly idLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly idNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** instructions field predicates */
  readonly instructions?: InputMaybe<Scalars['String']['input']>;
  readonly instructionsContains?: InputMaybe<Scalars['String']['input']>;
  readonly instructionsContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly instructionsEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly instructionsGT?: InputMaybe<Scalars['String']['input']>;
  readonly instructionsGTE?: InputMaybe<Scalars['String']['input']>;
  readonly instructionsHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly instructionsHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly instructionsIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly instructionsIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly instructionsLT?: InputMaybe<Scalars['String']['input']>;
  readonly instructionsLTE?: InputMaybe<Scalars['String']['input']>;
  readonly instructionsNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly instructionsNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly instructionsNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** is_rule_based field predicates */
  readonly isRuleBased?: InputMaybe<Scalars['Boolean']['input']>;
  readonly isRuleBasedIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly isRuleBasedNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  readonly isRuleBasedNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** name field predicates */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly nameContains?: InputMaybe<Scalars['String']['input']>;
  readonly nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly nameGT?: InputMaybe<Scalars['String']['input']>;
  readonly nameGTE?: InputMaybe<Scalars['String']['input']>;
  readonly nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly nameIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly nameLT?: InputMaybe<Scalars['String']['input']>;
  readonly nameLTE?: InputMaybe<Scalars['String']['input']>;
  readonly nameNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly nameNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly not?: InputMaybe<EnumerationFieldWhereInput>;
  /** old_created_by_id field predicates */
  readonly oldCreatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldCreatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_id field predicates */
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDGT?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly oldIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldIDLT?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly oldIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_updated_by_id field predicates */
  readonly oldUpdatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldUpdatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly or?: InputMaybe<ReadonlyArray<EnumerationFieldWhereInput>>;
  /** score_type field predicates */
  readonly scoreType?: InputMaybe<EnumerationFieldType>;
  readonly scoreTypeIn?: InputMaybe<ReadonlyArray<EnumerationFieldType>>;
  readonly scoreTypeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly scoreTypeNEQ?: InputMaybe<EnumerationFieldType>;
  readonly scoreTypeNotIn?: InputMaybe<ReadonlyArray<EnumerationFieldType>>;
  readonly scoreTypeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** scratchpad field predicates */
  readonly scratchpad?: InputMaybe<Scalars['String']['input']>;
  readonly scratchpadContains?: InputMaybe<Scalars['String']['input']>;
  readonly scratchpadContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly scratchpadEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly scratchpadGT?: InputMaybe<Scalars['String']['input']>;
  readonly scratchpadGTE?: InputMaybe<Scalars['String']['input']>;
  readonly scratchpadHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly scratchpadHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly scratchpadIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly scratchpadIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly scratchpadLT?: InputMaybe<Scalars['String']['input']>;
  readonly scratchpadLTE?: InputMaybe<Scalars['String']['input']>;
  readonly scratchpadNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly scratchpadNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly scratchpadNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  readonly updatedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly updatedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** updated_by_uuid field predicates */
  readonly updatedByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly updatedByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** value_type field predicates */
  readonly valueType?: InputMaybe<EnumerationFieldValue>;
  readonly valueTypeIn?: InputMaybe<ReadonlyArray<EnumerationFieldValue>>;
  readonly valueTypeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly valueTypeNEQ?: InputMaybe<EnumerationFieldValue>;
  readonly valueTypeNotIn?: InputMaybe<ReadonlyArray<EnumerationFieldValue>>;
  readonly valueTypeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** version field predicates */
  readonly version?: InputMaybe<Scalars['Int']['input']>;
  readonly versionGT?: InputMaybe<Scalars['Int']['input']>;
  readonly versionGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly versionIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly versionLT?: InputMaybe<Scalars['Int']['input']>;
  readonly versionLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly versionNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly versionNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
}

export interface EnumerationPromptConfig extends Node {
  readonly analysisMode: EnumerationPromptConfigMode;
  readonly createdAt: Scalars['Int']['output'];
  readonly createdByUUID: Scalars['ID']['output'];
  /** CustomDocumentPreface, if set, will either overwrite or append/prepend to the standard prompt document section. */
  readonly customDocumentPreface?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly customDocumentPrefaceAction?: Maybe<EnumerationPromptConfigCustomAction>;
  /**
   * CustomSystemMessage, if set, will either overwrite or append/prepend to the standard prompt "system message"
   * aka the very beginning of the prompt (depending on CustomSystemMessageAction). Each value will be on a new line.
   */
  readonly customSystemMessage?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly customSystemMessageAction?: Maybe<EnumerationPromptConfigCustomAction>;
  /**
   * CustomTranscriptPreface, if set, will either overwrite or append/prepend to the standard prompt transcript
   * preface (depending on CustomSystemMessageAction). Each value will be on a new line.
   */
  readonly customTranscriptPreface?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly customTranscriptPrefaceAction?: Maybe<EnumerationPromptConfigCustomAction>;
  readonly disabled: Scalars['Boolean']['output'];
  readonly enumerationConfigurationUUID: Scalars['ID']['output'];
  readonly enumerationConfigurations: EnumerationConfiguration;
  readonly id: Scalars['ID']['output'];
  readonly oldCreatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly oldID?: Maybe<Scalars['Int']['output']>;
  readonly oldUpdatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly updatedAt: Scalars['Int']['output'];
  readonly updatedByUUID: Scalars['ID']['output'];
}

/** A connection to a list of items. */
export interface EnumerationPromptConfigConnection {
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<EnumerationPromptConfigEdge>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
}

/** EnumerationPromptConfigCustomAction is enum for the field custom_system_message_action */
export const EnumerationPromptConfigCustomAction = {
  Append: 'APPEND',
  Overwrite: 'OVERWRITE',
  Prepend: 'PREPEND'
} as const;

export type EnumerationPromptConfigCustomAction = typeof EnumerationPromptConfigCustomAction[keyof typeof EnumerationPromptConfigCustomAction];
/** An edge in a connection. */
export interface EnumerationPromptConfigEdge {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<EnumerationPromptConfig>;
}

/** EnumerationPromptConfigMode is enum for the field analysis_mode */
export const EnumerationPromptConfigMode = {
  AllCalls: 'ALL_CALLS',
  CallPlusPastAnalysis: 'CALL_PLUS_PAST_ANALYSIS',
  CreateCustomerWinAnalysis: 'CREATE_CUSTOMER_WIN_ANALYSIS',
  DefaultMode: 'DEFAULT_MODE',
  IdentifyWowMoment: 'IDENTIFY_WOW_MOMENT',
  SingleCall: 'SINGLE_CALL'
} as const;

export type EnumerationPromptConfigMode = typeof EnumerationPromptConfigMode[keyof typeof EnumerationPromptConfigMode];
/** Ordering options for EnumerationPromptConfig connections */
export interface EnumerationPromptConfigOrder {
  /** The ordering direction. */
  readonly direction?: OrderDirection;
  /** The field by which to order EnumerationPromptConfigs. */
  readonly field: EnumerationPromptConfigOrderField;
}

/** Properties by which EnumerationPromptConfig connections can be ordered. */
export const EnumerationPromptConfigOrderField = {
  CreatedAt: 'CREATED_AT',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type EnumerationPromptConfigOrderField = typeof EnumerationPromptConfigOrderField[keyof typeof EnumerationPromptConfigOrderField];
/**
 * EnumerationPromptConfigWhereInput is used for filtering EnumerationPromptConfig objects.
 * Input was generated by ent.
 */
export interface EnumerationPromptConfigWhereInput {
  /** analysis_mode field predicates */
  readonly analysisMode?: InputMaybe<EnumerationPromptConfigMode>;
  readonly analysisModeIn?: InputMaybe<ReadonlyArray<EnumerationPromptConfigMode>>;
  readonly analysisModeNEQ?: InputMaybe<EnumerationPromptConfigMode>;
  readonly analysisModeNotIn?: InputMaybe<ReadonlyArray<EnumerationPromptConfigMode>>;
  readonly and?: InputMaybe<ReadonlyArray<EnumerationPromptConfigWhereInput>>;
  /** created_at field predicates */
  readonly createdAt?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly createdAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** created_by_uuid field predicates */
  readonly createdByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly createdByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** custom_document_preface_action field predicates */
  readonly customDocumentPrefaceAction?: InputMaybe<EnumerationPromptConfigCustomAction>;
  readonly customDocumentPrefaceActionIn?: InputMaybe<ReadonlyArray<EnumerationPromptConfigCustomAction>>;
  readonly customDocumentPrefaceActionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly customDocumentPrefaceActionNEQ?: InputMaybe<EnumerationPromptConfigCustomAction>;
  readonly customDocumentPrefaceActionNotIn?: InputMaybe<ReadonlyArray<EnumerationPromptConfigCustomAction>>;
  readonly customDocumentPrefaceActionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** custom_system_message_action field predicates */
  readonly customSystemMessageAction?: InputMaybe<EnumerationPromptConfigCustomAction>;
  readonly customSystemMessageActionIn?: InputMaybe<ReadonlyArray<EnumerationPromptConfigCustomAction>>;
  readonly customSystemMessageActionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly customSystemMessageActionNEQ?: InputMaybe<EnumerationPromptConfigCustomAction>;
  readonly customSystemMessageActionNotIn?: InputMaybe<ReadonlyArray<EnumerationPromptConfigCustomAction>>;
  readonly customSystemMessageActionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** custom_transcript_preface_action field predicates */
  readonly customTranscriptPrefaceAction?: InputMaybe<EnumerationPromptConfigCustomAction>;
  readonly customTranscriptPrefaceActionIn?: InputMaybe<ReadonlyArray<EnumerationPromptConfigCustomAction>>;
  readonly customTranscriptPrefaceActionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly customTranscriptPrefaceActionNEQ?: InputMaybe<EnumerationPromptConfigCustomAction>;
  readonly customTranscriptPrefaceActionNotIn?: InputMaybe<ReadonlyArray<EnumerationPromptConfigCustomAction>>;
  readonly customTranscriptPrefaceActionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** disabled field predicates */
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** enumeration_configuration_uuid field predicates */
  readonly enumerationConfigurationUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly enumerationConfigurationUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly enumerationConfigurationUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly enumerationConfigurationUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** enumeration_configurations edge predicates */
  readonly hasEnumerationConfigurations?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasEnumerationConfigurationsWith?: InputMaybe<ReadonlyArray<EnumerationConfigurationWhereInput>>;
  /** id field predicates */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly idGT?: InputMaybe<Scalars['ID']['input']>;
  readonly idGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly idLT?: InputMaybe<Scalars['ID']['input']>;
  readonly idLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly idNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly not?: InputMaybe<EnumerationPromptConfigWhereInput>;
  /** old_created_by_id field predicates */
  readonly oldCreatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldCreatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_id field predicates */
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDGT?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly oldIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldIDLT?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly oldIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_updated_by_id field predicates */
  readonly oldUpdatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldUpdatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly or?: InputMaybe<ReadonlyArray<EnumerationPromptConfigWhereInput>>;
  /** updated_at field predicates */
  readonly updatedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly updatedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** updated_by_uuid field predicates */
  readonly updatedByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly updatedByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
}

export interface EnumerationValue extends Node {
  readonly additionalCallUuids: ReadonlyArray<Scalars['ID']['output']>;
  readonly additionalDocumentUuids: ReadonlyArray<Scalars['ID']['output']>;
  readonly call?: Maybe<Call>;
  readonly callUUID?: Maybe<Scalars['ID']['output']>;
  readonly createdAt: Scalars['Int']['output'];
  readonly createdByUUID: Scalars['ID']['output'];
  readonly disabled: Scalars['Boolean']['output'];
  readonly document?: Maybe<Document>;
  readonly documentUUID?: Maybe<Scalars['ID']['output']>;
  readonly email?: Maybe<Email>;
  readonly emailDeliveries?: Maybe<ReadonlyArray<EmailDelivery>>;
  readonly emailUUID?: Maybe<Scalars['ID']['output']>;
  readonly endDate?: Maybe<Scalars['Unix']['output']>;
  readonly enumerationConfiguration?: Maybe<EnumerationConfiguration>;
  readonly enumerationConfigurationUUID?: Maybe<Scalars['ID']['output']>;
  readonly enumerationValueFeedback?: Maybe<ReadonlyArray<EnumerationValueFeedback>>;
  /**
   * "Feedback refers to feedback from a user (or internal) on
   * whether or not the EnumerationValue was (in)correct. If null,
   * no feedback has been given."
   */
  readonly feedback?: Maybe<Scalars['Boolean']['output']>;
  readonly feedbackComment?: Maybe<Scalars['String']['output']>;
  readonly gongUser?: Maybe<GongUser>;
  readonly gongUserUUID?: Maybe<Scalars['ID']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly oldCreatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly oldUpdatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly opportunityStageChange?: Maybe<OpportunityStageChange>;
  readonly opportunityStageChangeUUID?: Maybe<Scalars['ID']['output']>;
  readonly outputs?: Maybe<ReadonlyArray<EnumerationValueOutput>>;
  readonly scores?: Maybe<ReadonlyArray<EnumerationValueScore>>;
  readonly startDate?: Maybe<Scalars['Unix']['output']>;
  readonly updatedAt: Scalars['Int']['output'];
  readonly updatedByUUID: Scalars['ID']['output'];
}

/** A connection to a list of items. */
export interface EnumerationValueConnection {
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<EnumerationValueEdge>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface EnumerationValueEdge {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<EnumerationValue>;
}

export interface EnumerationValueFeedback extends Node {
  readonly createdAt: Scalars['Int']['output'];
  readonly createdByUUID: Scalars['ID']['output'];
  readonly disabled: Scalars['Boolean']['output'];
  readonly enumerationField: EnumerationField;
  readonly enumerationFieldUUID: Scalars['ID']['output'];
  readonly enumerationValue: EnumerationValue;
  readonly enumerationValueUUID: Scalars['ID']['output'];
  readonly feedback: Scalars['String']['output'];
  readonly fieldName: Scalars['String']['output'];
  readonly fieldType: EnumerationValueFeedbackFieldType;
  readonly id: Scalars['ID']['output'];
  readonly oldCreatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly oldID?: Maybe<Scalars['Int']['output']>;
  readonly oldUpdatedByID?: Maybe<Scalars['OldID']['output']>;
  /** specificFieldText represents a specific portion text that the user wants to give feedback on. */
  readonly specificFieldText?: Maybe<Scalars['String']['output']>;
  readonly updatedAt: Scalars['Int']['output'];
  readonly updatedByUUID: Scalars['ID']['output'];
}

/** A connection to a list of items. */
export interface EnumerationValueFeedbackConnection {
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<EnumerationValueFeedbackEdge>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface EnumerationValueFeedbackEdge {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<EnumerationValueFeedback>;
}

/** EnumerationValueFeedbackFieldType is enum for the field field_type */
export const EnumerationValueFeedbackFieldType = {
  CustomField: 'CUSTOM_FIELD',
  CustomScore: 'CUSTOM_SCORE',
  StandardField: 'STANDARD_FIELD',
  StandardScore: 'STANDARD_SCORE'
} as const;

export type EnumerationValueFeedbackFieldType = typeof EnumerationValueFeedbackFieldType[keyof typeof EnumerationValueFeedbackFieldType];
/** Ordering options for EnumerationValueFeedback connections */
export interface EnumerationValueFeedbackOrder {
  /** The ordering direction. */
  readonly direction?: OrderDirection;
  /** The field by which to order EnumerationValueFeedbacks. */
  readonly field: EnumerationValueFeedbackOrderField;
}

/** Properties by which EnumerationValueFeedback connections can be ordered. */
export const EnumerationValueFeedbackOrderField = {
  CreatedAt: 'CREATED_AT',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type EnumerationValueFeedbackOrderField = typeof EnumerationValueFeedbackOrderField[keyof typeof EnumerationValueFeedbackOrderField];
/**
 * EnumerationValueFeedbackWhereInput is used for filtering EnumerationValueFeedback objects.
 * Input was generated by ent.
 */
export interface EnumerationValueFeedbackWhereInput {
  readonly and?: InputMaybe<ReadonlyArray<EnumerationValueFeedbackWhereInput>>;
  /** created_at field predicates */
  readonly createdAt?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly createdAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** created_by_uuid field predicates */
  readonly createdByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly createdByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** disabled field predicates */
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** enumeration_field_uuid field predicates */
  readonly enumerationFieldUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly enumerationFieldUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly enumerationFieldUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly enumerationFieldUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** enumeration_value_uuid field predicates */
  readonly enumerationValueUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly enumerationValueUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly enumerationValueUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly enumerationValueUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** feedback field predicates */
  readonly feedback?: InputMaybe<Scalars['String']['input']>;
  readonly feedbackContains?: InputMaybe<Scalars['String']['input']>;
  readonly feedbackContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly feedbackEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly feedbackGT?: InputMaybe<Scalars['String']['input']>;
  readonly feedbackGTE?: InputMaybe<Scalars['String']['input']>;
  readonly feedbackHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly feedbackHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly feedbackIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly feedbackLT?: InputMaybe<Scalars['String']['input']>;
  readonly feedbackLTE?: InputMaybe<Scalars['String']['input']>;
  readonly feedbackNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly feedbackNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** field_name field predicates */
  readonly fieldName?: InputMaybe<Scalars['String']['input']>;
  readonly fieldNameContains?: InputMaybe<Scalars['String']['input']>;
  readonly fieldNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly fieldNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly fieldNameGT?: InputMaybe<Scalars['String']['input']>;
  readonly fieldNameGTE?: InputMaybe<Scalars['String']['input']>;
  readonly fieldNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly fieldNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly fieldNameIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly fieldNameLT?: InputMaybe<Scalars['String']['input']>;
  readonly fieldNameLTE?: InputMaybe<Scalars['String']['input']>;
  readonly fieldNameNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly fieldNameNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** field_type field predicates */
  readonly fieldType?: InputMaybe<EnumerationValueFeedbackFieldType>;
  readonly fieldTypeIn?: InputMaybe<ReadonlyArray<EnumerationValueFeedbackFieldType>>;
  readonly fieldTypeNEQ?: InputMaybe<EnumerationValueFeedbackFieldType>;
  readonly fieldTypeNotIn?: InputMaybe<ReadonlyArray<EnumerationValueFeedbackFieldType>>;
  /** enumeration_field edge predicates */
  readonly hasEnumerationField?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasEnumerationFieldWith?: InputMaybe<ReadonlyArray<EnumerationFieldWhereInput>>;
  /** enumeration_value edge predicates */
  readonly hasEnumerationValue?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasEnumerationValueWith?: InputMaybe<ReadonlyArray<EnumerationValueWhereInput>>;
  /** id field predicates */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly idGT?: InputMaybe<Scalars['ID']['input']>;
  readonly idGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly idLT?: InputMaybe<Scalars['ID']['input']>;
  readonly idLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly idNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly not?: InputMaybe<EnumerationValueFeedbackWhereInput>;
  /** old_created_by_id field predicates */
  readonly oldCreatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldCreatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_id field predicates */
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDGT?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly oldIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldIDLT?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly oldIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_updated_by_id field predicates */
  readonly oldUpdatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldUpdatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly or?: InputMaybe<ReadonlyArray<EnumerationValueFeedbackWhereInput>>;
  /** specific_field_text field predicates */
  readonly specificFieldText?: InputMaybe<Scalars['String']['input']>;
  readonly specificFieldTextContains?: InputMaybe<Scalars['String']['input']>;
  readonly specificFieldTextContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly specificFieldTextEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly specificFieldTextGT?: InputMaybe<Scalars['String']['input']>;
  readonly specificFieldTextGTE?: InputMaybe<Scalars['String']['input']>;
  readonly specificFieldTextHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly specificFieldTextHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly specificFieldTextIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly specificFieldTextIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly specificFieldTextLT?: InputMaybe<Scalars['String']['input']>;
  readonly specificFieldTextLTE?: InputMaybe<Scalars['String']['input']>;
  readonly specificFieldTextNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly specificFieldTextNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly specificFieldTextNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  readonly updatedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly updatedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** updated_by_uuid field predicates */
  readonly updatedByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly updatedByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
}

/** Ordering options for EnumerationValue connections */
export interface EnumerationValueOrder {
  /** The ordering direction. */
  readonly direction?: OrderDirection;
  /** The field by which to order EnumerationValues. */
  readonly field: EnumerationValueOrderField;
}

/** Properties by which EnumerationValue connections can be ordered. */
export const EnumerationValueOrderField = {
  CreatedAt: 'CREATED_AT',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type EnumerationValueOrderField = typeof EnumerationValueOrderField[keyof typeof EnumerationValueOrderField];
export interface EnumerationValueOutput extends Node {
  readonly createdAt: Scalars['Int']['output'];
  readonly createdByUUID: Scalars['ID']['output'];
  readonly deliveries?: Maybe<ReadonlyArray<CrmDelivery>>;
  readonly disabled: Scalars['Boolean']['output'];
  readonly enumerationField: EnumerationField;
  readonly enumerationFieldUUID: Scalars['ID']['output'];
  readonly enumerationValue: EnumerationValue;
  readonly enumerationValueUUID: Scalars['ID']['output'];
  readonly id: Scalars['ID']['output'];
  /** map is non-nil when the type of the enumeration_field associated with this row is 'Value_CUSTOM_MAP'. */
  readonly map?: Maybe<Scalars['Map']['output']>;
  readonly oldCreatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly oldID?: Maybe<Scalars['Int']['output']>;
  readonly oldUpdatedByID?: Maybe<Scalars['OldID']['output']>;
  /** string_value is non-nil when the type of the enumeration_field associated with this row is 'Value_CUSTOM_STRING'. It represents a standard set of text and is the most common output. */
  readonly stringValue?: Maybe<Scalars['String']['output']>;
  /** strings is non-nil when the type of the enumeration_field associated with this row is 'Value_CUSTOM_STRINGS'. */
  readonly strings?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly updatedAt: Scalars['Int']['output'];
  readonly updatedByUUID: Scalars['ID']['output'];
}

/** A connection to a list of items. */
export interface EnumerationValueOutputConnection {
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<EnumerationValueOutputEdge>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface EnumerationValueOutputEdge {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<EnumerationValueOutput>;
}

/** Ordering options for EnumerationValueOutput connections */
export interface EnumerationValueOutputOrder {
  /** The ordering direction. */
  readonly direction?: OrderDirection;
  /** The field by which to order EnumerationValueOutputs. */
  readonly field: EnumerationValueOutputOrderField;
}

/** Properties by which EnumerationValueOutput connections can be ordered. */
export const EnumerationValueOutputOrderField = {
  CreatedAt: 'CREATED_AT',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type EnumerationValueOutputOrderField = typeof EnumerationValueOutputOrderField[keyof typeof EnumerationValueOutputOrderField];
/**
 * EnumerationValueOutputWhereInput is used for filtering EnumerationValueOutput objects.
 * Input was generated by ent.
 */
export interface EnumerationValueOutputWhereInput {
  readonly and?: InputMaybe<ReadonlyArray<EnumerationValueOutputWhereInput>>;
  /** created_at field predicates */
  readonly createdAt?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly createdAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** created_by_uuid field predicates */
  readonly createdByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly createdByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** disabled field predicates */
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** enumeration_field_uuid field predicates */
  readonly enumerationFieldUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly enumerationFieldUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly enumerationFieldUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly enumerationFieldUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** enumeration_value_uuid field predicates */
  readonly enumerationValueUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly enumerationValueUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly enumerationValueUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly enumerationValueUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** deliveries edge predicates */
  readonly hasDeliveries?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasDeliveriesWith?: InputMaybe<ReadonlyArray<CrmDeliveryWhereInput>>;
  /** enumeration_field edge predicates */
  readonly hasEnumerationField?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasEnumerationFieldWith?: InputMaybe<ReadonlyArray<EnumerationFieldWhereInput>>;
  /** enumeration_value edge predicates */
  readonly hasEnumerationValue?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasEnumerationValueWith?: InputMaybe<ReadonlyArray<EnumerationValueWhereInput>>;
  /** id field predicates */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly idGT?: InputMaybe<Scalars['ID']['input']>;
  readonly idGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly idLT?: InputMaybe<Scalars['ID']['input']>;
  readonly idLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly idNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly not?: InputMaybe<EnumerationValueOutputWhereInput>;
  /** old_created_by_id field predicates */
  readonly oldCreatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldCreatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_id field predicates */
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDGT?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly oldIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldIDLT?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly oldIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_updated_by_id field predicates */
  readonly oldUpdatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldUpdatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly or?: InputMaybe<ReadonlyArray<EnumerationValueOutputWhereInput>>;
  /** string_value field predicates */
  readonly stringValue?: InputMaybe<Scalars['String']['input']>;
  readonly stringValueContains?: InputMaybe<Scalars['String']['input']>;
  readonly stringValueContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly stringValueEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly stringValueGT?: InputMaybe<Scalars['String']['input']>;
  readonly stringValueGTE?: InputMaybe<Scalars['String']['input']>;
  readonly stringValueHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly stringValueHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly stringValueIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly stringValueIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly stringValueLT?: InputMaybe<Scalars['String']['input']>;
  readonly stringValueLTE?: InputMaybe<Scalars['String']['input']>;
  readonly stringValueNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly stringValueNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly stringValueNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  readonly updatedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly updatedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** updated_by_uuid field predicates */
  readonly updatedByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly updatedByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
}

export interface EnumerationValueScore extends Node {
  readonly cons: Scalars['String']['output'];
  readonly createdAt: Scalars['Int']['output'];
  readonly createdByUUID: Scalars['ID']['output'];
  readonly deliveries?: Maybe<ReadonlyArray<CrmDelivery>>;
  readonly disabled: Scalars['Boolean']['output'];
  readonly enumerationField: EnumerationField;
  readonly enumerationFieldUUID: Scalars['ID']['output'];
  readonly enumerationValue: EnumerationValue;
  readonly enumerationValueUUID: Scalars['ID']['output'];
  readonly id: Scalars['ID']['output'];
  readonly oldCreatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly oldID?: Maybe<Scalars['Int']['output']>;
  readonly oldUpdatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly pros: Scalars['String']['output'];
  /**
   * Score is the score given to the enumeration value. It is a value between 1 and 10. If nil,
   * this score was not applicable for the given source input.
   */
  readonly score?: Maybe<Scalars['Int']['output']>;
  readonly suggestions?: Maybe<Scalars['String']['output']>;
  readonly updatedAt: Scalars['Int']['output'];
  readonly updatedByUUID: Scalars['ID']['output'];
}

/** A connection to a list of items. */
export interface EnumerationValueScoreConnection {
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<EnumerationValueScoreEdge>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface EnumerationValueScoreEdge {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<EnumerationValueScore>;
}

/** Ordering options for EnumerationValueScore connections */
export interface EnumerationValueScoreOrder {
  /** The ordering direction. */
  readonly direction?: OrderDirection;
  /** The field by which to order EnumerationValueScores. */
  readonly field: EnumerationValueScoreOrderField;
}

/** Properties by which EnumerationValueScore connections can be ordered. */
export const EnumerationValueScoreOrderField = {
  CreatedAt: 'CREATED_AT',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type EnumerationValueScoreOrderField = typeof EnumerationValueScoreOrderField[keyof typeof EnumerationValueScoreOrderField];
/**
 * EnumerationValueScoreWhereInput is used for filtering EnumerationValueScore objects.
 * Input was generated by ent.
 */
export interface EnumerationValueScoreWhereInput {
  readonly and?: InputMaybe<ReadonlyArray<EnumerationValueScoreWhereInput>>;
  /** cons field predicates */
  readonly cons?: InputMaybe<Scalars['String']['input']>;
  readonly consContains?: InputMaybe<Scalars['String']['input']>;
  readonly consContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly consEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly consGT?: InputMaybe<Scalars['String']['input']>;
  readonly consGTE?: InputMaybe<Scalars['String']['input']>;
  readonly consHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly consHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly consIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly consLT?: InputMaybe<Scalars['String']['input']>;
  readonly consLTE?: InputMaybe<Scalars['String']['input']>;
  readonly consNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly consNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** created_at field predicates */
  readonly createdAt?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly createdAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** created_by_uuid field predicates */
  readonly createdByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly createdByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** disabled field predicates */
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** enumeration_field_uuid field predicates */
  readonly enumerationFieldUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly enumerationFieldUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly enumerationFieldUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly enumerationFieldUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** enumeration_value_uuid field predicates */
  readonly enumerationValueUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly enumerationValueUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly enumerationValueUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly enumerationValueUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** deliveries edge predicates */
  readonly hasDeliveries?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasDeliveriesWith?: InputMaybe<ReadonlyArray<CrmDeliveryWhereInput>>;
  /** enumeration_field edge predicates */
  readonly hasEnumerationField?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasEnumerationFieldWith?: InputMaybe<ReadonlyArray<EnumerationFieldWhereInput>>;
  /** enumeration_value edge predicates */
  readonly hasEnumerationValue?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasEnumerationValueWith?: InputMaybe<ReadonlyArray<EnumerationValueWhereInput>>;
  /** id field predicates */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly idGT?: InputMaybe<Scalars['ID']['input']>;
  readonly idGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly idLT?: InputMaybe<Scalars['ID']['input']>;
  readonly idLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly idNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly not?: InputMaybe<EnumerationValueScoreWhereInput>;
  /** old_created_by_id field predicates */
  readonly oldCreatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldCreatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_id field predicates */
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDGT?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly oldIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldIDLT?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly oldIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_updated_by_id field predicates */
  readonly oldUpdatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldUpdatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly or?: InputMaybe<ReadonlyArray<EnumerationValueScoreWhereInput>>;
  /** pros field predicates */
  readonly pros?: InputMaybe<Scalars['String']['input']>;
  readonly prosContains?: InputMaybe<Scalars['String']['input']>;
  readonly prosContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly prosEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly prosGT?: InputMaybe<Scalars['String']['input']>;
  readonly prosGTE?: InputMaybe<Scalars['String']['input']>;
  readonly prosHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly prosHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly prosIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly prosLT?: InputMaybe<Scalars['String']['input']>;
  readonly prosLTE?: InputMaybe<Scalars['String']['input']>;
  readonly prosNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly prosNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** score field predicates */
  readonly score?: InputMaybe<Scalars['Int']['input']>;
  readonly scoreGT?: InputMaybe<Scalars['Int']['input']>;
  readonly scoreGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly scoreIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly scoreIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly scoreLT?: InputMaybe<Scalars['Int']['input']>;
  readonly scoreLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly scoreNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly scoreNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly scoreNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** suggestions field predicates */
  readonly suggestions?: InputMaybe<Scalars['String']['input']>;
  readonly suggestionsContains?: InputMaybe<Scalars['String']['input']>;
  readonly suggestionsContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly suggestionsEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly suggestionsGT?: InputMaybe<Scalars['String']['input']>;
  readonly suggestionsGTE?: InputMaybe<Scalars['String']['input']>;
  readonly suggestionsHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly suggestionsHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly suggestionsIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly suggestionsIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly suggestionsLT?: InputMaybe<Scalars['String']['input']>;
  readonly suggestionsLTE?: InputMaybe<Scalars['String']['input']>;
  readonly suggestionsNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly suggestionsNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly suggestionsNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  readonly updatedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly updatedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** updated_by_uuid field predicates */
  readonly updatedByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly updatedByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
}

/**
 * EnumerationValueWhereInput is used for filtering EnumerationValue objects.
 * Input was generated by ent.
 */
export interface EnumerationValueWhereInput {
  readonly and?: InputMaybe<ReadonlyArray<EnumerationValueWhereInput>>;
  /** call_uuid field predicates */
  readonly callUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly callUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly callUUIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly callUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly callUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly callUUIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  readonly createdAt?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly createdAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** created_by_uuid field predicates */
  readonly createdByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly createdByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** disabled field predicates */
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** document_uuid field predicates */
  readonly documentUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly documentUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly documentUUIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly documentUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly documentUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly documentUUIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** email_uuid field predicates */
  readonly emailUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly emailUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly emailUUIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly emailUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly emailUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly emailUUIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** end_date field predicates */
  readonly endDate?: InputMaybe<Scalars['Unix']['input']>;
  readonly endDateGT?: InputMaybe<Scalars['Unix']['input']>;
  readonly endDateGTE?: InputMaybe<Scalars['Unix']['input']>;
  readonly endDateIn?: InputMaybe<ReadonlyArray<Scalars['Unix']['input']>>;
  readonly endDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly endDateLT?: InputMaybe<Scalars['Unix']['input']>;
  readonly endDateLTE?: InputMaybe<Scalars['Unix']['input']>;
  readonly endDateNEQ?: InputMaybe<Scalars['Unix']['input']>;
  readonly endDateNotIn?: InputMaybe<ReadonlyArray<Scalars['Unix']['input']>>;
  readonly endDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** enumeration_configuration_uuid field predicates */
  readonly enumerationConfigurationUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly enumerationConfigurationUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly enumerationConfigurationUUIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly enumerationConfigurationUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly enumerationConfigurationUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly enumerationConfigurationUUIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** feedback field predicates */
  readonly feedback?: InputMaybe<Scalars['Boolean']['input']>;
  /** feedback_comment field predicates */
  readonly feedbackComment?: InputMaybe<Scalars['String']['input']>;
  readonly feedbackCommentContains?: InputMaybe<Scalars['String']['input']>;
  readonly feedbackCommentContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly feedbackCommentEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly feedbackCommentGT?: InputMaybe<Scalars['String']['input']>;
  readonly feedbackCommentGTE?: InputMaybe<Scalars['String']['input']>;
  readonly feedbackCommentHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly feedbackCommentHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly feedbackCommentIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly feedbackCommentIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly feedbackCommentLT?: InputMaybe<Scalars['String']['input']>;
  readonly feedbackCommentLTE?: InputMaybe<Scalars['String']['input']>;
  readonly feedbackCommentNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly feedbackCommentNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly feedbackCommentNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly feedbackIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly feedbackNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  readonly feedbackNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** gong_user_uuid field predicates */
  readonly gongUserUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly gongUserUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly gongUserUUIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly gongUserUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly gongUserUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly gongUserUUIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** call edge predicates */
  readonly hasCall?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasCallWith?: InputMaybe<ReadonlyArray<CallWhereInput>>;
  /** document edge predicates */
  readonly hasDocument?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasDocumentWith?: InputMaybe<ReadonlyArray<DocumentWhereInput>>;
  /** email edge predicates */
  readonly hasEmail?: InputMaybe<Scalars['Boolean']['input']>;
  /** email_deliveries edge predicates */
  readonly hasEmailDeliveries?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasEmailDeliveriesWith?: InputMaybe<ReadonlyArray<EmailDeliveryWhereInput>>;
  readonly hasEmailWith?: InputMaybe<ReadonlyArray<EmailWhereInput>>;
  /** enumeration_configuration edge predicates */
  readonly hasEnumerationConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasEnumerationConfigurationWith?: InputMaybe<ReadonlyArray<EnumerationConfigurationWhereInput>>;
  /** enumeration_value_feedback edge predicates */
  readonly hasEnumerationValueFeedback?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasEnumerationValueFeedbackWith?: InputMaybe<ReadonlyArray<EnumerationValueFeedbackWhereInput>>;
  /** gong_user edge predicates */
  readonly hasGongUser?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasGongUserWith?: InputMaybe<ReadonlyArray<GongUserWhereInput>>;
  /** opportunity_stage_change edge predicates */
  readonly hasOpportunityStageChange?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasOpportunityStageChangeWith?: InputMaybe<ReadonlyArray<OpportunityStageChangeWhereInput>>;
  /** outputs edge predicates */
  readonly hasOutputs?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasOutputsWith?: InputMaybe<ReadonlyArray<EnumerationValueOutputWhereInput>>;
  /** scores edge predicates */
  readonly hasScores?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasScoresWith?: InputMaybe<ReadonlyArray<EnumerationValueScoreWhereInput>>;
  /** id field predicates */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly idGT?: InputMaybe<Scalars['ID']['input']>;
  readonly idGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly idLT?: InputMaybe<Scalars['ID']['input']>;
  readonly idLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly idNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly not?: InputMaybe<EnumerationValueWhereInput>;
  /** old_created_by_id field predicates */
  readonly oldCreatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldCreatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_updated_by_id field predicates */
  readonly oldUpdatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldUpdatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** opportunity_stage_change_uuid field predicates */
  readonly opportunityStageChangeUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly opportunityStageChangeUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly opportunityStageChangeUUIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly opportunityStageChangeUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly opportunityStageChangeUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly opportunityStageChangeUUIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly or?: InputMaybe<ReadonlyArray<EnumerationValueWhereInput>>;
  /** start_date field predicates */
  readonly startDate?: InputMaybe<Scalars['Unix']['input']>;
  readonly startDateGT?: InputMaybe<Scalars['Unix']['input']>;
  readonly startDateGTE?: InputMaybe<Scalars['Unix']['input']>;
  readonly startDateIn?: InputMaybe<ReadonlyArray<Scalars['Unix']['input']>>;
  readonly startDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly startDateLT?: InputMaybe<Scalars['Unix']['input']>;
  readonly startDateLTE?: InputMaybe<Scalars['Unix']['input']>;
  readonly startDateNEQ?: InputMaybe<Scalars['Unix']['input']>;
  readonly startDateNotIn?: InputMaybe<ReadonlyArray<Scalars['Unix']['input']>>;
  readonly startDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  readonly updatedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly updatedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** updated_by_uuid field predicates */
  readonly updatedByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly updatedByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
}

export interface FieldDependencyLink extends Node {
  readonly createdAt: Scalars['Int']['output'];
  readonly createdByUUID: Scalars['ID']['output'];
  readonly disabled: Scalars['Boolean']['output'];
  readonly fromEnumerationField?: Maybe<EnumerationField>;
  readonly fromEnumerationFieldUUID?: Maybe<Scalars['ID']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly oldCreatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly oldID?: Maybe<Scalars['Int']['output']>;
  readonly oldUpdatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly toEnumerationField?: Maybe<EnumerationField>;
  readonly toEnumerationFieldUUID?: Maybe<Scalars['ID']['output']>;
  readonly updatedAt: Scalars['Int']['output'];
  readonly updatedByUUID: Scalars['ID']['output'];
}

/** A connection to a list of items. */
export interface FieldDependencyLinkConnection {
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<FieldDependencyLinkEdge>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface FieldDependencyLinkEdge {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<FieldDependencyLink>;
}

/** Ordering options for FieldDependencyLink connections */
export interface FieldDependencyLinkOrder {
  /** The ordering direction. */
  readonly direction?: OrderDirection;
  /** The field by which to order FieldDependencyLinks. */
  readonly field: FieldDependencyLinkOrderField;
}

/** Properties by which FieldDependencyLink connections can be ordered. */
export const FieldDependencyLinkOrderField = {
  CreatedAt: 'CREATED_AT',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type FieldDependencyLinkOrderField = typeof FieldDependencyLinkOrderField[keyof typeof FieldDependencyLinkOrderField];
/**
 * FieldDependencyLinkWhereInput is used for filtering FieldDependencyLink objects.
 * Input was generated by ent.
 */
export interface FieldDependencyLinkWhereInput {
  readonly and?: InputMaybe<ReadonlyArray<FieldDependencyLinkWhereInput>>;
  /** created_at field predicates */
  readonly createdAt?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly createdAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** created_by_uuid field predicates */
  readonly createdByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly createdByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** disabled field predicates */
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** from_enumeration_field_uuid field predicates */
  readonly fromEnumerationFieldUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly fromEnumerationFieldUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly fromEnumerationFieldUUIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly fromEnumerationFieldUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly fromEnumerationFieldUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly fromEnumerationFieldUUIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** from_enumeration_field edge predicates */
  readonly hasFromEnumerationField?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasFromEnumerationFieldWith?: InputMaybe<ReadonlyArray<EnumerationFieldWhereInput>>;
  /** to_enumeration_field edge predicates */
  readonly hasToEnumerationField?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasToEnumerationFieldWith?: InputMaybe<ReadonlyArray<EnumerationFieldWhereInput>>;
  /** id field predicates */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly idGT?: InputMaybe<Scalars['ID']['input']>;
  readonly idGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly idLT?: InputMaybe<Scalars['ID']['input']>;
  readonly idLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly idNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly not?: InputMaybe<FieldDependencyLinkWhereInput>;
  /** old_created_by_id field predicates */
  readonly oldCreatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldCreatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_id field predicates */
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDGT?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly oldIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldIDLT?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly oldIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_updated_by_id field predicates */
  readonly oldUpdatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldUpdatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly or?: InputMaybe<ReadonlyArray<FieldDependencyLinkWhereInput>>;
  /** to_enumeration_field_uuid field predicates */
  readonly toEnumerationFieldUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly toEnumerationFieldUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly toEnumerationFieldUUIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly toEnumerationFieldUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly toEnumerationFieldUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly toEnumerationFieldUUIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  readonly updatedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly updatedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** updated_by_uuid field predicates */
  readonly updatedByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly updatedByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
}

export interface GongUser extends Node {
  readonly active: Scalars['Boolean']['output'];
  readonly calls?: Maybe<ReadonlyArray<Call>>;
  readonly createdAt: Scalars['Int']['output'];
  readonly disabled: Scalars['Boolean']['output'];
  readonly documents?: Maybe<ReadonlyArray<Document>>;
  readonly emailAddress?: Maybe<Scalars['String']['output']>;
  readonly enumerationValues?: Maybe<ReadonlyArray<EnumerationValue>>;
  readonly externalUserID: Scalars['OldID']['output'];
  readonly fabiusManagers?: Maybe<ReadonlyArray<ReportingLink>>;
  readonly fabiusReports?: Maybe<ReadonlyArray<ReportingLink>>;
  readonly firstName: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly lastName: Scalars['String']['output'];
  readonly manager?: Maybe<GongUser>;
  readonly managerUUID?: Maybe<Scalars['ID']['output']>;
  readonly opportunities?: Maybe<ReadonlyArray<Opportunity>>;
  readonly reports?: Maybe<ReadonlyArray<GongUser>>;
  readonly sourcePlatform?: Maybe<GongUserCallIntegration>;
  readonly title?: Maybe<Scalars['String']['output']>;
  readonly updatedAt: Scalars['Int']['output'];
  readonly user?: Maybe<User>;
  readonly userUUID?: Maybe<Scalars['ID']['output']>;
}

/** GongUserCallIntegration is enum for the field source_platform */
export const GongUserCallIntegration = {
  Apollo: 'APOLLO',
  Freshcaller: 'FRESHCALLER',
  Freshdesk: 'FRESHDESK',
  Gmail: 'GMAIL',
  Gohighlevel: 'GOHIGHLEVEL',
  Gong: 'GONG',
  GongOauth: 'GONG_OAUTH',
  GoogleCalendar: 'GOOGLE_CALENDAR',
  GoogleMeet: 'GOOGLE_MEET',
  Hubspot: 'HUBSPOT',
  Justcall: 'JUSTCALL',
  Outreach: 'OUTREACH',
  Pipedrive: 'PIPEDRIVE',
  ProductBoard: 'PRODUCT_BOARD',
  Salesloft: 'SALESLOFT',
  Sfdc: 'SFDC',
  Slack: 'SLACK',
  UnknownIntegration: 'UNKNOWN_INTEGRATION',
  Volie: 'VOLIE',
  Wingman: 'WINGMAN',
  Zoho: 'ZOHO',
  Zoom: 'ZOOM'
} as const;

export type GongUserCallIntegration = typeof GongUserCallIntegration[keyof typeof GongUserCallIntegration];
/** A connection to a list of items. */
export interface GongUserConnection {
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<GongUserEdge>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface GongUserEdge {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<GongUser>;
}

/** Ordering options for GongUser connections */
export interface GongUserOrder {
  /** The ordering direction. */
  readonly direction?: OrderDirection;
  /** The field by which to order GongUsers. */
  readonly field: GongUserOrderField;
}

/** Properties by which GongUser connections can be ordered. */
export const GongUserOrderField = {
  CreatedAt: 'CREATED_AT',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type GongUserOrderField = typeof GongUserOrderField[keyof typeof GongUserOrderField];
/**
 * GongUserWhereInput is used for filtering GongUser objects.
 * Input was generated by ent.
 */
export interface GongUserWhereInput {
  /** active field predicates */
  readonly active?: InputMaybe<Scalars['Boolean']['input']>;
  readonly activeNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  readonly and?: InputMaybe<ReadonlyArray<GongUserWhereInput>>;
  /** created_at field predicates */
  readonly createdAt?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly createdAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** disabled field predicates */
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** email_address field predicates */
  readonly emailAddress?: InputMaybe<Scalars['String']['input']>;
  readonly emailAddressContains?: InputMaybe<Scalars['String']['input']>;
  readonly emailAddressContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly emailAddressEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly emailAddressGT?: InputMaybe<Scalars['String']['input']>;
  readonly emailAddressGTE?: InputMaybe<Scalars['String']['input']>;
  readonly emailAddressHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly emailAddressHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly emailAddressIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly emailAddressIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly emailAddressLT?: InputMaybe<Scalars['String']['input']>;
  readonly emailAddressLTE?: InputMaybe<Scalars['String']['input']>;
  readonly emailAddressNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly emailAddressNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly emailAddressNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** external_user_id field predicates */
  readonly externalUserID?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalUserIDContains?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalUserIDContainsFold?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalUserIDEqualFold?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalUserIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalUserIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalUserIDHasPrefix?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalUserIDHasSuffix?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalUserIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly externalUserIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalUserIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalUserIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalUserIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  /** first_name field predicates */
  readonly firstName?: InputMaybe<Scalars['String']['input']>;
  readonly firstNameContains?: InputMaybe<Scalars['String']['input']>;
  readonly firstNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly firstNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly firstNameGT?: InputMaybe<Scalars['String']['input']>;
  readonly firstNameGTE?: InputMaybe<Scalars['String']['input']>;
  readonly firstNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly firstNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly firstNameIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly firstNameLT?: InputMaybe<Scalars['String']['input']>;
  readonly firstNameLTE?: InputMaybe<Scalars['String']['input']>;
  readonly firstNameNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly firstNameNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** calls edge predicates */
  readonly hasCalls?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasCallsWith?: InputMaybe<ReadonlyArray<CallWhereInput>>;
  /** documents edge predicates */
  readonly hasDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasDocumentsWith?: InputMaybe<ReadonlyArray<DocumentWhereInput>>;
  /** enumeration_values edge predicates */
  readonly hasEnumerationValues?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasEnumerationValuesWith?: InputMaybe<ReadonlyArray<EnumerationValueWhereInput>>;
  /** fabius_managers edge predicates */
  readonly hasFabiusManagers?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasFabiusManagersWith?: InputMaybe<ReadonlyArray<ReportingLinkWhereInput>>;
  /** fabius_reports edge predicates */
  readonly hasFabiusReports?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasFabiusReportsWith?: InputMaybe<ReadonlyArray<ReportingLinkWhereInput>>;
  /** manager edge predicates */
  readonly hasManager?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasManagerWith?: InputMaybe<ReadonlyArray<GongUserWhereInput>>;
  /** opportunities edge predicates */
  readonly hasOpportunities?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasOpportunitiesWith?: InputMaybe<ReadonlyArray<OpportunityWhereInput>>;
  /** reports edge predicates */
  readonly hasReports?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasReportsWith?: InputMaybe<ReadonlyArray<GongUserWhereInput>>;
  /** user edge predicates */
  readonly hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasUserWith?: InputMaybe<ReadonlyArray<UserWhereInput>>;
  /** id field predicates */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly idGT?: InputMaybe<Scalars['ID']['input']>;
  readonly idGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly idLT?: InputMaybe<Scalars['ID']['input']>;
  readonly idLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly idNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** last_name field predicates */
  readonly lastName?: InputMaybe<Scalars['String']['input']>;
  readonly lastNameContains?: InputMaybe<Scalars['String']['input']>;
  readonly lastNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly lastNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly lastNameGT?: InputMaybe<Scalars['String']['input']>;
  readonly lastNameGTE?: InputMaybe<Scalars['String']['input']>;
  readonly lastNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly lastNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly lastNameIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly lastNameLT?: InputMaybe<Scalars['String']['input']>;
  readonly lastNameLTE?: InputMaybe<Scalars['String']['input']>;
  readonly lastNameNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly lastNameNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** manager_uuid field predicates */
  readonly managerUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly managerUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly managerUUIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly managerUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly managerUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly managerUUIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly not?: InputMaybe<GongUserWhereInput>;
  readonly or?: InputMaybe<ReadonlyArray<GongUserWhereInput>>;
  /** source_platform field predicates */
  readonly sourcePlatform?: InputMaybe<GongUserCallIntegration>;
  readonly sourcePlatformIn?: InputMaybe<ReadonlyArray<GongUserCallIntegration>>;
  readonly sourcePlatformIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly sourcePlatformNEQ?: InputMaybe<GongUserCallIntegration>;
  readonly sourcePlatformNotIn?: InputMaybe<ReadonlyArray<GongUserCallIntegration>>;
  readonly sourcePlatformNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** title field predicates */
  readonly title?: InputMaybe<Scalars['String']['input']>;
  readonly titleContains?: InputMaybe<Scalars['String']['input']>;
  readonly titleContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly titleEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly titleGT?: InputMaybe<Scalars['String']['input']>;
  readonly titleGTE?: InputMaybe<Scalars['String']['input']>;
  readonly titleHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly titleHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly titleIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly titleIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly titleLT?: InputMaybe<Scalars['String']['input']>;
  readonly titleLTE?: InputMaybe<Scalars['String']['input']>;
  readonly titleNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly titleNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly titleNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  readonly updatedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly updatedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** user_uuid field predicates */
  readonly userUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly userUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly userUUIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly userUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly userUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly userUUIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface IntegrationSecret extends Node {
  /** AccountID represents the associated account ID of the integration (if applicable). */
  readonly accountID?: Maybe<Scalars['String']['output']>;
  readonly childSecrets?: Maybe<ReadonlyArray<IntegrationSecret>>;
  readonly createdAt: Scalars['Int']['output'];
  readonly createdByUUID: Scalars['ID']['output'];
  readonly customerCrmConfig?: Maybe<CustomerCrmConfig>;
  readonly disabled: Scalars['Boolean']['output'];
  readonly documentIngestionConfig?: Maybe<DocumentIngestionConfig>;
  readonly id: Scalars['ID']['output'];
  readonly integration: IntegrationSecretCallIntegration;
  /** IsBackfilling means we are actively backfilling data from this integration if true. */
  readonly isBackfilling: Scalars['Boolean']['output'];
  readonly oldCreatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly oldID?: Maybe<Scalars['Int']['output']>;
  readonly oldUpdatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly parentSecret?: Maybe<IntegrationSecret>;
  readonly parentSecretUUID?: Maybe<Scalars['ID']['output']>;
  readonly updatedAt: Scalars['Int']['output'];
  readonly updatedByUUID: Scalars['ID']['output'];
  readonly useCases: ReadonlyArray<UseCase>;
  readonly user?: Maybe<User>;
  readonly userUUID?: Maybe<Scalars['ID']['output']>;
}

/** IntegrationSecretCallIntegration is enum for the field integration */
export const IntegrationSecretCallIntegration = {
  Apollo: 'APOLLO',
  Freshcaller: 'FRESHCALLER',
  Freshdesk: 'FRESHDESK',
  Gmail: 'GMAIL',
  Gohighlevel: 'GOHIGHLEVEL',
  Gong: 'GONG',
  GongOauth: 'GONG_OAUTH',
  GoogleCalendar: 'GOOGLE_CALENDAR',
  GoogleMeet: 'GOOGLE_MEET',
  Hubspot: 'HUBSPOT',
  Justcall: 'JUSTCALL',
  Outreach: 'OUTREACH',
  Pipedrive: 'PIPEDRIVE',
  ProductBoard: 'PRODUCT_BOARD',
  Salesloft: 'SALESLOFT',
  Sfdc: 'SFDC',
  Slack: 'SLACK',
  UnknownIntegration: 'UNKNOWN_INTEGRATION',
  Volie: 'VOLIE',
  Wingman: 'WINGMAN',
  Zoho: 'ZOHO',
  Zoom: 'ZOOM'
} as const;

export type IntegrationSecretCallIntegration = typeof IntegrationSecretCallIntegration[keyof typeof IntegrationSecretCallIntegration];
/** A connection to a list of items. */
export interface IntegrationSecretConnection {
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<IntegrationSecretEdge>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface IntegrationSecretEdge {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<IntegrationSecret>;
}

/** Ordering options for IntegrationSecret connections */
export interface IntegrationSecretOrder {
  /** The ordering direction. */
  readonly direction?: OrderDirection;
  /** The field by which to order IntegrationSecrets. */
  readonly field: IntegrationSecretOrderField;
}

/** Properties by which IntegrationSecret connections can be ordered. */
export const IntegrationSecretOrderField = {
  CreatedAt: 'CREATED_AT',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type IntegrationSecretOrderField = typeof IntegrationSecretOrderField[keyof typeof IntegrationSecretOrderField];
/**
 * IntegrationSecretWhereInput is used for filtering IntegrationSecret objects.
 * Input was generated by ent.
 */
export interface IntegrationSecretWhereInput {
  /** account_id field predicates */
  readonly accountID?: InputMaybe<Scalars['String']['input']>;
  readonly accountIDContains?: InputMaybe<Scalars['String']['input']>;
  readonly accountIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly accountIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly accountIDGT?: InputMaybe<Scalars['String']['input']>;
  readonly accountIDGTE?: InputMaybe<Scalars['String']['input']>;
  readonly accountIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly accountIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly accountIDIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly accountIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly accountIDLT?: InputMaybe<Scalars['String']['input']>;
  readonly accountIDLTE?: InputMaybe<Scalars['String']['input']>;
  readonly accountIDNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly accountIDNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly accountIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly and?: InputMaybe<ReadonlyArray<IntegrationSecretWhereInput>>;
  /** created_at field predicates */
  readonly createdAt?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly createdAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** created_by_uuid field predicates */
  readonly createdByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly createdByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** disabled field predicates */
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** child_secrets edge predicates */
  readonly hasChildSecrets?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasChildSecretsWith?: InputMaybe<ReadonlyArray<IntegrationSecretWhereInput>>;
  /** customer_crm_config edge predicates */
  readonly hasCustomerCrmConfig?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasCustomerCrmConfigWith?: InputMaybe<ReadonlyArray<CustomerCrmConfigWhereInput>>;
  /** document_ingestion_config edge predicates */
  readonly hasDocumentIngestionConfig?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasDocumentIngestionConfigWith?: InputMaybe<ReadonlyArray<DocumentIngestionConfigWhereInput>>;
  /** parent_secret edge predicates */
  readonly hasParentSecret?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasParentSecretWith?: InputMaybe<ReadonlyArray<IntegrationSecretWhereInput>>;
  /** user edge predicates */
  readonly hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasUserWith?: InputMaybe<ReadonlyArray<UserWhereInput>>;
  /** id field predicates */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly idGT?: InputMaybe<Scalars['ID']['input']>;
  readonly idGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly idLT?: InputMaybe<Scalars['ID']['input']>;
  readonly idLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly idNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** integration field predicates */
  readonly integration?: InputMaybe<IntegrationSecretCallIntegration>;
  readonly integrationIn?: InputMaybe<ReadonlyArray<IntegrationSecretCallIntegration>>;
  readonly integrationNEQ?: InputMaybe<IntegrationSecretCallIntegration>;
  readonly integrationNotIn?: InputMaybe<ReadonlyArray<IntegrationSecretCallIntegration>>;
  /** is_backfilling field predicates */
  readonly isBackfilling?: InputMaybe<Scalars['Boolean']['input']>;
  readonly isBackfillingNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  readonly not?: InputMaybe<IntegrationSecretWhereInput>;
  /** old_created_by_id field predicates */
  readonly oldCreatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldCreatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_id field predicates */
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDGT?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly oldIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldIDLT?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly oldIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_updated_by_id field predicates */
  readonly oldUpdatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldUpdatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly or?: InputMaybe<ReadonlyArray<IntegrationSecretWhereInput>>;
  /** parent_secret_uuid field predicates */
  readonly parentSecretUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly parentSecretUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly parentSecretUUIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly parentSecretUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly parentSecretUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly parentSecretUUIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  readonly updatedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly updatedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** updated_by_uuid field predicates */
  readonly updatedByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly updatedByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** user_uuid field predicates */
  readonly userUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly userUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly userUUIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly userUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly userUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly userUUIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface KnowledgeDocument extends Node {
  readonly createdAt: Scalars['Int']['output'];
  readonly createdByUUID: Scalars['ID']['output'];
  readonly currentVersion?: Maybe<KnowledgeDocumentVersion>;
  readonly currentVersionUUID?: Maybe<Scalars['ID']['output']>;
  /** Description is the customer-facing description of the document */
  readonly description: Scalars['String']['output'];
  readonly directory?: Maybe<Directory>;
  readonly directoryUUID?: Maybe<Scalars['ID']['output']>;
  readonly disabled: Scalars['Boolean']['output'];
  readonly emailReplyContexts?: Maybe<ReadonlyArray<EmailReplyContext>>;
  readonly id: Scalars['ID']['output'];
  /** IsUseful is a flag to indicate if the document is useful or not for further processing/synthesis. When we ingest large numbers of documents at once, we want to give the models an option to process a document (so we don't process it again) while flagging that it shouldn't be used for downstream purposes. An example could be a webpage with only 2-3 sentences on it, terms of service that are very long and don't have much information, or internal documents that aren't useful for sales */
  readonly isUseful?: Maybe<Scalars['Boolean']['output']>;
  readonly knowledgeDocumentPromptInstructions: KnowledgeDocumentPromptInstructionConnection;
  /** MimeType is the mime type of the raw document contents stored in the RawFilePath */
  readonly mimeType: Scalars['String']['output'];
  readonly name: Scalars['String']['output'];
  readonly oldCreatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly oldID?: Maybe<Scalars['OldID']['output']>;
  readonly oldUpdatedByID?: Maybe<Scalars['OldID']['output']>;
  /** Source is where the document came from, for example a manual upload, a URL, or a Google Docs. */
  readonly source: KnowledgeDocumentDocumentSourceType;
  /** Type is the type of the document - meant in a domain-specific way. For example, two documents from a customer's webpage could be different types, like one could be marketing material and the other product documentation */
  readonly type: KnowledgeDocumentDocumentType;
  readonly updatedAt: Scalars['Int']['output'];
  readonly updatedByUUID: Scalars['ID']['output'];
  /** URL is the URL to the document (if it was pulled from a URL). */
  readonly url?: Maybe<Scalars['String']['output']>;
  readonly versions: KnowledgeDocumentVersionConnection;
}


export interface KnowledgeDocumentKnowledgeDocumentPromptInstructionsArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<KnowledgeDocumentPromptInstructionOrder>;
  where?: InputMaybe<KnowledgeDocumentPromptInstructionWhereInput>;
}


export interface KnowledgeDocumentVersionsArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<KnowledgeDocumentVersionOrder>;
  where?: InputMaybe<KnowledgeDocumentVersionWhereInput>;
}

/** A connection to a list of items. */
export interface KnowledgeDocumentConnection {
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<KnowledgeDocumentEdge>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
}

/** KnowledgeDocumentDocumentSourceType is enum for the field source */
export const KnowledgeDocumentDocumentSourceType = {
  SourceCalls: 'SOURCE_CALLS',
  SourceCustomerWebpages: 'SOURCE_CUSTOMER_WEBPAGES',
  SourceEmails: 'SOURCE_EMAILS',
  SourceGoogleDocs: 'SOURCE_GOOGLE_DOCS',
  SourceManual: 'SOURCE_MANUAL',
  SourceUnknown: 'SOURCE_UNKNOWN',
  SourceVideos: 'SOURCE_VIDEOS'
} as const;

export type KnowledgeDocumentDocumentSourceType = typeof KnowledgeDocumentDocumentSourceType[keyof typeof KnowledgeDocumentDocumentSourceType];
/** KnowledgeDocumentDocumentType is enum for the field type */
export const KnowledgeDocumentDocumentType = {
  CallsByHighPerformers: 'CALLS_BY_HIGH_PERFORMERS',
  CaseStudies: 'CASE_STUDIES',
  CustomerWebpages: 'CUSTOMER_WEBPAGES',
  GoogleDocuments: 'GOOGLE_DOCUMENTS',
  HistoricEmailAnalysis: 'HISTORIC_EMAIL_ANALYSIS',
  MarketingMaterials: 'MARKETING_MATERIALS',
  ProductDocumentation: 'PRODUCT_DOCUMENTATION',
  SalesTrainingMaterials: 'SALES_TRAINING_MATERIALS',
  StandardOperatingProcedures: 'STANDARD_OPERATING_PROCEDURES',
  Unknown: 'UNKNOWN'
} as const;

export type KnowledgeDocumentDocumentType = typeof KnowledgeDocumentDocumentType[keyof typeof KnowledgeDocumentDocumentType];
/** An edge in a connection. */
export interface KnowledgeDocumentEdge {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<KnowledgeDocument>;
}

/** Ordering options for KnowledgeDocument connections */
export interface KnowledgeDocumentOrder {
  /** The ordering direction. */
  readonly direction?: OrderDirection;
  /** The field by which to order KnowledgeDocuments. */
  readonly field: KnowledgeDocumentOrderField;
}

/** Properties by which KnowledgeDocument connections can be ordered. */
export const KnowledgeDocumentOrderField = {
  CreatedAt: 'CREATED_AT',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type KnowledgeDocumentOrderField = typeof KnowledgeDocumentOrderField[keyof typeof KnowledgeDocumentOrderField];
export interface KnowledgeDocumentPromptInstruction extends Node {
  readonly classifierCondition?: Maybe<ClassifierCondition>;
  /** Reference to a ClassifierCondition, if applicable. */
  readonly classifierConditionUUID?: Maybe<Scalars['ID']['output']>;
  readonly createdAt: Scalars['Int']['output'];
  readonly createdByUUID: Scalars['ID']['output'];
  /** Definitions represent the contextual definition that the model needs in order to be able to best do it's job, so that there isn't ambiguity about the terms using in the instructions/directions or whether the calls/documents themselves. This is often left blank if there isn't much chance of confusion. If the type of the value or score is non-custom, then adding to this will append the text after the standard definitions for that field. */
  readonly definitions?: Maybe<Scalars['String']['output']>;
  /** Directions are the specific steps or detailed context that the model needs to take in order to complete the analysis. This is generally more detailed than the instructions and is often used to break down the instructions into more digestible steps or talk through edge cases. If the type of the value or score is non-custom, then adding to this will append the text after the standard directions for that field. */
  readonly directions?: Maybe<Scalars['String']['output']>;
  readonly disabled: Scalars['Boolean']['output'];
  readonly enumerationConfigFieldLink?: Maybe<EnumerationConfigFieldLink>;
  /** Reference to an EnumerationConfigFieldLink, if applicable. */
  readonly enumerationConfigFieldLinkUUID?: Maybe<Scalars['ID']['output']>;
  readonly enumerationConfiguration?: Maybe<EnumerationConfiguration>;
  /** Reference to an EnumerationConfiguration, if applicable. */
  readonly enumerationConfigurationUUID?: Maybe<Scalars['ID']['output']>;
  readonly enumerationField?: Maybe<EnumerationField>;
  /** Reference to an EnumerationField, if applicable. */
  readonly enumerationFieldUUID?: Maybe<Scalars['ID']['output']>;
  readonly id: Scalars['ID']['output'];
  /** Instructions represents the main description of the task that the model needs to do to complete the analysis. For normal fields, this generally describes how to analyze the call/document. For scores, this is the rubric that outlines exactly how to score the rep on the call. If the type of the value or score is non-custom, then adding to this will append the text after the standard instructions for that field. */
  readonly instructions?: Maybe<Scalars['String']['output']>;
  readonly knowledgeDocument: KnowledgeDocument;
  /** Reference to the associated KnowledgeDocument. */
  readonly knowledgeDocumentUUID: Scalars['ID']['output'];
  /** Mode indicating how the knowledge document's content affects the prompt. */
  readonly mode: KnowledgeDocumentPromptInstructionKnowledgeDocumentPromptInstructionMode;
  readonly oldCreatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly oldUpdatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly updatedAt: Scalars['Int']['output'];
  readonly updatedByUUID: Scalars['ID']['output'];
}

/** A connection to a list of items. */
export interface KnowledgeDocumentPromptInstructionConnection {
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<KnowledgeDocumentPromptInstructionEdge>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface KnowledgeDocumentPromptInstructionEdge {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<KnowledgeDocumentPromptInstruction>;
}

/** KnowledgeDocumentPromptInstructionKnowledgeDocumentPromptInstructionMode is enum for the field mode */
export const KnowledgeDocumentPromptInstructionKnowledgeDocumentPromptInstructionMode = {
  ModeBoth: 'MODE_BOTH',
  ModeInsert: 'MODE_INSERT',
  ModeUnknown: 'MODE_UNKNOWN',
  ModeUpdate: 'MODE_UPDATE'
} as const;

export type KnowledgeDocumentPromptInstructionKnowledgeDocumentPromptInstructionMode = typeof KnowledgeDocumentPromptInstructionKnowledgeDocumentPromptInstructionMode[keyof typeof KnowledgeDocumentPromptInstructionKnowledgeDocumentPromptInstructionMode];
/** Ordering options for KnowledgeDocumentPromptInstruction connections */
export interface KnowledgeDocumentPromptInstructionOrder {
  /** The ordering direction. */
  readonly direction?: OrderDirection;
  /** The field by which to order KnowledgeDocumentPromptInstructions. */
  readonly field: KnowledgeDocumentPromptInstructionOrderField;
}

/** Properties by which KnowledgeDocumentPromptInstruction connections can be ordered. */
export const KnowledgeDocumentPromptInstructionOrderField = {
  CreatedAt: 'CREATED_AT',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type KnowledgeDocumentPromptInstructionOrderField = typeof KnowledgeDocumentPromptInstructionOrderField[keyof typeof KnowledgeDocumentPromptInstructionOrderField];
/**
 * KnowledgeDocumentPromptInstructionWhereInput is used for filtering KnowledgeDocumentPromptInstruction objects.
 * Input was generated by ent.
 */
export interface KnowledgeDocumentPromptInstructionWhereInput {
  readonly and?: InputMaybe<ReadonlyArray<KnowledgeDocumentPromptInstructionWhereInput>>;
  /** classifier_condition_uuid field predicates */
  readonly classifierConditionUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly classifierConditionUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly classifierConditionUUIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly classifierConditionUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly classifierConditionUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly classifierConditionUUIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  readonly createdAt?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly createdAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** created_by_uuid field predicates */
  readonly createdByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly createdByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** definitions field predicates */
  readonly definitions?: InputMaybe<Scalars['String']['input']>;
  readonly definitionsContains?: InputMaybe<Scalars['String']['input']>;
  readonly definitionsContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly definitionsEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly definitionsGT?: InputMaybe<Scalars['String']['input']>;
  readonly definitionsGTE?: InputMaybe<Scalars['String']['input']>;
  readonly definitionsHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly definitionsHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly definitionsIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly definitionsIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly definitionsLT?: InputMaybe<Scalars['String']['input']>;
  readonly definitionsLTE?: InputMaybe<Scalars['String']['input']>;
  readonly definitionsNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly definitionsNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly definitionsNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** directions field predicates */
  readonly directions?: InputMaybe<Scalars['String']['input']>;
  readonly directionsContains?: InputMaybe<Scalars['String']['input']>;
  readonly directionsContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly directionsEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly directionsGT?: InputMaybe<Scalars['String']['input']>;
  readonly directionsGTE?: InputMaybe<Scalars['String']['input']>;
  readonly directionsHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly directionsHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly directionsIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly directionsIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly directionsLT?: InputMaybe<Scalars['String']['input']>;
  readonly directionsLTE?: InputMaybe<Scalars['String']['input']>;
  readonly directionsNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly directionsNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly directionsNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** disabled field predicates */
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** enumeration_config_field_link_uuid field predicates */
  readonly enumerationConfigFieldLinkUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly enumerationConfigFieldLinkUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly enumerationConfigFieldLinkUUIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly enumerationConfigFieldLinkUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly enumerationConfigFieldLinkUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly enumerationConfigFieldLinkUUIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** enumeration_configuration_uuid field predicates */
  readonly enumerationConfigurationUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly enumerationConfigurationUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly enumerationConfigurationUUIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly enumerationConfigurationUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly enumerationConfigurationUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly enumerationConfigurationUUIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** enumeration_field_uuid field predicates */
  readonly enumerationFieldUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly enumerationFieldUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly enumerationFieldUUIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly enumerationFieldUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly enumerationFieldUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly enumerationFieldUUIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** classifier_condition edge predicates */
  readonly hasClassifierCondition?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasClassifierConditionWith?: InputMaybe<ReadonlyArray<ClassifierConditionWhereInput>>;
  /** enumeration_config_field_link edge predicates */
  readonly hasEnumerationConfigFieldLink?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasEnumerationConfigFieldLinkWith?: InputMaybe<ReadonlyArray<EnumerationConfigFieldLinkWhereInput>>;
  /** enumeration_configuration edge predicates */
  readonly hasEnumerationConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasEnumerationConfigurationWith?: InputMaybe<ReadonlyArray<EnumerationConfigurationWhereInput>>;
  /** enumeration_field edge predicates */
  readonly hasEnumerationField?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasEnumerationFieldWith?: InputMaybe<ReadonlyArray<EnumerationFieldWhereInput>>;
  /** knowledge_document edge predicates */
  readonly hasKnowledgeDocument?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasKnowledgeDocumentWith?: InputMaybe<ReadonlyArray<KnowledgeDocumentWhereInput>>;
  /** id field predicates */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly idGT?: InputMaybe<Scalars['ID']['input']>;
  readonly idGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly idLT?: InputMaybe<Scalars['ID']['input']>;
  readonly idLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly idNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** instructions field predicates */
  readonly instructions?: InputMaybe<Scalars['String']['input']>;
  readonly instructionsContains?: InputMaybe<Scalars['String']['input']>;
  readonly instructionsContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly instructionsEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly instructionsGT?: InputMaybe<Scalars['String']['input']>;
  readonly instructionsGTE?: InputMaybe<Scalars['String']['input']>;
  readonly instructionsHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly instructionsHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly instructionsIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly instructionsIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly instructionsLT?: InputMaybe<Scalars['String']['input']>;
  readonly instructionsLTE?: InputMaybe<Scalars['String']['input']>;
  readonly instructionsNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly instructionsNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly instructionsNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** knowledge_document_uuid field predicates */
  readonly knowledgeDocumentUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly knowledgeDocumentUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly knowledgeDocumentUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly knowledgeDocumentUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** mode field predicates */
  readonly mode?: InputMaybe<KnowledgeDocumentPromptInstructionKnowledgeDocumentPromptInstructionMode>;
  readonly modeIn?: InputMaybe<ReadonlyArray<KnowledgeDocumentPromptInstructionKnowledgeDocumentPromptInstructionMode>>;
  readonly modeNEQ?: InputMaybe<KnowledgeDocumentPromptInstructionKnowledgeDocumentPromptInstructionMode>;
  readonly modeNotIn?: InputMaybe<ReadonlyArray<KnowledgeDocumentPromptInstructionKnowledgeDocumentPromptInstructionMode>>;
  readonly not?: InputMaybe<KnowledgeDocumentPromptInstructionWhereInput>;
  /** old_created_by_id field predicates */
  readonly oldCreatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldCreatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_updated_by_id field predicates */
  readonly oldUpdatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldUpdatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly or?: InputMaybe<ReadonlyArray<KnowledgeDocumentPromptInstructionWhereInput>>;
  /** updated_at field predicates */
  readonly updatedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly updatedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** updated_by_uuid field predicates */
  readonly updatedByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly updatedByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
}

export interface KnowledgeDocumentVersion extends Node {
  readonly createdAt: Scalars['Int']['output'];
  readonly createdByUUID: Scalars['ID']['output'];
  /** LLM-written summary of changes from the previous version, primarily used to pass downstream to have another LLM make updates to things like enumerationfield instructions, etc. */
  readonly diffSummary?: Maybe<Scalars['String']['output']>;
  readonly disabled: Scalars['Boolean']['output'];
  readonly id: Scalars['ID']['output'];
  /** InternalSummary is a summary of the document for internal (non-customer) use. */
  readonly internalSummary?: Maybe<Scalars['String']['output']>;
  readonly knowledgeDocument: KnowledgeDocument;
  readonly knowledgeDocumentUUID: Scalars['ID']['output'];
  /** Metadata specific to this version */
  readonly metadata?: Maybe<Scalars['JSON']['output']>;
  readonly oldCreatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly oldID?: Maybe<Scalars['Int']['output']>;
  readonly oldUpdatedByID?: Maybe<Scalars['OldID']['output']>;
  /** Checksum of the processed file */
  readonly processedChecksum?: Maybe<Scalars['String']['output']>;
  /** Path to the processed version of the file on S3 for this version */
  readonly processedFilePath?: Maybe<Scalars['String']['output']>;
  /** Timestamp when background processing finished (successfully or failed). */
  readonly processingCompletedAt?: Maybe<Scalars['Int']['output']>;
  /** Stores the error message if background processing failed. */
  readonly processingError?: Maybe<Scalars['String']['output']>;
  /** Timestamp when background processing started. */
  readonly processingStartedAt?: Maybe<Scalars['Int']['output']>;
  /** The status of background processing for this version. */
  readonly processingStatus: KnowledgeDocumentVersionProcessingStatus;
  /** Checksum of the raw file */
  readonly rawChecksum?: Maybe<Scalars['String']['output']>;
  /** Path to the raw version of the file on S3 for this version */
  readonly rawFilePath: Scalars['String']['output'];
  readonly updatedAt: Scalars['Int']['output'];
  readonly updatedByUUID: Scalars['ID']['output'];
  readonly versionNumber: Scalars['Int']['output'];
}

/** A connection to a list of items. */
export interface KnowledgeDocumentVersionConnection {
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<KnowledgeDocumentVersionEdge>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface KnowledgeDocumentVersionEdge {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<KnowledgeDocumentVersion>;
}

/** Ordering options for KnowledgeDocumentVersion connections */
export interface KnowledgeDocumentVersionOrder {
  /** The ordering direction. */
  readonly direction?: OrderDirection;
  /** The field by which to order KnowledgeDocumentVersions. */
  readonly field: KnowledgeDocumentVersionOrderField;
}

/** Properties by which KnowledgeDocumentVersion connections can be ordered. */
export const KnowledgeDocumentVersionOrderField = {
  CreatedAt: 'CREATED_AT',
  UpdatedAt: 'UPDATED_AT',
  VersionNumber: 'VERSION_NUMBER'
} as const;

export type KnowledgeDocumentVersionOrderField = typeof KnowledgeDocumentVersionOrderField[keyof typeof KnowledgeDocumentVersionOrderField];
/** KnowledgeDocumentVersionProcessingStatus is enum for the field processing_status */
export const KnowledgeDocumentVersionProcessingStatus = {
  StatusCompleted: 'STATUS_COMPLETED',
  StatusFailed: 'STATUS_FAILED',
  StatusPending: 'STATUS_PENDING',
  StatusProcessing: 'STATUS_PROCESSING',
  StatusUnknown: 'STATUS_UNKNOWN'
} as const;

export type KnowledgeDocumentVersionProcessingStatus = typeof KnowledgeDocumentVersionProcessingStatus[keyof typeof KnowledgeDocumentVersionProcessingStatus];
/**
 * KnowledgeDocumentVersionWhereInput is used for filtering KnowledgeDocumentVersion objects.
 * Input was generated by ent.
 */
export interface KnowledgeDocumentVersionWhereInput {
  readonly and?: InputMaybe<ReadonlyArray<KnowledgeDocumentVersionWhereInput>>;
  /** created_at field predicates */
  readonly createdAt?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly createdAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** created_by_uuid field predicates */
  readonly createdByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly createdByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** diff_summary field predicates */
  readonly diffSummary?: InputMaybe<Scalars['String']['input']>;
  readonly diffSummaryContains?: InputMaybe<Scalars['String']['input']>;
  readonly diffSummaryContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly diffSummaryEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly diffSummaryGT?: InputMaybe<Scalars['String']['input']>;
  readonly diffSummaryGTE?: InputMaybe<Scalars['String']['input']>;
  readonly diffSummaryHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly diffSummaryHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly diffSummaryIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly diffSummaryIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly diffSummaryLT?: InputMaybe<Scalars['String']['input']>;
  readonly diffSummaryLTE?: InputMaybe<Scalars['String']['input']>;
  readonly diffSummaryNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly diffSummaryNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly diffSummaryNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** disabled field predicates */
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** knowledge_document edge predicates */
  readonly hasKnowledgeDocument?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasKnowledgeDocumentWith?: InputMaybe<ReadonlyArray<KnowledgeDocumentWhereInput>>;
  /** id field predicates */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly idGT?: InputMaybe<Scalars['ID']['input']>;
  readonly idGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly idLT?: InputMaybe<Scalars['ID']['input']>;
  readonly idLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly idNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** internal_summary field predicates */
  readonly internalSummary?: InputMaybe<Scalars['String']['input']>;
  readonly internalSummaryContains?: InputMaybe<Scalars['String']['input']>;
  readonly internalSummaryContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly internalSummaryEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly internalSummaryGT?: InputMaybe<Scalars['String']['input']>;
  readonly internalSummaryGTE?: InputMaybe<Scalars['String']['input']>;
  readonly internalSummaryHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly internalSummaryHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly internalSummaryIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly internalSummaryIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly internalSummaryLT?: InputMaybe<Scalars['String']['input']>;
  readonly internalSummaryLTE?: InputMaybe<Scalars['String']['input']>;
  readonly internalSummaryNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly internalSummaryNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly internalSummaryNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** knowledge_document_uuid field predicates */
  readonly knowledgeDocumentUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly knowledgeDocumentUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly knowledgeDocumentUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly knowledgeDocumentUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly not?: InputMaybe<KnowledgeDocumentVersionWhereInput>;
  /** old_created_by_id field predicates */
  readonly oldCreatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldCreatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_id field predicates */
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDGT?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly oldIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldIDLT?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly oldIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_updated_by_id field predicates */
  readonly oldUpdatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldUpdatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly or?: InputMaybe<ReadonlyArray<KnowledgeDocumentVersionWhereInput>>;
  /** processed_checksum field predicates */
  readonly processedChecksum?: InputMaybe<Scalars['String']['input']>;
  readonly processedChecksumContains?: InputMaybe<Scalars['String']['input']>;
  readonly processedChecksumContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly processedChecksumEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly processedChecksumGT?: InputMaybe<Scalars['String']['input']>;
  readonly processedChecksumGTE?: InputMaybe<Scalars['String']['input']>;
  readonly processedChecksumHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly processedChecksumHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly processedChecksumIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly processedChecksumIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly processedChecksumLT?: InputMaybe<Scalars['String']['input']>;
  readonly processedChecksumLTE?: InputMaybe<Scalars['String']['input']>;
  readonly processedChecksumNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly processedChecksumNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly processedChecksumNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** processed_file_path field predicates */
  readonly processedFilePath?: InputMaybe<Scalars['String']['input']>;
  readonly processedFilePathContains?: InputMaybe<Scalars['String']['input']>;
  readonly processedFilePathContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly processedFilePathEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly processedFilePathGT?: InputMaybe<Scalars['String']['input']>;
  readonly processedFilePathGTE?: InputMaybe<Scalars['String']['input']>;
  readonly processedFilePathHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly processedFilePathHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly processedFilePathIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly processedFilePathIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly processedFilePathLT?: InputMaybe<Scalars['String']['input']>;
  readonly processedFilePathLTE?: InputMaybe<Scalars['String']['input']>;
  readonly processedFilePathNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly processedFilePathNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly processedFilePathNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** processing_completed_at field predicates */
  readonly processingCompletedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly processingCompletedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly processingCompletedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly processingCompletedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly processingCompletedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly processingCompletedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly processingCompletedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly processingCompletedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly processingCompletedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly processingCompletedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** processing_error field predicates */
  readonly processingError?: InputMaybe<Scalars['String']['input']>;
  readonly processingErrorContains?: InputMaybe<Scalars['String']['input']>;
  readonly processingErrorContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly processingErrorEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly processingErrorGT?: InputMaybe<Scalars['String']['input']>;
  readonly processingErrorGTE?: InputMaybe<Scalars['String']['input']>;
  readonly processingErrorHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly processingErrorHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly processingErrorIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly processingErrorIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly processingErrorLT?: InputMaybe<Scalars['String']['input']>;
  readonly processingErrorLTE?: InputMaybe<Scalars['String']['input']>;
  readonly processingErrorNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly processingErrorNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly processingErrorNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** processing_started_at field predicates */
  readonly processingStartedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly processingStartedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly processingStartedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly processingStartedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly processingStartedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly processingStartedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly processingStartedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly processingStartedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly processingStartedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly processingStartedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** processing_status field predicates */
  readonly processingStatus?: InputMaybe<KnowledgeDocumentVersionProcessingStatus>;
  readonly processingStatusIn?: InputMaybe<ReadonlyArray<KnowledgeDocumentVersionProcessingStatus>>;
  readonly processingStatusNEQ?: InputMaybe<KnowledgeDocumentVersionProcessingStatus>;
  readonly processingStatusNotIn?: InputMaybe<ReadonlyArray<KnowledgeDocumentVersionProcessingStatus>>;
  /** raw_checksum field predicates */
  readonly rawChecksum?: InputMaybe<Scalars['String']['input']>;
  readonly rawChecksumContains?: InputMaybe<Scalars['String']['input']>;
  readonly rawChecksumContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly rawChecksumEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly rawChecksumGT?: InputMaybe<Scalars['String']['input']>;
  readonly rawChecksumGTE?: InputMaybe<Scalars['String']['input']>;
  readonly rawChecksumHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly rawChecksumHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly rawChecksumIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly rawChecksumIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly rawChecksumLT?: InputMaybe<Scalars['String']['input']>;
  readonly rawChecksumLTE?: InputMaybe<Scalars['String']['input']>;
  readonly rawChecksumNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly rawChecksumNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly rawChecksumNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** raw_file_path field predicates */
  readonly rawFilePath?: InputMaybe<Scalars['String']['input']>;
  readonly rawFilePathContains?: InputMaybe<Scalars['String']['input']>;
  readonly rawFilePathContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly rawFilePathEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly rawFilePathGT?: InputMaybe<Scalars['String']['input']>;
  readonly rawFilePathGTE?: InputMaybe<Scalars['String']['input']>;
  readonly rawFilePathHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly rawFilePathHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly rawFilePathIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly rawFilePathLT?: InputMaybe<Scalars['String']['input']>;
  readonly rawFilePathLTE?: InputMaybe<Scalars['String']['input']>;
  readonly rawFilePathNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly rawFilePathNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** updated_at field predicates */
  readonly updatedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly updatedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** updated_by_uuid field predicates */
  readonly updatedByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly updatedByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** version_number field predicates */
  readonly versionNumber?: InputMaybe<Scalars['Int']['input']>;
  readonly versionNumberGT?: InputMaybe<Scalars['Int']['input']>;
  readonly versionNumberGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly versionNumberIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly versionNumberLT?: InputMaybe<Scalars['Int']['input']>;
  readonly versionNumberLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly versionNumberNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly versionNumberNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
}

/**
 * KnowledgeDocumentWhereInput is used for filtering KnowledgeDocument objects.
 * Input was generated by ent.
 */
export interface KnowledgeDocumentWhereInput {
  readonly and?: InputMaybe<ReadonlyArray<KnowledgeDocumentWhereInput>>;
  /** created_at field predicates */
  readonly createdAt?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly createdAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** created_by_uuid field predicates */
  readonly createdByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly createdByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** current_version_uuid field predicates */
  readonly currentVersionUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly currentVersionUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly currentVersionUUIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly currentVersionUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly currentVersionUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly currentVersionUUIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** description field predicates */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionContains?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionGT?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly descriptionLT?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** directory_uuid field predicates */
  readonly directoryUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly directoryUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly directoryUUIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly directoryUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly directoryUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly directoryUUIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** disabled field predicates */
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** current_version edge predicates */
  readonly hasCurrentVersion?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasCurrentVersionWith?: InputMaybe<ReadonlyArray<KnowledgeDocumentVersionWhereInput>>;
  /** directory edge predicates */
  readonly hasDirectory?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasDirectoryWith?: InputMaybe<ReadonlyArray<DirectoryWhereInput>>;
  /** email_reply_contexts edge predicates */
  readonly hasEmailReplyContexts?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasEmailReplyContextsWith?: InputMaybe<ReadonlyArray<EmailReplyContextWhereInput>>;
  /** knowledge_document_prompt_instructions edge predicates */
  readonly hasKnowledgeDocumentPromptInstructions?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasKnowledgeDocumentPromptInstructionsWith?: InputMaybe<ReadonlyArray<KnowledgeDocumentPromptInstructionWhereInput>>;
  /** versions edge predicates */
  readonly hasVersions?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasVersionsWith?: InputMaybe<ReadonlyArray<KnowledgeDocumentVersionWhereInput>>;
  /** id field predicates */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly idGT?: InputMaybe<Scalars['ID']['input']>;
  readonly idGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly idLT?: InputMaybe<Scalars['ID']['input']>;
  readonly idLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly idNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** is_useful field predicates */
  readonly isUseful?: InputMaybe<Scalars['Boolean']['input']>;
  readonly isUsefulIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly isUsefulNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  readonly isUsefulNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** mime_type field predicates */
  readonly mimeType?: InputMaybe<Scalars['String']['input']>;
  readonly mimeTypeContains?: InputMaybe<Scalars['String']['input']>;
  readonly mimeTypeContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly mimeTypeEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly mimeTypeGT?: InputMaybe<Scalars['String']['input']>;
  readonly mimeTypeGTE?: InputMaybe<Scalars['String']['input']>;
  readonly mimeTypeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly mimeTypeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly mimeTypeIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly mimeTypeLT?: InputMaybe<Scalars['String']['input']>;
  readonly mimeTypeLTE?: InputMaybe<Scalars['String']['input']>;
  readonly mimeTypeNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly mimeTypeNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** name field predicates */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly nameContains?: InputMaybe<Scalars['String']['input']>;
  readonly nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly nameGT?: InputMaybe<Scalars['String']['input']>;
  readonly nameGTE?: InputMaybe<Scalars['String']['input']>;
  readonly nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly nameIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly nameLT?: InputMaybe<Scalars['String']['input']>;
  readonly nameLTE?: InputMaybe<Scalars['String']['input']>;
  readonly nameNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly nameNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly not?: InputMaybe<KnowledgeDocumentWhereInput>;
  /** old_created_by_id field predicates */
  readonly oldCreatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldCreatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_id field predicates */
  readonly oldID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_updated_by_id field predicates */
  readonly oldUpdatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldUpdatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly or?: InputMaybe<ReadonlyArray<KnowledgeDocumentWhereInput>>;
  /** source field predicates */
  readonly source?: InputMaybe<KnowledgeDocumentDocumentSourceType>;
  readonly sourceIn?: InputMaybe<ReadonlyArray<KnowledgeDocumentDocumentSourceType>>;
  readonly sourceNEQ?: InputMaybe<KnowledgeDocumentDocumentSourceType>;
  readonly sourceNotIn?: InputMaybe<ReadonlyArray<KnowledgeDocumentDocumentSourceType>>;
  /** type field predicates */
  readonly type?: InputMaybe<KnowledgeDocumentDocumentType>;
  readonly typeIn?: InputMaybe<ReadonlyArray<KnowledgeDocumentDocumentType>>;
  readonly typeNEQ?: InputMaybe<KnowledgeDocumentDocumentType>;
  readonly typeNotIn?: InputMaybe<ReadonlyArray<KnowledgeDocumentDocumentType>>;
  /** updated_at field predicates */
  readonly updatedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly updatedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** updated_by_uuid field predicates */
  readonly updatedByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly updatedByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** url field predicates */
  readonly url?: InputMaybe<Scalars['String']['input']>;
  readonly urlContains?: InputMaybe<Scalars['String']['input']>;
  readonly urlContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly urlEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly urlGT?: InputMaybe<Scalars['String']['input']>;
  readonly urlGTE?: InputMaybe<Scalars['String']['input']>;
  readonly urlHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly urlHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly urlIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly urlIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly urlLT?: InputMaybe<Scalars['String']['input']>;
  readonly urlLTE?: InputMaybe<Scalars['String']['input']>;
  readonly urlNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly urlNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly urlNotNil?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface Mutation {
  readonly createAPIKey: ApiKey;
  readonly createAdhocEmailSend: AdhocEmailSend;
  readonly createCRMDelivery: CrmDelivery;
  readonly createCRMSubscription: CrmSubscription;
  readonly createClassifier: Classifier;
  readonly createClassifierEnumValue: ClassifierEnumValue;
  readonly createClassifierExample: ClassifierExample;
  readonly createClassifierResult: ClassifierResult;
  readonly createCustomField: CustomField;
  readonly createCustomFieldEnumerationFieldLink: CustomFieldEnumerationFieldLink;
  readonly createCustomer: Customer;
  readonly createCustomerCRMConfig: CustomerCrmConfig;
  readonly createCustomerProspectingConfig: CustomerProspectingConfig;
  readonly createDirectory: Directory;
  readonly createDocument: Document;
  readonly createDocumentIngestionConfig: DocumentIngestionConfig;
  readonly createEmailDelivery: EmailDelivery;
  readonly createEmailSubscription: EmailSubscription;
  readonly createEmailSubscriptionConfig: EmailSubscriptionConfig;
  readonly createEmailSubscriptionConfigField: EmailSubscriptionConfigField;
  readonly createEmailSubscriptionLink: EmailSubscriptionLink;
  readonly createEnumerationConfigFieldLink: EnumerationConfigFieldLink;
  readonly createEnumerationConfigFieldLinks: ReadonlyArray<EnumerationConfigFieldLink>;
  readonly createEnumerationConfiguration: EnumerationConfiguration;
  readonly createEnumerationConfigurationClassifierEnum: EnumerationConfigurationClassifierEnum;
  readonly createEnumerationConfigurationDraft: EnumerationConfigurationDraft;
  readonly createEnumerationField: EnumerationField;
  readonly createEnumerationPromptConfig: EnumerationPromptConfig;
  readonly createEnumerationValue: EnumerationValue;
  readonly createEnumerationValueFeedback: EnumerationValueFeedback;
  readonly createEnumerationValueScore: EnumerationValueScore;
  readonly createFieldDependencyLink: FieldDependencyLink;
  readonly createFieldDependencyLinks: ReadonlyArray<FieldDependencyLink>;
  readonly createGongUser: GongUser;
  readonly createIntegrationSecret: IntegrationSecret;
  readonly createKnowledgeDocument: KnowledgeDocument;
  readonly createKnowledgeDocumentPromptInstruction: KnowledgeDocumentPromptInstruction;
  readonly createKnowledgeDocumentVersion: KnowledgeDocumentVersion;
  readonly createNewDraftFromConfigLink: EnumerationFieldDraft;
  readonly createNewDraftFromField: EnumerationFieldDraft;
  readonly createOpportunity: Opportunity;
  readonly createOpportunityStageChange: OpportunityStageChange;
  readonly createProspect: Prospect;
  readonly createProspectContact: ProspectContact;
  readonly createProspectExecutive: ProspectExecutive;
  readonly createReportingLink: ReportingLink;
  readonly createSlackDelivery: SlackDelivery;
  readonly createSlackSubscription: SlackSubscription;
  readonly createUser: User;
  readonly createUserGroup: UserGroup;
  readonly createUserGroupMembership: UserGroupMembership;
  readonly createUserProspectingConfig: UserProspectingConfig;
  readonly deleteCustomFieldEnumerationFieldLinks: ReadonlyArray<CustomFieldEnumerationFieldLink>;
  readonly deleteCustomFields: ReadonlyArray<CustomField>;
  readonly deployEnumerationFieldDraft: EnumerationFieldDraft;
  readonly updateAPIKey: ApiKey;
  readonly updateAdhocEmailSend: AdhocEmailSend;
  readonly updateCRMDelivery: CrmDelivery;
  readonly updateCRMSubscription: CrmSubscription;
  readonly updateClassifier: Classifier;
  readonly updateClassifierEnumValue: ClassifierEnumValue;
  readonly updateClassifierExample: ClassifierExample;
  readonly updateClassifierResult: ClassifierResult;
  readonly updateCustomField: CustomField;
  readonly updateCustomFieldEnumerationFieldLink: CustomFieldEnumerationFieldLink;
  readonly updateCustomer: Customer;
  readonly updateCustomerCRMConfig: CustomerCrmConfig;
  readonly updateCustomerProspectingConfig: CustomerProspectingConfig;
  readonly updateDirectory: Directory;
  readonly updateDocument: Document;
  readonly updateDocumentIngestionConfig: DocumentIngestionConfig;
  readonly updateEmailDelivery: EmailDelivery;
  readonly updateEmailSubscription: EmailSubscription;
  readonly updateEmailSubscriptionConfig: EmailSubscriptionConfig;
  readonly updateEmailSubscriptionConfigField: EmailSubscriptionConfigField;
  readonly updateEmailSubscriptionLink: EmailSubscriptionLink;
  readonly updateEnumerationConfigFieldLink: EnumerationConfigFieldLink;
  readonly updateEnumerationConfiguration: EnumerationConfiguration;
  readonly updateEnumerationConfigurationClassifierEnum: EnumerationConfigurationClassifierEnum;
  readonly updateEnumerationConfigurationDraft: EnumerationConfigurationDraft;
  readonly updateEnumerationField: EnumerationField;
  readonly updateEnumerationFieldDraft: EnumerationFieldDraft;
  readonly updateEnumerationPromptConfig: EnumerationPromptConfig;
  readonly updateEnumerationValue: EnumerationValue;
  readonly updateEnumerationValueFeedback: EnumerationValueFeedback;
  readonly updateEnumerationValueScore: EnumerationValueScore;
  readonly updateFieldDependencyLink: FieldDependencyLink;
  readonly updateGongUser: GongUser;
  readonly updateIntegrationSecret: IntegrationSecret;
  readonly updateKnowledgeDocument: KnowledgeDocument;
  readonly updateKnowledgeDocumentPromptInstruction: KnowledgeDocumentPromptInstruction;
  readonly updateKnowledgeDocumentVersion: KnowledgeDocumentVersion;
  readonly updateOpportunity: Opportunity;
  readonly updateOpportunityStageChange: OpportunityStageChange;
  readonly updateProspect: Prospect;
  readonly updateProspectContact: ProspectContact;
  readonly updateProspectExecutive: ProspectExecutive;
  readonly updateReportingLink: ReportingLink;
  readonly updateSlackDelivery: SlackDelivery;
  readonly updateSlackSubscription: SlackSubscription;
  readonly updateUser: User;
  readonly updateUserGroup: UserGroup;
  readonly updateUserGroupMembership: UserGroupMembership;
  readonly updateUserProspectingConfig: UserProspectingConfig;
}


export interface MutationCreateApiKeyArgs {
  input: CreateApiKeyInput;
}


export interface MutationCreateAdhocEmailSendArgs {
  input: CreateAdhocEmailSendInput;
}


export interface MutationCreateCrmDeliveryArgs {
  input: CreateCrmDeliveryInput;
}


export interface MutationCreateCrmSubscriptionArgs {
  input: CreateCrmSubscriptionInput;
}


export interface MutationCreateClassifierArgs {
  input: CreateClassifierInput;
}


export interface MutationCreateClassifierEnumValueArgs {
  input: CreateClassifierEnumValueInput;
}


export interface MutationCreateClassifierExampleArgs {
  input: CreateClassifierExampleInput;
}


export interface MutationCreateClassifierResultArgs {
  input: CreateClassifierResultInput;
}


export interface MutationCreateCustomFieldArgs {
  input: CreateCustomFieldInput;
}


export interface MutationCreateCustomFieldEnumerationFieldLinkArgs {
  input: CreateCustomFieldEnumerationFieldLinkInput;
}


export interface MutationCreateCustomerArgs {
  input: CreateCustomerInput;
}


export interface MutationCreateCustomerCrmConfigArgs {
  input: CreateCustomerCrmConfigInput;
}


export interface MutationCreateCustomerProspectingConfigArgs {
  input: CreateCustomerProspectingConfigInput;
}


export interface MutationCreateDirectoryArgs {
  input: CreateDirectoryInput;
}


export interface MutationCreateDocumentArgs {
  input: CreateDocumentInput;
}


export interface MutationCreateDocumentIngestionConfigArgs {
  input: CreateDocumentIngestionConfigInput;
}


export interface MutationCreateEmailDeliveryArgs {
  input: CreateEmailDeliveryInput;
}


export interface MutationCreateEmailSubscriptionArgs {
  input: CreateEmailSubscriptionInput;
}


export interface MutationCreateEmailSubscriptionConfigArgs {
  input: CreateEmailSubscriptionConfigInput;
}


export interface MutationCreateEmailSubscriptionConfigFieldArgs {
  input: CreateEmailSubscriptionConfigFieldInput;
}


export interface MutationCreateEmailSubscriptionLinkArgs {
  input: CreateEmailSubscriptionLinkInput;
}


export interface MutationCreateEnumerationConfigFieldLinkArgs {
  input: CreateEnumerationConfigFieldLinkInput;
}


export interface MutationCreateEnumerationConfigFieldLinksArgs {
  input: ReadonlyArray<CreateEnumerationConfigFieldLinkInput>;
}


export interface MutationCreateEnumerationConfigurationArgs {
  input: CreateEnumerationConfigurationInput;
}


export interface MutationCreateEnumerationConfigurationClassifierEnumArgs {
  input: CreateEnumerationConfigurationClassifierEnumInput;
}


export interface MutationCreateEnumerationConfigurationDraftArgs {
  input: CreateEnumerationConfigurationDraftInput;
}


export interface MutationCreateEnumerationFieldArgs {
  input: CreateEnumerationFieldInput;
}


export interface MutationCreateEnumerationPromptConfigArgs {
  input: CreateEnumerationPromptConfigInput;
}


export interface MutationCreateEnumerationValueArgs {
  input: CreateEnumerationValueInput;
}


export interface MutationCreateEnumerationValueFeedbackArgs {
  input: CreateEnumerationValueFeedbackInput;
}


export interface MutationCreateEnumerationValueScoreArgs {
  input: CreateEnumerationValueScoreInput;
}


export interface MutationCreateFieldDependencyLinkArgs {
  input: CreateFieldDependencyLinkInput;
}


export interface MutationCreateFieldDependencyLinksArgs {
  input: ReadonlyArray<CreateFieldDependencyLinkInput>;
}


export interface MutationCreateGongUserArgs {
  input: CreateGongUserInput;
}


export interface MutationCreateIntegrationSecretArgs {
  input: CreateIntegrationSecretInput;
}


export interface MutationCreateKnowledgeDocumentArgs {
  input: CreateKnowledgeDocumentInput;
}


export interface MutationCreateKnowledgeDocumentPromptInstructionArgs {
  input: CreateKnowledgeDocumentPromptInstructionInput;
}


export interface MutationCreateKnowledgeDocumentVersionArgs {
  input: CreateKnowledgeDocumentVersionInput;
}


export interface MutationCreateNewDraftFromConfigLinkArgs {
  configLinkID: Scalars['UUID']['input'];
}


export interface MutationCreateNewDraftFromFieldArgs {
  fieldID: Scalars['UUID']['input'];
}


export interface MutationCreateOpportunityArgs {
  input: CreateOpportunityInput;
}


export interface MutationCreateOpportunityStageChangeArgs {
  input: CreateOpportunityStageChangeInput;
}


export interface MutationCreateProspectArgs {
  input: CreateProspectInput;
}


export interface MutationCreateProspectContactArgs {
  input: CreateProspectContactInput;
}


export interface MutationCreateProspectExecutiveArgs {
  input: CreateProspectExecutiveInput;
}


export interface MutationCreateReportingLinkArgs {
  input: CreateReportingLinkInput;
}


export interface MutationCreateSlackDeliveryArgs {
  input: CreateSlackDeliveryInput;
}


export interface MutationCreateSlackSubscriptionArgs {
  input: CreateSlackSubscriptionInput;
}


export interface MutationCreateUserArgs {
  input: CreateUserInput;
}


export interface MutationCreateUserGroupArgs {
  input: CreateUserGroupInput;
}


export interface MutationCreateUserGroupMembershipArgs {
  input: CreateUserGroupMembershipInput;
}


export interface MutationCreateUserProspectingConfigArgs {
  input: CreateUserProspectingConfigInput;
}


export interface MutationDeleteCustomFieldEnumerationFieldLinksArgs {
  ids: ReadonlyArray<Scalars['UUID']['input']>;
}


export interface MutationDeleteCustomFieldsArgs {
  ids: ReadonlyArray<Scalars['UUID']['input']>;
}


export interface MutationDeployEnumerationFieldDraftArgs {
  id: Scalars['UUID']['input'];
}


export interface MutationUpdateApiKeyArgs {
  id: Scalars['UUID']['input'];
  input: UpdateApiKeyInput;
}


export interface MutationUpdateAdhocEmailSendArgs {
  id: Scalars['UUID']['input'];
  input: UpdateAdhocEmailSendInput;
}


export interface MutationUpdateCrmDeliveryArgs {
  id: Scalars['UUID']['input'];
  input: UpdateCrmDeliveryInput;
}


export interface MutationUpdateCrmSubscriptionArgs {
  id: Scalars['UUID']['input'];
  input: UpdateCrmSubscriptionInput;
}


export interface MutationUpdateClassifierArgs {
  id: Scalars['UUID']['input'];
  input: UpdateClassifierInput;
}


export interface MutationUpdateClassifierEnumValueArgs {
  id: Scalars['UUID']['input'];
  input: UpdateClassifierEnumValueInput;
}


export interface MutationUpdateClassifierExampleArgs {
  id: Scalars['UUID']['input'];
  input: UpdateClassifierExampleInput;
}


export interface MutationUpdateClassifierResultArgs {
  id: Scalars['UUID']['input'];
  input: UpdateClassifierResultInput;
}


export interface MutationUpdateCustomFieldArgs {
  id: Scalars['UUID']['input'];
  input: UpdateCustomFieldInput;
}


export interface MutationUpdateCustomFieldEnumerationFieldLinkArgs {
  id: Scalars['UUID']['input'];
  input: UpdateCustomFieldEnumerationFieldLinkInput;
}


export interface MutationUpdateCustomerArgs {
  id: Scalars['UUID']['input'];
  input: UpdateCustomerInput;
}


export interface MutationUpdateCustomerCrmConfigArgs {
  id: Scalars['UUID']['input'];
  input: UpdateCustomerCrmConfigInput;
}


export interface MutationUpdateCustomerProspectingConfigArgs {
  id: Scalars['UUID']['input'];
  input: UpdateCustomerProspectingConfigInput;
}


export interface MutationUpdateDirectoryArgs {
  id: Scalars['UUID']['input'];
  input: UpdateDirectoryInput;
}


export interface MutationUpdateDocumentArgs {
  id: Scalars['UUID']['input'];
  input: UpdateDocumentInput;
}


export interface MutationUpdateDocumentIngestionConfigArgs {
  id: Scalars['UUID']['input'];
  input: UpdateDocumentIngestionConfigInput;
}


export interface MutationUpdateEmailDeliveryArgs {
  id: Scalars['UUID']['input'];
  input: UpdateEmailDeliveryInput;
}


export interface MutationUpdateEmailSubscriptionArgs {
  id: Scalars['UUID']['input'];
  input: UpdateEmailSubscriptionInput;
}


export interface MutationUpdateEmailSubscriptionConfigArgs {
  id: Scalars['UUID']['input'];
  input: UpdateEmailSubscriptionConfigInput;
}


export interface MutationUpdateEmailSubscriptionConfigFieldArgs {
  id: Scalars['UUID']['input'];
  input: UpdateEmailSubscriptionConfigFieldInput;
}


export interface MutationUpdateEmailSubscriptionLinkArgs {
  id: Scalars['UUID']['input'];
  input: UpdateEmailSubscriptionLinkInput;
}


export interface MutationUpdateEnumerationConfigFieldLinkArgs {
  id: Scalars['UUID']['input'];
  input: UpdateEnumerationConfigFieldLinkInput;
}


export interface MutationUpdateEnumerationConfigurationArgs {
  id: Scalars['UUID']['input'];
  input: UpdateEnumerationConfigurationInput;
}


export interface MutationUpdateEnumerationConfigurationClassifierEnumArgs {
  id: Scalars['UUID']['input'];
  input: UpdateEnumerationConfigurationClassifierEnumInput;
}


export interface MutationUpdateEnumerationConfigurationDraftArgs {
  id: Scalars['UUID']['input'];
  input: UpdateEnumerationConfigurationDraftInput;
}


export interface MutationUpdateEnumerationFieldArgs {
  id: Scalars['UUID']['input'];
  input: UpdateEnumerationFieldInput;
}


export interface MutationUpdateEnumerationFieldDraftArgs {
  id: Scalars['UUID']['input'];
  input: UpdateEnumerationFieldDraftInput;
}


export interface MutationUpdateEnumerationPromptConfigArgs {
  id: Scalars['UUID']['input'];
  input: UpdateEnumerationPromptConfigInput;
}


export interface MutationUpdateEnumerationValueArgs {
  id: Scalars['UUID']['input'];
  input: UpdateEnumerationValueInput;
}


export interface MutationUpdateEnumerationValueFeedbackArgs {
  id: Scalars['UUID']['input'];
  input: UpdateEnumerationValueFeedbackInput;
}


export interface MutationUpdateEnumerationValueScoreArgs {
  id: Scalars['UUID']['input'];
  input: UpdateEnumerationValueScoreInput;
}


export interface MutationUpdateFieldDependencyLinkArgs {
  id: Scalars['UUID']['input'];
  input: UpdateFieldDependencyLinkInput;
}


export interface MutationUpdateGongUserArgs {
  id: Scalars['UUID']['input'];
  input: UpdateGongUserInput;
}


export interface MutationUpdateIntegrationSecretArgs {
  id: Scalars['UUID']['input'];
  input: UpdateIntegrationSecretInput;
}


export interface MutationUpdateKnowledgeDocumentArgs {
  id: Scalars['UUID']['input'];
  input: UpdateKnowledgeDocumentInput;
}


export interface MutationUpdateKnowledgeDocumentPromptInstructionArgs {
  id: Scalars['UUID']['input'];
  input: UpdateKnowledgeDocumentPromptInstructionInput;
}


export interface MutationUpdateKnowledgeDocumentVersionArgs {
  id: Scalars['UUID']['input'];
  input: UpdateKnowledgeDocumentVersionInput;
}


export interface MutationUpdateOpportunityArgs {
  id: Scalars['UUID']['input'];
  input: UpdateOpportunityInput;
}


export interface MutationUpdateOpportunityStageChangeArgs {
  id: Scalars['UUID']['input'];
  input: UpdateOpportunityStageChangeInput;
}


export interface MutationUpdateProspectArgs {
  id: Scalars['UUID']['input'];
  input: UpdateProspectInput;
}


export interface MutationUpdateProspectContactArgs {
  id: Scalars['UUID']['input'];
  input: UpdateProspectContactInput;
}


export interface MutationUpdateProspectExecutiveArgs {
  id: Scalars['UUID']['input'];
  input: UpdateProspectExecutiveInput;
}


export interface MutationUpdateReportingLinkArgs {
  id: Scalars['UUID']['input'];
  input: UpdateReportingLinkInput;
}


export interface MutationUpdateSlackDeliveryArgs {
  id: Scalars['UUID']['input'];
  input: UpdateSlackDeliveryInput;
}


export interface MutationUpdateSlackSubscriptionArgs {
  id: Scalars['UUID']['input'];
  input: UpdateSlackSubscriptionInput;
}


export interface MutationUpdateUserArgs {
  id: Scalars['UUID']['input'];
  input: UpdateUserInput;
}


export interface MutationUpdateUserGroupArgs {
  id: Scalars['UUID']['input'];
  input: UpdateUserGroupInput;
}


export interface MutationUpdateUserGroupMembershipArgs {
  id: Scalars['UUID']['input'];
  input: UpdateUserGroupMembershipInput;
}


export interface MutationUpdateUserProspectingConfigArgs {
  id: Scalars['UUID']['input'];
  input: UpdateUserProspectingConfigInput;
}

/**
 * An object with an ID.
 * Follows the [Relay Global Object Identification Specification](https://relay.dev/graphql/objectidentification.htm)
 */
export interface Node {
  /** The id of the object. */
  readonly id: Scalars['ID']['output'];
}

export interface Opportunity extends Node {
  readonly account?: Maybe<Account>;
  readonly accountUUID?: Maybe<Scalars['ID']['output']>;
  readonly amount: Scalars['Int']['output'];
  readonly calls?: Maybe<ReadonlyArray<Call>>;
  readonly closeDate: Scalars['Unix']['output'];
  readonly contact?: Maybe<Contact>;
  readonly contactUUID?: Maybe<Scalars['ID']['output']>;
  readonly createdAt: Scalars['Int']['output'];
  readonly createdByUUID: Scalars['ID']['output'];
  readonly customFieldValues: CustomFieldValueConnection;
  readonly disabled: Scalars['Boolean']['output'];
  readonly documentUUID?: Maybe<Scalars['ID']['output']>;
  readonly documents?: Maybe<ReadonlyArray<Document>>;
  readonly externalMappingUUID?: Maybe<Scalars['ID']['output']>;
  readonly externalOpportunityID: Scalars['OldID']['output'];
  readonly id: Scalars['ID']['output'];
  readonly link?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  /** NewlyIngested is true if the opportunity was just ingested by the call-enricher. */
  readonly newlyIngested: Scalars['Boolean']['output'];
  readonly oldCreatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly oldUpdatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly opportunityCallLinks?: Maybe<ReadonlyArray<OpportunityCallLink>>;
  readonly opportunityStageChanges?: Maybe<ReadonlyArray<OpportunityStageChange>>;
  readonly owner?: Maybe<GongUser>;
  readonly ownerUUID?: Maybe<Scalars['ID']['output']>;
  readonly pipelineStage?: Maybe<PipelineStage>;
  readonly pipelineStageUUID?: Maybe<Scalars['ID']['output']>;
  /** PlatformCreatedAt is the date when the opportunity was created in the CRM/end-user platform. */
  readonly platformCreatedAt?: Maybe<Scalars['Unix']['output']>;
  readonly sourcePlatform?: Maybe<CallIntegration>;
  /**
   * StageName represents the current state of the opportunity.
   * For the state at the time of the call see the OpportunityCallLink table.
   */
  readonly stageName: Scalars['String']['output'];
  readonly type: Scalars['String']['output'];
  readonly updatedAt: Scalars['Int']['output'];
  readonly updatedByUUID: Scalars['ID']['output'];
}


export interface OpportunityCustomFieldValuesArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CustomFieldValueOrder>;
  where?: InputMaybe<CustomFieldValueWhereInput>;
}

export interface OpportunityCallLink extends Node {
  readonly call: Call;
  readonly callUUID: Scalars['ID']['output'];
  readonly createdAt: Scalars['Int']['output'];
  readonly createdByUUID: Scalars['ID']['output'];
  readonly disabled: Scalars['Boolean']['output'];
  readonly id: Scalars['ID']['output'];
  readonly oldCreatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly oldUpdatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly opportunity: Opportunity;
  readonly opportunityStageChange?: Maybe<OpportunityStageChange>;
  readonly opportunityStageChangeUUID?: Maybe<Scalars['ID']['output']>;
  readonly opportunityUUID: Scalars['ID']['output'];
  /** Probability is the listed probability of the opportunity at the time of the call. */
  readonly probability: Scalars['Float']['output'];
  /**
   * StageName represents the state of the opportunity at the time of the call.
   * For the current state see the Opportunity table.
   */
  readonly stageName: Scalars['String']['output'];
  readonly updatedAt: Scalars['Int']['output'];
  readonly updatedByUUID: Scalars['ID']['output'];
}

/** A connection to a list of items. */
export interface OpportunityCallLinkConnection {
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<OpportunityCallLinkEdge>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface OpportunityCallLinkEdge {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<OpportunityCallLink>;
}

/** Ordering options for OpportunityCallLink connections */
export interface OpportunityCallLinkOrder {
  /** The ordering direction. */
  readonly direction?: OrderDirection;
  /** The field by which to order OpportunityCallLinks. */
  readonly field: OpportunityCallLinkOrderField;
}

/** Properties by which OpportunityCallLink connections can be ordered. */
export const OpportunityCallLinkOrderField = {
  CreatedAt: 'CREATED_AT',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type OpportunityCallLinkOrderField = typeof OpportunityCallLinkOrderField[keyof typeof OpportunityCallLinkOrderField];
/**
 * OpportunityCallLinkWhereInput is used for filtering OpportunityCallLink objects.
 * Input was generated by ent.
 */
export interface OpportunityCallLinkWhereInput {
  readonly and?: InputMaybe<ReadonlyArray<OpportunityCallLinkWhereInput>>;
  /** created_at field predicates */
  readonly createdAt?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly createdAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** disabled field predicates */
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** id field predicates */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly idGT?: InputMaybe<Scalars['ID']['input']>;
  readonly idGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly idLT?: InputMaybe<Scalars['ID']['input']>;
  readonly idLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly idNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly not?: InputMaybe<OpportunityCallLinkWhereInput>;
  /** old_created_by_id field predicates */
  readonly oldCreatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldCreatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_updated_by_id field predicates */
  readonly oldUpdatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldUpdatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly or?: InputMaybe<ReadonlyArray<OpportunityCallLinkWhereInput>>;
  /** probability field predicates */
  readonly probability?: InputMaybe<Scalars['Float']['input']>;
  readonly probabilityGT?: InputMaybe<Scalars['Float']['input']>;
  readonly probabilityGTE?: InputMaybe<Scalars['Float']['input']>;
  readonly probabilityIn?: InputMaybe<ReadonlyArray<Scalars['Float']['input']>>;
  readonly probabilityLT?: InputMaybe<Scalars['Float']['input']>;
  readonly probabilityLTE?: InputMaybe<Scalars['Float']['input']>;
  readonly probabilityNEQ?: InputMaybe<Scalars['Float']['input']>;
  readonly probabilityNotIn?: InputMaybe<ReadonlyArray<Scalars['Float']['input']>>;
  /** stage_name field predicates */
  readonly stageName?: InputMaybe<Scalars['String']['input']>;
  readonly stageNameContains?: InputMaybe<Scalars['String']['input']>;
  readonly stageNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly stageNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly stageNameGT?: InputMaybe<Scalars['String']['input']>;
  readonly stageNameGTE?: InputMaybe<Scalars['String']['input']>;
  readonly stageNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly stageNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly stageNameIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly stageNameLT?: InputMaybe<Scalars['String']['input']>;
  readonly stageNameLTE?: InputMaybe<Scalars['String']['input']>;
  readonly stageNameNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly stageNameNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** updated_at field predicates */
  readonly updatedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly updatedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
}

/** A connection to a list of items. */
export interface OpportunityConnection {
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<OpportunityEdge>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface OpportunityEdge {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<Opportunity>;
}

/** Ordering options for Opportunity connections */
export interface OpportunityOrder {
  /** The ordering direction. */
  readonly direction?: OrderDirection;
  /** The field by which to order Opportunities. */
  readonly field: OpportunityOrderField;
}

/** Properties by which Opportunity connections can be ordered. */
export const OpportunityOrderField = {
  CreatedAt: 'CREATED_AT',
  PlatformCreatedAt: 'PLATFORM_CREATED_AT',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type OpportunityOrderField = typeof OpportunityOrderField[keyof typeof OpportunityOrderField];
export interface OpportunityStageChange extends Node {
  readonly createdAt: Scalars['Int']['output'];
  readonly createdByUUID: Scalars['ID']['output'];
  readonly disabled: Scalars['Boolean']['output'];
  readonly enteredDate: Scalars['Unix']['output'];
  readonly enumerationValues: EnumerationValueConnection;
  readonly id: Scalars['ID']['output'];
  readonly oldCreatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly oldID?: Maybe<Scalars['OldID']['output']>;
  readonly oldUpdatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly opportunity: Opportunity;
  readonly opportunityCallLink?: Maybe<ReadonlyArray<OpportunityCallLink>>;
  readonly opportunityUUID: Scalars['ID']['output'];
  readonly pipelineStage?: Maybe<PipelineStage>;
  readonly pipelineStageUUID?: Maybe<Scalars['ID']['output']>;
  readonly stageName: Scalars['String']['output'];
  readonly updatedAt: Scalars['Int']['output'];
  readonly updatedByUUID: Scalars['ID']['output'];
}


export interface OpportunityStageChangeEnumerationValuesArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EnumerationValueOrder>;
  where?: InputMaybe<EnumerationValueWhereInput>;
}

/** A connection to a list of items. */
export interface OpportunityStageChangeConnection {
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<OpportunityStageChangeEdge>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface OpportunityStageChangeEdge {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<OpportunityStageChange>;
}

/** Ordering options for OpportunityStageChange connections */
export interface OpportunityStageChangeOrder {
  /** The ordering direction. */
  readonly direction?: OrderDirection;
  /** The field by which to order OpportunityStageChanges. */
  readonly field: OpportunityStageChangeOrderField;
}

/** Properties by which OpportunityStageChange connections can be ordered. */
export const OpportunityStageChangeOrderField = {
  CreatedAt: 'CREATED_AT',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type OpportunityStageChangeOrderField = typeof OpportunityStageChangeOrderField[keyof typeof OpportunityStageChangeOrderField];
/**
 * OpportunityStageChangeWhereInput is used for filtering OpportunityStageChange objects.
 * Input was generated by ent.
 */
export interface OpportunityStageChangeWhereInput {
  readonly and?: InputMaybe<ReadonlyArray<OpportunityStageChangeWhereInput>>;
  /** created_at field predicates */
  readonly createdAt?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly createdAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** created_by_uuid field predicates */
  readonly createdByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly createdByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** disabled field predicates */
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** entered_date field predicates */
  readonly enteredDate?: InputMaybe<Scalars['Unix']['input']>;
  readonly enteredDateGT?: InputMaybe<Scalars['Unix']['input']>;
  readonly enteredDateGTE?: InputMaybe<Scalars['Unix']['input']>;
  readonly enteredDateIn?: InputMaybe<ReadonlyArray<Scalars['Unix']['input']>>;
  readonly enteredDateLT?: InputMaybe<Scalars['Unix']['input']>;
  readonly enteredDateLTE?: InputMaybe<Scalars['Unix']['input']>;
  readonly enteredDateNEQ?: InputMaybe<Scalars['Unix']['input']>;
  readonly enteredDateNotIn?: InputMaybe<ReadonlyArray<Scalars['Unix']['input']>>;
  /** enumeration_values edge predicates */
  readonly hasEnumerationValues?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasEnumerationValuesWith?: InputMaybe<ReadonlyArray<EnumerationValueWhereInput>>;
  /** opportunity edge predicates */
  readonly hasOpportunity?: InputMaybe<Scalars['Boolean']['input']>;
  /** opportunity_call_link edge predicates */
  readonly hasOpportunityCallLink?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasOpportunityCallLinkWith?: InputMaybe<ReadonlyArray<OpportunityCallLinkWhereInput>>;
  readonly hasOpportunityWith?: InputMaybe<ReadonlyArray<OpportunityWhereInput>>;
  /** pipeline_stage edge predicates */
  readonly hasPipelineStage?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasPipelineStageWith?: InputMaybe<ReadonlyArray<PipelineStageWhereInput>>;
  /** id field predicates */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly idGT?: InputMaybe<Scalars['ID']['input']>;
  readonly idGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly idLT?: InputMaybe<Scalars['ID']['input']>;
  readonly idLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly idNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly not?: InputMaybe<OpportunityStageChangeWhereInput>;
  /** old_created_by_id field predicates */
  readonly oldCreatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldCreatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_id field predicates */
  readonly oldID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_updated_by_id field predicates */
  readonly oldUpdatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldUpdatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** opportunity_uuid field predicates */
  readonly opportunityUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly opportunityUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly opportunityUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly opportunityUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly or?: InputMaybe<ReadonlyArray<OpportunityStageChangeWhereInput>>;
  /** pipeline_stage_uuid field predicates */
  readonly pipelineStageUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly pipelineStageUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly pipelineStageUUIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly pipelineStageUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly pipelineStageUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly pipelineStageUUIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** stage_name field predicates */
  readonly stageName?: InputMaybe<Scalars['String']['input']>;
  readonly stageNameContains?: InputMaybe<Scalars['String']['input']>;
  readonly stageNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly stageNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly stageNameGT?: InputMaybe<Scalars['String']['input']>;
  readonly stageNameGTE?: InputMaybe<Scalars['String']['input']>;
  readonly stageNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly stageNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly stageNameIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly stageNameLT?: InputMaybe<Scalars['String']['input']>;
  readonly stageNameLTE?: InputMaybe<Scalars['String']['input']>;
  readonly stageNameNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly stageNameNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** updated_at field predicates */
  readonly updatedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly updatedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** updated_by_uuid field predicates */
  readonly updatedByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly updatedByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
}

/**
 * OpportunityWhereInput is used for filtering Opportunity objects.
 * Input was generated by ent.
 */
export interface OpportunityWhereInput {
  /** account_uuid field predicates */
  readonly accountUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly accountUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly accountUUIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly accountUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly accountUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly accountUUIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** amount field predicates */
  readonly amount?: InputMaybe<Scalars['Int']['input']>;
  readonly amountGT?: InputMaybe<Scalars['Int']['input']>;
  readonly amountGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly amountIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly amountLT?: InputMaybe<Scalars['Int']['input']>;
  readonly amountLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly amountNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly amountNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly and?: InputMaybe<ReadonlyArray<OpportunityWhereInput>>;
  /** close_date field predicates */
  readonly closeDate?: InputMaybe<Scalars['Unix']['input']>;
  readonly closeDateGT?: InputMaybe<Scalars['Unix']['input']>;
  readonly closeDateGTE?: InputMaybe<Scalars['Unix']['input']>;
  readonly closeDateIn?: InputMaybe<ReadonlyArray<Scalars['Unix']['input']>>;
  readonly closeDateLT?: InputMaybe<Scalars['Unix']['input']>;
  readonly closeDateLTE?: InputMaybe<Scalars['Unix']['input']>;
  readonly closeDateNEQ?: InputMaybe<Scalars['Unix']['input']>;
  readonly closeDateNotIn?: InputMaybe<ReadonlyArray<Scalars['Unix']['input']>>;
  /** contact_uuid field predicates */
  readonly contactUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly contactUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly contactUUIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly contactUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly contactUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly contactUUIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  readonly createdAt?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly createdAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** created_by_uuid field predicates */
  readonly createdByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly createdByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** disabled field predicates */
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** document_uuid field predicates */
  readonly documentUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly documentUUIDGT?: InputMaybe<Scalars['ID']['input']>;
  readonly documentUUIDGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly documentUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly documentUUIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly documentUUIDLT?: InputMaybe<Scalars['ID']['input']>;
  readonly documentUUIDLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly documentUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly documentUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly documentUUIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** external_mapping_uuid field predicates */
  readonly externalMappingUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly externalMappingUUIDGT?: InputMaybe<Scalars['ID']['input']>;
  readonly externalMappingUUIDGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly externalMappingUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly externalMappingUUIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly externalMappingUUIDLT?: InputMaybe<Scalars['ID']['input']>;
  readonly externalMappingUUIDLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly externalMappingUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly externalMappingUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly externalMappingUUIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** external_opportunity_id field predicates */
  readonly externalOpportunityID?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalOpportunityIDContains?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalOpportunityIDContainsFold?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalOpportunityIDEqualFold?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalOpportunityIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalOpportunityIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalOpportunityIDHasPrefix?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalOpportunityIDHasSuffix?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalOpportunityIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly externalOpportunityIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalOpportunityIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalOpportunityIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalOpportunityIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  /** account edge predicates */
  readonly hasAccount?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasAccountWith?: InputMaybe<ReadonlyArray<AccountWhereInput>>;
  /** calls edge predicates */
  readonly hasCalls?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasCallsWith?: InputMaybe<ReadonlyArray<CallWhereInput>>;
  /** contact edge predicates */
  readonly hasContact?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasContactWith?: InputMaybe<ReadonlyArray<ContactWhereInput>>;
  /** custom_field_values edge predicates */
  readonly hasCustomFieldValues?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasCustomFieldValuesWith?: InputMaybe<ReadonlyArray<CustomFieldValueWhereInput>>;
  /** documents edge predicates */
  readonly hasDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasDocumentsWith?: InputMaybe<ReadonlyArray<DocumentWhereInput>>;
  /** opportunity_call_links edge predicates */
  readonly hasOpportunityCallLinks?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasOpportunityCallLinksWith?: InputMaybe<ReadonlyArray<OpportunityCallLinkWhereInput>>;
  /** opportunity_stage_changes edge predicates */
  readonly hasOpportunityStageChanges?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasOpportunityStageChangesWith?: InputMaybe<ReadonlyArray<OpportunityStageChangeWhereInput>>;
  /** owner edge predicates */
  readonly hasOwner?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasOwnerWith?: InputMaybe<ReadonlyArray<GongUserWhereInput>>;
  /** pipeline_stage edge predicates */
  readonly hasPipelineStage?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasPipelineStageWith?: InputMaybe<ReadonlyArray<PipelineStageWhereInput>>;
  /** id field predicates */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly idGT?: InputMaybe<Scalars['ID']['input']>;
  readonly idGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly idLT?: InputMaybe<Scalars['ID']['input']>;
  readonly idLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly idNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** link field predicates */
  readonly link?: InputMaybe<Scalars['String']['input']>;
  readonly linkContains?: InputMaybe<Scalars['String']['input']>;
  readonly linkContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly linkEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly linkGT?: InputMaybe<Scalars['String']['input']>;
  readonly linkGTE?: InputMaybe<Scalars['String']['input']>;
  readonly linkHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly linkHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly linkIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly linkIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly linkLT?: InputMaybe<Scalars['String']['input']>;
  readonly linkLTE?: InputMaybe<Scalars['String']['input']>;
  readonly linkNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly linkNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly linkNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** name field predicates */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly nameContains?: InputMaybe<Scalars['String']['input']>;
  readonly nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly nameGT?: InputMaybe<Scalars['String']['input']>;
  readonly nameGTE?: InputMaybe<Scalars['String']['input']>;
  readonly nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly nameIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly nameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly nameLT?: InputMaybe<Scalars['String']['input']>;
  readonly nameLTE?: InputMaybe<Scalars['String']['input']>;
  readonly nameNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly nameNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly nameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** newly_ingested field predicates */
  readonly newlyIngested?: InputMaybe<Scalars['Boolean']['input']>;
  readonly newlyIngestedNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  readonly not?: InputMaybe<OpportunityWhereInput>;
  /** old_created_by_id field predicates */
  readonly oldCreatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldCreatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_updated_by_id field predicates */
  readonly oldUpdatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldUpdatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly or?: InputMaybe<ReadonlyArray<OpportunityWhereInput>>;
  /** owner_uuid field predicates */
  readonly ownerUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly ownerUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly ownerUUIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly ownerUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly ownerUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly ownerUUIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** pipeline_stage_uuid field predicates */
  readonly pipelineStageUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly pipelineStageUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly pipelineStageUUIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly pipelineStageUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly pipelineStageUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly pipelineStageUUIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** platform_created_at field predicates */
  readonly platformCreatedAt?: InputMaybe<Scalars['Unix']['input']>;
  readonly platformCreatedAtGT?: InputMaybe<Scalars['Unix']['input']>;
  readonly platformCreatedAtGTE?: InputMaybe<Scalars['Unix']['input']>;
  readonly platformCreatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Unix']['input']>>;
  readonly platformCreatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly platformCreatedAtLT?: InputMaybe<Scalars['Unix']['input']>;
  readonly platformCreatedAtLTE?: InputMaybe<Scalars['Unix']['input']>;
  readonly platformCreatedAtNEQ?: InputMaybe<Scalars['Unix']['input']>;
  readonly platformCreatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Unix']['input']>>;
  readonly platformCreatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** source_platform field predicates */
  readonly sourcePlatform?: InputMaybe<CallIntegration>;
  readonly sourcePlatformIn?: InputMaybe<ReadonlyArray<CallIntegration>>;
  readonly sourcePlatformIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly sourcePlatformNEQ?: InputMaybe<CallIntegration>;
  readonly sourcePlatformNotIn?: InputMaybe<ReadonlyArray<CallIntegration>>;
  readonly sourcePlatformNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** stage_name field predicates */
  readonly stageName?: InputMaybe<Scalars['String']['input']>;
  readonly stageNameContains?: InputMaybe<Scalars['String']['input']>;
  readonly stageNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly stageNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly stageNameGT?: InputMaybe<Scalars['String']['input']>;
  readonly stageNameGTE?: InputMaybe<Scalars['String']['input']>;
  readonly stageNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly stageNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly stageNameIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly stageNameLT?: InputMaybe<Scalars['String']['input']>;
  readonly stageNameLTE?: InputMaybe<Scalars['String']['input']>;
  readonly stageNameNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly stageNameNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** type field predicates */
  readonly type?: InputMaybe<Scalars['String']['input']>;
  readonly typeContains?: InputMaybe<Scalars['String']['input']>;
  readonly typeContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly typeEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly typeGT?: InputMaybe<Scalars['String']['input']>;
  readonly typeGTE?: InputMaybe<Scalars['String']['input']>;
  readonly typeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly typeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly typeIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly typeLT?: InputMaybe<Scalars['String']['input']>;
  readonly typeLTE?: InputMaybe<Scalars['String']['input']>;
  readonly typeNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly typeNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** updated_at field predicates */
  readonly updatedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly updatedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** updated_by_uuid field predicates */
  readonly updatedByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly updatedByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
}

/** Possible directions in which to order a list of items when provided an `orderBy` argument. */
export const OrderDirection = {
  /** Specifies an ascending order for a given `orderBy` argument. */
  Asc: 'ASC',
  /** Specifies a descending order for a given `orderBy` argument. */
  Desc: 'DESC'
} as const;

export type OrderDirection = typeof OrderDirection[keyof typeof OrderDirection];
/**
 * Information about pagination in a connection.
 * https://relay.dev/graphql/connections.htm#sec-undefined.PageInfo
 */
export interface PageInfo {
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['Cursor']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['Cursor']['output']>;
}

export interface Pipeline extends Node {
  readonly createdAt: Scalars['Int']['output'];
  readonly createdByUUID: Scalars['ID']['output'];
  readonly disabled: Scalars['Boolean']['output'];
  /** ExternalPlatformID is the ID of the Pipeline in the CRM. */
  readonly externalPlatformID: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
  readonly oldCreatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly oldUpdatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly sourcePlatform: PipelineCallIntegration;
  readonly stages?: Maybe<ReadonlyArray<PipelineStage>>;
  readonly updatedAt: Scalars['Int']['output'];
  readonly updatedByUUID: Scalars['ID']['output'];
}

/** PipelineCallIntegration is enum for the field source_platform */
export const PipelineCallIntegration = {
  Apollo: 'APOLLO',
  Freshcaller: 'FRESHCALLER',
  Freshdesk: 'FRESHDESK',
  Gmail: 'GMAIL',
  Gohighlevel: 'GOHIGHLEVEL',
  Gong: 'GONG',
  GongOauth: 'GONG_OAUTH',
  GoogleCalendar: 'GOOGLE_CALENDAR',
  GoogleMeet: 'GOOGLE_MEET',
  Hubspot: 'HUBSPOT',
  Justcall: 'JUSTCALL',
  Outreach: 'OUTREACH',
  Pipedrive: 'PIPEDRIVE',
  ProductBoard: 'PRODUCT_BOARD',
  Salesloft: 'SALESLOFT',
  Sfdc: 'SFDC',
  Slack: 'SLACK',
  UnknownIntegration: 'UNKNOWN_INTEGRATION',
  Volie: 'VOLIE',
  Wingman: 'WINGMAN',
  Zoho: 'ZOHO',
  Zoom: 'ZOOM'
} as const;

export type PipelineCallIntegration = typeof PipelineCallIntegration[keyof typeof PipelineCallIntegration];
/** A connection to a list of items. */
export interface PipelineConnection {
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<PipelineEdge>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface PipelineEdge {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<Pipeline>;
}

/** Ordering options for Pipeline connections */
export interface PipelineOrder {
  /** The ordering direction. */
  readonly direction?: OrderDirection;
  /** The field by which to order Pipelines. */
  readonly field: PipelineOrderField;
}

/** Properties by which Pipeline connections can be ordered. */
export const PipelineOrderField = {
  CreatedAt: 'CREATED_AT',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type PipelineOrderField = typeof PipelineOrderField[keyof typeof PipelineOrderField];
export interface PipelineStage extends Node {
  readonly createdAt: Scalars['Int']['output'];
  readonly createdByUUID: Scalars['ID']['output'];
  readonly disabled: Scalars['Boolean']['output'];
  readonly enumerationConfigStageLinks?: Maybe<ReadonlyArray<EnumerationConfigStageLink>>;
  readonly enumerationConfigurations?: Maybe<ReadonlyArray<EnumerationConfiguration>>;
  /** ExternalPlatformID is the ID of the PipelineStage in the CRM. */
  readonly externalPlatformID: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
  readonly oldCreatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly oldUpdatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly opportunities?: Maybe<ReadonlyArray<Opportunity>>;
  readonly order: Scalars['Int']['output'];
  readonly outcome?: Maybe<PipelineStageOutcome>;
  readonly pipeline: Pipeline;
  readonly pipelineUUID: Scalars['ID']['output'];
  readonly stageChanges?: Maybe<ReadonlyArray<OpportunityStageChange>>;
  readonly updatedAt: Scalars['Int']['output'];
  readonly updatedByUUID: Scalars['ID']['output'];
}

/** A connection to a list of items. */
export interface PipelineStageConnection {
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<PipelineStageEdge>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface PipelineStageEdge {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<PipelineStage>;
}

/** Ordering options for PipelineStage connections */
export interface PipelineStageOrder {
  /** The ordering direction. */
  readonly direction?: OrderDirection;
  /** The field by which to order PipelineStages. */
  readonly field: PipelineStageOrderField;
}

/** Properties by which PipelineStage connections can be ordered. */
export const PipelineStageOrderField = {
  CreatedAt: 'CREATED_AT',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type PipelineStageOrderField = typeof PipelineStageOrderField[keyof typeof PipelineStageOrderField];
/** PipelineStageOutcome is enum for the field outcome */
export const PipelineStageOutcome = {
  Lost: 'LOST',
  Open: 'OPEN',
  Won: 'WON'
} as const;

export type PipelineStageOutcome = typeof PipelineStageOutcome[keyof typeof PipelineStageOutcome];
/**
 * PipelineStageWhereInput is used for filtering PipelineStage objects.
 * Input was generated by ent.
 */
export interface PipelineStageWhereInput {
  readonly and?: InputMaybe<ReadonlyArray<PipelineStageWhereInput>>;
  /** created_at field predicates */
  readonly createdAt?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly createdAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** created_by_uuid field predicates */
  readonly createdByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly createdByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** disabled field predicates */
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** external_platform_id field predicates */
  readonly externalPlatformID?: InputMaybe<Scalars['String']['input']>;
  readonly externalPlatformIDContains?: InputMaybe<Scalars['String']['input']>;
  readonly externalPlatformIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly externalPlatformIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly externalPlatformIDGT?: InputMaybe<Scalars['String']['input']>;
  readonly externalPlatformIDGTE?: InputMaybe<Scalars['String']['input']>;
  readonly externalPlatformIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly externalPlatformIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly externalPlatformIDIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly externalPlatformIDLT?: InputMaybe<Scalars['String']['input']>;
  readonly externalPlatformIDLTE?: InputMaybe<Scalars['String']['input']>;
  readonly externalPlatformIDNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly externalPlatformIDNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** enumeration_config_stage_links edge predicates */
  readonly hasEnumerationConfigStageLinks?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasEnumerationConfigStageLinksWith?: InputMaybe<ReadonlyArray<EnumerationConfigStageLinkWhereInput>>;
  /** enumeration_configurations edge predicates */
  readonly hasEnumerationConfigurations?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasEnumerationConfigurationsWith?: InputMaybe<ReadonlyArray<EnumerationConfigurationWhereInput>>;
  /** opportunities edge predicates */
  readonly hasOpportunities?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasOpportunitiesWith?: InputMaybe<ReadonlyArray<OpportunityWhereInput>>;
  /** pipeline edge predicates */
  readonly hasPipeline?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasPipelineWith?: InputMaybe<ReadonlyArray<PipelineWhereInput>>;
  /** stage_changes edge predicates */
  readonly hasStageChanges?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasStageChangesWith?: InputMaybe<ReadonlyArray<OpportunityStageChangeWhereInput>>;
  /** id field predicates */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly idGT?: InputMaybe<Scalars['ID']['input']>;
  readonly idGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly idLT?: InputMaybe<Scalars['ID']['input']>;
  readonly idLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly idNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** name field predicates */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly nameContains?: InputMaybe<Scalars['String']['input']>;
  readonly nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly nameGT?: InputMaybe<Scalars['String']['input']>;
  readonly nameGTE?: InputMaybe<Scalars['String']['input']>;
  readonly nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly nameIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly nameLT?: InputMaybe<Scalars['String']['input']>;
  readonly nameLTE?: InputMaybe<Scalars['String']['input']>;
  readonly nameNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly nameNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly not?: InputMaybe<PipelineStageWhereInput>;
  /** old_created_by_id field predicates */
  readonly oldCreatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldCreatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_updated_by_id field predicates */
  readonly oldUpdatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldUpdatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly or?: InputMaybe<ReadonlyArray<PipelineStageWhereInput>>;
  /** order field predicates */
  readonly order?: InputMaybe<Scalars['Int']['input']>;
  readonly orderGT?: InputMaybe<Scalars['Int']['input']>;
  readonly orderGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly orderIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly orderLT?: InputMaybe<Scalars['Int']['input']>;
  readonly orderLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly orderNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly orderNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** outcome field predicates */
  readonly outcome?: InputMaybe<PipelineStageOutcome>;
  readonly outcomeIn?: InputMaybe<ReadonlyArray<PipelineStageOutcome>>;
  readonly outcomeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly outcomeNEQ?: InputMaybe<PipelineStageOutcome>;
  readonly outcomeNotIn?: InputMaybe<ReadonlyArray<PipelineStageOutcome>>;
  readonly outcomeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** pipeline_uuid field predicates */
  readonly pipelineUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly pipelineUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly pipelineUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly pipelineUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  readonly updatedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly updatedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** updated_by_uuid field predicates */
  readonly updatedByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly updatedByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
}

/**
 * PipelineWhereInput is used for filtering Pipeline objects.
 * Input was generated by ent.
 */
export interface PipelineWhereInput {
  readonly and?: InputMaybe<ReadonlyArray<PipelineWhereInput>>;
  /** created_at field predicates */
  readonly createdAt?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly createdAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** created_by_uuid field predicates */
  readonly createdByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly createdByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** disabled field predicates */
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** external_platform_id field predicates */
  readonly externalPlatformID?: InputMaybe<Scalars['String']['input']>;
  readonly externalPlatformIDContains?: InputMaybe<Scalars['String']['input']>;
  readonly externalPlatformIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly externalPlatformIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly externalPlatformIDGT?: InputMaybe<Scalars['String']['input']>;
  readonly externalPlatformIDGTE?: InputMaybe<Scalars['String']['input']>;
  readonly externalPlatformIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly externalPlatformIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly externalPlatformIDIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly externalPlatformIDLT?: InputMaybe<Scalars['String']['input']>;
  readonly externalPlatformIDLTE?: InputMaybe<Scalars['String']['input']>;
  readonly externalPlatformIDNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly externalPlatformIDNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** stages edge predicates */
  readonly hasStages?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasStagesWith?: InputMaybe<ReadonlyArray<PipelineStageWhereInput>>;
  /** id field predicates */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly idGT?: InputMaybe<Scalars['ID']['input']>;
  readonly idGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly idLT?: InputMaybe<Scalars['ID']['input']>;
  readonly idLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly idNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** name field predicates */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly nameContains?: InputMaybe<Scalars['String']['input']>;
  readonly nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly nameGT?: InputMaybe<Scalars['String']['input']>;
  readonly nameGTE?: InputMaybe<Scalars['String']['input']>;
  readonly nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly nameIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly nameLT?: InputMaybe<Scalars['String']['input']>;
  readonly nameLTE?: InputMaybe<Scalars['String']['input']>;
  readonly nameNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly nameNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly not?: InputMaybe<PipelineWhereInput>;
  /** old_created_by_id field predicates */
  readonly oldCreatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldCreatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_updated_by_id field predicates */
  readonly oldUpdatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldUpdatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly or?: InputMaybe<ReadonlyArray<PipelineWhereInput>>;
  /** source_platform field predicates */
  readonly sourcePlatform?: InputMaybe<PipelineCallIntegration>;
  readonly sourcePlatformIn?: InputMaybe<ReadonlyArray<PipelineCallIntegration>>;
  readonly sourcePlatformNEQ?: InputMaybe<PipelineCallIntegration>;
  readonly sourcePlatformNotIn?: InputMaybe<ReadonlyArray<PipelineCallIntegration>>;
  /** updated_at field predicates */
  readonly updatedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly updatedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** updated_by_uuid field predicates */
  readonly updatedByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly updatedByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
}

export interface Prospect extends Node {
  readonly createdAt: Scalars['Int']['output'];
  readonly createdByUUID: Scalars['ID']['output'];
  readonly disabled: Scalars['Boolean']['output'];
  readonly domain: Scalars['String']['output'];
  readonly engagementPlatform?: Maybe<ProspectCallIntegration>;
  readonly externalProspectID?: Maybe<Scalars['OldID']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
  readonly oldCreatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly oldID?: Maybe<Scalars['Int']['output']>;
  readonly oldUpdatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly prospectContacts?: Maybe<ReadonlyArray<ProspectContact>>;
  readonly prospectExecutives?: Maybe<ReadonlyArray<ProspectExecutive>>;
  readonly status: ProspectProcessingStatus;
  readonly stockTicker?: Maybe<Scalars['String']['output']>;
  readonly updatedAt: Scalars['Int']['output'];
  readonly updatedByUUID: Scalars['ID']['output'];
}

/** ProspectCallIntegration is enum for the field engagement_platform */
export const ProspectCallIntegration = {
  Apollo: 'APOLLO',
  Freshcaller: 'FRESHCALLER',
  Freshdesk: 'FRESHDESK',
  Gmail: 'GMAIL',
  Gohighlevel: 'GOHIGHLEVEL',
  Gong: 'GONG',
  GongOauth: 'GONG_OAUTH',
  GoogleCalendar: 'GOOGLE_CALENDAR',
  GoogleMeet: 'GOOGLE_MEET',
  Hubspot: 'HUBSPOT',
  Justcall: 'JUSTCALL',
  Outreach: 'OUTREACH',
  Pipedrive: 'PIPEDRIVE',
  ProductBoard: 'PRODUCT_BOARD',
  Salesloft: 'SALESLOFT',
  Sfdc: 'SFDC',
  Slack: 'SLACK',
  UnknownIntegration: 'UNKNOWN_INTEGRATION',
  Volie: 'VOLIE',
  Wingman: 'WINGMAN',
  Zoho: 'ZOHO',
  Zoom: 'ZOOM'
} as const;

export type ProspectCallIntegration = typeof ProspectCallIntegration[keyof typeof ProspectCallIntegration];
/** A connection to a list of items. */
export interface ProspectConnection {
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<ProspectEdge>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
}

export interface ProspectContact extends Node {
  readonly contacted: Scalars['Boolean']['output'];
  readonly createdAt: Scalars['Int']['output'];
  readonly createdByUUID: Scalars['ID']['output'];
  readonly disabled: Scalars['Boolean']['output'];
  readonly engagementPlatform?: Maybe<ProspectContactCallIntegration>;
  readonly externalContactID?: Maybe<Scalars['OldID']['output']>;
  readonly externalSequenceID?: Maybe<Scalars['OldID']['output']>;
  readonly externalSequenceMembershipID?: Maybe<Scalars['OldID']['output']>;
  readonly firstName: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly lastName: Scalars['String']['output'];
  readonly oldCreatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly oldID?: Maybe<Scalars['Int']['output']>;
  readonly oldUpdatedByID?: Maybe<Scalars['OldID']['output']>;
  /** Processed is true when the ProspectContact has been analyzed by us. */
  readonly processed: Scalars['Boolean']['output'];
  readonly prospect: Prospect;
  readonly prospectUUID: Scalars['ID']['output'];
  readonly title: Scalars['String']['output'];
  readonly updatedAt: Scalars['Int']['output'];
  readonly updatedByUUID: Scalars['ID']['output'];
}

/** ProspectContactCallIntegration is enum for the field engagement_platform */
export const ProspectContactCallIntegration = {
  Apollo: 'APOLLO',
  Freshcaller: 'FRESHCALLER',
  Freshdesk: 'FRESHDESK',
  Gmail: 'GMAIL',
  Gohighlevel: 'GOHIGHLEVEL',
  Gong: 'GONG',
  GongOauth: 'GONG_OAUTH',
  GoogleCalendar: 'GOOGLE_CALENDAR',
  GoogleMeet: 'GOOGLE_MEET',
  Hubspot: 'HUBSPOT',
  Justcall: 'JUSTCALL',
  Outreach: 'OUTREACH',
  Pipedrive: 'PIPEDRIVE',
  ProductBoard: 'PRODUCT_BOARD',
  Salesloft: 'SALESLOFT',
  Sfdc: 'SFDC',
  Slack: 'SLACK',
  UnknownIntegration: 'UNKNOWN_INTEGRATION',
  Volie: 'VOLIE',
  Wingman: 'WINGMAN',
  Zoho: 'ZOHO',
  Zoom: 'ZOOM'
} as const;

export type ProspectContactCallIntegration = typeof ProspectContactCallIntegration[keyof typeof ProspectContactCallIntegration];
/** A connection to a list of items. */
export interface ProspectContactConnection {
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<ProspectContactEdge>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface ProspectContactEdge {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<ProspectContact>;
}

/** Ordering options for ProspectContact connections */
export interface ProspectContactOrder {
  /** The ordering direction. */
  readonly direction?: OrderDirection;
  /** The field by which to order ProspectContacts. */
  readonly field: ProspectContactOrderField;
}

/** Properties by which ProspectContact connections can be ordered. */
export const ProspectContactOrderField = {
  CreatedAt: 'CREATED_AT',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type ProspectContactOrderField = typeof ProspectContactOrderField[keyof typeof ProspectContactOrderField];
/**
 * ProspectContactWhereInput is used for filtering ProspectContact objects.
 * Input was generated by ent.
 */
export interface ProspectContactWhereInput {
  readonly and?: InputMaybe<ReadonlyArray<ProspectContactWhereInput>>;
  /** contacted field predicates */
  readonly contacted?: InputMaybe<Scalars['Boolean']['input']>;
  readonly contactedNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  readonly createdAt?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly createdAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** created_by_uuid field predicates */
  readonly createdByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly createdByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** disabled field predicates */
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** engagement_platform field predicates */
  readonly engagementPlatform?: InputMaybe<ProspectContactCallIntegration>;
  readonly engagementPlatformIn?: InputMaybe<ReadonlyArray<ProspectContactCallIntegration>>;
  readonly engagementPlatformIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly engagementPlatformNEQ?: InputMaybe<ProspectContactCallIntegration>;
  readonly engagementPlatformNotIn?: InputMaybe<ReadonlyArray<ProspectContactCallIntegration>>;
  readonly engagementPlatformNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** external_contact_id field predicates */
  readonly externalContactID?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalContactIDContains?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalContactIDContainsFold?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalContactIDEqualFold?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalContactIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalContactIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalContactIDHasPrefix?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalContactIDHasSuffix?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalContactIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly externalContactIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly externalContactIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalContactIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalContactIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalContactIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly externalContactIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** external_sequence_id field predicates */
  readonly externalSequenceID?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalSequenceIDContains?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalSequenceIDContainsFold?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalSequenceIDEqualFold?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalSequenceIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalSequenceIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalSequenceIDHasPrefix?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalSequenceIDHasSuffix?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalSequenceIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly externalSequenceIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly externalSequenceIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalSequenceIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalSequenceIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalSequenceIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly externalSequenceIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** external_sequence_membership_id field predicates */
  readonly externalSequenceMembershipID?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalSequenceMembershipIDContains?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalSequenceMembershipIDContainsFold?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalSequenceMembershipIDEqualFold?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalSequenceMembershipIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalSequenceMembershipIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalSequenceMembershipIDHasPrefix?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalSequenceMembershipIDHasSuffix?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalSequenceMembershipIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly externalSequenceMembershipIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly externalSequenceMembershipIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalSequenceMembershipIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalSequenceMembershipIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalSequenceMembershipIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly externalSequenceMembershipIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** first_name field predicates */
  readonly firstName?: InputMaybe<Scalars['String']['input']>;
  readonly firstNameContains?: InputMaybe<Scalars['String']['input']>;
  readonly firstNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly firstNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly firstNameGT?: InputMaybe<Scalars['String']['input']>;
  readonly firstNameGTE?: InputMaybe<Scalars['String']['input']>;
  readonly firstNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly firstNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly firstNameIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly firstNameLT?: InputMaybe<Scalars['String']['input']>;
  readonly firstNameLTE?: InputMaybe<Scalars['String']['input']>;
  readonly firstNameNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly firstNameNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** prospect edge predicates */
  readonly hasProspect?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasProspectWith?: InputMaybe<ReadonlyArray<ProspectWhereInput>>;
  /** id field predicates */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly idGT?: InputMaybe<Scalars['ID']['input']>;
  readonly idGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly idLT?: InputMaybe<Scalars['ID']['input']>;
  readonly idLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly idNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** last_name field predicates */
  readonly lastName?: InputMaybe<Scalars['String']['input']>;
  readonly lastNameContains?: InputMaybe<Scalars['String']['input']>;
  readonly lastNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly lastNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly lastNameGT?: InputMaybe<Scalars['String']['input']>;
  readonly lastNameGTE?: InputMaybe<Scalars['String']['input']>;
  readonly lastNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly lastNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly lastNameIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly lastNameLT?: InputMaybe<Scalars['String']['input']>;
  readonly lastNameLTE?: InputMaybe<Scalars['String']['input']>;
  readonly lastNameNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly lastNameNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly not?: InputMaybe<ProspectContactWhereInput>;
  /** old_created_by_id field predicates */
  readonly oldCreatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldCreatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_id field predicates */
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDGT?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly oldIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldIDLT?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly oldIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_updated_by_id field predicates */
  readonly oldUpdatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldUpdatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly or?: InputMaybe<ReadonlyArray<ProspectContactWhereInput>>;
  /** processed field predicates */
  readonly processed?: InputMaybe<Scalars['Boolean']['input']>;
  readonly processedNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** prospect_uuid field predicates */
  readonly prospectUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly prospectUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly prospectUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly prospectUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** title field predicates */
  readonly title?: InputMaybe<Scalars['String']['input']>;
  readonly titleContains?: InputMaybe<Scalars['String']['input']>;
  readonly titleContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly titleEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly titleGT?: InputMaybe<Scalars['String']['input']>;
  readonly titleGTE?: InputMaybe<Scalars['String']['input']>;
  readonly titleHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly titleHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly titleIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly titleLT?: InputMaybe<Scalars['String']['input']>;
  readonly titleLTE?: InputMaybe<Scalars['String']['input']>;
  readonly titleNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly titleNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** updated_at field predicates */
  readonly updatedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly updatedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** updated_by_uuid field predicates */
  readonly updatedByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly updatedByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
}

/** An edge in a connection. */
export interface ProspectEdge {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<Prospect>;
}

export interface ProspectExecutive extends Node {
  readonly createdAt: Scalars['Int']['output'];
  readonly createdByUUID: Scalars['ID']['output'];
  readonly disabled: Scalars['Boolean']['output'];
  readonly firstName: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  /** IsRelevant is true if this executive would be relevant to it's CustomerCustomer. */
  readonly isRelevant: Scalars['Boolean']['output'];
  readonly lastName: Scalars['String']['output'];
  readonly oldCreatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly oldID?: Maybe<Scalars['Int']['output']>;
  readonly oldUpdatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly prospect: Prospect;
  readonly prospectUUID: Scalars['ID']['output'];
  readonly title: Scalars['String']['output'];
  readonly updatedAt: Scalars['Int']['output'];
  readonly updatedByUUID: Scalars['ID']['output'];
}

/** A connection to a list of items. */
export interface ProspectExecutiveConnection {
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<ProspectExecutiveEdge>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface ProspectExecutiveEdge {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<ProspectExecutive>;
}

/** Ordering options for ProspectExecutive connections */
export interface ProspectExecutiveOrder {
  /** The ordering direction. */
  readonly direction?: OrderDirection;
  /** The field by which to order ProspectExecutives. */
  readonly field: ProspectExecutiveOrderField;
}

/** Properties by which ProspectExecutive connections can be ordered. */
export const ProspectExecutiveOrderField = {
  CreatedAt: 'CREATED_AT',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type ProspectExecutiveOrderField = typeof ProspectExecutiveOrderField[keyof typeof ProspectExecutiveOrderField];
/**
 * ProspectExecutiveWhereInput is used for filtering ProspectExecutive objects.
 * Input was generated by ent.
 */
export interface ProspectExecutiveWhereInput {
  readonly and?: InputMaybe<ReadonlyArray<ProspectExecutiveWhereInput>>;
  /** created_at field predicates */
  readonly createdAt?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly createdAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** created_by_uuid field predicates */
  readonly createdByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly createdByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** disabled field predicates */
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** first_name field predicates */
  readonly firstName?: InputMaybe<Scalars['String']['input']>;
  readonly firstNameContains?: InputMaybe<Scalars['String']['input']>;
  readonly firstNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly firstNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly firstNameGT?: InputMaybe<Scalars['String']['input']>;
  readonly firstNameGTE?: InputMaybe<Scalars['String']['input']>;
  readonly firstNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly firstNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly firstNameIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly firstNameLT?: InputMaybe<Scalars['String']['input']>;
  readonly firstNameLTE?: InputMaybe<Scalars['String']['input']>;
  readonly firstNameNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly firstNameNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** prospect edge predicates */
  readonly hasProspect?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasProspectWith?: InputMaybe<ReadonlyArray<ProspectWhereInput>>;
  /** id field predicates */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly idGT?: InputMaybe<Scalars['ID']['input']>;
  readonly idGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly idLT?: InputMaybe<Scalars['ID']['input']>;
  readonly idLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly idNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** is_relevant field predicates */
  readonly isRelevant?: InputMaybe<Scalars['Boolean']['input']>;
  readonly isRelevantNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** last_name field predicates */
  readonly lastName?: InputMaybe<Scalars['String']['input']>;
  readonly lastNameContains?: InputMaybe<Scalars['String']['input']>;
  readonly lastNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly lastNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly lastNameGT?: InputMaybe<Scalars['String']['input']>;
  readonly lastNameGTE?: InputMaybe<Scalars['String']['input']>;
  readonly lastNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly lastNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly lastNameIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly lastNameLT?: InputMaybe<Scalars['String']['input']>;
  readonly lastNameLTE?: InputMaybe<Scalars['String']['input']>;
  readonly lastNameNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly lastNameNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly not?: InputMaybe<ProspectExecutiveWhereInput>;
  /** old_created_by_id field predicates */
  readonly oldCreatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldCreatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_id field predicates */
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDGT?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly oldIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldIDLT?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly oldIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_updated_by_id field predicates */
  readonly oldUpdatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldUpdatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly or?: InputMaybe<ReadonlyArray<ProspectExecutiveWhereInput>>;
  /** prospect_uuid field predicates */
  readonly prospectUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly prospectUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly prospectUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly prospectUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** title field predicates */
  readonly title?: InputMaybe<Scalars['String']['input']>;
  readonly titleContains?: InputMaybe<Scalars['String']['input']>;
  readonly titleContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly titleEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly titleGT?: InputMaybe<Scalars['String']['input']>;
  readonly titleGTE?: InputMaybe<Scalars['String']['input']>;
  readonly titleHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly titleHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly titleIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly titleLT?: InputMaybe<Scalars['String']['input']>;
  readonly titleLTE?: InputMaybe<Scalars['String']['input']>;
  readonly titleNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly titleNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** updated_at field predicates */
  readonly updatedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly updatedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** updated_by_uuid field predicates */
  readonly updatedByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly updatedByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
}

/** Ordering options for Prospect connections */
export interface ProspectOrder {
  /** The ordering direction. */
  readonly direction?: OrderDirection;
  /** The field by which to order Prospects. */
  readonly field: ProspectOrderField;
}

/** Properties by which Prospect connections can be ordered. */
export const ProspectOrderField = {
  CreatedAt: 'CREATED_AT',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type ProspectOrderField = typeof ProspectOrderField[keyof typeof ProspectOrderField];
/** ProspectProcessingStatus is enum for the field status */
export const ProspectProcessingStatus = {
  Created: 'CREATED',
  DocumentsFetched: 'DOCUMENTS_FETCHED',
  EvaluatingIfIdealCustomer: 'EVALUATING_IF_IDEAL_CUSTOMER',
  MissingExecutives: 'MISSING_EXECUTIVES',
  NotIdealCustomer: 'NOT_IDEAL_CUSTOMER',
  NoDocumentsForTicker: 'NO_DOCUMENTS_FOR_TICKER',
  NoRelevantSources: 'NO_RELEVANT_SOURCES',
  Processed: 'PROCESSED',
  UnknownCompany: 'UNKNOWN_COMPANY',
  UnknownStatus: 'UNKNOWN_STATUS'
} as const;

export type ProspectProcessingStatus = typeof ProspectProcessingStatus[keyof typeof ProspectProcessingStatus];
/**
 * ProspectWhereInput is used for filtering Prospect objects.
 * Input was generated by ent.
 */
export interface ProspectWhereInput {
  readonly and?: InputMaybe<ReadonlyArray<ProspectWhereInput>>;
  /** created_at field predicates */
  readonly createdAt?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly createdAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** created_by_uuid field predicates */
  readonly createdByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly createdByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** disabled field predicates */
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** domain field predicates */
  readonly domain?: InputMaybe<Scalars['String']['input']>;
  readonly domainContains?: InputMaybe<Scalars['String']['input']>;
  readonly domainContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly domainEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly domainGT?: InputMaybe<Scalars['String']['input']>;
  readonly domainGTE?: InputMaybe<Scalars['String']['input']>;
  readonly domainHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly domainHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly domainIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly domainLT?: InputMaybe<Scalars['String']['input']>;
  readonly domainLTE?: InputMaybe<Scalars['String']['input']>;
  readonly domainNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly domainNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** engagement_platform field predicates */
  readonly engagementPlatform?: InputMaybe<ProspectCallIntegration>;
  readonly engagementPlatformIn?: InputMaybe<ReadonlyArray<ProspectCallIntegration>>;
  readonly engagementPlatformIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly engagementPlatformNEQ?: InputMaybe<ProspectCallIntegration>;
  readonly engagementPlatformNotIn?: InputMaybe<ReadonlyArray<ProspectCallIntegration>>;
  readonly engagementPlatformNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** external_prospect_id field predicates */
  readonly externalProspectID?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalProspectIDContains?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalProspectIDContainsFold?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalProspectIDEqualFold?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalProspectIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalProspectIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalProspectIDHasPrefix?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalProspectIDHasSuffix?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalProspectIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly externalProspectIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly externalProspectIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalProspectIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalProspectIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalProspectIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly externalProspectIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** prospect_contacts edge predicates */
  readonly hasProspectContacts?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasProspectContactsWith?: InputMaybe<ReadonlyArray<ProspectContactWhereInput>>;
  /** prospect_executives edge predicates */
  readonly hasProspectExecutives?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasProspectExecutivesWith?: InputMaybe<ReadonlyArray<ProspectExecutiveWhereInput>>;
  /** id field predicates */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly idGT?: InputMaybe<Scalars['ID']['input']>;
  readonly idGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly idLT?: InputMaybe<Scalars['ID']['input']>;
  readonly idLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly idNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** name field predicates */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly nameContains?: InputMaybe<Scalars['String']['input']>;
  readonly nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly nameGT?: InputMaybe<Scalars['String']['input']>;
  readonly nameGTE?: InputMaybe<Scalars['String']['input']>;
  readonly nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly nameIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly nameLT?: InputMaybe<Scalars['String']['input']>;
  readonly nameLTE?: InputMaybe<Scalars['String']['input']>;
  readonly nameNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly nameNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly not?: InputMaybe<ProspectWhereInput>;
  /** old_created_by_id field predicates */
  readonly oldCreatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldCreatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_id field predicates */
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDGT?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly oldIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldIDLT?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly oldIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_updated_by_id field predicates */
  readonly oldUpdatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldUpdatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly or?: InputMaybe<ReadonlyArray<ProspectWhereInput>>;
  /** status field predicates */
  readonly status?: InputMaybe<ProspectProcessingStatus>;
  readonly statusIn?: InputMaybe<ReadonlyArray<ProspectProcessingStatus>>;
  readonly statusNEQ?: InputMaybe<ProspectProcessingStatus>;
  readonly statusNotIn?: InputMaybe<ReadonlyArray<ProspectProcessingStatus>>;
  /** stock_ticker field predicates */
  readonly stockTicker?: InputMaybe<Scalars['String']['input']>;
  readonly stockTickerContains?: InputMaybe<Scalars['String']['input']>;
  readonly stockTickerContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly stockTickerEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly stockTickerGT?: InputMaybe<Scalars['String']['input']>;
  readonly stockTickerGTE?: InputMaybe<Scalars['String']['input']>;
  readonly stockTickerHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly stockTickerHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly stockTickerIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly stockTickerIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly stockTickerLT?: InputMaybe<Scalars['String']['input']>;
  readonly stockTickerLTE?: InputMaybe<Scalars['String']['input']>;
  readonly stockTickerNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly stockTickerNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly stockTickerNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  readonly updatedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly updatedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** updated_by_uuid field predicates */
  readonly updatedByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly updatedByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
}

export interface Query {
  readonly accounts: AccountConnection;
  readonly adhocEmailSends: AdhocEmailSendConnection;
  readonly apiKeys: ApiKeyConnection;
  readonly calls: CallConnection;
  readonly classifierConditions: ClassifierConditionConnection;
  readonly classifierEnumValues: ClassifierEnumValueConnection;
  readonly classifierExamples: ClassifierExampleConnection;
  readonly classifierResults: ClassifierResultConnection;
  readonly classifiers: ClassifierConnection;
  readonly contacts: ContactConnection;
  readonly crmDeliveries: CrmDeliveryConnection;
  readonly crmSubscriptions: CrmSubscriptionConnection;
  readonly customFieldEnumerationFieldLinks: CustomFieldEnumerationFieldLinkConnection;
  readonly customFieldEnums: CustomFieldEnumConnection;
  readonly customFieldValues: CustomFieldValueConnection;
  readonly customFields: CustomFieldConnection;
  readonly customerCrmConfigs: CustomerCrmConfigConnection;
  readonly customerProspectingConfigs: CustomerProspectingConfigConnection;
  readonly customers: CustomerConnection;
  readonly directories: DirectoryConnection;
  readonly documentIngestionConfigs: DocumentIngestionConfigConnection;
  readonly documents: DocumentConnection;
  readonly emailDeliveries: EmailDeliveryConnection;
  readonly emailDraftPublishes: EmailDraftPublishConnection;
  readonly emailRecipients: EmailRecipientConnection;
  readonly emailReplyContexts: EmailReplyContextConnection;
  readonly emailReplyDrafts: EmailReplyDraftConnection;
  readonly emailSubscriptionConfigFields: EmailSubscriptionConfigFieldConnection;
  readonly emailSubscriptionConfigs: EmailSubscriptionConfigConnection;
  readonly emailSubscriptionLinks: EmailSubscriptionLinkConnection;
  readonly emailSubscriptions: EmailSubscriptionConnection;
  readonly emailThreadSummaries: EmailThreadSummaryConnection;
  readonly emailThreads: EmailThreadConnection;
  readonly emails: EmailConnection;
  readonly enumerationConfigFieldLinks: EnumerationConfigFieldLinkConnection;
  readonly enumerationConfigStageLinks: EnumerationConfigStageLinkConnection;
  readonly enumerationConfigurationClassifierEnums: EnumerationConfigurationClassifierEnumConnection;
  readonly enumerationConfigurationDrafts: EnumerationConfigurationDraftConnection;
  readonly enumerationConfigurations: EnumerationConfigurationConnection;
  readonly enumerationDrafts: EnumerationDraftConnection;
  readonly enumerationFieldDrafts: EnumerationFieldDraftConnection;
  readonly enumerationFields: EnumerationFieldConnection;
  readonly enumerationPromptConfigs: EnumerationPromptConfigConnection;
  readonly enumerationValueFeedbacks: EnumerationValueFeedbackConnection;
  readonly enumerationValueOutputs: EnumerationValueOutputConnection;
  readonly enumerationValueScores: EnumerationValueScoreConnection;
  readonly enumerationValues: EnumerationValueConnection;
  readonly fieldDependencyLinks: FieldDependencyLinkConnection;
  readonly gongUsers: GongUserConnection;
  readonly integrationSecrets: IntegrationSecretConnection;
  readonly knowledgeDocumentPromptInstructions: KnowledgeDocumentPromptInstructionConnection;
  readonly knowledgeDocumentVersions: KnowledgeDocumentVersionConnection;
  readonly knowledgeDocuments: KnowledgeDocumentConnection;
  /** Fetches an object given its ID. */
  readonly node?: Maybe<Node>;
  /** Lookup nodes by a list of IDs. */
  readonly nodes: ReadonlyArray<Maybe<Node>>;
  readonly opportunities: OpportunityConnection;
  readonly opportunityCallLinks: OpportunityCallLinkConnection;
  readonly opportunityStageChanges: OpportunityStageChangeConnection;
  readonly pipelineStages: PipelineStageConnection;
  readonly pipelines: PipelineConnection;
  readonly prospectContacts: ProspectContactConnection;
  readonly prospectExecutives: ProspectExecutiveConnection;
  readonly prospects: ProspectConnection;
  readonly reportingLinks: ReportingLinkConnection;
  readonly slackDeliveries: SlackDeliveryConnection;
  readonly slackSubscriptions: SlackSubscriptionConnection;
  readonly taskReferences: TaskReferenceConnection;
  readonly tasks: TaskConnection;
  readonly userCallStats: UserCallStatConnection;
  readonly userGroupMemberships: UserGroupMembershipConnection;
  readonly userGroupViewers: UserGroupViewerConnection;
  readonly userGroups: UserGroupConnection;
  readonly userProspectingConfigs: UserProspectingConfigConnection;
  readonly userScoreStats: UserScoreStatConnection;
  readonly users: UserConnection;
}


export interface QueryAccountsArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AccountOrder>;
  where?: InputMaybe<AccountWhereInput>;
}


export interface QueryAdhocEmailSendsArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AdhocEmailSendOrder>;
  where?: InputMaybe<AdhocEmailSendWhereInput>;
}


export interface QueryApiKeysArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ApiKeyOrder>;
  where?: InputMaybe<ApiKeyWhereInput>;
}


export interface QueryCallsArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CallOrder>;
  where?: InputMaybe<CallWhereInput>;
}


export interface QueryClassifierConditionsArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ClassifierConditionOrder>;
  where?: InputMaybe<ClassifierConditionWhereInput>;
}


export interface QueryClassifierEnumValuesArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ClassifierEnumValueOrder>;
  where?: InputMaybe<ClassifierEnumValueWhereInput>;
}


export interface QueryClassifierExamplesArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ClassifierExampleOrder>;
  where?: InputMaybe<ClassifierExampleWhereInput>;
}


export interface QueryClassifierResultsArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ClassifierResultOrder>;
  where?: InputMaybe<ClassifierResultWhereInput>;
}


export interface QueryClassifiersArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ClassifierOrder>;
  where?: InputMaybe<ClassifierWhereInput>;
}


export interface QueryContactsArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ContactOrder>;
  where?: InputMaybe<ContactWhereInput>;
}


export interface QueryCrmDeliveriesArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CrmDeliveryOrder>;
  where?: InputMaybe<CrmDeliveryWhereInput>;
}


export interface QueryCrmSubscriptionsArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CrmSubscriptionOrder>;
  where?: InputMaybe<CrmSubscriptionWhereInput>;
}


export interface QueryCustomFieldEnumerationFieldLinksArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CustomFieldEnumerationFieldLinkOrder>;
  where?: InputMaybe<CustomFieldEnumerationFieldLinkWhereInput>;
}


export interface QueryCustomFieldEnumsArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CustomFieldEnumOrder>;
  where?: InputMaybe<CustomFieldEnumWhereInput>;
}


export interface QueryCustomFieldValuesArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CustomFieldValueOrder>;
  where?: InputMaybe<CustomFieldValueWhereInput>;
}


export interface QueryCustomFieldsArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CustomFieldOrder>;
  where?: InputMaybe<CustomFieldWhereInput>;
}


export interface QueryCustomerCrmConfigsArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CustomerCrmConfigOrder>;
  where?: InputMaybe<CustomerCrmConfigWhereInput>;
}


export interface QueryCustomerProspectingConfigsArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CustomerProspectingConfigOrder>;
  where?: InputMaybe<CustomerProspectingConfigWhereInput>;
}


export interface QueryCustomersArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CustomerOrder>;
  where?: InputMaybe<CustomerWhereInput>;
}


export interface QueryDirectoriesArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<DirectoryOrder>;
  where?: InputMaybe<DirectoryWhereInput>;
}


export interface QueryDocumentIngestionConfigsArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<DocumentIngestionConfigOrder>;
  where?: InputMaybe<DocumentIngestionConfigWhereInput>;
}


export interface QueryDocumentsArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<DocumentOrder>;
  where?: InputMaybe<DocumentWhereInput>;
}


export interface QueryEmailDeliveriesArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EmailDeliveryOrder>;
  where?: InputMaybe<EmailDeliveryWhereInput>;
}


export interface QueryEmailDraftPublishesArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EmailDraftPublishOrder>;
  where?: InputMaybe<EmailDraftPublishWhereInput>;
}


export interface QueryEmailRecipientsArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EmailRecipientOrder>;
  where?: InputMaybe<EmailRecipientWhereInput>;
}


export interface QueryEmailReplyContextsArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EmailReplyContextOrder>;
  where?: InputMaybe<EmailReplyContextWhereInput>;
}


export interface QueryEmailReplyDraftsArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EmailReplyDraftOrder>;
  where?: InputMaybe<EmailReplyDraftWhereInput>;
}


export interface QueryEmailSubscriptionConfigFieldsArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EmailSubscriptionConfigFieldOrder>;
  where?: InputMaybe<EmailSubscriptionConfigFieldWhereInput>;
}


export interface QueryEmailSubscriptionConfigsArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EmailSubscriptionConfigOrder>;
  where?: InputMaybe<EmailSubscriptionConfigWhereInput>;
}


export interface QueryEmailSubscriptionLinksArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EmailSubscriptionLinkOrder>;
  where?: InputMaybe<EmailSubscriptionLinkWhereInput>;
}


export interface QueryEmailSubscriptionsArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EmailSubscriptionOrder>;
  where?: InputMaybe<EmailSubscriptionWhereInput>;
}


export interface QueryEmailThreadSummariesArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EmailThreadSummaryOrder>;
  where?: InputMaybe<EmailThreadSummaryWhereInput>;
}


export interface QueryEmailThreadsArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EmailThreadOrder>;
  where?: InputMaybe<EmailThreadWhereInput>;
}


export interface QueryEmailsArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EmailOrder>;
  where?: InputMaybe<EmailWhereInput>;
}


export interface QueryEnumerationConfigFieldLinksArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EnumerationConfigFieldLinkOrder>;
  where?: InputMaybe<EnumerationConfigFieldLinkWhereInput>;
}


export interface QueryEnumerationConfigStageLinksArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EnumerationConfigStageLinkOrder>;
  where?: InputMaybe<EnumerationConfigStageLinkWhereInput>;
}


export interface QueryEnumerationConfigurationClassifierEnumsArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EnumerationConfigurationClassifierEnumOrder>;
  where?: InputMaybe<EnumerationConfigurationClassifierEnumWhereInput>;
}


export interface QueryEnumerationConfigurationDraftsArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EnumerationConfigurationDraftOrder>;
  where?: InputMaybe<EnumerationConfigurationDraftWhereInput>;
}


export interface QueryEnumerationConfigurationsArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EnumerationConfigurationOrder>;
  where?: InputMaybe<EnumerationConfigurationWhereInput>;
}


export interface QueryEnumerationDraftsArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EnumerationDraftOrder>;
  where?: InputMaybe<EnumerationDraftWhereInput>;
}


export interface QueryEnumerationFieldDraftsArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EnumerationFieldDraftOrder>;
  where?: InputMaybe<EnumerationFieldDraftWhereInput>;
}


export interface QueryEnumerationFieldsArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EnumerationFieldOrder>;
  where?: InputMaybe<EnumerationFieldWhereInput>;
}


export interface QueryEnumerationPromptConfigsArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EnumerationPromptConfigOrder>;
  where?: InputMaybe<EnumerationPromptConfigWhereInput>;
}


export interface QueryEnumerationValueFeedbacksArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EnumerationValueFeedbackOrder>;
  where?: InputMaybe<EnumerationValueFeedbackWhereInput>;
}


export interface QueryEnumerationValueOutputsArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EnumerationValueOutputOrder>;
  where?: InputMaybe<EnumerationValueOutputWhereInput>;
}


export interface QueryEnumerationValueScoresArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EnumerationValueScoreOrder>;
  where?: InputMaybe<EnumerationValueScoreWhereInput>;
}


export interface QueryEnumerationValuesArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EnumerationValueOrder>;
  where?: InputMaybe<EnumerationValueWhereInput>;
}


export interface QueryFieldDependencyLinksArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<FieldDependencyLinkOrder>;
  where?: InputMaybe<FieldDependencyLinkWhereInput>;
}


export interface QueryGongUsersArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<GongUserOrder>;
  where?: InputMaybe<GongUserWhereInput>;
}


export interface QueryIntegrationSecretsArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<IntegrationSecretOrder>;
  where?: InputMaybe<IntegrationSecretWhereInput>;
}


export interface QueryKnowledgeDocumentPromptInstructionsArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<KnowledgeDocumentPromptInstructionOrder>;
  where?: InputMaybe<KnowledgeDocumentPromptInstructionWhereInput>;
}


export interface QueryKnowledgeDocumentVersionsArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<KnowledgeDocumentVersionOrder>;
  where?: InputMaybe<KnowledgeDocumentVersionWhereInput>;
}


export interface QueryKnowledgeDocumentsArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<KnowledgeDocumentOrder>;
  where?: InputMaybe<KnowledgeDocumentWhereInput>;
}


export interface QueryNodeArgs {
  id: Scalars['ID']['input'];
}


export interface QueryNodesArgs {
  ids: ReadonlyArray<Scalars['ID']['input']>;
}


export interface QueryOpportunitiesArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OpportunityOrder>;
  where?: InputMaybe<OpportunityWhereInput>;
}


export interface QueryOpportunityCallLinksArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OpportunityCallLinkOrder>;
  where?: InputMaybe<OpportunityCallLinkWhereInput>;
}


export interface QueryOpportunityStageChangesArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OpportunityStageChangeOrder>;
  where?: InputMaybe<OpportunityStageChangeWhereInput>;
}


export interface QueryPipelineStagesArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PipelineStageOrder>;
  where?: InputMaybe<PipelineStageWhereInput>;
}


export interface QueryPipelinesArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PipelineOrder>;
  where?: InputMaybe<PipelineWhereInput>;
}


export interface QueryProspectContactsArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProspectContactOrder>;
  where?: InputMaybe<ProspectContactWhereInput>;
}


export interface QueryProspectExecutivesArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProspectExecutiveOrder>;
  where?: InputMaybe<ProspectExecutiveWhereInput>;
}


export interface QueryProspectsArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProspectOrder>;
  where?: InputMaybe<ProspectWhereInput>;
}


export interface QueryReportingLinksArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ReportingLinkOrder>;
  where?: InputMaybe<ReportingLinkWhereInput>;
}


export interface QuerySlackDeliveriesArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SlackDeliveryOrder>;
  where?: InputMaybe<SlackDeliveryWhereInput>;
}


export interface QuerySlackSubscriptionsArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SlackSubscriptionOrder>;
  where?: InputMaybe<SlackSubscriptionWhereInput>;
}


export interface QueryTaskReferencesArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TaskReferenceOrder>;
  where?: InputMaybe<TaskReferenceWhereInput>;
}


export interface QueryTasksArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TaskOrder>;
  where?: InputMaybe<TaskWhereInput>;
}


export interface QueryUserCallStatsArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UserCallStatOrder>;
  where?: InputMaybe<UserCallStatWhereInput>;
}


export interface QueryUserGroupMembershipsArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UserGroupMembershipOrder>;
  where?: InputMaybe<UserGroupMembershipWhereInput>;
}


export interface QueryUserGroupViewersArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UserGroupViewerOrder>;
  where?: InputMaybe<UserGroupViewerWhereInput>;
}


export interface QueryUserGroupsArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UserGroupOrder>;
  where?: InputMaybe<UserGroupWhereInput>;
}


export interface QueryUserProspectingConfigsArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UserProspectingConfigOrder>;
  where?: InputMaybe<UserProspectingConfigWhereInput>;
}


export interface QueryUserScoreStatsArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UserScoreStatOrder>;
  where?: InputMaybe<UserScoreStatWhereInput>;
}


export interface QueryUsersArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UserOrder>;
  where?: InputMaybe<UserWhereInput>;
}

export interface ReportingLink extends Node {
  readonly createdAt: Scalars['Int']['output'];
  readonly disabled: Scalars['Boolean']['output'];
  readonly id: Scalars['ID']['output'];
  readonly manager: GongUser;
  readonly managerUUID: Scalars['ID']['output'];
  readonly report: GongUser;
  readonly reportUUID: Scalars['ID']['output'];
  readonly updatedAt: Scalars['Int']['output'];
}

/** A connection to a list of items. */
export interface ReportingLinkConnection {
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<ReportingLinkEdge>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface ReportingLinkEdge {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<ReportingLink>;
}

/** Ordering options for ReportingLink connections */
export interface ReportingLinkOrder {
  /** The ordering direction. */
  readonly direction?: OrderDirection;
  /** The field by which to order ReportingLinks. */
  readonly field: ReportingLinkOrderField;
}

/** Properties by which ReportingLink connections can be ordered. */
export const ReportingLinkOrderField = {
  CreatedAt: 'CREATED_AT',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type ReportingLinkOrderField = typeof ReportingLinkOrderField[keyof typeof ReportingLinkOrderField];
/**
 * ReportingLinkWhereInput is used for filtering ReportingLink objects.
 * Input was generated by ent.
 */
export interface ReportingLinkWhereInput {
  readonly and?: InputMaybe<ReadonlyArray<ReportingLinkWhereInput>>;
  /** created_at field predicates */
  readonly createdAt?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly createdAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** disabled field predicates */
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** manager edge predicates */
  readonly hasManager?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasManagerWith?: InputMaybe<ReadonlyArray<GongUserWhereInput>>;
  /** report edge predicates */
  readonly hasReport?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasReportWith?: InputMaybe<ReadonlyArray<GongUserWhereInput>>;
  /** id field predicates */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly idGT?: InputMaybe<Scalars['ID']['input']>;
  readonly idGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly idLT?: InputMaybe<Scalars['ID']['input']>;
  readonly idLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly idNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** manager_uuid field predicates */
  readonly managerUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly managerUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly managerUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly managerUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly not?: InputMaybe<ReportingLinkWhereInput>;
  readonly or?: InputMaybe<ReadonlyArray<ReportingLinkWhereInput>>;
  /** report_uuid field predicates */
  readonly reportUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly reportUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly reportUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly reportUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  readonly updatedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly updatedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
}

export interface SlackDelivery extends Node {
  readonly createdAt: Scalars['Int']['output'];
  readonly createdByUUID: Scalars['ID']['output'];
  readonly disabled: Scalars['Boolean']['output'];
  readonly enumerationValue: EnumerationValue;
  readonly enumerationValueUUID: Scalars['ID']['output'];
  readonly id: Scalars['ID']['output'];
  readonly oldCreatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly oldID?: Maybe<Scalars['Int']['output']>;
  readonly oldUpdatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly slackSubscription: SlackSubscription;
  readonly slackSubscriptionUUID: Scalars['ID']['output'];
  readonly threadTs: Scalars['String']['output'];
  readonly updatedAt: Scalars['Int']['output'];
  readonly updatedByUUID: Scalars['ID']['output'];
}

/** A connection to a list of items. */
export interface SlackDeliveryConnection {
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<SlackDeliveryEdge>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface SlackDeliveryEdge {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<SlackDelivery>;
}

/** Ordering options for SlackDelivery connections */
export interface SlackDeliveryOrder {
  /** The ordering direction. */
  readonly direction?: OrderDirection;
  /** The field by which to order SlackDeliveries. */
  readonly field: SlackDeliveryOrderField;
}

/** Properties by which SlackDelivery connections can be ordered. */
export const SlackDeliveryOrderField = {
  CreatedAt: 'CREATED_AT',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type SlackDeliveryOrderField = typeof SlackDeliveryOrderField[keyof typeof SlackDeliveryOrderField];
/**
 * SlackDeliveryWhereInput is used for filtering SlackDelivery objects.
 * Input was generated by ent.
 */
export interface SlackDeliveryWhereInput {
  readonly and?: InputMaybe<ReadonlyArray<SlackDeliveryWhereInput>>;
  /** created_at field predicates */
  readonly createdAt?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly createdAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** created_by_uuid field predicates */
  readonly createdByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly createdByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** disabled field predicates */
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** enumeration_value_uuid field predicates */
  readonly enumerationValueUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly enumerationValueUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly enumerationValueUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly enumerationValueUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** enumeration_value edge predicates */
  readonly hasEnumerationValue?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasEnumerationValueWith?: InputMaybe<ReadonlyArray<EnumerationValueWhereInput>>;
  /** slack_subscription edge predicates */
  readonly hasSlackSubscription?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasSlackSubscriptionWith?: InputMaybe<ReadonlyArray<SlackSubscriptionWhereInput>>;
  /** id field predicates */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly idGT?: InputMaybe<Scalars['ID']['input']>;
  readonly idGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly idLT?: InputMaybe<Scalars['ID']['input']>;
  readonly idLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly idNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly not?: InputMaybe<SlackDeliveryWhereInput>;
  /** old_created_by_id field predicates */
  readonly oldCreatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldCreatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_id field predicates */
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDGT?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly oldIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldIDLT?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly oldIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_updated_by_id field predicates */
  readonly oldUpdatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldUpdatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly or?: InputMaybe<ReadonlyArray<SlackDeliveryWhereInput>>;
  /** slack_subscription_uuid field predicates */
  readonly slackSubscriptionUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly slackSubscriptionUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly slackSubscriptionUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly slackSubscriptionUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** thread_ts field predicates */
  readonly threadTs?: InputMaybe<Scalars['String']['input']>;
  readonly threadTsContains?: InputMaybe<Scalars['String']['input']>;
  readonly threadTsContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly threadTsEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly threadTsGT?: InputMaybe<Scalars['String']['input']>;
  readonly threadTsGTE?: InputMaybe<Scalars['String']['input']>;
  readonly threadTsHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly threadTsHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly threadTsIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly threadTsLT?: InputMaybe<Scalars['String']['input']>;
  readonly threadTsLTE?: InputMaybe<Scalars['String']['input']>;
  readonly threadTsNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly threadTsNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** updated_at field predicates */
  readonly updatedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly updatedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** updated_by_uuid field predicates */
  readonly updatedByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly updatedByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
}

export interface SlackSubscription extends Node {
  readonly attendeeGroups?: Maybe<ReadonlyArray<Scalars['ID']['output']>>;
  readonly attendees?: Maybe<ReadonlyArray<Scalars['ID']['output']>>;
  readonly callFilterTemplate?: Maybe<Scalars['String']['output']>;
  readonly channelID: Scalars['String']['output'];
  readonly createdAt: Scalars['Int']['output'];
  readonly createdByUUID: Scalars['ID']['output'];
  readonly customerCustomers?: Maybe<ReadonlyArray<Scalars['ID']['output']>>;
  readonly disabled: Scalars['Boolean']['output'];
  readonly enumType: SlackSubscriptionValueType;
  readonly hostGroups?: Maybe<ReadonlyArray<Scalars['ID']['output']>>;
  readonly hosts?: Maybe<ReadonlyArray<Scalars['ID']['output']>>;
  readonly id: Scalars['ID']['output'];
  readonly oldCreatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly oldID?: Maybe<Scalars['Int']['output']>;
  readonly oldUpdatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly slackDeliveries?: Maybe<ReadonlyArray<SlackDelivery>>;
  readonly type: SlackSubscriptionSubscriptionType;
  readonly updatedAt: Scalars['Int']['output'];
  readonly updatedByUUID: Scalars['ID']['output'];
}

/** A connection to a list of items. */
export interface SlackSubscriptionConnection {
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<SlackSubscriptionEdge>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface SlackSubscriptionEdge {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<SlackSubscription>;
}

/** Ordering options for SlackSubscription connections */
export interface SlackSubscriptionOrder {
  /** The ordering direction. */
  readonly direction?: OrderDirection;
  /** The field by which to order SlackSubscriptions. */
  readonly field: SlackSubscriptionOrderField;
}

/** Properties by which SlackSubscription connections can be ordered. */
export const SlackSubscriptionOrderField = {
  CreatedAt: 'CREATED_AT',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type SlackSubscriptionOrderField = typeof SlackSubscriptionOrderField[keyof typeof SlackSubscriptionOrderField];
/** SlackSubscriptionSubscriptionType is enum for the field type */
export const SlackSubscriptionSubscriptionType = {
  Daily: 'DAILY',
  Immediate: 'IMMEDIATE',
  Unknown: 'UNKNOWN',
  Weekly: 'WEEKLY'
} as const;

export type SlackSubscriptionSubscriptionType = typeof SlackSubscriptionSubscriptionType[keyof typeof SlackSubscriptionSubscriptionType];
/** SlackSubscriptionValueType is enum for the field enum_type */
export const SlackSubscriptionValueType = {
  AdQuickResponse: 'AD_QUICK_RESPONSE',
  AirbyteResponse: 'AIRBYTE_RESPONSE',
  AirbyteSdrSummaries: 'AIRBYTE_SDR_SUMMARIES',
  BantAuthority: 'BANT_AUTHORITY',
  BantBudget: 'BANT_BUDGET',
  BantNeed: 'BANT_NEED',
  BantTiming: 'BANT_TIMING',
  BruntworkInterviewSummary: 'BRUNTWORK_INTERVIEW_SUMMARY',
  BruntworkSummary: 'BRUNTWORK_SUMMARY',
  CompetitorMentions: 'COMPETITOR_MENTIONS',
  CustomerConcerns: 'CUSTOMER_CONCERNS',
  CustomerWins: 'CUSTOMER_WINS',
  DataSources: 'DATA_SOURCES',
  DealType: 'DEAL_TYPE',
  DiscoveryCue: 'DISCOVERY_CUE',
  DiscoveryResponse: 'DISCOVERY_RESPONSE',
  FabiusResponse: 'FABIUS_RESPONSE',
  FermatResponse: 'FERMAT_RESPONSE',
  Invalid: 'INVALID',
  MeddpiccChampion: 'MEDDPICC_CHAMPION',
  MeddpiccCompetition: 'MEDDPICC_COMPETITION',
  MeddpiccDecisionCriteria: 'MEDDPICC_DECISION_CRITERIA',
  MeddpiccDecisionProcess: 'MEDDPICC_DECISION_PROCESS',
  MeddpiccEconomicBuyer: 'MEDDPICC_ECONOMIC_BUYER',
  MeddpiccImplicatedPain: 'MEDDPICC_IMPLICATED_PAIN',
  MeddpiccMetrics: 'MEDDPICC_METRICS',
  MeddpiccPaperProcess: 'MEDDPICC_PAPER_PROCESS',
  MozartResponse: 'MOZART_RESPONSE',
  ObjectionHandling: 'OBJECTION_HANDLING',
  OneSchemaResponse: 'ONE_SCHEMA_RESPONSE',
  OrbSummary: 'ORB_SUMMARY',
  ParadeSummary: 'PARADE_SUMMARY',
  PaveAtRiskCall: 'PAVE_AT_RISK_CALL',
  PaveResponse: 'PAVE_RESPONSE',
  PostSales: 'POST_SALES',
  PreSales: 'PRE_SALES',
  ProductGaps: 'PRODUCT_GAPS',
  Qualification: 'QUALIFICATION',
  QuestionsAndAnswers: 'QUESTIONS_AND_ANSWERS',
  ReloSummary: 'RELO_SUMMARY',
  ReshapeSummary: 'RESHAPE_SUMMARY',
  Urgency: 'URGENCY',
  UxCamResponse: 'UX_CAM_RESPONSE',
  WinLosses: 'WIN_LOSSES'
} as const;

export type SlackSubscriptionValueType = typeof SlackSubscriptionValueType[keyof typeof SlackSubscriptionValueType];
/**
 * SlackSubscriptionWhereInput is used for filtering SlackSubscription objects.
 * Input was generated by ent.
 */
export interface SlackSubscriptionWhereInput {
  readonly and?: InputMaybe<ReadonlyArray<SlackSubscriptionWhereInput>>;
  /** call_filter_template field predicates */
  readonly callFilterTemplate?: InputMaybe<Scalars['String']['input']>;
  readonly callFilterTemplateContains?: InputMaybe<Scalars['String']['input']>;
  readonly callFilterTemplateContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly callFilterTemplateEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly callFilterTemplateGT?: InputMaybe<Scalars['String']['input']>;
  readonly callFilterTemplateGTE?: InputMaybe<Scalars['String']['input']>;
  readonly callFilterTemplateHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly callFilterTemplateHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly callFilterTemplateIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly callFilterTemplateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly callFilterTemplateLT?: InputMaybe<Scalars['String']['input']>;
  readonly callFilterTemplateLTE?: InputMaybe<Scalars['String']['input']>;
  readonly callFilterTemplateNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly callFilterTemplateNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly callFilterTemplateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** channel_id field predicates */
  readonly channelID?: InputMaybe<Scalars['String']['input']>;
  readonly channelIDContains?: InputMaybe<Scalars['String']['input']>;
  readonly channelIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly channelIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly channelIDGT?: InputMaybe<Scalars['String']['input']>;
  readonly channelIDGTE?: InputMaybe<Scalars['String']['input']>;
  readonly channelIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly channelIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly channelIDIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly channelIDLT?: InputMaybe<Scalars['String']['input']>;
  readonly channelIDLTE?: InputMaybe<Scalars['String']['input']>;
  readonly channelIDNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly channelIDNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** created_at field predicates */
  readonly createdAt?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly createdAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** created_by_uuid field predicates */
  readonly createdByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly createdByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** disabled field predicates */
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** enum_type field predicates */
  readonly enumType?: InputMaybe<SlackSubscriptionValueType>;
  readonly enumTypeIn?: InputMaybe<ReadonlyArray<SlackSubscriptionValueType>>;
  readonly enumTypeNEQ?: InputMaybe<SlackSubscriptionValueType>;
  readonly enumTypeNotIn?: InputMaybe<ReadonlyArray<SlackSubscriptionValueType>>;
  /** slack_deliveries edge predicates */
  readonly hasSlackDeliveries?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasSlackDeliveriesWith?: InputMaybe<ReadonlyArray<SlackDeliveryWhereInput>>;
  /** id field predicates */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly idGT?: InputMaybe<Scalars['ID']['input']>;
  readonly idGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly idLT?: InputMaybe<Scalars['ID']['input']>;
  readonly idLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly idNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly not?: InputMaybe<SlackSubscriptionWhereInput>;
  /** old_created_by_id field predicates */
  readonly oldCreatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldCreatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_id field predicates */
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDGT?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly oldIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldIDLT?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly oldIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_updated_by_id field predicates */
  readonly oldUpdatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldUpdatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly or?: InputMaybe<ReadonlyArray<SlackSubscriptionWhereInput>>;
  /** type field predicates */
  readonly type?: InputMaybe<SlackSubscriptionSubscriptionType>;
  readonly typeIn?: InputMaybe<ReadonlyArray<SlackSubscriptionSubscriptionType>>;
  readonly typeNEQ?: InputMaybe<SlackSubscriptionSubscriptionType>;
  readonly typeNotIn?: InputMaybe<ReadonlyArray<SlackSubscriptionSubscriptionType>>;
  /** updated_at field predicates */
  readonly updatedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly updatedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** updated_by_uuid field predicates */
  readonly updatedByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly updatedByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
}

export interface Task extends Node {
  readonly account?: Maybe<Account>;
  readonly accountUUID?: Maybe<Scalars['ID']['output']>;
  readonly assignedUser?: Maybe<User>;
  readonly assignedUserUUID?: Maybe<Scalars['ID']['output']>;
  readonly contact?: Maybe<Contact>;
  readonly contactUUID?: Maybe<Scalars['ID']['output']>;
  readonly createdAt: Scalars['Int']['output'];
  readonly description: Scalars['String']['output'];
  /** Details for the task, if applicable. This might be quite long and contain instructions to the user on how to complete the task. */
  readonly details?: Maybe<Scalars['String']['output']>;
  readonly disabled: Scalars['Boolean']['output'];
  readonly email?: Maybe<ReadonlyArray<Email>>;
  readonly id: Scalars['ID']['output'];
  readonly status: TaskStatus;
  readonly taskReferences?: Maybe<ReadonlyArray<TaskReference>>;
  readonly title: Scalars['String']['output'];
  readonly updatedAt: Scalars['Int']['output'];
}

/** A connection to a list of items. */
export interface TaskConnection {
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<TaskEdge>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface TaskEdge {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<Task>;
}

/** Ordering options for Task connections */
export interface TaskOrder {
  /** The ordering direction. */
  readonly direction?: OrderDirection;
  /** The field by which to order Tasks. */
  readonly field: TaskOrderField;
}

/** Properties by which Task connections can be ordered. */
export const TaskOrderField = {
  CreatedAt: 'CREATED_AT',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type TaskOrderField = typeof TaskOrderField[keyof typeof TaskOrderField];
export interface TaskReference extends Node {
  readonly createdAt: Scalars['Int']['output'];
  readonly disabled: Scalars['Boolean']['output'];
  readonly email: Email;
  readonly emailUUID: Scalars['ID']['output'];
  readonly id: Scalars['ID']['output'];
  readonly task: Task;
  readonly taskUUID: Scalars['ID']['output'];
  readonly updatedAt: Scalars['Int']['output'];
}

/** A connection to a list of items. */
export interface TaskReferenceConnection {
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<TaskReferenceEdge>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface TaskReferenceEdge {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<TaskReference>;
}

/** Ordering options for TaskReference connections */
export interface TaskReferenceOrder {
  /** The ordering direction. */
  readonly direction?: OrderDirection;
  /** The field by which to order TaskReferences. */
  readonly field: TaskReferenceOrderField;
}

/** Properties by which TaskReference connections can be ordered. */
export const TaskReferenceOrderField = {
  CreatedAt: 'CREATED_AT',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type TaskReferenceOrderField = typeof TaskReferenceOrderField[keyof typeof TaskReferenceOrderField];
/**
 * TaskReferenceWhereInput is used for filtering TaskReference objects.
 * Input was generated by ent.
 */
export interface TaskReferenceWhereInput {
  readonly and?: InputMaybe<ReadonlyArray<TaskReferenceWhereInput>>;
  /** created_at field predicates */
  readonly createdAt?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly createdAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** disabled field predicates */
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** id field predicates */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly idGT?: InputMaybe<Scalars['ID']['input']>;
  readonly idGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly idLT?: InputMaybe<Scalars['ID']['input']>;
  readonly idLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly idNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly not?: InputMaybe<TaskReferenceWhereInput>;
  readonly or?: InputMaybe<ReadonlyArray<TaskReferenceWhereInput>>;
  /** updated_at field predicates */
  readonly updatedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly updatedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
}

/** TaskStatus is enum for the field status */
export const TaskStatus = {
  Cancelled: 'CANCELLED',
  Done: 'DONE',
  InProgress: 'IN_PROGRESS',
  Open: 'OPEN',
  Unknown: 'UNKNOWN'
} as const;

export type TaskStatus = typeof TaskStatus[keyof typeof TaskStatus];
/**
 * TaskWhereInput is used for filtering Task objects.
 * Input was generated by ent.
 */
export interface TaskWhereInput {
  /** account_uuid field predicates */
  readonly accountUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly accountUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly accountUUIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly accountUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly accountUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly accountUUIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly and?: InputMaybe<ReadonlyArray<TaskWhereInput>>;
  /** assigned_user_uuid field predicates */
  readonly assignedUserUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly assignedUserUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly assignedUserUUIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly assignedUserUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly assignedUserUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly assignedUserUUIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** contact_uuid field predicates */
  readonly contactUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly contactUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly contactUUIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly contactUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly contactUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly contactUUIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  readonly createdAt?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly createdAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** description field predicates */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionContains?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionGT?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly descriptionLT?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** details field predicates */
  readonly details?: InputMaybe<Scalars['String']['input']>;
  readonly detailsContains?: InputMaybe<Scalars['String']['input']>;
  readonly detailsContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly detailsEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly detailsGT?: InputMaybe<Scalars['String']['input']>;
  readonly detailsGTE?: InputMaybe<Scalars['String']['input']>;
  readonly detailsHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly detailsHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly detailsIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly detailsIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly detailsLT?: InputMaybe<Scalars['String']['input']>;
  readonly detailsLTE?: InputMaybe<Scalars['String']['input']>;
  readonly detailsNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly detailsNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly detailsNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** disabled field predicates */
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** account edge predicates */
  readonly hasAccount?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasAccountWith?: InputMaybe<ReadonlyArray<AccountWhereInput>>;
  /** assigned_user edge predicates */
  readonly hasAssignedUser?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasAssignedUserWith?: InputMaybe<ReadonlyArray<UserWhereInput>>;
  /** contact edge predicates */
  readonly hasContact?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasContactWith?: InputMaybe<ReadonlyArray<ContactWhereInput>>;
  /** email edge predicates */
  readonly hasEmail?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasEmailWith?: InputMaybe<ReadonlyArray<EmailWhereInput>>;
  /** task_references edge predicates */
  readonly hasTaskReferences?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasTaskReferencesWith?: InputMaybe<ReadonlyArray<TaskReferenceWhereInput>>;
  /** id field predicates */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly idGT?: InputMaybe<Scalars['ID']['input']>;
  readonly idGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly idLT?: InputMaybe<Scalars['ID']['input']>;
  readonly idLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly idNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly not?: InputMaybe<TaskWhereInput>;
  readonly or?: InputMaybe<ReadonlyArray<TaskWhereInput>>;
  /** status field predicates */
  readonly status?: InputMaybe<TaskStatus>;
  readonly statusIn?: InputMaybe<ReadonlyArray<TaskStatus>>;
  readonly statusNEQ?: InputMaybe<TaskStatus>;
  readonly statusNotIn?: InputMaybe<ReadonlyArray<TaskStatus>>;
  /** title field predicates */
  readonly title?: InputMaybe<Scalars['String']['input']>;
  readonly titleContains?: InputMaybe<Scalars['String']['input']>;
  readonly titleContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly titleEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly titleGT?: InputMaybe<Scalars['String']['input']>;
  readonly titleGTE?: InputMaybe<Scalars['String']['input']>;
  readonly titleHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly titleHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly titleIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly titleLT?: InputMaybe<Scalars['String']['input']>;
  readonly titleLTE?: InputMaybe<Scalars['String']['input']>;
  readonly titleNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly titleNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** updated_at field predicates */
  readonly updatedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly updatedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
}

/**
 * UpdateAPIKeyInput is used for update APIKey object.
 * Input was generated by ent.
 */
export interface UpdateApiKeyInput {
  readonly clearOldID?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
}

/**
 * UpdateAccountInput is used for update Account object.
 * Input was generated by ent.
 */
export interface UpdateAccountInput {
  readonly addCallIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addContactIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addCustomFieldValueIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addDocumentIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addOpportunityIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addTaskIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly appendWebsites?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly clearCalls?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearContacts?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearCustomFieldValues?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearOpportunities?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearTasks?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearWebsites?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly removeCallIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeContactIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeCustomFieldValueIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeDocumentIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeOpportunityIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeTaskIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly sourcePlatform?: InputMaybe<CallIntegration>;
  /** Websites represents the websites of the account. It is not sanitized in anyway, as different platforms allow URLs vs domains, etc. */
  readonly websites?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
}

/**
 * UpdateAdhocEmailSendInput is used for update AdhocEmailSend object.
 * Input was generated by ent.
 */
export interface UpdateAdhocEmailSendInput {
  readonly additionalNotes?: InputMaybe<Scalars['String']['input']>;
  readonly clearAdditionalNotes?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearEmailSubscriptionConfig?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearOldID?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly emailSubscriptionConfigID?: InputMaybe<Scalars['ID']['input']>;
  readonly enumerationValueID?: InputMaybe<Scalars['ID']['input']>;
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  readonly senderUserID?: InputMaybe<Scalars['ID']['input']>;
  readonly toAddress?: InputMaybe<Scalars['String']['input']>;
}

/**
 * UpdateCRMDeliveryInput is used for update CRMDelivery object.
 * Input was generated by ent.
 */
export interface UpdateCrmDeliveryInput {
  readonly clearEnumerationValue?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearEnumerationValueOutput?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearEnumerationValueScore?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearFieldName?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearFieldValue?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearNoteID?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearObjectID?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearObjectType?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearOldID?: InputMaybe<Scalars['Boolean']['input']>;
  readonly crmSubscriptionID?: InputMaybe<Scalars['ID']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly enumerationValueID?: InputMaybe<Scalars['ID']['input']>;
  readonly enumerationValueOutputID?: InputMaybe<Scalars['ID']['input']>;
  readonly enumerationValueScoreID?: InputMaybe<Scalars['ID']['input']>;
  readonly fieldName?: InputMaybe<Scalars['String']['input']>;
  readonly fieldValue?: InputMaybe<Scalars['String']['input']>;
  readonly noteID?: InputMaybe<Scalars['String']['input']>;
  readonly objectID?: InputMaybe<Scalars['String']['input']>;
  readonly objectType?: InputMaybe<CrmDeliveryObjectType>;
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
}

/**
 * UpdateCRMSubscriptionInput is used for update CRMSubscription object.
 * Input was generated by ent.
 */
export interface UpdateCrmSubscriptionInput {
  readonly clearEnumerationField?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearFieldName?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearOldID?: InputMaybe<Scalars['Boolean']['input']>;
  /** ConvertMarkdown indicates that the content should be converted from markdown to HTML before being pushed to the CRM system. */
  readonly convertMarkdown?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly enumType?: InputMaybe<CrmSubscriptionValueType>;
  readonly enumerationFieldID?: InputMaybe<Scalars['ID']['input']>;
  /** FieldName is the name of the field in the CRM system. If not set, the data will be pushed as a note */
  readonly fieldName?: InputMaybe<Scalars['String']['input']>;
  readonly integrationSecretID?: InputMaybe<Scalars['ID']['input']>;
  readonly objectType?: InputMaybe<CrmSubscriptionObjectType>;
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
}

/**
 * UpdateClassifierConditionInput is used for update ClassifierCondition object.
 * Input was generated by ent.
 */
export interface UpdateClassifierConditionInput {
  readonly addKnowledgeDocumentPromptInstructionIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly classifierEnumValueID?: InputMaybe<Scalars['ID']['input']>;
  readonly clearDefinitions?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearDirections?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearInstructions?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearKnowledgeDocumentPromptInstructions?: InputMaybe<Scalars['Boolean']['input']>;
  /** Definitions represent the contextual definition that the model needs in order to be able to best do it's job, so that there isn't ambiguity about the terms using in the instructions/directions or whether the calls/documents themselves. This is often left blank if there isn't much chance of confusion. If the type of the value or score is non-custom, then adding to this will append the text after the standard definitions for that field. */
  readonly definitions?: InputMaybe<Scalars['String']['input']>;
  /** Directions are the specific steps or detailed context that the model needs to take in order to complete the analysis. This is generally more detailed than the instructions and is often used to break down the instructions into more digestible steps or talk through edge cases. If the type of the value or score is non-custom, then adding to this will append the text after the standard directions for that field. */
  readonly directions?: InputMaybe<Scalars['String']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Instructions represents the main description of the task that the model needs to do to complete the analysis. For normal fields, this generally describes how to analyze the call/document. For scores, this is the rubric that outlines exactly how to score the rep on the call. If the type of the value or score is non-custom, then adding to this will append the text after the standard instructions for that field. */
  readonly instructions?: InputMaybe<Scalars['String']['input']>;
  readonly removeKnowledgeDocumentPromptInstructionIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
}

/**
 * UpdateClassifierEnumValueInput is used for update ClassifierEnumValue object.
 * Input was generated by ent.
 */
export interface UpdateClassifierEnumValueInput {
  readonly addClassifierConditionIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addClassifierExampleIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addClassifierResultIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addEnumerationConfigurationClassifierEnumValueIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly classifierID?: InputMaybe<Scalars['ID']['input']>;
  readonly clearClassifierConditions?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearClassifierExamples?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearClassifierResults?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearDescription?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearEnumerationConfigurationClassifierEnumValues?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearOldID?: InputMaybe<Scalars['Boolean']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly enumValue?: InputMaybe<Scalars['String']['input']>;
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  readonly removeClassifierConditionIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeClassifierExampleIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeClassifierResultIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeEnumerationConfigurationClassifierEnumValueIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
}

/**
 * UpdateClassifierExampleInput is used for update ClassifierExample object.
 * Input was generated by ent.
 */
export interface UpdateClassifierExampleInput {
  readonly callID?: InputMaybe<Scalars['ID']['input']>;
  readonly classifierEnumValueID?: InputMaybe<Scalars['ID']['input']>;
  readonly classifierID?: InputMaybe<Scalars['ID']['input']>;
  readonly clearCall?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearDocument?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearOldID?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearOpportunity?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly documentID?: InputMaybe<Scalars['ID']['input']>;
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  readonly opportunityID?: InputMaybe<Scalars['ID']['input']>;
}

/**
 * UpdateClassifierInput is used for update Classifier object.
 * Input was generated by ent.
 */
export interface UpdateClassifierInput {
  readonly active?: InputMaybe<Scalars['Boolean']['input']>;
  readonly addClassifierEnumValueIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addClassifierExampleIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addClassifierResultIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** Indicates whether the classifier assigns a single enum value or multiple enum values to an event */
  readonly classificationType?: InputMaybe<ClassifierType>;
  readonly clearClassifierEnumValues?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearClassifierExamples?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearClassifierResults?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearDescription?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearModel?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearOldID?: InputMaybe<Scalars['Boolean']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Specifies the LLM model to use; defaults to standard model if not provided */
  readonly model?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  readonly removeClassifierEnumValueIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeClassifierExampleIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeClassifierResultIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
}

/**
 * UpdateClassifierResultInput is used for update ClassifierResult object.
 * Input was generated by ent.
 */
export interface UpdateClassifierResultInput {
  readonly callID?: InputMaybe<Scalars['ID']['input']>;
  readonly classifierEnumValueID?: InputMaybe<Scalars['ID']['input']>;
  readonly classifierID?: InputMaybe<Scalars['ID']['input']>;
  readonly clearCall?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearDocument?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearOldID?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearOpportunityStageChange?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly documentID?: InputMaybe<Scalars['ID']['input']>;
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  readonly opportunityStageChangeID?: InputMaybe<Scalars['ID']['input']>;
}

/**
 * UpdateContactInput is used for update Contact object.
 * Input was generated by ent.
 */
export interface UpdateContactInput {
  readonly accountID?: InputMaybe<Scalars['ID']['input']>;
  readonly addCallIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addCustomFieldValueIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addDocumentIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addOpportunityIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addReceivedEmailIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addSentEmailIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addTaskIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly clearAccount?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearCalls?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearCustomFieldValues?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearEmailAddress?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearFirstName?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearLastName?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearOpportunities?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearPhoneNumber?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearReceivedEmails?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearSentEmails?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearTasks?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearTitle?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly emailAddress?: InputMaybe<Scalars['String']['input']>;
  readonly firstName?: InputMaybe<Scalars['String']['input']>;
  readonly lastName?: InputMaybe<Scalars['String']['input']>;
  readonly phoneNumber?: InputMaybe<Scalars['String']['input']>;
  readonly removeCallIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeCustomFieldValueIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeDocumentIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeOpportunityIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeReceivedEmailIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeSentEmailIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeTaskIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly sourcePlatform?: InputMaybe<CallIntegration>;
  readonly title?: InputMaybe<Scalars['String']['input']>;
}

/**
 * UpdateCustomFieldEnumInput is used for update CustomFieldEnum object.
 * Input was generated by ent.
 */
export interface UpdateCustomFieldEnumInput {
  readonly addValueIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly clearExternalIdentifier?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearValues?: InputMaybe<Scalars['Boolean']['input']>;
  readonly customFieldID?: InputMaybe<Scalars['ID']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * ExternalIdentifier refers to a platform's internal name / ID for a given field value.
   * Not every platform has these (e.g. HubSpot), but some (like Volie) do.
   */
  readonly externalIdentifier?: InputMaybe<Scalars['String']['input']>;
  readonly removeValueIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly value?: InputMaybe<Scalars['String']['input']>;
}

/**
 * UpdateCustomFieldEnumerationFieldLinkInput is used for update CustomFieldEnumerationFieldLink object.
 * Input was generated by ent.
 */
export interface UpdateCustomFieldEnumerationFieldLinkInput {
  readonly customFieldID?: InputMaybe<Scalars['ID']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly enumerationFieldID?: InputMaybe<Scalars['ID']['input']>;
}

/**
 * UpdateCustomFieldInput is used for update CustomField object.
 * Input was generated by ent.
 */
export interface UpdateCustomFieldInput {
  readonly addEnumIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addEnumerationFieldIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addValueIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly clearDescription?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearEnumerationFields?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearEnums?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearExternalIdentifier?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearFieldType?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearGroupName?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearObjectType?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearSourcePlatform?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearValues?: InputMaybe<Scalars['Boolean']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly displayName?: InputMaybe<Scalars['String']['input']>;
  /**
   * ExternalIdentifier refers to a platform's internal name / ID for a given field.
   * E.g. in HubSpot, a property has both "label" (which is equivalent to our DisplayName field)
   * and a "name" field (which is unique, e.g. "favorite_food"). Other platforms have a typical
   * identifier, e.g. a UUID.
   */
  readonly externalIdentifier?: InputMaybe<Scalars['String']['input']>;
  readonly fieldType?: InputMaybe<CustomFieldCustomFieldType>;
  /** GroupName corresponds to the grouping of fields present in CRMs like Hubspot */
  readonly groupName?: InputMaybe<Scalars['String']['input']>;
  readonly objectType?: InputMaybe<CustomFieldObjectType>;
  readonly removeEnumIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeEnumerationFieldIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeValueIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly sourcePlatform?: InputMaybe<CallIntegration>;
}

/**
 * UpdateCustomFieldValueInput is used for update CustomFieldValue object.
 * Input was generated by ent.
 */
export interface UpdateCustomFieldValueInput {
  readonly accountID?: InputMaybe<Scalars['ID']['input']>;
  readonly callID?: InputMaybe<Scalars['ID']['input']>;
  readonly clearAccount?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearCall?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearContact?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearCustomFieldEnum?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearDocument?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearOpportunity?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearValue?: InputMaybe<Scalars['Boolean']['input']>;
  readonly contactID?: InputMaybe<Scalars['ID']['input']>;
  readonly customFieldEnumID?: InputMaybe<Scalars['ID']['input']>;
  readonly customFieldID?: InputMaybe<Scalars['ID']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly documentID?: InputMaybe<Scalars['ID']['input']>;
  readonly opportunityID?: InputMaybe<Scalars['ID']['input']>;
  readonly value?: InputMaybe<Scalars['String']['input']>;
}

/**
 * UpdateCustomerCRMConfigInput is used for update CustomerCRMConfig object.
 * Input was generated by ent.
 */
export interface UpdateCustomerCrmConfigInput {
  readonly appendStageIdsToUpdate?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly appendTerminalStageIds?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly clearOldID?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearOwner?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearStageIdsToUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearTerminalStageIds?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly integrationSecretID?: InputMaybe<Scalars['ID']['input']>;
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  readonly ownerID?: InputMaybe<Scalars['ID']['input']>;
  /** StagesToUpdate is a list of stage IDs which should be updated. */
  readonly stageIdsToUpdate?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** TerminalStages is a list of stage IDs which should no longer be updated. */
  readonly terminalStageIds?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
}

/**
 * UpdateCustomerInput is used for update Customer object.
 * Input was generated by ent.
 */
export interface UpdateCustomerInput {
  readonly addChildCustomerIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addCustomerProspectingConfigIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addEnumerationConfigurationIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addIntegrationSecretIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addUserIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly appendDomains?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly clearChildCustomers?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearCustomerCrmConfig?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearCustomerProspectingConfig?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearDescription?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearDomains?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearEnumerationConfigurations?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearIntegrationSecrets?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearInternalSummary?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearOldID?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearParentCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearUsers?: InputMaybe<Scalars['Boolean']['input']>;
  readonly customerCrmConfigID?: InputMaybe<Scalars['ID']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly domains?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly fiscalYearStartDay?: InputMaybe<Scalars['Int']['input']>;
  readonly fiscalYearStartMonth?: InputMaybe<Scalars['Int']['input']>;
  /** A summary of the customer that is only visible to Fabius, used for prompts */
  readonly internalSummary?: InputMaybe<Scalars['String']['input']>;
  readonly isActive?: InputMaybe<Scalars['Boolean']['input']>;
  readonly isReseller?: InputMaybe<Scalars['Boolean']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  readonly parentCustomerID?: InputMaybe<Scalars['ID']['input']>;
  readonly removeChildCustomerIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeCustomerProspectingConfigIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeEnumerationConfigurationIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeIntegrationSecretIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeUserIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
}

/**
 * UpdateCustomerProspectingConfigInput is used for update CustomerProspectingConfig object.
 * Input was generated by ent.
 */
export interface UpdateCustomerProspectingConfigInput {
  readonly appendClosedLostStageNames?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly appendPrimaryEmailTemplates?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly appendReengagementEmailTemplates?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly automatedAccountsPerDay?: InputMaybe<Scalars['Int']['input']>;
  readonly automaticallyPushContacts?: InputMaybe<Scalars['Boolean']['input']>;
  readonly buyerOrg?: InputMaybe<Scalars['String']['input']>;
  readonly buyerSkills?: InputMaybe<Scalars['String']['input']>;
  readonly clearAutomatedAccountsPerDay?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearClosedLostStageNames?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearDomainSpecificDirections?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearOldID?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearOnlyWebsite?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearPrimaryEmailTemplates?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearReengagementEmailTemplates?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearReengagementWithPublicInfo?: InputMaybe<Scalars['Boolean']['input']>;
  readonly closedLostStageNames?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** DomainSpecificDirections adds additional steering to the Contact Analysis prompt if set. */
  readonly domainSpecificDirections?: InputMaybe<Scalars['String']['input']>;
  /** The number of primary emails to create for each prospect. Each primary email will then have follow ups. */
  readonly numPrimaryEmails?: InputMaybe<Scalars['Int']['input']>;
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  /** OnlyWebsite determines whether to only use the prospect's website for prospecting. If true, we will scrape the website in depth vs making Google searches and other outside searches. */
  readonly onlyWebsite?: InputMaybe<Scalars['Boolean']['input']>;
  readonly primaryEmailTemplates?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** Re-engagement email templates represent the templates to use when sending emails to prospects that the customer has met with before, and hence referencing the previous call */
  readonly reengagementEmailTemplates?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** ReengagementWithPublicInfo determines whether to include public information about the prospect in the re-engagement email. */
  readonly reengagementWithPublicInfo?: InputMaybe<Scalars['Boolean']['input']>;
  readonly valueMessaging?: InputMaybe<Scalars['String']['input']>;
}

/**
 * UpdateDirectoryInput is used for update Directory object.
 * Input was generated by ent.
 */
export interface UpdateDirectoryInput {
  readonly addDocumentIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addSubdirectoryIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly clearDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearOldID?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearParent?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearSubdirectories?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly oldID?: InputMaybe<Scalars['OldID']['input']>;
  readonly parentID?: InputMaybe<Scalars['ID']['input']>;
  readonly removeDocumentIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeSubdirectoryIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
}

/**
 * UpdateDocumentIngestionConfigInput is used for update DocumentIngestionConfig object.
 * Input was generated by ent.
 */
export interface UpdateDocumentIngestionConfigInput {
  readonly clearOldID?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly documentType?: InputMaybe<DocumentIngestionConfigDocumentType>;
  readonly integrationSecretID?: InputMaybe<Scalars['ID']['input']>;
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
}

/**
 * UpdateDocumentInput is used for update Document object.
 * Input was generated by ent.
 */
export interface UpdateDocumentInput {
  readonly accountID?: InputMaybe<Scalars['ID']['input']>;
  readonly addCustomFieldValueIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addEnumerationValueIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly clearAccount?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearContact?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearCustomFieldValues?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearDocumentSource?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearEnumerationValues?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearGongUser?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearOpportunity?: InputMaybe<Scalars['Boolean']['input']>;
  readonly contactID?: InputMaybe<Scalars['ID']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly documentSource?: InputMaybe<DocumentCallIntegration>;
  /** DocumentTimestamp is the timestamp of when the document was generated, published, etc. */
  readonly documentTimestamp?: InputMaybe<Scalars['Unix']['input']>;
  readonly documentType?: InputMaybe<DocumentDocumentType>;
  readonly gongUserID?: InputMaybe<Scalars['ID']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly opportunityID?: InputMaybe<Scalars['ID']['input']>;
  /** Path is the relative path to the file on s3 */
  readonly path?: InputMaybe<Scalars['String']['input']>;
  readonly removeCustomFieldValueIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeEnumerationValueIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
}

/**
 * UpdateEmailDeliveryInput is used for update EmailDelivery object.
 * Input was generated by ent.
 */
export interface UpdateEmailDeliveryInput {
  readonly clearEmailAddress?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearOldID?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearSubject?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** EmailAddress is the email address of the recipient of the email delivery. */
  readonly emailAddress?: InputMaybe<Scalars['String']['input']>;
  readonly emailSubscriptionID?: InputMaybe<Scalars['ID']['input']>;
  readonly enumerationValueID?: InputMaybe<Scalars['ID']['input']>;
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  /** Subject is the subject of the email delivery. */
  readonly subject?: InputMaybe<Scalars['String']['input']>;
}

/**
 * UpdateEmailDraftPublishInput is used for update EmailDraftPublish object.
 * Input was generated by ent.
 */
export interface UpdateEmailDraftPublishInput {
  readonly body?: InputMaybe<Scalars['String']['input']>;
  readonly clearBody?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly emailID?: InputMaybe<Scalars['ID']['input']>;
  readonly emailReplyDraftID?: InputMaybe<Scalars['ID']['input']>;
}

/**
 * UpdateEmailInput is used for update Email object.
 * Input was generated by ent.
 */
export interface UpdateEmailInput {
  readonly addEmailReplyContextIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addEmailReplyDraftIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addEnumerationValueIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addRecipientIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addResponseIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addTaskIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly appendBcc?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly appendCc?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly appendTo?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** Bcc is the raw Bcc header value from the email. */
  readonly bcc?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly body?: InputMaybe<Scalars['String']['input']>;
  /** Cc is the raw Cc header value from the email. */
  readonly cc?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly clearBody?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearCurrentSummary?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearEmailReplyContexts?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearEmailReplyDrafts?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearEnumerationValues?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearFromContact?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearFromUser?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearInReplyTo?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearNext?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearPrevious?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearRecipients?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearReferences?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearResponses?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearSubject?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearTasks?: InputMaybe<Scalars['Boolean']['input']>;
  readonly currentSummaryID?: InputMaybe<Scalars['ID']['input']>;
  /** Date is the timestamp of when the email was delivered. */
  readonly date?: InputMaybe<Scalars['Unix']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** ExternalIdentifier is the unique identifier of the email in the source platform (e.g. `gmail_message_id`). */
  readonly externalIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** From is the raw FROM header value from the email. */
  readonly from?: InputMaybe<Scalars['String']['input']>;
  readonly fromContactID?: InputMaybe<Scalars['ID']['input']>;
  readonly fromUserID?: InputMaybe<Scalars['ID']['input']>;
  /** InReplyTo is the raw In-Reply-To header value from the email. */
  readonly inReplyTo?: InputMaybe<Scalars['String']['input']>;
  readonly nextID?: InputMaybe<Scalars['ID']['input']>;
  readonly previousID?: InputMaybe<Scalars['ID']['input']>;
  /** References is the raw References header value from the email. */
  readonly references?: InputMaybe<Scalars['String']['input']>;
  readonly removeEmailReplyContextIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeEmailReplyDraftIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeEnumerationValueIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeRecipientIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeResponseIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeTaskIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** RFCMessageID is the unique identifier of the email in the RFC822 format (e.g. `Message-ID`). */
  readonly rfcMessageID?: InputMaybe<Scalars['String']['input']>;
  readonly sourcePlatform?: InputMaybe<EmailCallIntegration>;
  /** Subject is the raw Subject header value from the email. */
  readonly subject?: InputMaybe<Scalars['String']['input']>;
  readonly threadID?: InputMaybe<Scalars['ID']['input']>;
  /** To is the raw To header value from the email. */
  readonly to?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
}

/**
 * UpdateEmailRecipientInput is used for update EmailRecipient object.
 * Input was generated by ent.
 */
export interface UpdateEmailRecipientInput {
  readonly clearContact?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearUser?: InputMaybe<Scalars['Boolean']['input']>;
  readonly contactID?: InputMaybe<Scalars['ID']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly emailID?: InputMaybe<Scalars['ID']['input']>;
  readonly recipientType?: InputMaybe<EmailRecipientRecipientType>;
  readonly userID?: InputMaybe<Scalars['ID']['input']>;
}

/**
 * UpdateEmailReplyContextInput is used for update EmailReplyContext object.
 * Input was generated by ent.
 */
export interface UpdateEmailReplyContextInput {
  readonly clearKnowledgeDocument?: InputMaybe<Scalars['Boolean']['input']>;
  /** A human-readable context for the email reply, also used by the LLM to generate the reply. */
  readonly context?: InputMaybe<Scalars['String']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly emailID?: InputMaybe<Scalars['ID']['input']>;
  readonly knowledgeDocumentID?: InputMaybe<Scalars['ID']['input']>;
}

/**
 * UpdateEmailReplyDraftInput is used for update EmailReplyDraft object.
 * Input was generated by ent.
 */
export interface UpdateEmailReplyDraftInput {
  readonly addEmailDraftPublishIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly body?: InputMaybe<Scalars['String']['input']>;
  readonly clearBody?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearEmailDraftPublishes?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly emailID?: InputMaybe<Scalars['ID']['input']>;
  readonly removeEmailDraftPublishIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
}

/**
 * UpdateEmailSubscriptionConfigFieldInput is used for update EmailSubscriptionConfigField object.
 * Input was generated by ent.
 */
export interface UpdateEmailSubscriptionConfigFieldInput {
  readonly clearDisplayName?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearEnumerationField?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearOldID?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly displayName?: InputMaybe<Scalars['String']['input']>;
  readonly emailSubscriptionConfigID?: InputMaybe<Scalars['ID']['input']>;
  readonly enumerationFieldID?: InputMaybe<Scalars['ID']['input']>;
  readonly filterTemplate?: InputMaybe<Scalars['String']['input']>;
  /**
   * Index specifies which order this field should be rendered in an email.
   * Index is zero based, and lower values are rendered first.
   */
  readonly index?: InputMaybe<Scalars['Int']['input']>;
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
}

/**
 * UpdateEmailSubscriptionConfigInput is used for update EmailSubscriptionConfig object.
 * Input was generated by ent.
 */
export interface UpdateEmailSubscriptionConfigInput {
  readonly addAdhocEmailSendIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addEmailSubscriptionConfigFieldIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addEmailSubscriptionLinkIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly clearAdhocEmailSends?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearEmailSubscriptionConfigFields?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearEmailSubscriptionLinks?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearOldID?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearSubjectTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  /** Default is a boolean field that when set to true will be the default email subscription config for the enumeration configuration. */
  readonly default?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly enumerationConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  readonly removeAdhocEmailSendIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeEmailSubscriptionConfigFieldIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeEmailSubscriptionLinkIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** ShowFeedbackLink is a boolean field that when set to true will include a feedback link in the email. */
  readonly showFeedbackLink?: InputMaybe<Scalars['Boolean']['input']>;
  /** SubjectTemplate is an optional field that when set will be executed to generate the email subject. */
  readonly subjectTemplate?: InputMaybe<Scalars['String']['input']>;
}

/**
 * UpdateEmailSubscriptionInput is used for update EmailSubscription object.
 * Input was generated by ent.
 */
export interface UpdateEmailSubscriptionInput {
  readonly addEmailDeliveryIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addEmailSubscriptionLinkIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly appendAttendeeGroups?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly appendAttendees?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly appendCustomerCustomers?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly appendHostGroups?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly appendHosts?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly appendUserGroupIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly attendeeGroups?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly attendees?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly callFilterTemplate?: InputMaybe<Scalars['String']['input']>;
  readonly clearAttendeeGroups?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearAttendees?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearCallFilterTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearCustomerCustomers?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearEmailDeliveries?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearEmailSubscriptionLinks?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearHostGroups?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearHosts?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearToAddress?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearUser?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearUserGroupIds?: InputMaybe<Scalars['Boolean']['input']>;
  readonly customerCustomers?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hostGroups?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly hosts?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeEmailDeliveryIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeEmailSubscriptionLinkIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly toAddress?: InputMaybe<Scalars['String']['input']>;
  readonly userGroupIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly userID?: InputMaybe<Scalars['ID']['input']>;
}

/**
 * UpdateEmailSubscriptionLinkInput is used for update EmailSubscriptionLink object.
 * Input was generated by ent.
 */
export interface UpdateEmailSubscriptionLinkInput {
  readonly clearOldID?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly emailSubscriptionConfigID?: InputMaybe<Scalars['ID']['input']>;
  readonly emailSubscriptionID?: InputMaybe<Scalars['ID']['input']>;
  readonly enumerationConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
}

/**
 * UpdateEmailThreadInput is used for update EmailThread object.
 * Input was generated by ent.
 */
export interface UpdateEmailThreadInput {
  readonly addEmailIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addSummaryIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly clearEmails?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearSummaries?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly externalIdentifier?: InputMaybe<Scalars['String']['input']>;
  readonly lastActivityAt?: InputMaybe<Scalars['Unix']['input']>;
  readonly removeEmailIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeSummaryIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly sourcePlatform?: InputMaybe<CallIntegration>;
  readonly userID?: InputMaybe<Scalars['ID']['input']>;
}

/**
 * UpdateEmailThreadSummaryInput is used for update EmailThreadSummary object.
 * Input was generated by ent.
 */
export interface UpdateEmailThreadSummaryInput {
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly emailID?: InputMaybe<Scalars['ID']['input']>;
  readonly emailThreadID?: InputMaybe<Scalars['ID']['input']>;
  readonly summary?: InputMaybe<Scalars['String']['input']>;
}

/**
 * UpdateEnumerationConfigFieldLinkInput is used for update EnumerationConfigFieldLink object.
 * Input was generated by ent.
 */
export interface UpdateEnumerationConfigFieldLinkInput {
  readonly addClassifierConditionIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addDraftIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addKnowledgeDocumentPromptInstructionIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly clearClassifierConditions?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearDefinitions?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearDirections?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearDrafts?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearInstructions?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearKnowledgeDocumentPromptInstructions?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearOldID?: InputMaybe<Scalars['Boolean']['input']>;
  /** Definitions represent the contextual definition that the model needs in order to be able to best do it's job, so that there isn't ambiguity about the terms using in the instructions/directions or whether the calls/documents themselves. This is often left blank if there isn't much chance of confusion. If the type of the value or score is non-custom, then adding to this will append the text after the standard definitions for that field. */
  readonly definitions?: InputMaybe<Scalars['String']['input']>;
  /** Directions are the specific steps or detailed context that the model needs to take in order to complete the analysis. This is generally more detailed than the instructions and is often used to break down the instructions into more digestible steps or talk through edge cases. If the type of the value or score is non-custom, then adding to this will append the text after the standard directions for that field. */
  readonly directions?: InputMaybe<Scalars['String']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly enumerationConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  readonly enumerationFieldID?: InputMaybe<Scalars['ID']['input']>;
  /** Instructions represents the main description of the task that the model needs to do to complete the analysis. For normal fields, this generally describes how to analyze the call/document. For scores, this is the rubric that outlines exactly how to score the rep on the call. If the type of the value or score is non-custom, then adding to this will append the text after the standard instructions for that field. */
  readonly instructions?: InputMaybe<Scalars['String']['input']>;
  /**
   * IsAggregation represents whether the field is an aggregation of the enumeration field, or the
   * field itself is what is to be enumerated.
   */
  readonly isAggregation?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  readonly removeClassifierConditionIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeDraftIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeKnowledgeDocumentPromptInstructionIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** Version tracks the revision number of this EnumerationConfigFieldLink. It increments with each deployment. */
  readonly version?: InputMaybe<Scalars['Int']['input']>;
}

/**
 * UpdateEnumerationConfigStageLinkInput is used for update EnumerationConfigStageLink object.
 * Input was generated by ent.
 */
export interface UpdateEnumerationConfigStageLinkInput {
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly enumerationConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  readonly pipelineStageID?: InputMaybe<Scalars['ID']['input']>;
}

/**
 * UpdateEnumerationConfigurationClassifierEnumInput is used for update EnumerationConfigurationClassifierEnum object.
 * Input was generated by ent.
 */
export interface UpdateEnumerationConfigurationClassifierEnumInput {
  readonly classifierEnumValueID?: InputMaybe<Scalars['ID']['input']>;
  readonly clearOldID?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly enumerationConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
}

/**
 * UpdateEnumerationConfigurationDraftInput is used for update EnumerationConfigurationDraft object.
 * Input was generated by ent.
 */
export interface UpdateEnumerationConfigurationDraftInput {
  readonly addEnumerationFieldIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly clearDescription?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearEnumerationField?: InputMaybe<Scalars['Boolean']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly enumerationConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly removeEnumerationFieldIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
}

/**
 * UpdateEnumerationConfigurationInput is used for update EnumerationConfiguration object.
 * Input was generated by ent.
 */
export interface UpdateEnumerationConfigurationInput {
  /** Active specifies whether the enumeration_configuration is currently active. This is separate from disabled, which means that it is soft-deleted. */
  readonly active?: InputMaybe<Scalars['Boolean']['input']>;
  readonly addDraftIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addEmailSubscriptionConfigIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addEmailSubscriptionLinkIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addEnumerationConfigurationClassifierEnumValueIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addEnumerationFieldIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addEnumerationPromptConfigIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addEnumerationValueIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addKnowledgeDocumentPromptInstructionIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addPipelineStageIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly appendScoreEligibilityQuestions?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly clearCustomPreface?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearDrafts?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearEmailSubscriptionConfigs?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearEmailSubscriptionLinks?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearEnumerationConfigurationClassifierEnumValues?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearEnumerationFields?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearEnumerationPromptConfig?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearEnumerationPromptConfigFilter?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearEnumerationValues?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearFilterTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearKnowledgeDocumentPromptInstructions?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearLookBackDays?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearName?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearOldID?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearPipelineStages?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearScoreEligibilityQuestions?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearUseTool?: InputMaybe<Scalars['Boolean']['input']>;
  /** CustomPreface, if set, will overwrite or the standard prompt preface (which differs depending on the Mode). */
  readonly customPreface?: InputMaybe<Scalars['String']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly enumerationPromptConfigFilterID?: InputMaybe<Scalars['ID']['input']>;
  /** FilterTemplate determines which calls/documents/etc should be analyzed by this specific enumeration_configuration. For example, we could filter it to only analyze calls from certain reps, or calls with certain names, or documents that are added to the account during a certain part of the sales pipeline */
  readonly filterTemplate?: InputMaybe<Scalars['String']['input']>;
  readonly lookBackDays?: InputMaybe<Scalars['Int']['input']>;
  /** Mode specifies which type(s) of messages the config applies to. */
  readonly mode?: InputMaybe<EnumerationConfigurationMode>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Publish specifies whether the resulting enumeration values are published to downstream consumers.
   * Should be set to true once "live".
   */
  readonly publish?: InputMaybe<Scalars['Boolean']['input']>;
  readonly removeDraftIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeEmailSubscriptionConfigIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeEmailSubscriptionLinkIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeEnumerationConfigurationClassifierEnumValueIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeEnumerationFieldIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeEnumerationPromptConfigIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeEnumerationValueIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeKnowledgeDocumentPromptInstructionIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removePipelineStageIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** ScoreEligibilityQuestions represents a way to "turn off" doing a full analysis if it doesn't fit into the type of analysis we want to perform. For example, the default is that if the client doesn't show up to a call, then we don't do a full analysis. */
  readonly scoreEligibilityQuestions?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** UseTool specifies whether to use the tool to generate analysis. */
  readonly useTool?: InputMaybe<Scalars['Boolean']['input']>;
}

/**
 * UpdateEnumerationDraftInput is used for update EnumerationDraft object.
 * Input was generated by ent.
 */
export interface UpdateEnumerationDraftInput {
  readonly addEnumerationFieldDraftIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly clearDescription?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearEnumerationFieldDrafts?: InputMaybe<Scalars['Boolean']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly removeEnumerationFieldDraftIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** Status indicates the current state of the draft in the drafting workflow. */
  readonly status?: InputMaybe<EnumerationDraftDraftStatus>;
}

/**
 * UpdateEnumerationFieldDraftInput is used for update EnumerationFieldDraft object.
 * Input was generated by ent.
 */
export interface UpdateEnumerationFieldDraftInput {
  readonly alwaysIncludeTranscript?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearCustomOutputMessage?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearDefinitions?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearDescription?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearDirections?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearEnumerationDraft?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearInstructions?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearLiveField?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearScoreType?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearScratchpad?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearValueType?: InputMaybe<Scalars['Boolean']['input']>;
  readonly complexity?: InputMaybe<EnumerationFieldDraftComplexity>;
  /** CustomOutputMessage provides a template for the output formatting of the analysis, if needed. */
  readonly customOutputMessage?: InputMaybe<Scalars['String']['input']>;
  /** Definitions represent the contextual definition that the model needs in order to be able to best do it's job, so that there isn't ambiguity about the terms using in the instructions/directions or whether the calls/documents themselves. This is often left blank if there isn't much chance of confusion. If the type of the value or score is non-custom, then adding to this will append the text after the standard definitions for that field. */
  readonly definitions?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** Directions are the specific steps or detailed context that the model needs to take in order to complete the analysis. This is generally more detailed than the instructions and is often used to break down the instructions into more digestible steps or talk through edge cases. If the type of the value or score is non-custom, then adding to this will append the text after the standard directions for that field. */
  readonly directions?: InputMaybe<Scalars['String']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly enumerationDraftID?: InputMaybe<Scalars['ID']['input']>;
  /** Instructions represents the main description of the task that the model needs to do to complete the analysis. For normal fields, this generally describes how to analyze the call/document. For scores, this is the rubric that outlines exactly how to score the rep on the call. If the type of the value or score is non-custom, then adding to this will append the text after the standard instructions for that field. */
  readonly instructions?: InputMaybe<Scalars['String']['input']>;
  /** IsRuleBased indicates if the analysis follows specific rules (true) or is more judgment-based (false). */
  readonly isRuleBased?: InputMaybe<Scalars['Boolean']['input']>;
  readonly liveFieldID?: InputMaybe<Scalars['ID']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  /** ScoreType specifies the scoring method for score analyses. It may be a custom score or a predefined score type. */
  readonly scoreType?: InputMaybe<EnumerationFieldDraftType>;
  /** Scratchpad contains prompts or instructions to assist the model in processing complex analyses. */
  readonly scratchpad?: InputMaybe<Scalars['String']['input']>;
  /** Status indicates the current state of the draft in the drafting workflow. */
  readonly status?: InputMaybe<EnumerationFieldDraftDraftStatus>;
  /** ValueType specifies the output type for value analyses. It may be a standard field, an array of strings, a key-value map, etc. */
  readonly valueType?: InputMaybe<EnumerationFieldDraftValue>;
  /** Version tracks the revision number of this draft. It increments with each new draft for a specific field, and it is DIFFERENT than the version of the EnumerationField that this draft is modifying (because drafts can be rejected, etc). */
  readonly version?: InputMaybe<Scalars['Int']['input']>;
}

/**
 * UpdateEnumerationFieldInput is used for update EnumerationField object.
 * Input was generated by ent.
 */
export interface UpdateEnumerationFieldInput {
  readonly addCrmSubscriptionIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addCustomFieldIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addDraftIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addEmailSubscriptionConfigFieldIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addEnumerationConfigurationIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addFromFieldDependencyLinkIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addKnowledgeDocumentPromptInstructionIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addOutputIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addScoreIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addToFieldDependencyLinkIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addUserScoreStatIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /**
   * AlwaysIncludeTranscript determines whether we should include the transcript in the analysis IF
   * the analysis also has fields it depends on.
   */
  readonly alwaysIncludeTranscript?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearAlwaysIncludeTranscript?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearCrmSubscriptions?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearCustomFields?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearCustomOutputMessage?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearDefinitions?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearDescription?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearDirections?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearDrafts?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearEmailSubscriptionConfigFields?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearEnumerationConfigurations?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearFromFieldDependencyLinks?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearInstructions?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearIsRuleBased?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearKnowledgeDocumentPromptInstructions?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearOldID?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearOutputs?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearScoreType?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearScores?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearScratchpad?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearToFieldDependencyLinks?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearUserScoreStats?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearValueType?: InputMaybe<Scalars['Boolean']['input']>;
  readonly complexity?: InputMaybe<EnumerationFieldComplexity>;
  /** CustomOutputMessage, if set, will replace the generic value in the OutputFormat. This will provide the template for the output of the analysis. For example, if generating a job description, the CustomOutputMessage may show the model to format the JD with sections for Requirements, Responsibilities, and Scope. */
  readonly customOutputMessage?: InputMaybe<Scalars['String']['input']>;
  /** Definitions represent the contextual definition that the model needs in order to be able to best do it's job, so that there isn't ambiguity about the terms using in the instructions/directions or whether the calls/documents themselves. This is often left blank if there isn't much chance of confusion. If the type of the value or score is non-custom, then adding to this will append the text after the standard definitions for that field. */
  readonly definitions?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** Directions are the specific steps or detailed context that the model needs to take in order to complete the analysis. This is generally more detailed than the instructions and is often used to break down the instructions into more digestible steps or talk through edge cases. If the type of the value or score is non-custom, then adding to this will append the text after the standard directions for that field. */
  readonly directions?: InputMaybe<Scalars['String']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Instructions represents the main description of the task that the model needs to do to complete the analysis. For normal fields, this generally describes how to analyze the call/document. For scores, this is the rubric that outlines exactly how to score the rep on the call. If the type of the value or score is non-custom, then adding to this will append the text after the standard instructions for that field. */
  readonly instructions?: InputMaybe<Scalars['String']['input']>;
  /**
   * IsRuleBased is a flag that determines whether the instructions are primarily based on specific rules to follow (such as "did the sales rep mention XYZ while selling")
   * or is it more judgement based (how good of a fit is this customer for our product).
   */
  readonly isRuleBased?: InputMaybe<Scalars['Boolean']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  readonly removeCrmSubscriptionIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeCustomFieldIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeDraftIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeEmailSubscriptionConfigFieldIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeEnumerationConfigurationIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeFromFieldDependencyLinkIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeKnowledgeDocumentPromptInstructionIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeOutputIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeScoreIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeToFieldDependencyLinkIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeUserScoreStatIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** ScoreType is non-nill when the enumeration_field represents a score analysis. It is either a pre-defined score like 'Type_DISCOVERY' that already has the score laid out, or (more likely) it defines the type of the score which would be 'Type_CUSTOM_SCORE'. */
  readonly scoreType?: InputMaybe<EnumerationFieldType>;
  /** Scratchpad, if set, will add a scratchpad field prior to the output of this field whose directions are the value of this field. This will let the model think through the answer beforehand, which is useful when the analysis is complex and the model may need to think out loud before outputting the final analysis. */
  readonly scratchpad?: InputMaybe<Scalars['String']['input']>;
  /** ValueType is non-nil when the enumeration_field represents a value analysis. It is either a pre-defined analysis like 'Stakeholders' that already has the analysis laid out, or (more likely) it defines the type of the value. This is either a standard field (which is type Value_CUSTOM_STRING), an array of fields such as when trying to capture all the competitors (which is type Value_CUSTOM_STRINGS), or a key/value map such as when trying to capture the customer's objections and explaining how the rep handled it (which is type Value_CUSTOM_MAP). */
  readonly valueType?: InputMaybe<EnumerationFieldValue>;
  /** Version tracks the revision number of this EnumerationField. It increments with each deployment. */
  readonly version?: InputMaybe<Scalars['Int']['input']>;
}

/**
 * UpdateEnumerationPromptConfigInput is used for update EnumerationPromptConfig object.
 * Input was generated by ent.
 */
export interface UpdateEnumerationPromptConfigInput {
  readonly analysisMode?: InputMaybe<EnumerationPromptConfigMode>;
  readonly appendCustomDocumentPreface?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly appendCustomSystemMessage?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly appendCustomTranscriptPreface?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly clearCustomDocumentPreface?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearCustomDocumentPrefaceAction?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearCustomSystemMessage?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearCustomSystemMessageAction?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearCustomTranscriptPreface?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearCustomTranscriptPrefaceAction?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearOldID?: InputMaybe<Scalars['Boolean']['input']>;
  /** CustomDocumentPreface, if set, will either overwrite or append/prepend to the standard prompt document section. */
  readonly customDocumentPreface?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly customDocumentPrefaceAction?: InputMaybe<EnumerationPromptConfigCustomAction>;
  /**
   * CustomSystemMessage, if set, will either overwrite or append/prepend to the standard prompt "system message"
   * aka the very beginning of the prompt (depending on CustomSystemMessageAction). Each value will be on a new line.
   */
  readonly customSystemMessage?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly customSystemMessageAction?: InputMaybe<EnumerationPromptConfigCustomAction>;
  /**
   * CustomTranscriptPreface, if set, will either overwrite or append/prepend to the standard prompt transcript
   * preface (depending on CustomSystemMessageAction). Each value will be on a new line.
   */
  readonly customTranscriptPreface?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly customTranscriptPrefaceAction?: InputMaybe<EnumerationPromptConfigCustomAction>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly enumerationConfigurationsID?: InputMaybe<Scalars['ID']['input']>;
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
}

/**
 * UpdateEnumerationValueFeedbackInput is used for update EnumerationValueFeedback object.
 * Input was generated by ent.
 */
export interface UpdateEnumerationValueFeedbackInput {
  readonly clearOldID?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearSpecificFieldText?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly enumerationFieldID?: InputMaybe<Scalars['ID']['input']>;
  readonly enumerationValueID?: InputMaybe<Scalars['ID']['input']>;
  readonly feedback?: InputMaybe<Scalars['String']['input']>;
  readonly fieldName?: InputMaybe<Scalars['String']['input']>;
  readonly fieldType?: InputMaybe<EnumerationValueFeedbackFieldType>;
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  /** specificFieldText represents a specific portion text that the user wants to give feedback on. */
  readonly specificFieldText?: InputMaybe<Scalars['String']['input']>;
}

/**
 * UpdateEnumerationValueInput is used for update EnumerationValue object.
 * Input was generated by ent.
 */
export interface UpdateEnumerationValueInput {
  readonly addEmailDeliveryIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addEnumerationValueFeedbackIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addOutputIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addScoreIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly additionalCallUuids: ReadonlyArray<Scalars['ID']['input']>;
  readonly additionalDocumentUuids: ReadonlyArray<Scalars['ID']['input']>;
  readonly appendAdditionalCallUuids: ReadonlyArray<Scalars['ID']['input']>;
  readonly appendAdditionalDocumentUuids: ReadonlyArray<Scalars['ID']['input']>;
  readonly callID?: InputMaybe<Scalars['ID']['input']>;
  readonly clearAdditionalCallUuids?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearAdditionalDocumentUuids?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearCall?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearDocument?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearEmail?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearEmailDeliveries?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearEndDate?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearEnumerationConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearEnumerationValueFeedback?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearFeedback?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearFeedbackComment?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearGongUser?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearOpportunityStageChange?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearOutputs?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearScores?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearStartDate?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly documentID?: InputMaybe<Scalars['ID']['input']>;
  readonly emailID?: InputMaybe<Scalars['ID']['input']>;
  readonly endDate?: InputMaybe<Scalars['Unix']['input']>;
  readonly enumerationConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  /**
   * "Feedback refers to feedback from a user (or internal) on
   * whether or not the EnumerationValue was (in)correct. If null,
   * no feedback has been given."
   */
  readonly feedback?: InputMaybe<Scalars['Boolean']['input']>;
  readonly feedbackComment?: InputMaybe<Scalars['String']['input']>;
  readonly gongUserID?: InputMaybe<Scalars['ID']['input']>;
  readonly opportunityStageChangeID?: InputMaybe<Scalars['ID']['input']>;
  readonly removeEmailDeliveryIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeEnumerationValueFeedbackIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeOutputIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeScoreIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly startDate?: InputMaybe<Scalars['Unix']['input']>;
}

/**
 * UpdateEnumerationValueScoreInput is used for update EnumerationValueScore object.
 * Input was generated by ent.
 */
export interface UpdateEnumerationValueScoreInput {
  readonly addDeliveryIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly clearDeliveries?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearOldID?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearScore?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearSuggestions?: InputMaybe<Scalars['Boolean']['input']>;
  readonly cons?: InputMaybe<Scalars['String']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly enumerationFieldID?: InputMaybe<Scalars['ID']['input']>;
  readonly enumerationValueID?: InputMaybe<Scalars['ID']['input']>;
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  readonly pros?: InputMaybe<Scalars['String']['input']>;
  readonly removeDeliveryIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /**
   * Score is the score given to the enumeration value. It is a value between 1 and 10. If nil,
   * this score was not applicable for the given source input.
   */
  readonly score?: InputMaybe<Scalars['Int']['input']>;
  readonly suggestions?: InputMaybe<Scalars['String']['input']>;
}

/**
 * UpdateFieldDependencyLinkInput is used for update FieldDependencyLink object.
 * Input was generated by ent.
 */
export interface UpdateFieldDependencyLinkInput {
  readonly clearFromEnumerationField?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearOldID?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearToEnumerationField?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly fromEnumerationFieldID?: InputMaybe<Scalars['ID']['input']>;
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  readonly toEnumerationFieldID?: InputMaybe<Scalars['ID']['input']>;
}

/**
 * UpdateGongUserInput is used for update GongUser object.
 * Input was generated by ent.
 */
export interface UpdateGongUserInput {
  readonly active?: InputMaybe<Scalars['Boolean']['input']>;
  readonly addCallIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addDocumentIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addEnumerationValueIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addFabiusManagerIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addFabiusReportIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addOpportunityIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addReportIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly clearCalls?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearEmailAddress?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearEnumerationValues?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearFabiusManagers?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearFabiusReports?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearManager?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearOpportunities?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearReports?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearSourcePlatform?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearTitle?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearUser?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly emailAddress?: InputMaybe<Scalars['String']['input']>;
  readonly externalUserID?: InputMaybe<Scalars['OldID']['input']>;
  readonly firstName?: InputMaybe<Scalars['String']['input']>;
  readonly lastName?: InputMaybe<Scalars['String']['input']>;
  readonly managerID?: InputMaybe<Scalars['ID']['input']>;
  readonly removeCallIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeDocumentIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeEnumerationValueIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeFabiusManagerIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeFabiusReportIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeOpportunityIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeReportIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly sourcePlatform?: InputMaybe<GongUserCallIntegration>;
  readonly title?: InputMaybe<Scalars['String']['input']>;
  readonly userID?: InputMaybe<Scalars['ID']['input']>;
}

/**
 * UpdateIntegrationSecretInput is used for update IntegrationSecret object.
 * Input was generated by ent.
 */
export interface UpdateIntegrationSecretInput {
  /** AccountID represents the associated account ID of the integration (if applicable). */
  readonly accountID?: InputMaybe<Scalars['String']['input']>;
  readonly addChildSecretIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly appendUseCases: ReadonlyArray<UseCase>;
  readonly clearAccountID?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearChildSecrets?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearCustomerCrmConfig?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearDocumentIngestionConfig?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearOldID?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearParentSecret?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearUseCases?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearUser?: InputMaybe<Scalars['Boolean']['input']>;
  readonly customerCrmConfigID?: InputMaybe<Scalars['ID']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly documentIngestionConfigID?: InputMaybe<Scalars['ID']['input']>;
  readonly integration?: InputMaybe<IntegrationSecretCallIntegration>;
  /** IsBackfilling means we are actively backfilling data from this integration if true. */
  readonly isBackfilling?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  readonly parentSecretID?: InputMaybe<Scalars['ID']['input']>;
  readonly removeChildSecretIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly secretArn?: InputMaybe<Scalars['String']['input']>;
  readonly useCases: ReadonlyArray<UseCase>;
  readonly userID?: InputMaybe<Scalars['ID']['input']>;
}

/**
 * UpdateKnowledgeDocumentInput is used for update KnowledgeDocument object.
 * Input was generated by ent.
 */
export interface UpdateKnowledgeDocumentInput {
  readonly addEmailReplyContextIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addKnowledgeDocumentPromptInstructionIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addVersionIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly clearCurrentVersion?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearDirectory?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearEmailReplyContexts?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearIsUseful?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearKnowledgeDocumentPromptInstructions?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearOldID?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearURL?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearVersions?: InputMaybe<Scalars['Boolean']['input']>;
  readonly currentVersionID?: InputMaybe<Scalars['ID']['input']>;
  /** Description is the customer-facing description of the document */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly directoryID?: InputMaybe<Scalars['ID']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** IsUseful is a flag to indicate if the document is useful or not for further processing/synthesis. When we ingest large numbers of documents at once, we want to give the models an option to process a document (so we don't process it again) while flagging that it shouldn't be used for downstream purposes. An example could be a webpage with only 2-3 sentences on it, terms of service that are very long and don't have much information, or internal documents that aren't useful for sales */
  readonly isUseful?: InputMaybe<Scalars['Boolean']['input']>;
  /** MimeType is the mime type of the raw document contents stored in the RawFilePath */
  readonly mimeType?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly oldID?: InputMaybe<Scalars['OldID']['input']>;
  readonly removeEmailReplyContextIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeKnowledgeDocumentPromptInstructionIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeVersionIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** Source is where the document came from, for example a manual upload, a URL, or a Google Docs. */
  readonly source?: InputMaybe<KnowledgeDocumentDocumentSourceType>;
  /** Type is the type of the document - meant in a domain-specific way. For example, two documents from a customer's webpage could be different types, like one could be marketing material and the other product documentation */
  readonly type?: InputMaybe<KnowledgeDocumentDocumentType>;
  /** URL is the URL to the document (if it was pulled from a URL). */
  readonly url?: InputMaybe<Scalars['String']['input']>;
}

/**
 * UpdateKnowledgeDocumentPromptInstructionInput is used for update KnowledgeDocumentPromptInstruction object.
 * Input was generated by ent.
 */
export interface UpdateKnowledgeDocumentPromptInstructionInput {
  readonly classifierConditionID?: InputMaybe<Scalars['ID']['input']>;
  readonly clearClassifierCondition?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearDefinitions?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearDirections?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearEnumerationConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearEnumerationField?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearInstructions?: InputMaybe<Scalars['Boolean']['input']>;
  /** Definitions represent the contextual definition that the model needs in order to be able to best do it's job, so that there isn't ambiguity about the terms using in the instructions/directions or whether the calls/documents themselves. This is often left blank if there isn't much chance of confusion. If the type of the value or score is non-custom, then adding to this will append the text after the standard definitions for that field. */
  readonly definitions?: InputMaybe<Scalars['String']['input']>;
  /** Directions are the specific steps or detailed context that the model needs to take in order to complete the analysis. This is generally more detailed than the instructions and is often used to break down the instructions into more digestible steps or talk through edge cases. If the type of the value or score is non-custom, then adding to this will append the text after the standard directions for that field. */
  readonly directions?: InputMaybe<Scalars['String']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly enumerationConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  readonly enumerationFieldID?: InputMaybe<Scalars['ID']['input']>;
  /** Instructions represents the main description of the task that the model needs to do to complete the analysis. For normal fields, this generally describes how to analyze the call/document. For scores, this is the rubric that outlines exactly how to score the rep on the call. If the type of the value or score is non-custom, then adding to this will append the text after the standard instructions for that field. */
  readonly instructions?: InputMaybe<Scalars['String']['input']>;
  readonly knowledgeDocumentID?: InputMaybe<Scalars['ID']['input']>;
  /** Mode indicating how the knowledge document's content affects the prompt. */
  readonly mode?: InputMaybe<KnowledgeDocumentPromptInstructionKnowledgeDocumentPromptInstructionMode>;
}

/**
 * UpdateKnowledgeDocumentVersionInput is used for update KnowledgeDocumentVersion object.
 * Input was generated by ent.
 */
export interface UpdateKnowledgeDocumentVersionInput {
  readonly appendMetadata?: InputMaybe<Scalars['JSON']['input']>;
  readonly clearDiffSummary?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearInternalSummary?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearMetadata?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearOldID?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearProcessedChecksum?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearProcessedFilePath?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearProcessingCompletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearProcessingError?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearProcessingStartedAt?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearRawChecksum?: InputMaybe<Scalars['Boolean']['input']>;
  /** LLM-written summary of changes from the previous version, primarily used to pass downstream to have another LLM make updates to things like enumerationfield instructions, etc. */
  readonly diffSummary?: InputMaybe<Scalars['String']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** InternalSummary is a summary of the document for internal (non-customer) use. */
  readonly internalSummary?: InputMaybe<Scalars['String']['input']>;
  readonly knowledgeDocumentID?: InputMaybe<Scalars['ID']['input']>;
  /** Metadata specific to this version */
  readonly metadata?: InputMaybe<Scalars['JSON']['input']>;
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  /** Checksum of the processed file */
  readonly processedChecksum?: InputMaybe<Scalars['String']['input']>;
  /** Path to the processed version of the file on S3 for this version */
  readonly processedFilePath?: InputMaybe<Scalars['String']['input']>;
  /** Timestamp when background processing finished (successfully or failed). */
  readonly processingCompletedAt?: InputMaybe<Scalars['Int']['input']>;
  /** Stores the error message if background processing failed. */
  readonly processingError?: InputMaybe<Scalars['String']['input']>;
  /** Timestamp when background processing started. */
  readonly processingStartedAt?: InputMaybe<Scalars['Int']['input']>;
  /** The status of background processing for this version. */
  readonly processingStatus?: InputMaybe<KnowledgeDocumentVersionProcessingStatus>;
  /** Checksum of the raw file */
  readonly rawChecksum?: InputMaybe<Scalars['String']['input']>;
  /** Path to the raw version of the file on S3 for this version */
  readonly rawFilePath?: InputMaybe<Scalars['String']['input']>;
  readonly versionNumber?: InputMaybe<Scalars['Int']['input']>;
}

/**
 * UpdateOpportunityCallLinkInput is used for update OpportunityCallLink object.
 * Input was generated by ent.
 */
export interface UpdateOpportunityCallLinkInput {
  readonly callID?: InputMaybe<Scalars['ID']['input']>;
  readonly clearOpportunityStageChange?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly opportunityID?: InputMaybe<Scalars['ID']['input']>;
  readonly opportunityStageChangeID?: InputMaybe<Scalars['ID']['input']>;
  /** Probability is the listed probability of the opportunity at the time of the call. */
  readonly probability?: InputMaybe<Scalars['Float']['input']>;
  /**
   * StageName represents the state of the opportunity at the time of the call.
   * For the current state see the Opportunity table.
   */
  readonly stageName?: InputMaybe<Scalars['String']['input']>;
}

/**
 * UpdateOpportunityInput is used for update Opportunity object.
 * Input was generated by ent.
 */
export interface UpdateOpportunityInput {
  readonly accountID?: InputMaybe<Scalars['ID']['input']>;
  readonly addCallIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addCustomFieldValueIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addDocumentIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addOpportunityStageChangeIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly amount?: InputMaybe<Scalars['Int']['input']>;
  readonly clearAccount?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearCalls?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearContact?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearCustomFieldValues?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearDocumentUUID?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearExternalMappingUUID?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearLink?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearName?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearOpportunityStageChanges?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearOwner?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearPipelineStage?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearPlatformCreatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearSourcePlatform?: InputMaybe<Scalars['Boolean']['input']>;
  readonly closeDate?: InputMaybe<Scalars['Unix']['input']>;
  readonly contactID?: InputMaybe<Scalars['ID']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly documentUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly externalMappingUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly link?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  /** NewlyIngested is true if the opportunity was just ingested by the call-enricher. */
  readonly newlyIngested?: InputMaybe<Scalars['Boolean']['input']>;
  readonly ownerID?: InputMaybe<Scalars['ID']['input']>;
  readonly pipelineStageID?: InputMaybe<Scalars['ID']['input']>;
  /** PlatformCreatedAt is the date when the opportunity was created in the CRM/end-user platform. */
  readonly platformCreatedAt?: InputMaybe<Scalars['Unix']['input']>;
  readonly removeCallIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeCustomFieldValueIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeDocumentIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeOpportunityStageChangeIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly sourcePlatform?: InputMaybe<CallIntegration>;
  /**
   * StageName represents the current state of the opportunity.
   * For the state at the time of the call see the OpportunityCallLink table.
   */
  readonly stageName?: InputMaybe<Scalars['String']['input']>;
  readonly type?: InputMaybe<Scalars['String']['input']>;
}

/**
 * UpdateOpportunityStageChangeInput is used for update OpportunityStageChange object.
 * Input was generated by ent.
 */
export interface UpdateOpportunityStageChangeInput {
  readonly addEnumerationValueIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly clearEnumerationValues?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearOldID?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearPipelineStage?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly enteredDate?: InputMaybe<Scalars['Unix']['input']>;
  readonly oldID?: InputMaybe<Scalars['OldID']['input']>;
  readonly opportunityID?: InputMaybe<Scalars['ID']['input']>;
  readonly pipelineStageID?: InputMaybe<Scalars['ID']['input']>;
  readonly removeEnumerationValueIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly stageName?: InputMaybe<Scalars['String']['input']>;
}

/**
 * UpdatePipelineInput is used for update Pipeline object.
 * Input was generated by ent.
 */
export interface UpdatePipelineInput {
  readonly addStageIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly clearStages?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** ExternalPlatformID is the ID of the Pipeline in the CRM. */
  readonly externalPlatformID?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly removeStageIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly sourcePlatform?: InputMaybe<PipelineCallIntegration>;
}

/**
 * UpdatePipelineStageInput is used for update PipelineStage object.
 * Input was generated by ent.
 */
export interface UpdatePipelineStageInput {
  readonly addEnumerationConfigurationIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addOpportunityIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addStageChangeIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly clearEnumerationConfigurations?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearOpportunities?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearOutcome?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearStageChanges?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** ExternalPlatformID is the ID of the PipelineStage in the CRM. */
  readonly externalPlatformID?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly order?: InputMaybe<Scalars['Int']['input']>;
  readonly outcome?: InputMaybe<PipelineStageOutcome>;
  readonly pipelineID?: InputMaybe<Scalars['ID']['input']>;
  readonly removeEnumerationConfigurationIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeOpportunityIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeStageChangeIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
}

/**
 * UpdateProspectContactInput is used for update ProspectContact object.
 * Input was generated by ent.
 */
export interface UpdateProspectContactInput {
  readonly clearEngagementPlatform?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearExternalContactID?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearExternalSequenceID?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearExternalSequenceMembershipID?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearOldID?: InputMaybe<Scalars['Boolean']['input']>;
  readonly contacted?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly engagementPlatform?: InputMaybe<ProspectContactCallIntegration>;
  readonly externalContactID?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalSequenceID?: InputMaybe<Scalars['OldID']['input']>;
  readonly externalSequenceMembershipID?: InputMaybe<Scalars['OldID']['input']>;
  readonly firstName?: InputMaybe<Scalars['String']['input']>;
  readonly lastName?: InputMaybe<Scalars['String']['input']>;
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  /** Processed is true when the ProspectContact has been analyzed by us. */
  readonly processed?: InputMaybe<Scalars['Boolean']['input']>;
  readonly prospectID?: InputMaybe<Scalars['ID']['input']>;
  readonly title?: InputMaybe<Scalars['String']['input']>;
}

/**
 * UpdateProspectExecutiveInput is used for update ProspectExecutive object.
 * Input was generated by ent.
 */
export interface UpdateProspectExecutiveInput {
  readonly clearOldID?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly firstName?: InputMaybe<Scalars['String']['input']>;
  /** IsRelevant is true if this executive would be relevant to it's CustomerCustomer. */
  readonly isRelevant?: InputMaybe<Scalars['Boolean']['input']>;
  readonly lastName?: InputMaybe<Scalars['String']['input']>;
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  readonly prospectID?: InputMaybe<Scalars['ID']['input']>;
  readonly title?: InputMaybe<Scalars['String']['input']>;
}

/**
 * UpdateProspectInput is used for update Prospect object.
 * Input was generated by ent.
 */
export interface UpdateProspectInput {
  readonly addProspectContactIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addProspectExecutiveIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly clearEngagementPlatform?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearExternalProspectID?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearOldID?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearProspectContacts?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearProspectExecutives?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearStockTicker?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly domain?: InputMaybe<Scalars['String']['input']>;
  readonly engagementPlatform?: InputMaybe<ProspectCallIntegration>;
  readonly externalProspectID?: InputMaybe<Scalars['OldID']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  readonly removeProspectContactIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeProspectExecutiveIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly status?: InputMaybe<ProspectProcessingStatus>;
  readonly stockTicker?: InputMaybe<Scalars['String']['input']>;
}

/**
 * UpdateReportingLinkInput is used for update ReportingLink object.
 * Input was generated by ent.
 */
export interface UpdateReportingLinkInput {
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly managerID?: InputMaybe<Scalars['ID']['input']>;
  readonly reportID?: InputMaybe<Scalars['ID']['input']>;
}

/**
 * UpdateSlackDeliveryInput is used for update SlackDelivery object.
 * Input was generated by ent.
 */
export interface UpdateSlackDeliveryInput {
  readonly clearOldID?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly enumerationValueID?: InputMaybe<Scalars['ID']['input']>;
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  readonly slackSubscriptionID?: InputMaybe<Scalars['ID']['input']>;
  readonly threadTs?: InputMaybe<Scalars['String']['input']>;
}

/**
 * UpdateSlackSubscriptionInput is used for update SlackSubscription object.
 * Input was generated by ent.
 */
export interface UpdateSlackSubscriptionInput {
  readonly addSlackDeliveryIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly appendAttendeeGroups?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly appendAttendees?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly appendCustomerCustomers?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly appendHostGroups?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly appendHosts?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly attendeeGroups?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly attendees?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly callFilterTemplate?: InputMaybe<Scalars['String']['input']>;
  readonly channelID?: InputMaybe<Scalars['String']['input']>;
  readonly clearAttendeeGroups?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearAttendees?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearCallFilterTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearCustomerCustomers?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearHostGroups?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearHosts?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearOldID?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearSlackDeliveries?: InputMaybe<Scalars['Boolean']['input']>;
  readonly customerCustomers?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly enumType?: InputMaybe<SlackSubscriptionValueType>;
  readonly hostGroups?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly hosts?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  readonly removeSlackDeliveryIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly type?: InputMaybe<SlackSubscriptionSubscriptionType>;
}

/**
 * UpdateTaskInput is used for update Task object.
 * Input was generated by ent.
 */
export interface UpdateTaskInput {
  readonly accountID?: InputMaybe<Scalars['ID']['input']>;
  readonly addEmailIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly assignedUserID?: InputMaybe<Scalars['ID']['input']>;
  readonly clearAccount?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearAssignedUser?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearContact?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearDetails?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearEmail?: InputMaybe<Scalars['Boolean']['input']>;
  readonly contactID?: InputMaybe<Scalars['ID']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** Details for the task, if applicable. This might be quite long and contain instructions to the user on how to complete the task. */
  readonly details?: InputMaybe<Scalars['String']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly removeEmailIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly status?: InputMaybe<TaskStatus>;
  readonly title?: InputMaybe<Scalars['String']['input']>;
}

/**
 * UpdateTaskReferenceInput is used for update TaskReference object.
 * Input was generated by ent.
 */
export interface UpdateTaskReferenceInput {
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly emailID?: InputMaybe<Scalars['ID']['input']>;
  readonly taskID?: InputMaybe<Scalars['ID']['input']>;
}

/**
 * UpdateUserCallStatInput is used for update UserCallStat object.
 * Input was generated by ent.
 */
export interface UpdateUserCallStatInput {
  readonly count?: InputMaybe<Scalars['Int']['input']>;
  readonly date?: InputMaybe<Scalars['Unix']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly userID?: InputMaybe<Scalars['ID']['input']>;
}

/**
 * UpdateUserGroupInput is used for update UserGroup object.
 * Input was generated by ent.
 */
export interface UpdateUserGroupInput {
  readonly addUserIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addViewerIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly clearManager?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearOldID?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearUsers?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearViewers?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly managerID?: InputMaybe<Scalars['ID']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly oldID?: InputMaybe<Scalars['OldID']['input']>;
  readonly removeUserIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeViewerIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
}

/**
 * UpdateUserGroupMembershipInput is used for update UserGroupMembership object.
 * Input was generated by ent.
 */
export interface UpdateUserGroupMembershipInput {
  readonly clearOldID?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  readonly userGroupID?: InputMaybe<Scalars['ID']['input']>;
  readonly userID?: InputMaybe<Scalars['ID']['input']>;
}

/**
 * UpdateUserGroupViewerInput is used for update UserGroupViewer object.
 * Input was generated by ent.
 */
export interface UpdateUserGroupViewerInput {
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly userGroupID?: InputMaybe<Scalars['ID']['input']>;
  readonly viewerID?: InputMaybe<Scalars['ID']['input']>;
}

/**
 * UpdateUserInput is used for update User object.
 * Input was generated by ent.
 */
export interface UpdateUserInput {
  readonly addAssignedTaskIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addCallStatIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addEmailSubscriptionIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addEmailThreadIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addGongUserIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addIntegrationSecretIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addManagedUserGroupIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addReceivedEmailIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addScoreStatIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addSentEmailIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addUserGroupIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly addViewedUserGroupIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly auth0ID?: InputMaybe<Scalars['String']['input']>;
  readonly clearAssignedTasks?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearAuth0ID?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearCallStats?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearEmailSubscriptions?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearEmailThreads?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearFirstName?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearGongUsers?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearIntegrationSecrets?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearLastName?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearManagedUserGroups?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearOldID?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearReceivedEmails?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearRole?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearScoreStats?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearSentEmails?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearUserGroups?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearUserProspectingConfig?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearViewedUserGroups?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly email?: InputMaybe<Scalars['String']['input']>;
  readonly firstName?: InputMaybe<Scalars['String']['input']>;
  readonly internal?: InputMaybe<Scalars['Boolean']['input']>;
  readonly lastName?: InputMaybe<Scalars['String']['input']>;
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  readonly removeAssignedTaskIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeCallStatIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeEmailSubscriptionIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeEmailThreadIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeGongUserIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeIntegrationSecretIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeManagedUserGroupIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeReceivedEmailIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeScoreStatIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeSentEmailIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeUserGroupIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly removeViewedUserGroupIDs?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly role?: InputMaybe<UserRole>;
  readonly userProspectingConfigID?: InputMaybe<Scalars['ID']['input']>;
  readonly welcomeEmailSent?: InputMaybe<Scalars['Boolean']['input']>;
}

/**
 * UpdateUserProspectingConfigInput is used for update UserProspectingConfig object.
 * Input was generated by ent.
 */
export interface UpdateUserProspectingConfigInput {
  /** Automatically ingest prospects from the user's engagement platform (e.g. HubSpot). */
  readonly autoIngestProspects?: InputMaybe<Scalars['Boolean']['input']>;
  /** Automatically push prospect analysis to the user's CRM (e.g. HubSpot). */
  readonly autoPushToCrm?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearMeetingLink?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearOldID?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** User-specific link to schedule a meeting, e.g. Calendly */
  readonly meetingLink?: InputMaybe<Scalars['String']['input']>;
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  readonly userID?: InputMaybe<Scalars['ID']['input']>;
}

/**
 * UpdateUserScoreStatInput is used for update UserScoreStat object.
 * Input was generated by ent.
 */
export interface UpdateUserScoreStatInput {
  readonly clearEightCount?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearFiveCount?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearFourCount?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearNineCount?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearOneCount?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearSevenCount?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearSixCount?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearTenCount?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearThreeCount?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clearTwoCount?: InputMaybe<Scalars['Boolean']['input']>;
  readonly count?: InputMaybe<Scalars['Int']['input']>;
  readonly date?: InputMaybe<Scalars['Unix']['input']>;
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly eightCount?: InputMaybe<Scalars['Int']['input']>;
  readonly enumerationFieldID?: InputMaybe<Scalars['ID']['input']>;
  readonly fiveCount?: InputMaybe<Scalars['Int']['input']>;
  readonly fourCount?: InputMaybe<Scalars['Int']['input']>;
  readonly nineCount?: InputMaybe<Scalars['Int']['input']>;
  readonly oneCount?: InputMaybe<Scalars['Int']['input']>;
  readonly sevenCount?: InputMaybe<Scalars['Int']['input']>;
  readonly sixCount?: InputMaybe<Scalars['Int']['input']>;
  readonly tenCount?: InputMaybe<Scalars['Int']['input']>;
  readonly threeCount?: InputMaybe<Scalars['Int']['input']>;
  readonly total?: InputMaybe<Scalars['Int']['input']>;
  readonly twoCount?: InputMaybe<Scalars['Int']['input']>;
  readonly userID?: InputMaybe<Scalars['ID']['input']>;
}

export const UseCase = {
  Call: 'CALL',
  Crm: 'CRM',
  Productivity: 'PRODUCTIVITY',
  Prospecting: 'PROSPECTING',
  UnknownUseCase: 'UNKNOWN_USE_CASE'
} as const;

export type UseCase = typeof UseCase[keyof typeof UseCase];
export interface User extends Node {
  readonly assignedTasks?: Maybe<ReadonlyArray<Task>>;
  readonly auth0ID?: Maybe<Scalars['String']['output']>;
  readonly callStats?: Maybe<ReadonlyArray<UserCallStat>>;
  readonly createdAt: Scalars['Int']['output'];
  readonly createdBy?: Maybe<Scalars['OldID']['output']>;
  readonly createdByUUID?: Maybe<Scalars['ID']['output']>;
  readonly disabled: Scalars['Boolean']['output'];
  readonly email: Scalars['String']['output'];
  readonly emailSubscriptions?: Maybe<ReadonlyArray<EmailSubscription>>;
  readonly emailThreads?: Maybe<ReadonlyArray<EmailThread>>;
  readonly firstName?: Maybe<Scalars['String']['output']>;
  readonly gongUsers?: Maybe<ReadonlyArray<GongUser>>;
  readonly id: Scalars['ID']['output'];
  readonly integrationSecrets?: Maybe<ReadonlyArray<IntegrationSecret>>;
  readonly internal: Scalars['Boolean']['output'];
  readonly lastName?: Maybe<Scalars['String']['output']>;
  readonly managedUserGroups?: Maybe<ReadonlyArray<UserGroup>>;
  readonly oldID?: Maybe<Scalars['Int']['output']>;
  readonly receivedEmails?: Maybe<ReadonlyArray<EmailRecipient>>;
  readonly role?: Maybe<UserRole>;
  readonly scoreStats?: Maybe<ReadonlyArray<UserScoreStat>>;
  readonly sentEmails?: Maybe<ReadonlyArray<Email>>;
  readonly updatedAt: Scalars['Int']['output'];
  readonly updatedBy?: Maybe<Scalars['OldID']['output']>;
  readonly updatedByUUID?: Maybe<Scalars['ID']['output']>;
  readonly userGroupMemberships?: Maybe<ReadonlyArray<UserGroupMembership>>;
  readonly userGroupViewers?: Maybe<ReadonlyArray<UserGroupViewer>>;
  readonly userGroups?: Maybe<ReadonlyArray<UserGroup>>;
  readonly userProspectingConfig?: Maybe<UserProspectingConfig>;
  readonly viewedUserGroups?: Maybe<ReadonlyArray<UserGroup>>;
  readonly welcomeEmailSent: Scalars['Boolean']['output'];
}

export interface UserCallStat extends Node {
  readonly count: Scalars['Int']['output'];
  readonly createdAt: Scalars['Int']['output'];
  readonly date: Scalars['Unix']['output'];
  readonly disabled: Scalars['Boolean']['output'];
  readonly id: Scalars['ID']['output'];
  readonly updatedAt: Scalars['Int']['output'];
  readonly user: User;
  readonly userUUID: Scalars['ID']['output'];
}

/** A connection to a list of items. */
export interface UserCallStatConnection {
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<UserCallStatEdge>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface UserCallStatEdge {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<UserCallStat>;
}

/** Ordering options for UserCallStat connections */
export interface UserCallStatOrder {
  /** The ordering direction. */
  readonly direction?: OrderDirection;
  /** The field by which to order UserCallStats. */
  readonly field: UserCallStatOrderField;
}

/** Properties by which UserCallStat connections can be ordered. */
export const UserCallStatOrderField = {
  CreatedAt: 'CREATED_AT',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type UserCallStatOrderField = typeof UserCallStatOrderField[keyof typeof UserCallStatOrderField];
/**
 * UserCallStatWhereInput is used for filtering UserCallStat objects.
 * Input was generated by ent.
 */
export interface UserCallStatWhereInput {
  readonly and?: InputMaybe<ReadonlyArray<UserCallStatWhereInput>>;
  /** count field predicates */
  readonly count?: InputMaybe<Scalars['Int']['input']>;
  readonly countGT?: InputMaybe<Scalars['Int']['input']>;
  readonly countGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly countIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly countLT?: InputMaybe<Scalars['Int']['input']>;
  readonly countLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly countNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly countNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** created_at field predicates */
  readonly createdAt?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly createdAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** date field predicates */
  readonly date?: InputMaybe<Scalars['Unix']['input']>;
  readonly dateGT?: InputMaybe<Scalars['Unix']['input']>;
  readonly dateGTE?: InputMaybe<Scalars['Unix']['input']>;
  readonly dateIn?: InputMaybe<ReadonlyArray<Scalars['Unix']['input']>>;
  readonly dateLT?: InputMaybe<Scalars['Unix']['input']>;
  readonly dateLTE?: InputMaybe<Scalars['Unix']['input']>;
  readonly dateNEQ?: InputMaybe<Scalars['Unix']['input']>;
  readonly dateNotIn?: InputMaybe<ReadonlyArray<Scalars['Unix']['input']>>;
  /** disabled field predicates */
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** user edge predicates */
  readonly hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasUserWith?: InputMaybe<ReadonlyArray<UserWhereInput>>;
  /** id field predicates */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly idGT?: InputMaybe<Scalars['ID']['input']>;
  readonly idGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly idLT?: InputMaybe<Scalars['ID']['input']>;
  readonly idLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly idNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly not?: InputMaybe<UserCallStatWhereInput>;
  readonly or?: InputMaybe<ReadonlyArray<UserCallStatWhereInput>>;
  /** updated_at field predicates */
  readonly updatedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly updatedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** user_uuid field predicates */
  readonly userUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly userUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly userUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly userUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
}

/** A connection to a list of items. */
export interface UserConnection {
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<UserEdge>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface UserEdge {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<User>;
}

export interface UserGroup extends Node {
  readonly createdAt: Scalars['Int']['output'];
  readonly createdByUUID: Scalars['ID']['output'];
  readonly disabled: Scalars['Boolean']['output'];
  readonly id: Scalars['ID']['output'];
  readonly manager?: Maybe<User>;
  readonly managerUUID?: Maybe<Scalars['ID']['output']>;
  readonly name: Scalars['String']['output'];
  readonly oldCreatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly oldID?: Maybe<Scalars['OldID']['output']>;
  readonly oldUpdatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly updatedAt: Scalars['Int']['output'];
  readonly updatedByUUID: Scalars['ID']['output'];
  readonly userGroupMemberships: UserGroupMembershipConnection;
  readonly userGroupViewers?: Maybe<ReadonlyArray<UserGroupViewer>>;
  readonly users: UserConnection;
  readonly viewers?: Maybe<ReadonlyArray<User>>;
}


export interface UserGroupUserGroupMembershipsArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UserGroupMembershipOrder>;
  where?: InputMaybe<UserGroupMembershipWhereInput>;
}


export interface UserGroupUsersArgs {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UserOrder>;
  where?: InputMaybe<UserWhereInput>;
}

/** A connection to a list of items. */
export interface UserGroupConnection {
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<UserGroupEdge>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface UserGroupEdge {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<UserGroup>;
}

export interface UserGroupMembership extends Node {
  readonly createdAt: Scalars['Int']['output'];
  readonly createdBy?: Maybe<Scalars['OldID']['output']>;
  readonly createdByUUID?: Maybe<Scalars['ID']['output']>;
  readonly disabled: Scalars['Boolean']['output'];
  readonly id: Scalars['ID']['output'];
  readonly oldID?: Maybe<Scalars['Int']['output']>;
  readonly updatedAt: Scalars['Int']['output'];
  readonly updatedBy?: Maybe<Scalars['OldID']['output']>;
  readonly updatedByUUID?: Maybe<Scalars['ID']['output']>;
  readonly user: User;
  readonly userGroup: UserGroup;
  readonly userGroupUUID: Scalars['ID']['output'];
  readonly userUUID: Scalars['ID']['output'];
}

/** A connection to a list of items. */
export interface UserGroupMembershipConnection {
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<UserGroupMembershipEdge>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface UserGroupMembershipEdge {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<UserGroupMembership>;
}

/** Ordering options for UserGroupMembership connections */
export interface UserGroupMembershipOrder {
  /** The ordering direction. */
  readonly direction?: OrderDirection;
  /** The field by which to order UserGroupMemberships. */
  readonly field: UserGroupMembershipOrderField;
}

/** Properties by which UserGroupMembership connections can be ordered. */
export const UserGroupMembershipOrderField = {
  CreatedAt: 'CREATED_AT',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type UserGroupMembershipOrderField = typeof UserGroupMembershipOrderField[keyof typeof UserGroupMembershipOrderField];
/**
 * UserGroupMembershipWhereInput is used for filtering UserGroupMembership objects.
 * Input was generated by ent.
 */
export interface UserGroupMembershipWhereInput {
  readonly and?: InputMaybe<ReadonlyArray<UserGroupMembershipWhereInput>>;
  /** created_at field predicates */
  readonly createdAt?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly createdAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** created_by field predicates */
  readonly createdBy?: InputMaybe<Scalars['OldID']['input']>;
  readonly createdByGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly createdByGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly createdByIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly createdByIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly createdByLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly createdByLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly createdByNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly createdByNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly createdByNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_by_uuid field predicates */
  readonly createdByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDGT?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly createdByUUIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly createdByUUIDLT?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly createdByUUIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** disabled field predicates */
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** id field predicates */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly idGT?: InputMaybe<Scalars['ID']['input']>;
  readonly idGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly idLT?: InputMaybe<Scalars['ID']['input']>;
  readonly idLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly idNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly not?: InputMaybe<UserGroupMembershipWhereInput>;
  /** old_id field predicates */
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDGT?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly oldIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldIDLT?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly oldIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly or?: InputMaybe<ReadonlyArray<UserGroupMembershipWhereInput>>;
  /** updated_at field predicates */
  readonly updatedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly updatedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** updated_by field predicates */
  readonly updatedBy?: InputMaybe<Scalars['OldID']['input']>;
  readonly updatedByGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly updatedByGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly updatedByIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly updatedByIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly updatedByLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly updatedByLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly updatedByNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly updatedByNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly updatedByNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_by_uuid field predicates */
  readonly updatedByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDGT?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly updatedByUUIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly updatedByUUIDLT?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly updatedByUUIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
}

/** Ordering options for UserGroup connections */
export interface UserGroupOrder {
  /** The ordering direction. */
  readonly direction?: OrderDirection;
  /** The field by which to order UserGroups. */
  readonly field: UserGroupOrderField;
}

/** Properties by which UserGroup connections can be ordered. */
export const UserGroupOrderField = {
  CreatedAt: 'CREATED_AT',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type UserGroupOrderField = typeof UserGroupOrderField[keyof typeof UserGroupOrderField];
export interface UserGroupViewer extends Node {
  readonly createdAt: Scalars['Int']['output'];
  readonly createdBy?: Maybe<Scalars['OldID']['output']>;
  readonly createdByUUID?: Maybe<Scalars['ID']['output']>;
  readonly disabled: Scalars['Boolean']['output'];
  readonly id: Scalars['ID']['output'];
  readonly updatedAt: Scalars['Int']['output'];
  readonly updatedBy?: Maybe<Scalars['OldID']['output']>;
  readonly updatedByUUID?: Maybe<Scalars['ID']['output']>;
  readonly userGroup: UserGroup;
  readonly userGroupUUID: Scalars['ID']['output'];
  readonly viewer: User;
  readonly viewerUUID: Scalars['ID']['output'];
}

/** A connection to a list of items. */
export interface UserGroupViewerConnection {
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<UserGroupViewerEdge>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface UserGroupViewerEdge {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<UserGroupViewer>;
}

/** Ordering options for UserGroupViewer connections */
export interface UserGroupViewerOrder {
  /** The ordering direction. */
  readonly direction?: OrderDirection;
  /** The field by which to order UserGroupViewers. */
  readonly field: UserGroupViewerOrderField;
}

/** Properties by which UserGroupViewer connections can be ordered. */
export const UserGroupViewerOrderField = {
  CreatedAt: 'CREATED_AT',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type UserGroupViewerOrderField = typeof UserGroupViewerOrderField[keyof typeof UserGroupViewerOrderField];
/**
 * UserGroupViewerWhereInput is used for filtering UserGroupViewer objects.
 * Input was generated by ent.
 */
export interface UserGroupViewerWhereInput {
  readonly and?: InputMaybe<ReadonlyArray<UserGroupViewerWhereInput>>;
  /** created_at field predicates */
  readonly createdAt?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly createdAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** created_by field predicates */
  readonly createdBy?: InputMaybe<Scalars['OldID']['input']>;
  readonly createdByGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly createdByGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly createdByIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly createdByIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly createdByLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly createdByLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly createdByNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly createdByNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly createdByNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_by_uuid field predicates */
  readonly createdByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDGT?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly createdByUUIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly createdByUUIDLT?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly createdByUUIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** disabled field predicates */
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** id field predicates */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly idGT?: InputMaybe<Scalars['ID']['input']>;
  readonly idGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly idLT?: InputMaybe<Scalars['ID']['input']>;
  readonly idLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly idNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly not?: InputMaybe<UserGroupViewerWhereInput>;
  readonly or?: InputMaybe<ReadonlyArray<UserGroupViewerWhereInput>>;
  /** updated_at field predicates */
  readonly updatedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly updatedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** updated_by field predicates */
  readonly updatedBy?: InputMaybe<Scalars['OldID']['input']>;
  readonly updatedByGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly updatedByGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly updatedByIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly updatedByIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly updatedByLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly updatedByLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly updatedByNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly updatedByNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly updatedByNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_by_uuid field predicates */
  readonly updatedByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDGT?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly updatedByUUIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly updatedByUUIDLT?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly updatedByUUIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
}

/**
 * UserGroupWhereInput is used for filtering UserGroup objects.
 * Input was generated by ent.
 */
export interface UserGroupWhereInput {
  readonly and?: InputMaybe<ReadonlyArray<UserGroupWhereInput>>;
  /** created_at field predicates */
  readonly createdAt?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly createdAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** created_by_uuid field predicates */
  readonly createdByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly createdByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** disabled field predicates */
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** manager edge predicates */
  readonly hasManager?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasManagerWith?: InputMaybe<ReadonlyArray<UserWhereInput>>;
  /** user_group_memberships edge predicates */
  readonly hasUserGroupMemberships?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasUserGroupMembershipsWith?: InputMaybe<ReadonlyArray<UserGroupMembershipWhereInput>>;
  /** user_group_viewers edge predicates */
  readonly hasUserGroupViewers?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasUserGroupViewersWith?: InputMaybe<ReadonlyArray<UserGroupViewerWhereInput>>;
  /** users edge predicates */
  readonly hasUsers?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasUsersWith?: InputMaybe<ReadonlyArray<UserWhereInput>>;
  /** viewers edge predicates */
  readonly hasViewers?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasViewersWith?: InputMaybe<ReadonlyArray<UserWhereInput>>;
  /** id field predicates */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly idGT?: InputMaybe<Scalars['ID']['input']>;
  readonly idGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly idLT?: InputMaybe<Scalars['ID']['input']>;
  readonly idLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly idNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** manager_uuid field predicates */
  readonly managerUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly managerUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly managerUUIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly managerUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly managerUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly managerUUIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** name field predicates */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly nameContains?: InputMaybe<Scalars['String']['input']>;
  readonly nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly nameGT?: InputMaybe<Scalars['String']['input']>;
  readonly nameGTE?: InputMaybe<Scalars['String']['input']>;
  readonly nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly nameIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly nameLT?: InputMaybe<Scalars['String']['input']>;
  readonly nameLTE?: InputMaybe<Scalars['String']['input']>;
  readonly nameNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly nameNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly not?: InputMaybe<UserGroupWhereInput>;
  /** old_created_by_id field predicates */
  readonly oldCreatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldCreatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_id field predicates */
  readonly oldID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_updated_by_id field predicates */
  readonly oldUpdatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldUpdatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly or?: InputMaybe<ReadonlyArray<UserGroupWhereInput>>;
  /** updated_at field predicates */
  readonly updatedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly updatedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** updated_by_uuid field predicates */
  readonly updatedByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly updatedByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
}

/** Ordering options for User connections */
export interface UserOrder {
  /** The ordering direction. */
  readonly direction?: OrderDirection;
  /** The field by which to order Users. */
  readonly field: UserOrderField;
}

/** Properties by which User connections can be ordered. */
export const UserOrderField = {
  CreatedAt: 'CREATED_AT',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type UserOrderField = typeof UserOrderField[keyof typeof UserOrderField];
export interface UserProspectingConfig extends Node {
  /** Automatically ingest prospects from the user's engagement platform (e.g. HubSpot). */
  readonly autoIngestProspects: Scalars['Boolean']['output'];
  /** Automatically push prospect analysis to the user's CRM (e.g. HubSpot). */
  readonly autoPushToCrm: Scalars['Boolean']['output'];
  readonly createdAt: Scalars['Int']['output'];
  readonly createdByUUID: Scalars['ID']['output'];
  readonly disabled: Scalars['Boolean']['output'];
  readonly id: Scalars['ID']['output'];
  /** User-specific link to schedule a meeting, e.g. Calendly */
  readonly meetingLink?: Maybe<Scalars['String']['output']>;
  readonly oldCreatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly oldID?: Maybe<Scalars['Int']['output']>;
  readonly oldUpdatedByID?: Maybe<Scalars['OldID']['output']>;
  readonly updatedAt: Scalars['Int']['output'];
  readonly updatedByUUID: Scalars['ID']['output'];
  readonly user: User;
  readonly userUUID: Scalars['ID']['output'];
}

/** A connection to a list of items. */
export interface UserProspectingConfigConnection {
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<UserProspectingConfigEdge>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface UserProspectingConfigEdge {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<UserProspectingConfig>;
}

/** Ordering options for UserProspectingConfig connections */
export interface UserProspectingConfigOrder {
  /** The ordering direction. */
  readonly direction?: OrderDirection;
  /** The field by which to order UserProspectingConfigs. */
  readonly field: UserProspectingConfigOrderField;
}

/** Properties by which UserProspectingConfig connections can be ordered. */
export const UserProspectingConfigOrderField = {
  CreatedAt: 'CREATED_AT',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type UserProspectingConfigOrderField = typeof UserProspectingConfigOrderField[keyof typeof UserProspectingConfigOrderField];
/**
 * UserProspectingConfigWhereInput is used for filtering UserProspectingConfig objects.
 * Input was generated by ent.
 */
export interface UserProspectingConfigWhereInput {
  readonly and?: InputMaybe<ReadonlyArray<UserProspectingConfigWhereInput>>;
  /** auto_ingest_prospects field predicates */
  readonly autoIngestProspects?: InputMaybe<Scalars['Boolean']['input']>;
  readonly autoIngestProspectsNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** auto_push_to_crm field predicates */
  readonly autoPushToCrm?: InputMaybe<Scalars['Boolean']['input']>;
  readonly autoPushToCrmNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  readonly createdAt?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly createdAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** created_by_uuid field predicates */
  readonly createdByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly createdByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** disabled field predicates */
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** user edge predicates */
  readonly hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasUserWith?: InputMaybe<ReadonlyArray<UserWhereInput>>;
  /** id field predicates */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly idGT?: InputMaybe<Scalars['ID']['input']>;
  readonly idGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly idLT?: InputMaybe<Scalars['ID']['input']>;
  readonly idLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly idNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** meeting_link field predicates */
  readonly meetingLink?: InputMaybe<Scalars['String']['input']>;
  readonly meetingLinkContains?: InputMaybe<Scalars['String']['input']>;
  readonly meetingLinkContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly meetingLinkEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly meetingLinkGT?: InputMaybe<Scalars['String']['input']>;
  readonly meetingLinkGTE?: InputMaybe<Scalars['String']['input']>;
  readonly meetingLinkHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly meetingLinkHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly meetingLinkIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly meetingLinkIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly meetingLinkLT?: InputMaybe<Scalars['String']['input']>;
  readonly meetingLinkLTE?: InputMaybe<Scalars['String']['input']>;
  readonly meetingLinkNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly meetingLinkNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly meetingLinkNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly not?: InputMaybe<UserProspectingConfigWhereInput>;
  /** old_created_by_id field predicates */
  readonly oldCreatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldCreatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldCreatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldCreatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_id field predicates */
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDGT?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly oldIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldIDLT?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly oldIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** old_updated_by_id field predicates */
  readonly oldUpdatedByID?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldUpdatedByIDLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly oldUpdatedByIDNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly oldUpdatedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly or?: InputMaybe<ReadonlyArray<UserProspectingConfigWhereInput>>;
  /** updated_at field predicates */
  readonly updatedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly updatedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** updated_by_uuid field predicates */
  readonly updatedByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly updatedByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** user_uuid field predicates */
  readonly userUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly userUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly userUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly userUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
}

/** UserRole is enum for the field role */
export const UserRole = {
  Admin: 'ADMIN',
  Invalid: 'INVALID',
  User: 'USER'
} as const;

export type UserRole = typeof UserRole[keyof typeof UserRole];
export interface UserScoreStat extends Node {
  readonly count: Scalars['Int']['output'];
  readonly createdAt: Scalars['Int']['output'];
  readonly date: Scalars['Unix']['output'];
  readonly disabled: Scalars['Boolean']['output'];
  readonly eightCount?: Maybe<Scalars['Int']['output']>;
  readonly enumerationField: EnumerationField;
  readonly enumerationFieldUUID: Scalars['ID']['output'];
  readonly fiveCount?: Maybe<Scalars['Int']['output']>;
  readonly fourCount?: Maybe<Scalars['Int']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly nineCount?: Maybe<Scalars['Int']['output']>;
  readonly oneCount?: Maybe<Scalars['Int']['output']>;
  readonly sevenCount?: Maybe<Scalars['Int']['output']>;
  readonly sixCount?: Maybe<Scalars['Int']['output']>;
  readonly tenCount?: Maybe<Scalars['Int']['output']>;
  readonly threeCount?: Maybe<Scalars['Int']['output']>;
  readonly total: Scalars['Int']['output'];
  readonly twoCount?: Maybe<Scalars['Int']['output']>;
  readonly updatedAt: Scalars['Int']['output'];
  readonly user: User;
  readonly userUUID: Scalars['ID']['output'];
}

/** A connection to a list of items. */
export interface UserScoreStatConnection {
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<UserScoreStatEdge>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface UserScoreStatEdge {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<UserScoreStat>;
}

/** Ordering options for UserScoreStat connections */
export interface UserScoreStatOrder {
  /** The ordering direction. */
  readonly direction?: OrderDirection;
  /** The field by which to order UserScoreStats. */
  readonly field: UserScoreStatOrderField;
}

/** Properties by which UserScoreStat connections can be ordered. */
export const UserScoreStatOrderField = {
  CreatedAt: 'CREATED_AT',
  UpdatedAt: 'UPDATED_AT'
} as const;

export type UserScoreStatOrderField = typeof UserScoreStatOrderField[keyof typeof UserScoreStatOrderField];
/**
 * UserScoreStatWhereInput is used for filtering UserScoreStat objects.
 * Input was generated by ent.
 */
export interface UserScoreStatWhereInput {
  readonly and?: InputMaybe<ReadonlyArray<UserScoreStatWhereInput>>;
  /** count field predicates */
  readonly count?: InputMaybe<Scalars['Int']['input']>;
  readonly countGT?: InputMaybe<Scalars['Int']['input']>;
  readonly countGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly countIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly countLT?: InputMaybe<Scalars['Int']['input']>;
  readonly countLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly countNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly countNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** created_at field predicates */
  readonly createdAt?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly createdAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** date field predicates */
  readonly date?: InputMaybe<Scalars['Unix']['input']>;
  readonly dateGT?: InputMaybe<Scalars['Unix']['input']>;
  readonly dateGTE?: InputMaybe<Scalars['Unix']['input']>;
  readonly dateIn?: InputMaybe<ReadonlyArray<Scalars['Unix']['input']>>;
  readonly dateLT?: InputMaybe<Scalars['Unix']['input']>;
  readonly dateLTE?: InputMaybe<Scalars['Unix']['input']>;
  readonly dateNEQ?: InputMaybe<Scalars['Unix']['input']>;
  readonly dateNotIn?: InputMaybe<ReadonlyArray<Scalars['Unix']['input']>>;
  /** disabled field predicates */
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** eight_count field predicates */
  readonly eightCount?: InputMaybe<Scalars['Int']['input']>;
  readonly eightCountGT?: InputMaybe<Scalars['Int']['input']>;
  readonly eightCountGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly eightCountIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly eightCountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly eightCountLT?: InputMaybe<Scalars['Int']['input']>;
  readonly eightCountLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly eightCountNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly eightCountNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly eightCountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** enumeration_field_uuid field predicates */
  readonly enumerationFieldUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly enumerationFieldUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly enumerationFieldUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly enumerationFieldUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** five_count field predicates */
  readonly fiveCount?: InputMaybe<Scalars['Int']['input']>;
  readonly fiveCountGT?: InputMaybe<Scalars['Int']['input']>;
  readonly fiveCountGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly fiveCountIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly fiveCountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly fiveCountLT?: InputMaybe<Scalars['Int']['input']>;
  readonly fiveCountLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly fiveCountNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly fiveCountNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly fiveCountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** four_count field predicates */
  readonly fourCount?: InputMaybe<Scalars['Int']['input']>;
  readonly fourCountGT?: InputMaybe<Scalars['Int']['input']>;
  readonly fourCountGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly fourCountIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly fourCountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly fourCountLT?: InputMaybe<Scalars['Int']['input']>;
  readonly fourCountLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly fourCountNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly fourCountNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly fourCountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** enumeration_field edge predicates */
  readonly hasEnumerationField?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasEnumerationFieldWith?: InputMaybe<ReadonlyArray<EnumerationFieldWhereInput>>;
  /** user edge predicates */
  readonly hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasUserWith?: InputMaybe<ReadonlyArray<UserWhereInput>>;
  /** id field predicates */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly idGT?: InputMaybe<Scalars['ID']['input']>;
  readonly idGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly idLT?: InputMaybe<Scalars['ID']['input']>;
  readonly idLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly idNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** nine_count field predicates */
  readonly nineCount?: InputMaybe<Scalars['Int']['input']>;
  readonly nineCountGT?: InputMaybe<Scalars['Int']['input']>;
  readonly nineCountGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly nineCountIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly nineCountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly nineCountLT?: InputMaybe<Scalars['Int']['input']>;
  readonly nineCountLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly nineCountNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly nineCountNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly nineCountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly not?: InputMaybe<UserScoreStatWhereInput>;
  /** one_count field predicates */
  readonly oneCount?: InputMaybe<Scalars['Int']['input']>;
  readonly oneCountGT?: InputMaybe<Scalars['Int']['input']>;
  readonly oneCountGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly oneCountIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly oneCountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oneCountLT?: InputMaybe<Scalars['Int']['input']>;
  readonly oneCountLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly oneCountNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly oneCountNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly oneCountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly or?: InputMaybe<ReadonlyArray<UserScoreStatWhereInput>>;
  /** seven_count field predicates */
  readonly sevenCount?: InputMaybe<Scalars['Int']['input']>;
  readonly sevenCountGT?: InputMaybe<Scalars['Int']['input']>;
  readonly sevenCountGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly sevenCountIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly sevenCountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly sevenCountLT?: InputMaybe<Scalars['Int']['input']>;
  readonly sevenCountLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly sevenCountNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly sevenCountNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly sevenCountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** six_count field predicates */
  readonly sixCount?: InputMaybe<Scalars['Int']['input']>;
  readonly sixCountGT?: InputMaybe<Scalars['Int']['input']>;
  readonly sixCountGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly sixCountIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly sixCountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly sixCountLT?: InputMaybe<Scalars['Int']['input']>;
  readonly sixCountLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly sixCountNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly sixCountNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly sixCountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** ten_count field predicates */
  readonly tenCount?: InputMaybe<Scalars['Int']['input']>;
  readonly tenCountGT?: InputMaybe<Scalars['Int']['input']>;
  readonly tenCountGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly tenCountIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly tenCountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly tenCountLT?: InputMaybe<Scalars['Int']['input']>;
  readonly tenCountLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly tenCountNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly tenCountNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly tenCountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** three_count field predicates */
  readonly threeCount?: InputMaybe<Scalars['Int']['input']>;
  readonly threeCountGT?: InputMaybe<Scalars['Int']['input']>;
  readonly threeCountGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly threeCountIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly threeCountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly threeCountLT?: InputMaybe<Scalars['Int']['input']>;
  readonly threeCountLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly threeCountNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly threeCountNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly threeCountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** total field predicates */
  readonly total?: InputMaybe<Scalars['Int']['input']>;
  readonly totalGT?: InputMaybe<Scalars['Int']['input']>;
  readonly totalGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly totalIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly totalLT?: InputMaybe<Scalars['Int']['input']>;
  readonly totalLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly totalNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly totalNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** two_count field predicates */
  readonly twoCount?: InputMaybe<Scalars['Int']['input']>;
  readonly twoCountGT?: InputMaybe<Scalars['Int']['input']>;
  readonly twoCountGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly twoCountIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly twoCountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly twoCountLT?: InputMaybe<Scalars['Int']['input']>;
  readonly twoCountLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly twoCountNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly twoCountNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly twoCountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  readonly updatedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly updatedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** user_uuid field predicates */
  readonly userUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly userUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly userUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly userUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
}

/**
 * UserWhereInput is used for filtering User objects.
 * Input was generated by ent.
 */
export interface UserWhereInput {
  readonly and?: InputMaybe<ReadonlyArray<UserWhereInput>>;
  /** auth0_id field predicates */
  readonly auth0ID?: InputMaybe<Scalars['String']['input']>;
  readonly auth0IDContains?: InputMaybe<Scalars['String']['input']>;
  readonly auth0IDContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly auth0IDEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly auth0IDGT?: InputMaybe<Scalars['String']['input']>;
  readonly auth0IDGTE?: InputMaybe<Scalars['String']['input']>;
  readonly auth0IDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly auth0IDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly auth0IDIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly auth0IDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly auth0IDLT?: InputMaybe<Scalars['String']['input']>;
  readonly auth0IDLTE?: InputMaybe<Scalars['String']['input']>;
  readonly auth0IDNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly auth0IDNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly auth0IDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  readonly createdAt?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly createdAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly createdAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** created_by field predicates */
  readonly createdBy?: InputMaybe<Scalars['OldID']['input']>;
  readonly createdByGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly createdByGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly createdByIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly createdByIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly createdByLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly createdByLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly createdByNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly createdByNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly createdByNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_by_uuid field predicates */
  readonly createdByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDGT?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly createdByUUIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly createdByUUIDLT?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly createdByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly createdByUUIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** disabled field predicates */
  readonly disabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly disabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** email field predicates */
  readonly email?: InputMaybe<Scalars['String']['input']>;
  readonly emailContains?: InputMaybe<Scalars['String']['input']>;
  readonly emailContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly emailEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly emailGT?: InputMaybe<Scalars['String']['input']>;
  readonly emailGTE?: InputMaybe<Scalars['String']['input']>;
  readonly emailHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly emailHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly emailIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly emailLT?: InputMaybe<Scalars['String']['input']>;
  readonly emailLTE?: InputMaybe<Scalars['String']['input']>;
  readonly emailNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly emailNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** first_name field predicates */
  readonly firstName?: InputMaybe<Scalars['String']['input']>;
  readonly firstNameContains?: InputMaybe<Scalars['String']['input']>;
  readonly firstNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly firstNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly firstNameGT?: InputMaybe<Scalars['String']['input']>;
  readonly firstNameGTE?: InputMaybe<Scalars['String']['input']>;
  readonly firstNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly firstNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly firstNameIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly firstNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly firstNameLT?: InputMaybe<Scalars['String']['input']>;
  readonly firstNameLTE?: InputMaybe<Scalars['String']['input']>;
  readonly firstNameNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly firstNameNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly firstNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** assigned_tasks edge predicates */
  readonly hasAssignedTasks?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasAssignedTasksWith?: InputMaybe<ReadonlyArray<TaskWhereInput>>;
  /** call_stats edge predicates */
  readonly hasCallStats?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasCallStatsWith?: InputMaybe<ReadonlyArray<UserCallStatWhereInput>>;
  /** email_subscriptions edge predicates */
  readonly hasEmailSubscriptions?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasEmailSubscriptionsWith?: InputMaybe<ReadonlyArray<EmailSubscriptionWhereInput>>;
  /** email_threads edge predicates */
  readonly hasEmailThreads?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasEmailThreadsWith?: InputMaybe<ReadonlyArray<EmailThreadWhereInput>>;
  /** gong_users edge predicates */
  readonly hasGongUsers?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasGongUsersWith?: InputMaybe<ReadonlyArray<GongUserWhereInput>>;
  /** integration_secrets edge predicates */
  readonly hasIntegrationSecrets?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasIntegrationSecretsWith?: InputMaybe<ReadonlyArray<IntegrationSecretWhereInput>>;
  /** managed_user_groups edge predicates */
  readonly hasManagedUserGroups?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasManagedUserGroupsWith?: InputMaybe<ReadonlyArray<UserGroupWhereInput>>;
  /** received_emails edge predicates */
  readonly hasReceivedEmails?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasReceivedEmailsWith?: InputMaybe<ReadonlyArray<EmailRecipientWhereInput>>;
  /** score_stats edge predicates */
  readonly hasScoreStats?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasScoreStatsWith?: InputMaybe<ReadonlyArray<UserScoreStatWhereInput>>;
  /** sent_emails edge predicates */
  readonly hasSentEmails?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasSentEmailsWith?: InputMaybe<ReadonlyArray<EmailWhereInput>>;
  /** user_group_memberships edge predicates */
  readonly hasUserGroupMemberships?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasUserGroupMembershipsWith?: InputMaybe<ReadonlyArray<UserGroupMembershipWhereInput>>;
  /** user_group_viewers edge predicates */
  readonly hasUserGroupViewers?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasUserGroupViewersWith?: InputMaybe<ReadonlyArray<UserGroupViewerWhereInput>>;
  /** user_groups edge predicates */
  readonly hasUserGroups?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasUserGroupsWith?: InputMaybe<ReadonlyArray<UserGroupWhereInput>>;
  /** user_prospecting_config edge predicates */
  readonly hasUserProspectingConfig?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasUserProspectingConfigWith?: InputMaybe<ReadonlyArray<UserProspectingConfigWhereInput>>;
  /** viewed_user_groups edge predicates */
  readonly hasViewedUserGroups?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hasViewedUserGroupsWith?: InputMaybe<ReadonlyArray<UserGroupWhereInput>>;
  /** id field predicates */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly idGT?: InputMaybe<Scalars['ID']['input']>;
  readonly idGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly idLT?: InputMaybe<Scalars['ID']['input']>;
  readonly idLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly idNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly idNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** internal field predicates */
  readonly internal?: InputMaybe<Scalars['Boolean']['input']>;
  readonly internalNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** last_name field predicates */
  readonly lastName?: InputMaybe<Scalars['String']['input']>;
  readonly lastNameContains?: InputMaybe<Scalars['String']['input']>;
  readonly lastNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  readonly lastNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  readonly lastNameGT?: InputMaybe<Scalars['String']['input']>;
  readonly lastNameGTE?: InputMaybe<Scalars['String']['input']>;
  readonly lastNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly lastNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readonly lastNameIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly lastNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly lastNameLT?: InputMaybe<Scalars['String']['input']>;
  readonly lastNameLTE?: InputMaybe<Scalars['String']['input']>;
  readonly lastNameNEQ?: InputMaybe<Scalars['String']['input']>;
  readonly lastNameNotIn?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly lastNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly not?: InputMaybe<UserWhereInput>;
  /** old_id field predicates */
  readonly oldID?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDGT?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly oldIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly oldIDLT?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly oldIDNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly oldIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly or?: InputMaybe<ReadonlyArray<UserWhereInput>>;
  /** role field predicates */
  readonly role?: InputMaybe<UserRole>;
  readonly roleIn?: InputMaybe<ReadonlyArray<UserRole>>;
  readonly roleIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly roleNEQ?: InputMaybe<UserRole>;
  readonly roleNotIn?: InputMaybe<ReadonlyArray<UserRole>>;
  readonly roleNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  readonly updatedAt?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtGTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly updatedAtLT?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtLTE?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNEQ?: InputMaybe<Scalars['Int']['input']>;
  readonly updatedAtNotIn?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** updated_by field predicates */
  readonly updatedBy?: InputMaybe<Scalars['OldID']['input']>;
  readonly updatedByGT?: InputMaybe<Scalars['OldID']['input']>;
  readonly updatedByGTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly updatedByIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly updatedByIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly updatedByLT?: InputMaybe<Scalars['OldID']['input']>;
  readonly updatedByLTE?: InputMaybe<Scalars['OldID']['input']>;
  readonly updatedByNEQ?: InputMaybe<Scalars['OldID']['input']>;
  readonly updatedByNotIn?: InputMaybe<ReadonlyArray<Scalars['OldID']['input']>>;
  readonly updatedByNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_by_uuid field predicates */
  readonly updatedByUUID?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDGT?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDGTE?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly updatedByUUIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readonly updatedByUUIDLT?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDLTE?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  readonly updatedByUUIDNotIn?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly updatedByUUIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** welcome_email_sent field predicates */
  readonly welcomeEmailSent?: InputMaybe<Scalars['Boolean']['input']>;
  readonly welcomeEmailSentNEQ?: InputMaybe<Scalars['Boolean']['input']>;
}
